// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/vue-query';

import { client } from '../client.gen';
import { abortMediaDownload, abortStorageOperations, addReservableItem, adminAddMigrationException, adminAllowedUpdate, adminAuthenticationPolicies, adminAuthenticationPolicy, adminAuthenticationPolicyAdd, adminAuthenticationPolicyDelete, adminAuthenticationPolicyEdit, adminAuthenticationProviders, adminAutoRegister, adminBackupConfig, adminBackupGet, adminBackupIntegrityGet, adminBackupIntegritySet, adminBackupReport, adminBackupsList, adminBroadcast, adminBulkCreateUsers, adminCancelTask, adminCategoryDeleteCheck, adminCheckDisclaimer, adminCheckEmailVerification, adminCheckGroupCategory, adminCheckMigrated, adminCheckMigration, adminCheckMigrationRequired, adminCheckPasswordResetRequired, adminCreateCategory, adminCreateGroup, adminCreateNotification, adminCreateNotificationTemplate, adminCreateSecret, adminCreateUser, adminDeleteAllNotificationData, adminDeleteCategory, adminDeleteGroup, adminDeleteMigrationException, adminDeleteNotification, adminDeleteNotificationData, adminDeleteNotificationTemplate, adminDeleteOldTasks, adminDeleteOldTasksAuto, adminDeleteSecret, adminDeleteUserNotificationData, adminDeleteUsers, adminDesktopsStatus, adminDesktopsStatusCategory, adminDesktopsTreeList, adminDomainDetails, adminDomainHardware, adminDomainLiveXml, adminDomainSearchInfo, adminDomainsField, adminDomainsNameSearch, adminDomainsStartedCount, adminDomainsStatus, adminDomainStorage, adminDomainStoragePath, adminDomainTemplateTree, adminDomainViewerData, adminDomainXmlCapabilities, adminDomainXmlGet, adminDomainXmlSectionsGet, adminDomainXmlSectionsParse, adminDomainXmlSectionsSave, adminDomainXmlSectionsSaveAsVirtInstall, adminDomainXmlUpdate, adminDownloads, adminDownloadsAction, adminDownloadsActionId, adminDownloadsKind, adminDownloadsRegister, adminEchart, adminEchartDailyItems, adminEditCsvUsers, adminEmitSocketio, adminFindStoragesByDomainStatus, adminForceDisclaimer, adminForceEmail, adminForcePassword, adminGetBastionDomain, adminGetCategory, adminGetCategoryByName, adminGetCategoryUsers, adminGetGroup, adminGetGroupByNameCategory, adminGetGroupUsers, adminGetJwt, adminGetMigrationExceptions, adminGetNotification, adminGetNotificationsDataByStatus, adminGetNotificationsGroupedByStatus, adminGetNotificationStatuses, adminGetNotificationTemplate, adminGetOldTasks, adminGetOldTasksConfig, adminGetPasswordPolicy, adminGetQuotaByKind, adminGetQuotaByKindItem, adminGetQuotas, adminGetRole, adminGetRoles, adminGetSecrets, adminGetStorageSchedulerConfig, adminGetTemplates, adminGetUser, adminGetUserAppliedQuota, adminGetUserByEmailCategory, adminGetUserDesktops, adminGetUserNotificationDisplays, adminGetUserRaw, adminGetUserSchema, adminGetUserTemplates, adminGetUserVpn, adminGetUserVpnWithOs, adminGpuForceProfilePreview, adminGroupDeleteCheck, adminGroupEnrollment, adminHypervisorBootProgress, adminHypervisorCreate, adminHypervisorDelete, adminHypervisorDisksFound, adminHypervisorEnable, adminHypervisorGpuApplied, adminHypervisorMediaDelete, adminHypervisorMediaFound, adminHypervisorMountpoints, adminHypervisorsList, adminHypervisorsListByStatus, adminHypervisorStartedDomains, adminHypervisorStatus, adminHypervisorStopDomains, adminHypervisorVirtPoolsGet, adminHypervisorVirtPoolsUpdate, adminHypervisorVpn, adminHypervisorWgAddr, adminImportCsvUsers, adminListCategories, adminListCategoriesFrontend, adminListCategoriesNav, adminListCustomNotificationTemplates, adminListDomains, adminListGroups, adminListGroupsNav, adminListNotificationActions, adminListNotifications, adminListNotificationTemplates, adminListSystemNotificationTemplates, adminListUsers, adminListUsersNav, adminLoginConfigByCategory, adminLoginConfigGet, adminLoginNotificationCoverEnable, adminLoginNotificationFormEnable, adminLoginNotificationUpdate, adminLogsDesktopsAction, adminLogsDesktopsConfig, adminLogsDesktopsDelete, adminLogsDesktopsDeleteAll, adminLogsDesktopsList, adminLogsDesktopsMaxTime, adminLogsDesktopsRaw, adminLogsDesktopsView, adminLogsUsersAction, adminLogsUsersConfig, adminLogsUsersDelete, adminLogsUsersDeleteAll, adminLogsUsersList, adminLogsUsersMaxTime, adminLogsUsersRaw, adminLogsUsersView, adminMediaByStatus, adminMediaDomains, adminMediaList, adminMediaStatus, adminMigrateUser, adminMigrateUserDeployments, adminMigrateUserDesktops, adminMigrateUserMedia, adminMigrateUserTemplates, adminMultipleActions, adminNotifyDesktop, adminNotifyDesktopQueue, adminNotifyUserDesktop, adminOperationsHypervisors, adminOperationsHypervisorStart, adminOperationsHypervisorStop, adminOrchestratorConfig, adminOrchestratorConfigUpdate, adminOrchestratorDeadRowReset, adminOrchestratorDeadRowSet, adminOrchestratorHypervisorGet, adminOrchestratorHypervisorsList, adminOrchestratorManagedList, adminOrchestratorManageSet, adminOrchestratorManageUnset, adminOrchestratorOnlyForcedSet, adminOrchestratorStopDesktops, adminPreviewNotificationTemplate, adminQosDiskAdd, adminQosDiskUpdate, adminQueuesBacklog, adminQueuesConsumers, adminQueuesGovernor, adminQueuesJobs, adminQueuesLaneHealth, adminQueuesProblemTasks, adminRegisterVlans, adminRemoteVpn, adminRemoteVpnWithOs, adminResetPassword, adminResetVpn, adminSchedulerJobsBookings, adminSchedulerJobsSystem, adminSearchUsers, adminSecondaryGroupsAdd, adminSecondaryGroupsDelete, adminSecondaryGroupsOverwrite, adminSetOldTasksEnabled, adminSetOldTasksMaxTime, adminSetOldTasksQueueRegistries, adminSetStorageSchedulerConfig, adminSmtpEnabledGet, adminSmtpGet, adminSmtpPut, adminSmtpTestPost, adminStorageByRole, adminStorageByStatus, adminStorageByStatusFiltered, adminStorageDelete, adminStorageDomains, adminStorageInfo, adminStorageList, adminStorageListFiltered, adminStorageMigrationAction, adminStorageMigrationConfig, adminStorageMigrationCreate, adminStorageMigrationList, adminStorageMigrationLog, adminStorageMigrationPathPrefixes, adminStorageMigrationPlan, adminStorageMigrationStatus, adminStoragePoolMigrationPlan, adminStorageRefreshRunningSizes, adminStorageSearchInfo, adminStorageStatus, adminSystemLogoGet, adminSystemLogoPut, adminTableDelete, adminTableGet, adminTableInsert, adminTableList, adminTableUpdate, adminTemplateDelete, adminUpdateBastionDomain, adminUpdateCategory, adminUpdateCategoryLimits, adminUpdateCategoryQuota, adminUpdateGroup, adminUpdateGroupLimits, adminUpdateGroupQuota, adminUpdateNotification, adminUpdateNotificationTemplate, adminUpdateRole, adminUpdateUser, adminUpdateUsersBulk, adminUsageAllCredits, adminUsageCheckOverlapping, adminUsageConsolidate, adminUsageConsolidateItem, adminUsageConsolidateItemDays, adminUsageConsumers, adminUsageConsumersCount, adminUsageConsumption, adminUsageCredits, adminUsageCreditsAdd, adminUsageCreditsById, adminUsageCreditsDelete, adminUsageCreditsUpdate, adminUsageDeleteConsumptionData, adminUsageDistinctItems, adminUsageGroupingGet, adminUsageGroupingsAdd, adminUsageGroupingsDelete, adminUsageGroupingsDropdown, adminUsageGroupingsList, adminUsageGroupingsUpdate, adminUsageLimitsAdd, adminUsageLimitsDelete, adminUsageLimitsList, adminUsageLimitsUpdate, adminUsageListParameters, adminUsageParametersAdd, adminUsageParametersDelete, adminUsageParametersList, adminUsageParametersUpdate, adminUsageResetDatesAdd, adminUsageResetDatesAll, adminUsageResetDatesRange, adminUsageRetentionGet, adminUsageRetentionUpdate, adminUsageStartEnd, adminUsageUnifyItemName, adminUserDeleteCheck, adminUserExists, adminUserLogout, adminUserStorageAdd, adminUserStorageAutoRegister, adminUserStorageGet, adminUserStorageList, adminUserStorageLoginAuth, adminUserStorageRemove, adminUserStorageReset, adminUserStorageResetAll, adminUserStorageSync, adminUserStorageTest, adminUserStorageUsers, adminValidateCsvUsers, adminValidateCsvUsersEdit, adminViewersConfig, adminViewersConfigReset, adminViewersConfigUpdate, adminVirtInstallXmlSectionsGet, adminVirtInstallXmlSectionsSave, allowedsTableTerm, allowedTable, analyticsDesktopsLessUsed, analyticsDesktopsMostUsed, analyticsDesktopsRecentlyUsed, analyticsGraphConfAdd, analyticsGraphConfDelete, analyticsGraphConfGet, analyticsGraphConfUpdate, analyticsGraphsConfList, analyticsResourceCount, analyticsStorage, analyticsSuggestedRemovals, apiV4Categories, apiV4Category, apiV4CategoryCustomUrl, apiV4Disclaimer, apiV4LoginConfig, apiVersion, batchCheckBackingChain, batchCheckBackingChainByStatus, batchFindStorages, batchFindStoragesByStatus, batchSparsifyStorages, batchSparsifyStoragesByStatus, bookingProvisioning, bulkCreatePersistentDesktops, bulkDeleteDeployments, bulkDeleteRecycleBin, bulkEditDesktops, bulkRestoreRecycleBin, cancelTask, changeDeploymentOwner, changeDesktopOwner, changeMediaOwner, changeTemplateOwner, checkCategoryStoragePoolAvailability, checkDeploymentQuotaGet, checkDeploymentQuotaPost, checkIntegrity, checkLastItem, checkLastSubitem, checkMedia, checkQuotaNewDeployment, checkQuotaNewDesktop, checkQuotaNewMedia, checkQuotaNewTemplate, checkQuotaNewVolatileDesktop, checkStorageBackingChain, checkStoragePoolAvailabilityCompat, checkStoragePoolCreationAvailability, convertStorage, convertTemplateToDesktop, countRecreateDeploymentDesktops, createBookingEvent, createDeployment, createDesktop, createDesktopFromMedia, createMedia, createNonpersistentDesktop, createPlan, createPlanning, createStorage, createStoragePool, createTemplate, createUnusedItemTimeoutRule, deleteBookingEvent, deleteCutoffTimeSurpassed, deleteDeployment, deleteDesktop, deleteExpiredUserNotificationsData, deleteMedia, deleteMigration, deleteOldEntries, deletePlan, deletePlanning, deletePriority, deleteRecycleBinEntry, deleteReservableItem, deleteStorage, deleteStoragePath, deleteStoragePool, deleteTemplate, deleteUnusedItemTimeoutRule, deleteUser, deleteUserBastionSshKey, deleteUserDeploymentDesktops, disconnectStorage, duplicateTemplate, editDeployment, editDeploymentUsers, editDesktop, editProviderConfigRoute, emptyBookingPlan, emptyRecycleBin, enableCategoryLoginNotification, enableReservableSubitem, expireUserApiKey, extendDesktopTimeout, findStorage, forceStopDesktop, generateDefaultCard, getActualPlan, getAdminBastionConfig, getAdminTasks, getAllBookings, getAllDeployments, getAllDesktops, getAllGroups, getAllMigrations, getAllowedHardware, getAllowedHardwareForDomain, getAllSharedDeployments, getAllUnusedItemTimeoutRules, getAllUsers, getAvailableGroupsForCategory, getBastionAllowed, getBastionDomainVerificationConfig, getBastionTargets, getBookingDeployment, getBookingDesktop, getBookingPlans, getBookingPriorityDeployment, getBookingPriorityDesktop, getBookingReservablesAvailable, getCategoryAuthentication, getCategoryBranding, getCategoryLogo, getCategoryLogoCollapsed, getCategoryMaintenance, getDefaultStoragePool, getDeleteAction, getDeployment, getDeploymentAllowed, getDeploymentBastion, getDeploymentBastionCsv, getDeploymentCoOwners, getDeploymentCsv, getDeploymentDesktopBastion, getDeploymentHardware, getDeploymentInfo, getDeploymentPermissions, getDeploymentUserDesktops, getDeploymentUserDesktopsDetail, getDeploymentVideowall, getDesktop, getDesktopBastion, getDesktopBastionActive, getDesktopBastionLegacy, getDesktopCardImages, getDesktopDetails, getDesktopDetailsFromToken, getDesktopImages, getDesktopImagesByType, getDesktopInfo, getDesktopNetworks, getDesktopViewerByToken, getDesktopViewerByType, getDisclaimer, getDomainsAllowedReservables, getGpuBookingsForecast, getHardwareKindAllowed, getItemAvailability, getItemPlannings, getItemPlans, getLoginConfigByCategory, getLogo, getLogoCollapsed, getMaintenance, getMaintenanceText, getMaintenanceTextFrontend, getMaxBookingDate, getMedia, getMediaAllowedTable, getMediaDesktops, getMediaInstalls, getMediaTasks, getMigrationConfig, getNetworksFromToken, getOldEntriesConfig, getPlanBookings, getProviderConfigRoute, getProviderExportEnabled, getProviderImportEnabled, getQcow2Geometry, getQueuesHealth, getRecycleBin, getRecycleBinAdminEntries, getRecycleBinCount, getRecycleBinCutoffTime, getRecycleBinDefaultDeleteConfig, getRecycleBinItemCountUser, getRecycleBinStatus, getReservableItems, getReservables, getReservablesAvailable, getShareLink, getStatusBarNotifications, getStockDefaultCard, getStorage, getStorageHasDerivatives, getStorageParents, getStoragePool, getStoragePoolByPath, getStoragePoolPending, getStorageReady, getStorageStatuses, getStorageStoragesWithUuid, getStorageTask, getStorageTasks, getSystemCutoffTime, getTask, getTemplateAllowed, getTemplateDetails, getTemplateInfo, getTemplateNonpersistentDesktop, getTemplateTree, getUnusedItemTimeoutRule, getUser, getUserAllowedMedia, getUserAllowedTemplates, getUserAllowedTemplatesFlat, getUserApiKey, getUserAppliedQuota, getUserBastionSshKey, getUserBookings, getUserConfig, getUserDefaultCard, getUserDesktop, getUserDesktops, getUserDesktopsLegacy, getUserDesktopsPaginated, getUserDetails, getUserMedia, getUserNotificationDisplays, getUserNotificationTriggerDisplay, getUserNotificationTriggerDisplayNested, getUserPasswordPolicy, getUserQuotas, getUserReadyStorages, getUserSharedMedia, getUserSharedTemplates, getUsersInGroup, getUsersPriorities, getUserTasks, getUserTemplates, getUserTemplatesPaginated, getUserVpn, getUserVpnByKind, getUserVpnWithOs, getViewerDocs, getWebappDesktops, getWebappTemplates, groupsUsersCount, increaseStorageSize, listAllPlans, listAllStoragesWithUuid, listAllStoragesWithUuidFiltered, listAllStoragesWithUuidStatus, listBookables, listDesktopAttachedMedia, listEnabledSubitems, listPriorityRules, listProfiles, listReservableSubitems, listStoragePools, listStuckRecycleBinEntries, logViewerClick, maintenanceStatus, migrationExportUser, migrationImportUser, migrationListItems, migrationMigrateUser, moveStorageByPath, type Options, recoverStuckRecycleBinEntries, recreateDeployment, recreateDesktop, recreateStorage, recycleBinAddUnusedItems, registerUser, removeDisallowedBastionTargets, renewDesktopViewerByToken, reRegisterUser, resetDesktop, restoreRecycleBin, retryAllFailedTasks, retryFailedDesktop, retryTask, revokeMigration, rsyncStorageToPath, rsyncStorageToStoragePool, searchUsersInCategory, setDefaultDelete, setDeleteAction, setDeploymentBastion, setOldEntriesAction, setOldEntriesMaxTime, setStorageMaintenance, setStoragePath, setStorageReady, setTemplateEnabled, setUserBastionSshKey, setUserEmail, setUserLanguage, setUserPassword, sparsifyStorage, startAllDesktopsInDeployment, startDesktop, startDesktopFromToken, startMediaDownload, statsCategories, statsCategoriesDeployments, statsDesktops, statsDesktopsStatus, statsDomainsStatus, statsHypervisors, statsTemplates, statsUsers, stopAllDesktopsInDeployment, stopDesktop, stopDesktops, stopStorageDesktops, stopUserDesktopsInDeployment, toggleDeploymentVisibility, toggleDesktopDeploymentVisibility, toggleDomainVisibility, toggleTemplateEnabled, updateBastionAuthorizedKeys, updateBastionConfig, updateBastionDomains, updateBookingEvent, updateCategoryAuthentication, updateCategoryBranding, updateCategoryLoginNotification, updateDeploymentCoOwners, updateDesktopBastion, updateDesktopBastionAuthorizedKeys, updateDesktopBastionDomain, updateDesktopBastionDomains, updateMaintenance, updateMaintenanceText, updateMediaAllowed, updateMigrationConfig, updatePlan, updateReservableItem, updateShareLink, updateStatusDesktop, updateStoragePool, updateSystemCutoffTime, updateTemplate, updateTemplateAllowed, updateUnusedItemTimeoutRule, userOwnsDesktop, userResetVpn, verifyBastionDomain, verifyDesktopBastionDomain, virtWinRegStorage, vpnConnectionConnect, vpnConnectionDisconnect, vpnConnectionReset, vpnConnectionRoam, vpnConnectionsDisconnect } from '../sdk.gen';
import type { AbortMediaDownloadData, AbortMediaDownloadError, AbortMediaDownloadResponse, AbortStorageOperationsData, AbortStorageOperationsError, AbortStorageOperationsResponse, AddReservableItemData, AddReservableItemError, AddReservableItemResponse, AdminAddMigrationExceptionData, AdminAddMigrationExceptionError, AdminAddMigrationExceptionResponse, AdminAllowedUpdateData, AdminAllowedUpdateError, AdminAllowedUpdateResponse, AdminAuthenticationPoliciesData, AdminAuthenticationPoliciesError, AdminAuthenticationPoliciesResponse, AdminAuthenticationPolicyAddData, AdminAuthenticationPolicyAddError, AdminAuthenticationPolicyAddResponse, AdminAuthenticationPolicyData, AdminAuthenticationPolicyDeleteData, AdminAuthenticationPolicyDeleteError, AdminAuthenticationPolicyDeleteResponse, AdminAuthenticationPolicyEditData, AdminAuthenticationPolicyEditError, AdminAuthenticationPolicyEditResponse, AdminAuthenticationPolicyError, AdminAuthenticationPolicyResponse, AdminAuthenticationProvidersData, AdminAuthenticationProvidersError, AdminAuthenticationProvidersResponse, AdminAutoRegisterData, AdminAutoRegisterError, AdminAutoRegisterResponse, AdminBackupConfigData, AdminBackupConfigError, AdminBackupConfigResponse, AdminBackupGetData, AdminBackupGetError, AdminBackupGetResponse, AdminBackupIntegrityGetData, AdminBackupIntegrityGetError, AdminBackupIntegrityGetResponse, AdminBackupIntegritySetData, AdminBackupIntegritySetError, AdminBackupIntegritySetResponse, AdminBackupReportData, AdminBackupReportError, AdminBackupReportResponse, AdminBackupsListData, AdminBackupsListError, AdminBackupsListResponse, AdminBroadcastData2, AdminBroadcastError, AdminBroadcastResponse, AdminBulkCreateUsersData, AdminBulkCreateUsersError, AdminBulkCreateUsersResponse, AdminCancelTaskData, AdminCancelTaskError, AdminCancelTaskResponse, AdminCategoryDeleteCheckData, AdminCategoryDeleteCheckError, AdminCategoryDeleteCheckResponse, AdminCheckDisclaimerData, AdminCheckDisclaimerError, AdminCheckDisclaimerResponse, AdminCheckEmailVerificationData, AdminCheckEmailVerificationError, AdminCheckEmailVerificationResponse, AdminCheckGroupCategoryData2, AdminCheckGroupCategoryError, AdminCheckGroupCategoryResponse, AdminCheckMigratedData2, AdminCheckMigratedError, AdminCheckMigratedResponse2, AdminCheckMigrationData, AdminCheckMigrationError, AdminCheckMigrationRequiredData, AdminCheckMigrationRequiredError, AdminCheckMigrationRequiredResponse, AdminCheckMigrationResponse, AdminCheckPasswordResetRequiredData, AdminCheckPasswordResetRequiredError, AdminCheckPasswordResetRequiredResponse, AdminCreateCategoryData, AdminCreateCategoryError, AdminCreateCategoryResponse, AdminCreateGroupData, AdminCreateGroupError, AdminCreateGroupResponse, AdminCreateNotificationData, AdminCreateNotificationError, AdminCreateNotificationResponse, AdminCreateNotificationTemplateData, AdminCreateNotificationTemplateError, AdminCreateNotificationTemplateResponse, AdminCreateSecretData, AdminCreateSecretError, AdminCreateSecretResponse, AdminCreateUserData, AdminCreateUserError, AdminCreateUserResponse, AdminDeleteAllNotificationDataData, AdminDeleteAllNotificationDataError, AdminDeleteAllNotificationDataResponse, AdminDeleteCategoryData, AdminDeleteCategoryError, AdminDeleteCategoryResponse, AdminDeleteGroupData, AdminDeleteGroupError, AdminDeleteGroupResponse, AdminDeleteMigrationExceptionData, AdminDeleteMigrationExceptionError, AdminDeleteMigrationExceptionResponse, AdminDeleteNotificationData, AdminDeleteNotificationDataData, AdminDeleteNotificationDataError, AdminDeleteNotificationDataResponse, AdminDeleteNotificationError, AdminDeleteNotificationResponse, AdminDeleteNotificationTemplateData, AdminDeleteNotificationTemplateError, AdminDeleteNotificationTemplateResponse, AdminDeleteOldTasksAutoData, AdminDeleteOldTasksAutoError, AdminDeleteOldTasksAutoResponse, AdminDeleteOldTasksData, AdminDeleteOldTasksError, AdminDeleteOldTasksResponse, AdminDeleteSecretData, AdminDeleteSecretError, AdminDeleteSecretResponse, AdminDeleteUserNotificationDataData, AdminDeleteUserNotificationDataError, AdminDeleteUserNotificationDataResponse, AdminDeleteUsersData, AdminDeleteUsersError, AdminDeleteUsersResponse, AdminDesktopsStatusCategoryData, AdminDesktopsStatusCategoryError, AdminDesktopsStatusCategoryResponse, AdminDesktopsStatusData, AdminDesktopsStatusError, AdminDesktopsStatusResponse, AdminDesktopsTreeListData, AdminDesktopsTreeListError, AdminDesktopsTreeListResponse, AdminDomainDetailsData, AdminDomainDetailsError, AdminDomainDetailsResponse2, AdminDomainHardwareData, AdminDomainHardwareError, AdminDomainHardwareResponse2, AdminDomainLiveXmlData, AdminDomainLiveXmlError, AdminDomainLiveXmlResponse2, AdminDomainSearchInfoData, AdminDomainSearchInfoError, AdminDomainSearchInfoResponse2, AdminDomainsFieldData, AdminDomainsFieldError, AdminDomainsFieldResponse2, AdminDomainsNameSearchData, AdminDomainsNameSearchError, AdminDomainsNameSearchResponse, AdminDomainsStartedCountData, AdminDomainsStartedCountError, AdminDomainsStartedCountResponse, AdminDomainsStatusData, AdminDomainsStatusError, AdminDomainsStatusResponse, AdminDomainStorageData, AdminDomainStorageError, AdminDomainStoragePathData2, AdminDomainStoragePathError, AdminDomainStoragePathResponse2, AdminDomainStorageResponse, AdminDomainTemplateTreeData, AdminDomainTemplateTreeError, AdminDomainTemplateTreeResponse, AdminDomainViewerDataData, AdminDomainViewerDataError, AdminDomainViewerDataResponse2, AdminDomainXmlCapabilitiesData, AdminDomainXmlCapabilitiesError, AdminDomainXmlCapabilitiesResponse2, AdminDomainXmlGetData, AdminDomainXmlGetError, AdminDomainXmlGetResponse, AdminDomainXmlSectionsGetData, AdminDomainXmlSectionsGetError, AdminDomainXmlSectionsGetResponse2, AdminDomainXmlSectionsParseData, AdminDomainXmlSectionsParseError, AdminDomainXmlSectionsParseResponse2, AdminDomainXmlSectionsSaveAsVirtInstallData, AdminDomainXmlSectionsSaveAsVirtInstallError, AdminDomainXmlSectionsSaveAsVirtInstallResponse, AdminDomainXmlSectionsSaveData2, AdminDomainXmlSectionsSaveError, AdminDomainXmlSectionsSaveResponse2, AdminDomainXmlUpdateData, AdminDomainXmlUpdateError, AdminDomainXmlUpdateResponse, AdminDownloadsActionData, AdminDownloadsActionError, AdminDownloadsActionIdData, AdminDownloadsActionIdError, AdminDownloadsActionIdResponse, AdminDownloadsActionResponse, AdminDownloadsData, AdminDownloadsError, AdminDownloadsKindData, AdminDownloadsKindError, AdminDownloadsKindResponse, AdminDownloadsRegisterData, AdminDownloadsRegisterError, AdminDownloadsRegisterResponse, AdminDownloadsResponse, AdminEchartDailyItemsData, AdminEchartDailyItemsError, AdminEchartDailyItemsResponse, AdminEchartData, AdminEchartError, AdminEchartResponse, AdminEditCsvUsersData, AdminEditCsvUsersError, AdminEditCsvUsersResponse, AdminEmitSocketioData, AdminEmitSocketioError, AdminEmitSocketioResponse, AdminFindStoragesByDomainStatusData, AdminFindStoragesByDomainStatusError, AdminFindStoragesByDomainStatusResponse, AdminForceDisclaimerData, AdminForceDisclaimerError, AdminForceDisclaimerResponse, AdminForceEmailData, AdminForceEmailError, AdminForceEmailResponse, AdminForcePasswordData, AdminForcePasswordError, AdminForcePasswordResponse, AdminGetBastionDomainData, AdminGetBastionDomainError, AdminGetBastionDomainResponse, AdminGetCategoryByNameData, AdminGetCategoryByNameError, AdminGetCategoryByNameResponse, AdminGetCategoryData, AdminGetCategoryError, AdminGetCategoryResponse, AdminGetCategoryUsersData, AdminGetCategoryUsersError, AdminGetCategoryUsersResponse, AdminGetGroupByNameCategoryData, AdminGetGroupByNameCategoryError, AdminGetGroupByNameCategoryResponse, AdminGetGroupData, AdminGetGroupError, AdminGetGroupResponse, AdminGetGroupUsersData, AdminGetGroupUsersError, AdminGetGroupUsersResponse, AdminGetJwtData, AdminGetJwtError, AdminGetJwtResponse, AdminGetMigrationExceptionsData, AdminGetMigrationExceptionsError, AdminGetMigrationExceptionsResponse, AdminGetNotificationData, AdminGetNotificationError, AdminGetNotificationResponse, AdminGetNotificationsDataByStatusData, AdminGetNotificationsDataByStatusError, AdminGetNotificationsDataByStatusResponse, AdminGetNotificationsGroupedByStatusData, AdminGetNotificationsGroupedByStatusError, AdminGetNotificationsGroupedByStatusResponse, AdminGetNotificationStatusesData, AdminGetNotificationStatusesError, AdminGetNotificationStatusesResponse, AdminGetNotificationTemplateData, AdminGetNotificationTemplateError, AdminGetNotificationTemplateResponse, AdminGetOldTasksConfigData, AdminGetOldTasksConfigError, AdminGetOldTasksConfigResponse, AdminGetOldTasksData, AdminGetOldTasksError, AdminGetOldTasksResponse, AdminGetPasswordPolicyData, AdminGetPasswordPolicyError, AdminGetPasswordPolicyResponse, AdminGetQuotaByKindData, AdminGetQuotaByKindError, AdminGetQuotaByKindItemData, AdminGetQuotaByKindItemError, AdminGetQuotaByKindItemResponse, AdminGetQuotaByKindResponse, AdminGetQuotasData, AdminGetQuotasError, AdminGetQuotasResponse, AdminGetRoleData, AdminGetRoleError, AdminGetRoleResponse, AdminGetRolesData, AdminGetRolesError, AdminGetRolesResponse, AdminGetSecretsData, AdminGetSecretsError, AdminGetSecretsResponse, AdminGetStorageSchedulerConfigData, AdminGetStorageSchedulerConfigError, AdminGetStorageSchedulerConfigResponse, AdminGetTemplatesData, AdminGetTemplatesError, AdminGetTemplatesResponse, AdminGetUserAppliedQuotaData, AdminGetUserAppliedQuotaError, AdminGetUserAppliedQuotaResponse, AdminGetUserByEmailCategoryData, AdminGetUserByEmailCategoryError, AdminGetUserByEmailCategoryResponse, AdminGetUserData, AdminGetUserDesktopsData, AdminGetUserDesktopsError, AdminGetUserDesktopsResponse, AdminGetUserError, AdminGetUserNotificationDisplaysData, AdminGetUserNotificationDisplaysError, AdminGetUserNotificationDisplaysResponse, AdminGetUserRawData, AdminGetUserRawError, AdminGetUserRawResponse, AdminGetUserResponse, AdminGetUserSchemaData, AdminGetUserSchemaError, AdminGetUserSchemaResponse, AdminGetUserTemplatesData, AdminGetUserTemplatesError, AdminGetUserTemplatesResponse, AdminGetUserVpnData, AdminGetUserVpnError, AdminGetUserVpnResponse, AdminGetUserVpnWithOsData, AdminGetUserVpnWithOsError, AdminGetUserVpnWithOsResponse, AdminGpuForceProfilePreviewData, AdminGpuForceProfilePreviewError, AdminGpuForceProfilePreviewResponse2, AdminGroupDeleteCheckData, AdminGroupDeleteCheckError, AdminGroupDeleteCheckResponse, AdminGroupEnrollmentData2, AdminGroupEnrollmentError, AdminGroupEnrollmentResponse2, AdminHypervisorBootProgressData, AdminHypervisorBootProgressError, AdminHypervisorBootProgressResponse, AdminHypervisorCreateData2, AdminHypervisorCreateError, AdminHypervisorCreateResponse2, AdminHypervisorDeleteData, AdminHypervisorDeleteError, AdminHypervisorDeleteResponse, AdminHypervisorDisksFoundData2, AdminHypervisorDisksFoundError, AdminHypervisorDisksFoundResponse, AdminHypervisorEnableData2, AdminHypervisorEnableError, AdminHypervisorEnableResponse2, AdminHypervisorGpuAppliedData, AdminHypervisorGpuAppliedError, AdminHypervisorGpuAppliedResponse, AdminHypervisorMediaDeleteData2, AdminHypervisorMediaDeleteError, AdminHypervisorMediaDeleteResponse, AdminHypervisorMediaFoundData2, AdminHypervisorMediaFoundError, AdminHypervisorMediaFoundResponse, AdminHypervisorMountpointsData, AdminHypervisorMountpointsError, AdminHypervisorMountpointsResponse, AdminHypervisorsListByStatusData, AdminHypervisorsListByStatusError, AdminHypervisorsListByStatusResponse, AdminHypervisorsListData, AdminHypervisorsListError, AdminHypervisorsListResponse, AdminHypervisorStartedDomainsData, AdminHypervisorStartedDomainsError, AdminHypervisorStartedDomainsResponse, AdminHypervisorStatusData, AdminHypervisorStatusError, AdminHypervisorStatusResponse2, AdminHypervisorStopDomainsData, AdminHypervisorStopDomainsError, AdminHypervisorStopDomainsResponse, AdminHypervisorVirtPoolsGetData, AdminHypervisorVirtPoolsGetError, AdminHypervisorVirtPoolsGetResponse, AdminHypervisorVirtPoolsUpdateData, AdminHypervisorVirtPoolsUpdateError, AdminHypervisorVirtPoolsUpdateResponse, AdminHypervisorVpnData, AdminHypervisorVpnError, AdminHypervisorVpnResponse2, AdminHypervisorWgAddrData2, AdminHypervisorWgAddrError, AdminHypervisorWgAddrResponse2, AdminImportCsvUsersData, AdminImportCsvUsersError, AdminImportCsvUsersResponse, AdminListCategoriesData, AdminListCategoriesError, AdminListCategoriesFrontendData, AdminListCategoriesFrontendError, AdminListCategoriesFrontendResponse, AdminListCategoriesNavData, AdminListCategoriesNavError, AdminListCategoriesNavResponse, AdminListCategoriesResponse, AdminListCustomNotificationTemplatesData, AdminListCustomNotificationTemplatesError, AdminListCustomNotificationTemplatesResponse, AdminListDomainsData2, AdminListDomainsError, AdminListDomainsResponse, AdminListGroupsData, AdminListGroupsError, AdminListGroupsNavData, AdminListGroupsNavError, AdminListGroupsNavResponse, AdminListGroupsResponse, AdminListNotificationActionsData, AdminListNotificationActionsError, AdminListNotificationActionsResponse, AdminListNotificationsData, AdminListNotificationsError, AdminListNotificationsResponse, AdminListNotificationTemplatesData, AdminListNotificationTemplatesError, AdminListNotificationTemplatesResponse, AdminListSystemNotificationTemplatesData, AdminListSystemNotificationTemplatesError, AdminListSystemNotificationTemplatesResponse, AdminListUsersData, AdminListUsersError, AdminListUsersNavData, AdminListUsersNavError, AdminListUsersNavResponse, AdminListUsersResponse, AdminLoginConfigByCategoryData, AdminLoginConfigByCategoryError, AdminLoginConfigByCategoryResponse, AdminLoginConfigGetData, AdminLoginConfigGetError, AdminLoginConfigGetResponse, AdminLoginNotificationCoverEnableData, AdminLoginNotificationCoverEnableError, AdminLoginNotificationCoverEnableResponse, AdminLoginNotificationFormEnableData, AdminLoginNotificationFormEnableError, AdminLoginNotificationFormEnableResponse, AdminLoginNotificationUpdateData, AdminLoginNotificationUpdateError, AdminLoginNotificationUpdateResponse, AdminLogsDesktopsActionData, AdminLogsDesktopsActionError, AdminLogsDesktopsActionResponse, AdminLogsDesktopsConfigData, AdminLogsDesktopsConfigError, AdminLogsDesktopsConfigResponse, AdminLogsDesktopsDeleteAllData, AdminLogsDesktopsDeleteAllError, AdminLogsDesktopsDeleteAllResponse, AdminLogsDesktopsDeleteData, AdminLogsDesktopsDeleteError, AdminLogsDesktopsDeleteResponse, AdminLogsDesktopsListData, AdminLogsDesktopsListError, AdminLogsDesktopsListResponse, AdminLogsDesktopsMaxTimeData, AdminLogsDesktopsMaxTimeError, AdminLogsDesktopsMaxTimeResponse, AdminLogsDesktopsRawData, AdminLogsDesktopsRawError, AdminLogsDesktopsRawResponse, AdminLogsDesktopsViewData, AdminLogsDesktopsViewError, AdminLogsDesktopsViewResponse, AdminLogsUsersActionData, AdminLogsUsersActionError, AdminLogsUsersActionResponse, AdminLogsUsersConfigData, AdminLogsUsersConfigError, AdminLogsUsersConfigResponse, AdminLogsUsersDeleteAllData, AdminLogsUsersDeleteAllError, AdminLogsUsersDeleteAllResponse, AdminLogsUsersDeleteData, AdminLogsUsersDeleteError, AdminLogsUsersDeleteResponse, AdminLogsUsersListData, AdminLogsUsersListError, AdminLogsUsersListResponse, AdminLogsUsersMaxTimeData, AdminLogsUsersMaxTimeError, AdminLogsUsersMaxTimeResponse, AdminLogsUsersRawData, AdminLogsUsersRawError, AdminLogsUsersRawResponse, AdminLogsUsersViewData, AdminLogsUsersViewError, AdminLogsUsersViewResponse, AdminMediaByStatusData, AdminMediaByStatusError, AdminMediaByStatusResponse, AdminMediaDomainsData, AdminMediaDomainsError, AdminMediaDomainsResponse, AdminMediaListData, AdminMediaListError, AdminMediaListResponse, AdminMediaStatusData, AdminMediaStatusError, AdminMediaStatusResponse, AdminMigrateUserData, AdminMigrateUserDeploymentsData, AdminMigrateUserDeploymentsError, AdminMigrateUserDeploymentsResponse, AdminMigrateUserDesktopsData, AdminMigrateUserDesktopsError, AdminMigrateUserDesktopsResponse, AdminMigrateUserError, AdminMigrateUserMediaData, AdminMigrateUserMediaError, AdminMigrateUserMediaResponse, AdminMigrateUserResponse, AdminMigrateUserTemplatesData, AdminMigrateUserTemplatesError, AdminMigrateUserTemplatesResponse, AdminMultipleActionsData2, AdminMultipleActionsError, AdminMultipleActionsResponse, AdminNotifyDesktopData, AdminNotifyDesktopError, AdminNotifyDesktopQueueData, AdminNotifyDesktopQueueError, AdminNotifyDesktopQueueResponse, AdminNotifyDesktopResponse, AdminNotifyUserDesktopData, AdminNotifyUserDesktopError, AdminNotifyUserDesktopResponse, AdminOperationsHypervisorsData, AdminOperationsHypervisorsError, AdminOperationsHypervisorsResponse, AdminOperationsHypervisorStartData, AdminOperationsHypervisorStartError, AdminOperationsHypervisorStartResponse, AdminOperationsHypervisorStopData, AdminOperationsHypervisorStopError, AdminOperationsHypervisorStopResponse, AdminOrchestratorConfigData, AdminOrchestratorConfigError, AdminOrchestratorConfigResponse, AdminOrchestratorConfigUpdateData, AdminOrchestratorConfigUpdateError, AdminOrchestratorConfigUpdateResponse, AdminOrchestratorDeadRowResetData, AdminOrchestratorDeadRowResetError, AdminOrchestratorDeadRowResetResponse, AdminOrchestratorDeadRowSetData, AdminOrchestratorDeadRowSetError, AdminOrchestratorDeadRowSetResponse, AdminOrchestratorHypervisorGetData, AdminOrchestratorHypervisorGetError, AdminOrchestratorHypervisorGetResponse, AdminOrchestratorHypervisorsListData, AdminOrchestratorHypervisorsListError, AdminOrchestratorHypervisorsListResponse, AdminOrchestratorManagedListData, AdminOrchestratorManagedListError, AdminOrchestratorManagedListResponse, AdminOrchestratorManageSetData, AdminOrchestratorManageSetError, AdminOrchestratorManageSetResponse, AdminOrchestratorManageUnsetData, AdminOrchestratorManageUnsetError, AdminOrchestratorManageUnsetResponse, AdminOrchestratorOnlyForcedSetData, AdminOrchestratorOnlyForcedSetError, AdminOrchestratorOnlyForcedSetResponse, AdminOrchestratorStopDesktopsData, AdminOrchestratorStopDesktopsError, AdminOrchestratorStopDesktopsResponse, AdminPreviewNotificationTemplateData, AdminPreviewNotificationTemplateError, AdminPreviewNotificationTemplateResponse, AdminQosDiskAddData, AdminQosDiskAddError, AdminQosDiskAddResponse, AdminQosDiskUpdateData, AdminQosDiskUpdateError, AdminQosDiskUpdateResponse, AdminQueuesBacklogData, AdminQueuesBacklogError, AdminQueuesBacklogResponse, AdminQueuesConsumersData, AdminQueuesConsumersError, AdminQueuesConsumersResponse, AdminQueuesGovernorData, AdminQueuesGovernorError, AdminQueuesGovernorResponse, AdminQueuesJobsData, AdminQueuesJobsError, AdminQueuesJobsResponse, AdminQueuesLaneHealthData, AdminQueuesLaneHealthError, AdminQueuesLaneHealthResponse, AdminQueuesProblemTasksData, AdminQueuesProblemTasksError, AdminQueuesProblemTasksResponse, AdminRegisterVlansData, AdminRegisterVlansError, AdminRegisterVlansResponse, AdminRemoteVpnData, AdminRemoteVpnError, AdminRemoteVpnResponse, AdminRemoteVpnWithOsData, AdminRemoteVpnWithOsError, AdminRemoteVpnWithOsResponse, AdminResetPasswordData, AdminResetPasswordError, AdminResetPasswordResponse, AdminResetVpnData, AdminResetVpnError, AdminResetVpnResponse, AdminSchedulerJobsBookingsData, AdminSchedulerJobsBookingsError, AdminSchedulerJobsBookingsResponse, AdminSchedulerJobsSystemData, AdminSchedulerJobsSystemError, AdminSchedulerJobsSystemResponse, AdminSearchUsersData, AdminSearchUsersError, AdminSearchUsersResponse, AdminSecondaryGroupsAddData, AdminSecondaryGroupsAddError, AdminSecondaryGroupsAddResponse, AdminSecondaryGroupsDeleteData, AdminSecondaryGroupsDeleteError, AdminSecondaryGroupsDeleteResponse, AdminSecondaryGroupsOverwriteData, AdminSecondaryGroupsOverwriteError, AdminSecondaryGroupsOverwriteResponse, AdminSetOldTasksEnabledData, AdminSetOldTasksEnabledError, AdminSetOldTasksEnabledResponse, AdminSetOldTasksMaxTimeData, AdminSetOldTasksMaxTimeError, AdminSetOldTasksMaxTimeResponse, AdminSetOldTasksQueueRegistriesData, AdminSetOldTasksQueueRegistriesError, AdminSetOldTasksQueueRegistriesResponse, AdminSetStorageSchedulerConfigData, AdminSetStorageSchedulerConfigError, AdminSetStorageSchedulerConfigResponse, AdminSmtpEnabledGetData, AdminSmtpEnabledGetError, AdminSmtpEnabledGetResponse, AdminSmtpGetData, AdminSmtpGetError, AdminSmtpGetResponse, AdminSmtpPutData, AdminSmtpPutError, AdminSmtpPutResponse, AdminSmtpTestPostData, AdminSmtpTestPostError, AdminSmtpTestPostResponse, AdminStorageByRoleData, AdminStorageByRoleError, AdminStorageByRoleResponse, AdminStorageByStatusData, AdminStorageByStatusError, AdminStorageByStatusFilteredData, AdminStorageByStatusFilteredError, AdminStorageByStatusFilteredResponse, AdminStorageByStatusResponse, AdminStorageDeleteData, AdminStorageDeleteError, AdminStorageDeleteResponse, AdminStorageDomainsData, AdminStorageDomainsError, AdminStorageDomainsResponse, AdminStorageInfoData, AdminStorageInfoError, AdminStorageInfoResponse, AdminStorageListData, AdminStorageListError, AdminStorageListFilteredData, AdminStorageListFilteredError, AdminStorageListFilteredResponse, AdminStorageListResponse, AdminStorageMigrationActionData, AdminStorageMigrationActionError, AdminStorageMigrationActionResponse, AdminStorageMigrationConfigData, AdminStorageMigrationConfigError, AdminStorageMigrationConfigResponse, AdminStorageMigrationCreateData, AdminStorageMigrationCreateError, AdminStorageMigrationCreateResponse, AdminStorageMigrationListData, AdminStorageMigrationListError, AdminStorageMigrationListResponse, AdminStorageMigrationLogData, AdminStorageMigrationLogError, AdminStorageMigrationPathPrefixesData, AdminStorageMigrationPathPrefixesError, AdminStorageMigrationPathPrefixesResponse, AdminStorageMigrationPlanData, AdminStorageMigrationPlanError, AdminStorageMigrationPlanResponse, AdminStorageMigrationStatusData, AdminStorageMigrationStatusError, AdminStorageMigrationStatusResponse, AdminStoragePoolMigrationPlanData, AdminStoragePoolMigrationPlanError, AdminStoragePoolMigrationPlanResponse, AdminStorageRefreshRunningSizesData, AdminStorageRefreshRunningSizesError, AdminStorageRefreshRunningSizesResponse, AdminStorageSearchInfoData, AdminStorageSearchInfoError, AdminStorageSearchInfoResponse, AdminStorageStatusData, AdminStorageStatusError, AdminStorageStatusResponse, AdminSystemLogoGetData, AdminSystemLogoGetError, AdminSystemLogoGetResponse, AdminSystemLogoPutData, AdminSystemLogoPutError, AdminSystemLogoPutResponse, AdminTableDeleteData, AdminTableDeleteError, AdminTableDeleteResponse, AdminTableGetData, AdminTableGetError, AdminTableGetResponse, AdminTableInsertData, AdminTableInsertError, AdminTableInsertResponse, AdminTableListData, AdminTableListError, AdminTableListResponse, AdminTableUpdateData, AdminTableUpdateError, AdminTableUpdateResponse, AdminTemplateDeleteData, AdminTemplateDeleteError, AdminTemplateDeleteResponse, AdminUpdateBastionDomainData, AdminUpdateBastionDomainError, AdminUpdateBastionDomainResponse, AdminUpdateCategoryData, AdminUpdateCategoryError, AdminUpdateCategoryLimitsData, AdminUpdateCategoryLimitsError, AdminUpdateCategoryLimitsResponse, AdminUpdateCategoryQuotaData, AdminUpdateCategoryQuotaError, AdminUpdateCategoryQuotaResponse, AdminUpdateCategoryResponse, AdminUpdateGroupData, AdminUpdateGroupError, AdminUpdateGroupLimitsData, AdminUpdateGroupLimitsError, AdminUpdateGroupLimitsResponse, AdminUpdateGroupQuotaData, AdminUpdateGroupQuotaError, AdminUpdateGroupQuotaResponse, AdminUpdateGroupResponse, AdminUpdateNotificationData, AdminUpdateNotificationError, AdminUpdateNotificationResponse, AdminUpdateNotificationTemplateData, AdminUpdateNotificationTemplateError, AdminUpdateNotificationTemplateResponse, AdminUpdateRoleData, AdminUpdateRoleError, AdminUpdateRoleResponse, AdminUpdateUserData, AdminUpdateUserError, AdminUpdateUserResponse, AdminUpdateUsersBulkData, AdminUpdateUsersBulkError, AdminUpdateUsersBulkResponse, AdminUsageAllCreditsData, AdminUsageAllCreditsError, AdminUsageAllCreditsResponse, AdminUsageCheckOverlappingData, AdminUsageCheckOverlappingError, AdminUsageCheckOverlappingResponse, AdminUsageConsolidateData, AdminUsageConsolidateError, AdminUsageConsolidateItemData, AdminUsageConsolidateItemDaysData, AdminUsageConsolidateItemDaysError, AdminUsageConsolidateItemDaysResponse, AdminUsageConsolidateItemError, AdminUsageConsolidateItemResponse, AdminUsageConsolidateResponse, AdminUsageConsumersCountData, AdminUsageConsumersCountError, AdminUsageConsumersCountResponse, AdminUsageConsumersData, AdminUsageConsumersError, AdminUsageConsumersResponse, AdminUsageConsumptionData, AdminUsageConsumptionError, AdminUsageConsumptionResponse, AdminUsageCreditsAddData, AdminUsageCreditsAddError, AdminUsageCreditsAddResponse, AdminUsageCreditsByIdData, AdminUsageCreditsByIdError, AdminUsageCreditsByIdResponse, AdminUsageCreditsData, AdminUsageCreditsDeleteData, AdminUsageCreditsDeleteError, AdminUsageCreditsDeleteResponse, AdminUsageCreditsError, AdminUsageCreditsResponse, AdminUsageCreditsUpdateData, AdminUsageCreditsUpdateError, AdminUsageCreditsUpdateResponse, AdminUsageDeleteConsumptionDataData, AdminUsageDeleteConsumptionDataError, AdminUsageDeleteConsumptionDataResponse, AdminUsageDistinctItemsData, AdminUsageDistinctItemsError, AdminUsageDistinctItemsResponse, AdminUsageGroupingGetData, AdminUsageGroupingGetError, AdminUsageGroupingGetResponse, AdminUsageGroupingsAddData, AdminUsageGroupingsAddError, AdminUsageGroupingsAddResponse, AdminUsageGroupingsDeleteData, AdminUsageGroupingsDeleteError, AdminUsageGroupingsDeleteResponse, AdminUsageGroupingsDropdownData, AdminUsageGroupingsDropdownError, AdminUsageGroupingsDropdownResponse, AdminUsageGroupingsListData, AdminUsageGroupingsListError, AdminUsageGroupingsListResponse, AdminUsageGroupingsUpdateData, AdminUsageGroupingsUpdateError, AdminUsageGroupingsUpdateResponse, AdminUsageLimitsAddData, AdminUsageLimitsAddError, AdminUsageLimitsAddResponse, AdminUsageLimitsDeleteData, AdminUsageLimitsDeleteError, AdminUsageLimitsDeleteResponse, AdminUsageLimitsListData, AdminUsageLimitsListError, AdminUsageLimitsListResponse, AdminUsageLimitsUpdateData, AdminUsageLimitsUpdateError, AdminUsageLimitsUpdateResponse, AdminUsageListParametersData, AdminUsageListParametersError, AdminUsageListParametersResponse, AdminUsageParametersAddData, AdminUsageParametersAddError, AdminUsageParametersAddResponse, AdminUsageParametersDeleteData, AdminUsageParametersDeleteError, AdminUsageParametersDeleteResponse, AdminUsageParametersListData, AdminUsageParametersListError, AdminUsageParametersListResponse, AdminUsageParametersUpdateData, AdminUsageParametersUpdateError, AdminUsageParametersUpdateResponse, AdminUsageResetDatesAddData, AdminUsageResetDatesAddError, AdminUsageResetDatesAddResponse, AdminUsageResetDatesAllData, AdminUsageResetDatesAllError, AdminUsageResetDatesAllResponse, AdminUsageResetDatesRangeData, AdminUsageResetDatesRangeError, AdminUsageResetDatesRangeResponse, AdminUsageRetentionGetData, AdminUsageRetentionGetError, AdminUsageRetentionGetResponse, AdminUsageRetentionUpdateData, AdminUsageRetentionUpdateError, AdminUsageRetentionUpdateResponse, AdminUsageStartEndData, AdminUsageStartEndError, AdminUsageStartEndResponse, AdminUsageUnifyItemNameData, AdminUsageUnifyItemNameError, AdminUsageUnifyItemNameResponse, AdminUserDeleteCheckData, AdminUserDeleteCheckError, AdminUserDeleteCheckResponse, AdminUserExistsData, AdminUserExistsError, AdminUserExistsResponse, AdminUserLogoutData, AdminUserLogoutError, AdminUserLogoutResponse, AdminUserStorageAddData, AdminUserStorageAddError, AdminUserStorageAddResponse, AdminUserStorageAutoRegisterData, AdminUserStorageAutoRegisterError, AdminUserStorageAutoRegisterResponse, AdminUserStorageGetData, AdminUserStorageGetError, AdminUserStorageGetResponse, AdminUserStorageListData, AdminUserStorageListError, AdminUserStorageListResponse, AdminUserStorageLoginAuthData, AdminUserStorageLoginAuthError, AdminUserStorageLoginAuthResponse, AdminUserStorageRemoveData, AdminUserStorageRemoveError, AdminUserStorageRemoveResponse, AdminUserStorageResetAllData, AdminUserStorageResetAllError, AdminUserStorageResetAllResponse, AdminUserStorageResetData, AdminUserStorageResetError, AdminUserStorageResetResponse, AdminUserStorageSyncData, AdminUserStorageSyncError, AdminUserStorageSyncResponse, AdminUserStorageTestData, AdminUserStorageTestError, AdminUserStorageTestResponse, AdminUserStorageUsersData, AdminUserStorageUsersError, AdminUserStorageUsersResponse, AdminValidateCsvUsersData, AdminValidateCsvUsersEditData, AdminValidateCsvUsersEditError, AdminValidateCsvUsersEditResponse, AdminValidateCsvUsersError, AdminValidateCsvUsersResponse, AdminViewersConfigData, AdminViewersConfigError, AdminViewersConfigResetData, AdminViewersConfigResetError, AdminViewersConfigResetResponse, AdminViewersConfigResponse, AdminViewersConfigUpdateData, AdminViewersConfigUpdateError, AdminViewersConfigUpdateResponse, AdminVirtInstallXmlSectionsGetData, AdminVirtInstallXmlSectionsGetError, AdminVirtInstallXmlSectionsGetResponse, AdminVirtInstallXmlSectionsSaveData, AdminVirtInstallXmlSectionsSaveError, AdminVirtInstallXmlSectionsSaveResponse2, AllowedsTableTermData, AllowedsTableTermError, AllowedsTableTermResponse, AllowedTableData, AllowedTableError, AllowedTableResponse2, AnalyticsDesktopsLessUsedData, AnalyticsDesktopsLessUsedError, AnalyticsDesktopsLessUsedResponse, AnalyticsDesktopsMostUsedData, AnalyticsDesktopsMostUsedError, AnalyticsDesktopsMostUsedResponse, AnalyticsDesktopsRecentlyUsedData, AnalyticsDesktopsRecentlyUsedError, AnalyticsDesktopsRecentlyUsedResponse, AnalyticsGraphConfAddData, AnalyticsGraphConfAddError, AnalyticsGraphConfAddResponse, AnalyticsGraphConfDeleteData, AnalyticsGraphConfDeleteError, AnalyticsGraphConfDeleteResponse, AnalyticsGraphConfGetData, AnalyticsGraphConfGetError, AnalyticsGraphConfGetResponse, AnalyticsGraphConfUpdateData, AnalyticsGraphConfUpdateError, AnalyticsGraphConfUpdateResponse, AnalyticsGraphsConfListData, AnalyticsGraphsConfListError, AnalyticsGraphsConfListResponse, AnalyticsResourceCountData, AnalyticsResourceCountError, AnalyticsResourceCountResponse, AnalyticsStorageData, AnalyticsStorageError, AnalyticsStorageResponse, AnalyticsSuggestedRemovalsData, AnalyticsSuggestedRemovalsError, AnalyticsSuggestedRemovalsResponse, ApiV4CategoriesData, ApiV4CategoriesError, ApiV4CategoriesResponse, ApiV4CategoryCustomUrlData, ApiV4CategoryCustomUrlError, ApiV4CategoryCustomUrlResponse, ApiV4CategoryData, ApiV4CategoryError, ApiV4CategoryResponse, ApiV4DisclaimerData, ApiV4DisclaimerError, ApiV4DisclaimerResponse, ApiV4LoginConfigData, ApiV4LoginConfigError, ApiV4LoginConfigResponse, ApiVersionData, ApiVersionResponse, BatchCheckBackingChainByStatusData, BatchCheckBackingChainByStatusError, BatchCheckBackingChainByStatusResponse, BatchCheckBackingChainData, BatchCheckBackingChainError, BatchCheckBackingChainResponse, BatchFindStoragesByStatusData, BatchFindStoragesByStatusError, BatchFindStoragesByStatusResponse, BatchFindStoragesData, BatchFindStoragesError, BatchFindStoragesResponse, BatchSparsifyStoragesByStatusData, BatchSparsifyStoragesByStatusError, BatchSparsifyStoragesByStatusResponse, BatchSparsifyStoragesData, BatchSparsifyStoragesError, BatchSparsifyStoragesResponse, BookingProvisioningData, BookingProvisioningError, BookingProvisioningResponse, BulkCreatePersistentDesktopsData, BulkCreatePersistentDesktopsError, BulkCreatePersistentDesktopsResponse, BulkDeleteDeploymentsData, BulkDeleteDeploymentsError, BulkDeleteDeploymentsResponse, BulkDeleteRecycleBinData, BulkDeleteRecycleBinError, BulkDeleteRecycleBinResponse, BulkEditDesktopsData, BulkEditDesktopsError, BulkEditDesktopsResponse, BulkRestoreRecycleBinData, BulkRestoreRecycleBinError, BulkRestoreRecycleBinResponse, CancelTaskData, CancelTaskError, CancelTaskResponse, ChangeDeploymentOwnerData, ChangeDeploymentOwnerError, ChangeDeploymentOwnerResponse, ChangeDesktopOwnerData, ChangeDesktopOwnerError, ChangeDesktopOwnerResponse, ChangeMediaOwnerData, ChangeMediaOwnerError, ChangeMediaOwnerResponse, ChangeTemplateOwnerData, ChangeTemplateOwnerError, ChangeTemplateOwnerResponse, CheckCategoryStoragePoolAvailabilityData, CheckCategoryStoragePoolAvailabilityError, CheckCategoryStoragePoolAvailabilityResponse, CheckDeploymentQuotaGetData, CheckDeploymentQuotaGetError, CheckDeploymentQuotaGetResponse, CheckDeploymentQuotaPostData, CheckDeploymentQuotaPostError, CheckDeploymentQuotaPostResponse, CheckIntegrityData, CheckIntegrityError, CheckIntegrityResponse, CheckLastItemData, CheckLastItemError, CheckLastItemResponse, CheckLastSubitemData, CheckLastSubitemError, CheckLastSubitemResponse, CheckMediaData, CheckMediaError, CheckMediaResponse, CheckQuotaNewDeploymentData, CheckQuotaNewDeploymentError, CheckQuotaNewDeploymentResponse, CheckQuotaNewDesktopData, CheckQuotaNewDesktopError, CheckQuotaNewDesktopResponse, CheckQuotaNewMediaData, CheckQuotaNewMediaError, CheckQuotaNewMediaResponse, CheckQuotaNewTemplateData, CheckQuotaNewTemplateError, CheckQuotaNewTemplateResponse, CheckQuotaNewVolatileDesktopData, CheckQuotaNewVolatileDesktopError, CheckQuotaNewVolatileDesktopResponse, CheckStorageBackingChainData, CheckStorageBackingChainError, CheckStorageBackingChainResponse, CheckStoragePoolAvailabilityCompatData, CheckStoragePoolAvailabilityCompatError, CheckStoragePoolAvailabilityCompatResponse, CheckStoragePoolCreationAvailabilityData, CheckStoragePoolCreationAvailabilityError, CheckStoragePoolCreationAvailabilityResponse, ConvertStorageData, ConvertStorageError, ConvertStorageResponse, ConvertTemplateToDesktopData, ConvertTemplateToDesktopError, ConvertTemplateToDesktopResponse, CountRecreateDeploymentDesktopsData, CountRecreateDeploymentDesktopsError, CountRecreateDeploymentDesktopsResponse, CreateBookingEventData, CreateBookingEventError, CreateBookingEventResponse, CreateDeploymentData, CreateDeploymentError, CreateDeploymentResponse, CreateDesktopData, CreateDesktopError, CreateDesktopFromMediaData, CreateDesktopFromMediaError, CreateDesktopFromMediaResponse, CreateDesktopResponse, CreateMediaData, CreateMediaError, CreateMediaResponse, CreateNonpersistentDesktopData, CreateNonpersistentDesktopError, CreateNonpersistentDesktopResponse, CreatePlanData, CreatePlanError, CreatePlanningData, CreatePlanningError, CreatePlanningResponse, CreatePlanResponse, CreateStorageData, CreateStorageError, CreateStoragePoolData, CreateStoragePoolError, CreateStoragePoolResponse, CreateStorageResponse, CreateTemplateData, CreateTemplateError, CreateTemplateResponse, CreateUnusedItemTimeoutRuleData, CreateUnusedItemTimeoutRuleError, CreateUnusedItemTimeoutRuleResponse, DeleteBookingEventData, DeleteBookingEventError, DeleteBookingEventResponse, DeleteCutoffTimeSurpassedData, DeleteCutoffTimeSurpassedError, DeleteCutoffTimeSurpassedResponse, DeleteDeploymentData, DeleteDeploymentError, DeleteDeploymentResponse, DeleteDesktopData, DeleteDesktopError, DeleteDesktopResponse, DeleteExpiredUserNotificationsDataData, DeleteExpiredUserNotificationsDataError, DeleteExpiredUserNotificationsDataResponse, DeleteMediaData, DeleteMediaError, DeleteMediaResponse, DeleteMigrationData, DeleteMigrationError, DeleteMigrationResponse, DeleteOldEntriesData, DeleteOldEntriesError, DeleteOldEntriesResponse, DeletePlanData, DeletePlanError, DeletePlanningData, DeletePlanningError, DeletePlanningResponse, DeletePlanResponse, DeletePriorityData, DeletePriorityError, DeletePriorityResponse, DeleteRecycleBinEntryData, DeleteRecycleBinEntryError, DeleteRecycleBinEntryResponse, DeleteReservableItemData, DeleteReservableItemError, DeleteReservableItemResponse, DeleteStorageData, DeleteStorageError, DeleteStoragePathData, DeleteStoragePathError, DeleteStoragePathResponse, DeleteStoragePoolData, DeleteStoragePoolError, DeleteStoragePoolResponse, DeleteStorageResponse, DeleteTemplateData, DeleteTemplateError, DeleteTemplateResponse, DeleteUnusedItemTimeoutRuleData, DeleteUnusedItemTimeoutRuleError, DeleteUnusedItemTimeoutRuleResponse, DeleteUserBastionSshKeyData, DeleteUserBastionSshKeyError, DeleteUserBastionSshKeyResponse, DeleteUserData, DeleteUserDeploymentDesktopsData, DeleteUserDeploymentDesktopsError, DeleteUserDeploymentDesktopsResponse, DeleteUserError, DeleteUserResponse, DisconnectStorageData, DisconnectStorageError, DisconnectStorageResponse, DuplicateTemplateData, DuplicateTemplateError, DuplicateTemplateResponse, EditDeploymentData, EditDeploymentError, EditDeploymentResponse, EditDeploymentUsersData, EditDeploymentUsersError, EditDeploymentUsersResponse, EditDesktopData, EditDesktopError, EditDesktopResponse, EditProviderConfigRouteData, EditProviderConfigRouteError, EditProviderConfigRouteResponse, EmptyBookingPlanData, EmptyBookingPlanError, EmptyBookingPlanResponse, EmptyRecycleBinData, EmptyRecycleBinError, EmptyRecycleBinResponse, EnableCategoryLoginNotificationData, EnableCategoryLoginNotificationError, EnableCategoryLoginNotificationResponse, EnableReservableSubitemData, EnableReservableSubitemError, EnableReservableSubitemResponse, ExpireUserApiKeyData, ExpireUserApiKeyError, ExpireUserApiKeyResponse, ExtendDesktopTimeoutData, ExtendDesktopTimeoutError, ExtendDesktopTimeoutResponse, FindStorageData, FindStorageError, FindStorageResponse, ForceStopDesktopData, ForceStopDesktopError, ForceStopDesktopResponse, GenerateDefaultCardData, GenerateDefaultCardError, GenerateDefaultCardResponse, GetActualPlanData, GetActualPlanError, GetActualPlanResponse, GetAdminBastionConfigData, GetAdminBastionConfigError, GetAdminBastionConfigResponse, GetAdminTasksData, GetAdminTasksError, GetAdminTasksResponse, GetAllBookingsData, GetAllBookingsError, GetAllBookingsResponse, GetAllDeploymentsData, GetAllDeploymentsError, GetAllDeploymentsResponse, GetAllDesktopsData, GetAllDesktopsError, GetAllDesktopsResponse, GetAllGroupsData, GetAllGroupsError, GetAllGroupsResponse, GetAllMigrationsData, GetAllMigrationsError, GetAllMigrationsResponse, GetAllowedHardwareData, GetAllowedHardwareError, GetAllowedHardwareForDomainData, GetAllowedHardwareForDomainError, GetAllowedHardwareForDomainResponse, GetAllowedHardwareResponse, GetAllSharedDeploymentsData, GetAllSharedDeploymentsError, GetAllSharedDeploymentsResponse, GetAllUnusedItemTimeoutRulesData, GetAllUnusedItemTimeoutRulesError, GetAllUnusedItemTimeoutRulesResponse, GetAllUsersData, GetAllUsersError, GetAllUsersResponse, GetAvailableGroupsForCategoryData, GetAvailableGroupsForCategoryError, GetAvailableGroupsForCategoryResponse, GetBastionAllowedData, GetBastionAllowedError, GetBastionAllowedResponse, GetBastionDomainVerificationConfigData, GetBastionDomainVerificationConfigError, GetBastionDomainVerificationConfigResponse, GetBastionTargetsData, GetBastionTargetsError, GetBastionTargetsResponse, GetBookingDeploymentData, GetBookingDeploymentError, GetBookingDeploymentResponse, GetBookingDesktopData, GetBookingDesktopError, GetBookingDesktopResponse, GetBookingPlansData, GetBookingPlansError, GetBookingPlansResponse, GetBookingPriorityDeploymentData, GetBookingPriorityDeploymentError, GetBookingPriorityDeploymentResponse, GetBookingPriorityDesktopData, GetBookingPriorityDesktopError, GetBookingPriorityDesktopResponse, GetBookingReservablesAvailableData, GetBookingReservablesAvailableError, GetBookingReservablesAvailableResponse, GetCategoryAuthenticationData, GetCategoryAuthenticationError, GetCategoryAuthenticationResponse, GetCategoryBrandingData, GetCategoryBrandingError, GetCategoryBrandingResponse, GetCategoryLogoCollapsedData, GetCategoryLogoCollapsedError, GetCategoryLogoData, GetCategoryLogoError, GetCategoryMaintenanceData, GetCategoryMaintenanceError, GetCategoryMaintenanceResponse, GetDefaultStoragePoolData, GetDefaultStoragePoolError, GetDefaultStoragePoolResponse, GetDeleteActionData, GetDeleteActionError, GetDeleteActionResponse, GetDeploymentAllowedData, GetDeploymentAllowedError, GetDeploymentAllowedResponse, GetDeploymentBastionCsvData, GetDeploymentBastionCsvError, GetDeploymentBastionData, GetDeploymentBastionError, GetDeploymentBastionResponse, GetDeploymentCoOwnersData, GetDeploymentCoOwnersError, GetDeploymentCoOwnersResponse, GetDeploymentCsvData, GetDeploymentCsvError, GetDeploymentData, GetDeploymentDesktopBastionData, GetDeploymentDesktopBastionError, GetDeploymentDesktopBastionResponse, GetDeploymentError, GetDeploymentHardwareData, GetDeploymentHardwareError, GetDeploymentHardwareResponse, GetDeploymentInfoData, GetDeploymentInfoError, GetDeploymentInfoResponse, GetDeploymentPermissionsData, GetDeploymentPermissionsError, GetDeploymentPermissionsResponse, GetDeploymentResponse, GetDeploymentUserDesktopsData, GetDeploymentUserDesktopsDetailData, GetDeploymentUserDesktopsDetailError, GetDeploymentUserDesktopsDetailResponse, GetDeploymentUserDesktopsError, GetDeploymentUserDesktopsResponse, GetDeploymentVideowallData, GetDeploymentVideowallError, GetDeploymentVideowallResponse, GetDesktopBastionActiveData, GetDesktopBastionActiveError, GetDesktopBastionActiveResponse, GetDesktopBastionData, GetDesktopBastionError, GetDesktopBastionLegacyData, GetDesktopBastionLegacyError, GetDesktopBastionLegacyResponse, GetDesktopBastionResponse, GetDesktopCardImagesData, GetDesktopCardImagesError, GetDesktopCardImagesResponse, GetDesktopData, GetDesktopDetailsData, GetDesktopDetailsError, GetDesktopDetailsFromTokenData, GetDesktopDetailsFromTokenError, GetDesktopDetailsFromTokenResponse, GetDesktopDetailsResponse, GetDesktopError, GetDesktopImagesByTypeData, GetDesktopImagesByTypeError, GetDesktopImagesByTypeResponse, GetDesktopImagesData, GetDesktopImagesError, GetDesktopImagesResponse, GetDesktopInfoData, GetDesktopInfoError, GetDesktopInfoResponse, GetDesktopNetworksData, GetDesktopNetworksError, GetDesktopNetworksResponse, GetDesktopResponse, GetDesktopViewerByTokenData, GetDesktopViewerByTokenError, GetDesktopViewerByTokenResponse, GetDesktopViewerByTypeData, GetDesktopViewerByTypeError, GetDesktopViewerByTypeResponse, GetDisclaimerData, GetDisclaimerError, GetDisclaimerResponse, GetDomainsAllowedReservablesData, GetDomainsAllowedReservablesError, GetDomainsAllowedReservablesResponse, GetGpuBookingsForecastData, GetGpuBookingsForecastError, GetGpuBookingsForecastResponse, GetHardwareKindAllowedData, GetHardwareKindAllowedError, GetHardwareKindAllowedResponse, GetItemAvailabilityData, GetItemAvailabilityError, GetItemAvailabilityResponse, GetItemPlanningsData, GetItemPlanningsError, GetItemPlanningsResponse, GetItemPlansData, GetItemPlansError, GetItemPlansResponse, GetLoginConfigByCategoryData, GetLoginConfigByCategoryError, GetLoginConfigByCategoryResponse, GetLogoCollapsedData, GetLogoCollapsedError, GetLogoData, GetLogoError, GetMaintenanceData, GetMaintenanceError, GetMaintenanceResponse, GetMaintenanceTextData, GetMaintenanceTextError, GetMaintenanceTextFrontendData, GetMaintenanceTextFrontendError, GetMaintenanceTextFrontendResponse, GetMaintenanceTextResponse, GetMaxBookingDateData, GetMaxBookingDateError, GetMaxBookingDateResponse, GetMediaAllowedTableData, GetMediaAllowedTableError, GetMediaAllowedTableResponse, GetMediaData, GetMediaDesktopsData, GetMediaDesktopsError, GetMediaDesktopsResponse, GetMediaError, GetMediaInstallsData, GetMediaInstallsError, GetMediaInstallsResponse, GetMediaResponse, GetMediaTasksData, GetMediaTasksError, GetMediaTasksResponse, GetMigrationConfigData, GetMigrationConfigError, GetMigrationConfigResponse, GetNetworksFromTokenData, GetNetworksFromTokenError, GetNetworksFromTokenResponse, GetOldEntriesConfigData, GetOldEntriesConfigError, GetOldEntriesConfigResponse, GetPlanBookingsData, GetPlanBookingsError, GetPlanBookingsResponse, GetProviderConfigRouteData, GetProviderConfigRouteError, GetProviderConfigRouteResponse, GetProviderExportEnabledData, GetProviderExportEnabledError, GetProviderExportEnabledResponse, GetProviderImportEnabledData, GetProviderImportEnabledError, GetProviderImportEnabledResponse, GetQcow2GeometryData, GetQcow2GeometryError, GetQcow2GeometryResponse, GetQueuesHealthData, GetQueuesHealthError, GetQueuesHealthResponse, GetRecycleBinAdminEntriesData, GetRecycleBinAdminEntriesError, GetRecycleBinAdminEntriesResponse, GetRecycleBinCountData, GetRecycleBinCountError, GetRecycleBinCountResponse, GetRecycleBinCutoffTimeData, GetRecycleBinCutoffTimeError, GetRecycleBinCutoffTimeResponse, GetRecycleBinData, GetRecycleBinDefaultDeleteConfigData, GetRecycleBinDefaultDeleteConfigError, GetRecycleBinDefaultDeleteConfigResponse, GetRecycleBinError, GetRecycleBinItemCountUserData, GetRecycleBinItemCountUserError, GetRecycleBinItemCountUserResponse, GetRecycleBinResponse, GetRecycleBinStatusData, GetRecycleBinStatusError, GetRecycleBinStatusResponse, GetReservableItemsData, GetReservableItemsError, GetReservableItemsResponse, GetReservablesAvailableData, GetReservablesAvailableError, GetReservablesAvailableResponse, GetReservablesData, GetReservablesError, GetReservablesResponse, GetShareLinkData, GetShareLinkError, GetShareLinkResponse, GetStatusBarNotificationsData, GetStatusBarNotificationsError, GetStatusBarNotificationsResponse, GetStockDefaultCardData, GetStockDefaultCardError, GetStockDefaultCardResponse, GetStorageData, GetStorageError, GetStorageHasDerivativesData, GetStorageHasDerivativesError, GetStorageHasDerivativesResponse, GetStorageParentsData, GetStorageParentsError, GetStorageParentsResponse, GetStoragePoolByPathData, GetStoragePoolByPathError, GetStoragePoolByPathResponse, GetStoragePoolData, GetStoragePoolError, GetStoragePoolPendingData, GetStoragePoolPendingError, GetStoragePoolPendingResponse, GetStoragePoolResponse, GetStorageReadyData, GetStorageReadyError, GetStorageReadyResponse, GetStorageResponse, GetStorageStatusesData, GetStorageStatusesError, GetStorageStatusesResponse, GetStorageStoragesWithUuidData, GetStorageStoragesWithUuidError, GetStorageStoragesWithUuidResponse, GetStorageTaskData, GetStorageTaskError, GetStorageTaskResponse, GetStorageTasksData, GetStorageTasksError, GetStorageTasksResponse, GetSystemCutoffTimeData, GetSystemCutoffTimeError, GetSystemCutoffTimeResponse, GetTaskData, GetTaskError, GetTaskResponse, GetTemplateAllowedData, GetTemplateAllowedError, GetTemplateAllowedResponse, GetTemplateDetailsData, GetTemplateDetailsError, GetTemplateDetailsResponse, GetTemplateInfoData, GetTemplateInfoError, GetTemplateInfoResponse, GetTemplateNonpersistentDesktopData, GetTemplateNonpersistentDesktopError, GetTemplateNonpersistentDesktopResponse, GetTemplateTreeData, GetTemplateTreeError, GetTemplateTreeResponse, GetUnusedItemTimeoutRuleData, GetUnusedItemTimeoutRuleError, GetUnusedItemTimeoutRuleResponse, GetUserAllowedMediaData, GetUserAllowedMediaError, GetUserAllowedMediaResponse, GetUserAllowedTemplatesData, GetUserAllowedTemplatesError, GetUserAllowedTemplatesFlatData, GetUserAllowedTemplatesFlatError, GetUserAllowedTemplatesFlatResponse, GetUserAllowedTemplatesResponse, GetUserApiKeyData, GetUserApiKeyError, GetUserApiKeyResponse, GetUserAppliedQuotaData, GetUserAppliedQuotaError, GetUserAppliedQuotaResponse, GetUserBastionSshKeyData, GetUserBastionSshKeyError, GetUserBastionSshKeyResponse, GetUserBookingsData, GetUserBookingsError, GetUserBookingsResponse, GetUserConfigData, GetUserConfigError, GetUserConfigResponse, GetUserData, GetUserDefaultCardData, GetUserDefaultCardError, GetUserDefaultCardResponse, GetUserDesktopData, GetUserDesktopError, GetUserDesktopResponse, GetUserDesktopsData, GetUserDesktopsError, GetUserDesktopsLegacyData, GetUserDesktopsLegacyError, GetUserDesktopsLegacyResponse, GetUserDesktopsPaginatedData, GetUserDesktopsPaginatedError, GetUserDesktopsPaginatedResponse, GetUserDesktopsResponse, GetUserDetailsData, GetUserDetailsError, GetUserDetailsResponse, GetUserError, GetUserMediaData, GetUserMediaError, GetUserMediaResponse, GetUserNotificationDisplaysData, GetUserNotificationDisplaysError, GetUserNotificationDisplaysResponse, GetUserNotificationTriggerDisplayData, GetUserNotificationTriggerDisplayError, GetUserNotificationTriggerDisplayNestedData, GetUserNotificationTriggerDisplayNestedError, GetUserNotificationTriggerDisplayNestedResponse, GetUserNotificationTriggerDisplayResponse, GetUserPasswordPolicyData, GetUserPasswordPolicyError, GetUserPasswordPolicyResponse, GetUserQuotasData, GetUserQuotasError, GetUserQuotasResponse, GetUserReadyStoragesData, GetUserReadyStoragesError, GetUserReadyStoragesResponse, GetUserResponse, GetUserSharedMediaData, GetUserSharedMediaError, GetUserSharedMediaResponse, GetUserSharedTemplatesData, GetUserSharedTemplatesError, GetUserSharedTemplatesResponse, GetUsersInGroupData, GetUsersInGroupError, GetUsersInGroupResponse, GetUsersPrioritiesData, GetUsersPrioritiesError, GetUsersPrioritiesResponse, GetUserTasksData, GetUserTasksError, GetUserTasksResponse, GetUserTemplatesData, GetUserTemplatesError, GetUserTemplatesPaginatedData, GetUserTemplatesPaginatedError, GetUserTemplatesPaginatedResponse, GetUserTemplatesResponse, GetUserVpnByKindData, GetUserVpnByKindError, GetUserVpnByKindResponse, GetUserVpnData, GetUserVpnError, GetUserVpnWithOsData, GetUserVpnWithOsError, GetUserVpnWithOsResponse, GetViewerDocsData, GetViewerDocsError, GetViewerDocsResponse, GetWebappDesktopsData, GetWebappDesktopsError, GetWebappDesktopsResponse, GetWebappTemplatesData, GetWebappTemplatesError, GetWebappTemplatesResponse, GroupsUsersCountData, GroupsUsersCountError, GroupsUsersCountResponse2, IncreaseStorageSizeData, IncreaseStorageSizeError, IncreaseStorageSizeResponse, ListAllPlansData, ListAllPlansError, ListAllPlansResponse, ListAllStoragesWithUuidData, ListAllStoragesWithUuidError, ListAllStoragesWithUuidFilteredData, ListAllStoragesWithUuidFilteredError, ListAllStoragesWithUuidFilteredResponse, ListAllStoragesWithUuidResponse, ListAllStoragesWithUuidStatusData, ListAllStoragesWithUuidStatusError, ListAllStoragesWithUuidStatusResponse, ListBookablesData, ListBookablesError, ListBookablesResponse, ListDesktopAttachedMediaData, ListDesktopAttachedMediaError, ListDesktopAttachedMediaResponse, ListEnabledSubitemsData, ListEnabledSubitemsError, ListEnabledSubitemsResponse, ListPriorityRulesData, ListPriorityRulesError, ListPriorityRulesResponse, ListProfilesData, ListProfilesError, ListProfilesResponse, ListReservableSubitemsData, ListReservableSubitemsError, ListReservableSubitemsResponse, ListStoragePoolsData, ListStoragePoolsError, ListStoragePoolsResponse, ListStuckRecycleBinEntriesData, ListStuckRecycleBinEntriesError, ListStuckRecycleBinEntriesResponse, LogViewerClickData, LogViewerClickError, LogViewerClickResponse, MaintenanceStatusData, MaintenanceStatusError, MaintenanceStatusResponse2, MigrationExportUserData, MigrationExportUserError, MigrationExportUserResponse, MigrationImportUserData, MigrationImportUserError, MigrationImportUserResponse, MigrationListItemsData, MigrationListItemsError, MigrationListItemsResponse2, MigrationMigrateUserData, MigrationMigrateUserError, MigrationMigrateUserResponse, MoveStorageByPathData, MoveStorageByPathError, MoveStorageByPathResponse, RecoverStuckRecycleBinEntriesData, RecoverStuckRecycleBinEntriesError, RecoverStuckRecycleBinEntriesResponse, RecreateDeploymentData, RecreateDeploymentError, RecreateDeploymentResponse, RecreateDesktopData, RecreateDesktopError, RecreateDesktopResponse, RecreateStorageData, RecreateStorageError, RecreateStorageResponse, RecycleBinAddUnusedItemsData, RecycleBinAddUnusedItemsError, RecycleBinAddUnusedItemsResponse, RegisterUserData, RegisterUserError, RegisterUserResponse, RemoveDisallowedBastionTargetsData, RemoveDisallowedBastionTargetsError, RemoveDisallowedBastionTargetsResponse, RenewDesktopViewerByTokenData, RenewDesktopViewerByTokenError, RenewDesktopViewerByTokenResponse, ReRegisterUserData, ReRegisterUserError, ReRegisterUserResponse, ResetDesktopData, ResetDesktopError, ResetDesktopResponse, RestoreRecycleBinData, RestoreRecycleBinError, RestoreRecycleBinResponse, RetryAllFailedTasksData, RetryAllFailedTasksError, RetryAllFailedTasksResponse, RetryFailedDesktopData, RetryFailedDesktopError, RetryFailedDesktopResponse, RetryTaskData, RetryTaskError, RetryTaskResponse, RevokeMigrationData, RevokeMigrationError, RevokeMigrationResponse, RsyncStorageToPathData, RsyncStorageToPathError, RsyncStorageToPathResponse, RsyncStorageToStoragePoolData, RsyncStorageToStoragePoolError, RsyncStorageToStoragePoolResponse, SearchUsersInCategoryData, SearchUsersInCategoryError, SearchUsersInCategoryResponse, SetDefaultDeleteData, SetDefaultDeleteError, SetDefaultDeleteResponse, SetDeleteActionData, SetDeleteActionError, SetDeleteActionResponse, SetDeploymentBastionData, SetDeploymentBastionError, SetDeploymentBastionResponse, SetOldEntriesActionData, SetOldEntriesActionError, SetOldEntriesActionResponse, SetOldEntriesMaxTimeData, SetOldEntriesMaxTimeError, SetOldEntriesMaxTimeResponse, SetStorageMaintenanceData, SetStorageMaintenanceError, SetStorageMaintenanceResponse, SetStoragePathData, SetStoragePathError, SetStoragePathResponse, SetStorageReadyData, SetStorageReadyError, SetStorageReadyResponse, SetTemplateEnabledData, SetTemplateEnabledError, SetTemplateEnabledResponse, SetUserBastionSshKeyData, SetUserBastionSshKeyError, SetUserBastionSshKeyResponse, SetUserEmailData, SetUserEmailError, SetUserEmailResponse, SetUserLanguageData, SetUserLanguageError, SetUserLanguageResponse, SetUserPasswordData, SetUserPasswordError, SetUserPasswordResponse, SparsifyStorageData, SparsifyStorageError, SparsifyStorageResponse, StartAllDesktopsInDeploymentData, StartAllDesktopsInDeploymentError, StartAllDesktopsInDeploymentResponse, StartDesktopData, StartDesktopError, StartDesktopFromTokenData, StartDesktopFromTokenError, StartDesktopFromTokenResponse, StartDesktopResponse, StartMediaDownloadData, StartMediaDownloadError, StartMediaDownloadResponse, StatsCategoriesData, StatsCategoriesDeploymentsData, StatsCategoriesDeploymentsError, StatsCategoriesDeploymentsResponse2, StatsCategoriesError, StatsCategoriesResponse2, StatsDesktopsData, StatsDesktopsError, StatsDesktopsResponse, StatsDesktopsStatusData, StatsDesktopsStatusError, StatsDesktopsStatusResponse, StatsDomainsStatusData, StatsDomainsStatusError, StatsDomainsStatusResponse2, StatsHypervisorsData, StatsHypervisorsError, StatsHypervisorsResponse, StatsTemplatesData, StatsTemplatesError, StatsTemplatesResponse, StatsUsersData, StatsUsersError, StatsUsersResponse, StopAllDesktopsInDeploymentData, StopAllDesktopsInDeploymentError, StopAllDesktopsInDeploymentResponse, StopDesktopData, StopDesktopError, StopDesktopResponse, StopDesktopsData, StopDesktopsError, StopDesktopsResponse, StopStorageDesktopsData, StopStorageDesktopsError, StopStorageDesktopsResponse, StopUserDesktopsInDeploymentData, StopUserDesktopsInDeploymentError, StopUserDesktopsInDeploymentResponse, ToggleDeploymentVisibilityData, ToggleDeploymentVisibilityError, ToggleDeploymentVisibilityResponse, ToggleDesktopDeploymentVisibilityData, ToggleDesktopDeploymentVisibilityError, ToggleDesktopDeploymentVisibilityResponse, ToggleDomainVisibilityData, ToggleDomainVisibilityError, ToggleDomainVisibilityResponse, ToggleTemplateEnabledData, ToggleTemplateEnabledError, ToggleTemplateEnabledResponse, UpdateBastionAuthorizedKeysData, UpdateBastionAuthorizedKeysError, UpdateBastionAuthorizedKeysResponse, UpdateBastionConfigData, UpdateBastionConfigError, UpdateBastionConfigResponse, UpdateBastionDomainsData, UpdateBastionDomainsError, UpdateBastionDomainsResponse, UpdateBookingEventData, UpdateBookingEventError, UpdateBookingEventResponse, UpdateCategoryAuthenticationData, UpdateCategoryAuthenticationError, UpdateCategoryAuthenticationResponse, UpdateCategoryBrandingData, UpdateCategoryBrandingError, UpdateCategoryBrandingResponse, UpdateCategoryLoginNotificationData, UpdateCategoryLoginNotificationError, UpdateCategoryLoginNotificationResponse, UpdateDeploymentCoOwnersData, UpdateDeploymentCoOwnersError, UpdateDeploymentCoOwnersResponse, UpdateDesktopBastionAuthorizedKeysData, UpdateDesktopBastionAuthorizedKeysError, UpdateDesktopBastionAuthorizedKeysResponse, UpdateDesktopBastionData, UpdateDesktopBastionDomainData, UpdateDesktopBastionDomainError, UpdateDesktopBastionDomainResponse, UpdateDesktopBastionDomainsData, UpdateDesktopBastionDomainsError, UpdateDesktopBastionDomainsResponse, UpdateDesktopBastionError, UpdateDesktopBastionResponse, UpdateMaintenanceData, UpdateMaintenanceError, UpdateMaintenanceResponse, UpdateMaintenanceTextData, UpdateMaintenanceTextError, UpdateMaintenanceTextResponse, UpdateMediaAllowedData, UpdateMediaAllowedError, UpdateMediaAllowedResponse, UpdateMigrationConfigData, UpdateMigrationConfigError, UpdateMigrationConfigResponse, UpdatePlanData, UpdatePlanError, UpdatePlanResponse, UpdateReservableItemData, UpdateReservableItemError, UpdateReservableItemResponse, UpdateShareLinkData, UpdateShareLinkError, UpdateShareLinkResponse, UpdateStatusDesktopData, UpdateStatusDesktopError, UpdateStatusDesktopResponse, UpdateStoragePoolData, UpdateStoragePoolError, UpdateStoragePoolResponse, UpdateSystemCutoffTimeData, UpdateSystemCutoffTimeError, UpdateSystemCutoffTimeResponse, UpdateTemplateAllowedData, UpdateTemplateAllowedError, UpdateTemplateAllowedResponse, UpdateTemplateData, UpdateTemplateError, UpdateTemplateResponse, UpdateUnusedItemTimeoutRuleData, UpdateUnusedItemTimeoutRuleError, UpdateUnusedItemTimeoutRuleResponse, UserOwnsDesktopData, UserOwnsDesktopError, UserOwnsDesktopResponse, UserResetVpnData, UserResetVpnError, UserResetVpnResponse, VerifyBastionDomainData, VerifyBastionDomainError, VerifyBastionDomainResponse, VerifyDesktopBastionDomainData, VerifyDesktopBastionDomainError, VerifyDesktopBastionDomainResponse, VirtWinRegStorageData, VirtWinRegStorageError, VirtWinRegStorageResponse, VpnConnectionConnectData, VpnConnectionConnectError, VpnConnectionConnectResponse, VpnConnectionDisconnectData, VpnConnectionDisconnectError, VpnConnectionDisconnectResponse, VpnConnectionResetData, VpnConnectionResetError, VpnConnectionResetResponse, VpnConnectionRoamData, VpnConnectionRoamError, VpnConnectionRoamResponse, VpnConnectionsDisconnectData, VpnConnectionsDisconnectError, VpnConnectionsDisconnectResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const apiV4CategoriesQueryKey = (options?: Options<ApiV4CategoriesData>) => createQueryKey('apiV4Categories', options);

/**
 * Get all categories
 *
 * Returns a list of all available categories.
 */
export const apiV4CategoriesOptions = (options?: Options<ApiV4CategoriesData>) => queryOptions<ApiV4CategoriesResponse, ApiV4CategoriesError, ApiV4CategoriesResponse, ReturnType<typeof apiV4CategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiV4Categories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiV4CategoriesQueryKey(options)
});

export const apiV4CategoryQueryKey = (options: Options<ApiV4CategoryData>) => createQueryKey('apiV4Category', options);

/**
 * Get category details
 *
 * Returns detailed information about a specific category.
 */
export const apiV4CategoryOptions = (options: Options<ApiV4CategoryData>) => queryOptions<ApiV4CategoryResponse, ApiV4CategoryError, ApiV4CategoryResponse, ReturnType<typeof apiV4CategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiV4Category({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiV4CategoryQueryKey(options)
});

export const apiV4LoginConfigQueryKey = (options?: Options<ApiV4LoginConfigData>) => createQueryKey('apiV4LoginConfig', options);

/**
 * Get login configuration
 *
 * Returns login page configuration including notifications.
 */
export const apiV4LoginConfigOptions = (options?: Options<ApiV4LoginConfigData>) => queryOptions<ApiV4LoginConfigResponse, ApiV4LoginConfigError, ApiV4LoginConfigResponse, ReturnType<typeof apiV4LoginConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiV4LoginConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiV4LoginConfigQueryKey(options)
});

export const getLoginConfigByCategoryQueryKey = (options: Options<GetLoginConfigByCategoryData>) => createQueryKey('getLoginConfigByCategory', options);

/**
 * Get login config for category
 *
 * Returns login configuration for a specific category, falling back to global.
 */
export const getLoginConfigByCategoryOptions = (options: Options<GetLoginConfigByCategoryData>) => queryOptions<GetLoginConfigByCategoryResponse, GetLoginConfigByCategoryError, GetLoginConfigByCategoryResponse, ReturnType<typeof getLoginConfigByCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLoginConfigByCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLoginConfigByCategoryQueryKey(options)
});

export const maintenanceStatusQueryKey = (options?: Options<MaintenanceStatusData>) => createQueryKey('maintenanceStatus', options);

/**
 * Get Maintenance Status
 *
 * Returns the current global maintenance status of the API.
 */
export const maintenanceStatusOptions = (options?: Options<MaintenanceStatusData>) => queryOptions<MaintenanceStatusResponse2, MaintenanceStatusError, MaintenanceStatusResponse2, ReturnType<typeof maintenanceStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await maintenanceStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: maintenanceStatusQueryKey(options)
});

export const getMaintenanceTextFrontendQueryKey = (options?: Options<GetMaintenanceTextFrontendData>) => createQueryKey('getMaintenanceTextFrontend', options);

/**
 * Get maintenance text for frontend
 *
 * Returns the current maintenance text for frontend display.
 */
export const getMaintenanceTextFrontendOptions = (options?: Options<GetMaintenanceTextFrontendData>) => queryOptions<GetMaintenanceTextFrontendResponse, GetMaintenanceTextFrontendError, GetMaintenanceTextFrontendResponse, ReturnType<typeof getMaintenanceTextFrontendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaintenanceTextFrontend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenanceTextFrontendQueryKey(options)
});

export const apiVersionQueryKey = (options?: Options<ApiVersionData>) => createQueryKey('apiVersion', options);

/**
 * Get API Version
 *
 * Returns the current version of the API and IsardVDI.
 */
export const apiVersionOptions = (options?: Options<ApiVersionData>) => queryOptions<ApiVersionResponse, DefaultError, ApiVersionResponse, ReturnType<typeof apiVersionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiVersion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiVersionQueryKey(options)
});

export const apiV4CategoryCustomUrlQueryKey = (options: Options<ApiV4CategoryCustomUrlData>) => createQueryKey('apiV4CategoryCustomUrl', options);

/**
 * Get category custom login URL
 *
 * Returns the custom login URL for a specific category.
 */
export const apiV4CategoryCustomUrlOptions = (options: Options<ApiV4CategoryCustomUrlData>) => queryOptions<ApiV4CategoryCustomUrlResponse, ApiV4CategoryCustomUrlError, ApiV4CategoryCustomUrlResponse, ReturnType<typeof apiV4CategoryCustomUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiV4CategoryCustomUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiV4CategoryCustomUrlQueryKey(options)
});

export const getLogoQueryKey = (options?: Options<GetLogoData>) => createQueryKey('getLogo', options);

/**
 * Get logo
 *
 * Returns the logo for the requesting domain. Falls back to the default logo.
 */
export const getLogoOptions = (options?: Options<GetLogoData>) => queryOptions<unknown, GetLogoError, unknown, ReturnType<typeof getLogoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLogo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLogoQueryKey(options)
});

export const getCategoryLogoQueryKey = (options: Options<GetCategoryLogoData>) => createQueryKey('getCategoryLogo', options);

/**
 * Get category logo
 *
 * Returns the branding logo for a category. Falls back to the default logo.
 */
export const getCategoryLogoOptions = (options: Options<GetCategoryLogoData>) => queryOptions<unknown, GetCategoryLogoError, unknown, ReturnType<typeof getCategoryLogoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryLogo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryLogoQueryKey(options)
});

export const getLogoCollapsedQueryKey = (options?: Options<GetLogoCollapsedData>) => createQueryKey('getLogoCollapsed', options);

/**
 * Get collapsed logo
 *
 * Returns the collapsed-sidebar logo for the requesting domain. Falls back through the configured collapsed logo, then the configured full logo, and finally the bundled default collapsed logo.
 */
export const getLogoCollapsedOptions = (options?: Options<GetLogoCollapsedData>) => queryOptions<unknown, GetLogoCollapsedError, unknown, ReturnType<typeof getLogoCollapsedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLogoCollapsed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLogoCollapsedQueryKey(options)
});

export const getCategoryLogoCollapsedQueryKey = (options: Options<GetCategoryLogoCollapsedData>) => createQueryKey('getCategoryLogoCollapsed', options);

/**
 * Get category collapsed logo
 *
 * Returns the collapsed-sidebar branding logo for a category. Falls back through the category's collapsed logo, then its full logo, and finally the bundled default collapsed logo.
 */
export const getCategoryLogoCollapsedOptions = (options: Options<GetCategoryLogoCollapsedData>) => queryOptions<unknown, GetCategoryLogoCollapsedError, unknown, ReturnType<typeof getCategoryLogoCollapsedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryLogoCollapsed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryLogoCollapsedQueryKey(options)
});

export const getDesktopViewerByTokenQueryKey = (options: Options<GetDesktopViewerByTokenData>) => createQueryKey('getDesktopViewerByToken', options);

/**
 * Get Desktop Viewer
 */
export const getDesktopViewerByTokenOptions = (options: Options<GetDesktopViewerByTokenData>) => queryOptions<GetDesktopViewerByTokenResponse, GetDesktopViewerByTokenError, GetDesktopViewerByTokenResponse, ReturnType<typeof getDesktopViewerByTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopViewerByToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopViewerByTokenQueryKey(options)
});

export const renewDesktopViewerByTokenQueryKey = (options: Options<RenewDesktopViewerByTokenData>) => createQueryKey('renewDesktopViewerByToken', options);

/**
 * Renew the viewer JWT of a direct viewer share token
 *
 * Returns the same payload as get-viewer with a freshly minted viewer JWT, so a long-lived direct viewer page can keep working past the token lifetime without a reload. Unlike get-viewer it never starts a stopped desktop and does not log a viewer access.
 */
export const renewDesktopViewerByTokenOptions = (options: Options<RenewDesktopViewerByTokenData>) => queryOptions<RenewDesktopViewerByTokenResponse, RenewDesktopViewerByTokenError, RenewDesktopViewerByTokenResponse, ReturnType<typeof renewDesktopViewerByTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await renewDesktopViewerByToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: renewDesktopViewerByTokenQueryKey(options)
});

export const getViewerDocsQueryKey = (options?: Options<GetViewerDocsData>) => createQueryKey('getViewerDocs', options);

/**
 * Get viewer documentation URL
 *
 * Returns the URL for the viewer documentation
 */
export const getViewerDocsOptions = (options?: Options<GetViewerDocsData>) => queryOptions<GetViewerDocsResponse, GetViewerDocsError, GetViewerDocsResponse, ReturnType<typeof getViewerDocsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getViewerDocs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getViewerDocsQueryKey(options)
});

/**
 * Log Viewer Click
 *
 * Log a direct viewer click event with the protocol used.
 */
export const logViewerClickMutation = (options?: Partial<Options<LogViewerClickData>>): UseMutationOptions<LogViewerClickResponse, LogViewerClickError, Options<LogViewerClickData>> => {
    const mutationOptions: UseMutationOptions<LogViewerClickResponse, LogViewerClickError, Options<LogViewerClickData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logViewerClick({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBastionTargetsQueryKey = (options?: Options<GetBastionTargetsData>) => createQueryKey('getBastionTargets', options);

/**
 * Get user's bastion targets
 *
 * Returns a list of bastion target configurations for the user.
 *
 * @deprecated
 */
export const getBastionTargetsOptions = (options?: Options<GetBastionTargetsData>) => queryOptions<GetBastionTargetsResponse, GetBastionTargetsError, GetBastionTargetsResponse, ReturnType<typeof getBastionTargetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBastionTargets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBastionTargetsQueryKey(options)
});

export const getDesktopBastionQueryKey = (options: Options<GetDesktopBastionData>) => createQueryKey('getDesktopBastion', options);

/**
 * Get bastion target for desktop
 *
 * Returns the bastion target configuration for a desktop. Creates an empty target if none exists.
 *
 * @deprecated
 */
export const getDesktopBastionOptions = (options: Options<GetDesktopBastionData>) => queryOptions<GetDesktopBastionResponse, GetDesktopBastionError, GetDesktopBastionResponse, ReturnType<typeof getDesktopBastionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopBastion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopBastionQueryKey(options)
});

/**
 * Update bastion target for desktop
 *
 * Updates the bastion target configuration for a desktop. If the user cannot use individual domains, the domain field is cleared.
 *
 * @deprecated
 */
export const updateDesktopBastionMutation = (options?: Partial<Options<UpdateDesktopBastionData>>): UseMutationOptions<UpdateDesktopBastionResponse, UpdateDesktopBastionError, Options<UpdateDesktopBastionData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesktopBastionResponse, UpdateDesktopBastionError, Options<UpdateDesktopBastionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesktopBastion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopBastionActiveQueryKey = (options: Options<GetDesktopBastionActiveData>) => createQueryKey('getDesktopBastionActive', options);

/**
 * Get read-only bastion status for a desktop
 *
 * Returns whether bastion SSH/HTTP access is enabled for the desktop, plus the data needed to render the read-only access links. Never creates a target, so it can be called lazily on demand for any desktop in any status.
 */
export const getDesktopBastionActiveOptions = (options: Options<GetDesktopBastionActiveData>) => queryOptions<GetDesktopBastionActiveResponse, GetDesktopBastionActiveError, GetDesktopBastionActiveResponse, ReturnType<typeof getDesktopBastionActiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopBastionActive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopBastionActiveQueryKey(options)
});

/**
 * Update bastion SSH authorized keys
 *
 * Updates the SSH authorized keys for a desktop's bastion target.
 */
export const updateBastionAuthorizedKeysMutation = (options?: Partial<Options<UpdateBastionAuthorizedKeysData>>): UseMutationOptions<UpdateBastionAuthorizedKeysResponse, UpdateBastionAuthorizedKeysError, Options<UpdateBastionAuthorizedKeysData>> => {
    const mutationOptions: UseMutationOptions<UpdateBastionAuthorizedKeysResponse, UpdateBastionAuthorizedKeysError, Options<UpdateBastionAuthorizedKeysData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBastionAuthorizedKeys({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update bastion custom domains
 *
 * Updates the custom domain names for a desktop's bastion target. New domains are verified via DNS if domain verification is required.
 */
export const updateBastionDomainsMutation = (options?: Partial<Options<UpdateBastionDomainsData>>): UseMutationOptions<UpdateBastionDomainsResponse, UpdateBastionDomainsError, Options<UpdateBastionDomainsData>> => {
    const mutationOptions: UseMutationOptions<UpdateBastionDomainsResponse, UpdateBastionDomainsError, Options<UpdateBastionDomainsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBastionDomains({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify bastion domain DNS
 *
 * Verifies a single domain's DNS configuration without saving. Returns success if the CNAME record is valid.
 *
 * @deprecated
 */
export const verifyBastionDomainMutation = (options?: Partial<Options<VerifyBastionDomainData>>): UseMutationOptions<VerifyBastionDomainResponse, VerifyBastionDomainError, Options<VerifyBastionDomainData>> => {
    const mutationOptions: UseMutationOptions<VerifyBastionDomainResponse, VerifyBastionDomainError, Options<VerifyBastionDomainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyBastionDomain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopCardImagesQueryKey = (options?: Options<GetDesktopCardImagesData>) => createQueryKey('getDesktopCardImages', options);

/**
 * Get desktop images
 *
 * Returns all available desktop images (stock + user).
 */
export const getDesktopCardImagesOptions = (options?: Options<GetDesktopCardImagesData>) => queryOptions<GetDesktopCardImagesResponse, GetDesktopCardImagesError, GetDesktopCardImagesResponse, ReturnType<typeof getDesktopCardImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopCardImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopCardImagesQueryKey(options)
});

export const getDesktopImagesByTypeQueryKey = (options: Options<GetDesktopImagesByTypeData>) => createQueryKey('getDesktopImagesByType', options);

/**
 * Get desktop images by type
 *
 * Returns desktop images filtered by type (stock or user).
 *
 * @deprecated
 */
export const getDesktopImagesByTypeOptions = (options: Options<GetDesktopImagesByTypeData>) => queryOptions<GetDesktopImagesByTypeResponse, GetDesktopImagesByTypeError, GetDesktopImagesByTypeResponse, ReturnType<typeof getDesktopImagesByTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopImagesByType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopImagesByTypeQueryKey(options)
});

export const getStockDefaultCardQueryKey = (options: Options<GetStockDefaultCardData>) => createQueryKey('getStockDefaultCard', options);

/**
 * Get default stock card for a domain
 *
 * Returns the default stock card image for a specific domain.
 *
 * @deprecated
 */
export const getStockDefaultCardOptions = (options: Options<GetStockDefaultCardData>) => queryOptions<GetStockDefaultCardResponse, GetStockDefaultCardError, GetStockDefaultCardResponse, ReturnType<typeof getStockDefaultCardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStockDefaultCard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStockDefaultCardQueryKey(options)
});

export const getUserDefaultCardQueryKey = (options: Options<GetUserDefaultCardData>) => createQueryKey('getUserDefaultCard', options);

/**
 * Get default user card for a domain
 *
 * Returns the default user card image for a specific domain.
 *
 * @deprecated
 */
export const getUserDefaultCardOptions = (options: Options<GetUserDefaultCardData>) => queryOptions<GetUserDefaultCardResponse, GetUserDefaultCardError, GetUserDefaultCardResponse, ReturnType<typeof getUserDefaultCardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDefaultCard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDefaultCardQueryKey(options)
});

/**
 * Stop all desktops from a user in a deployment
 *
 * Stop all started desktops from a user in a deployment.
 */
export const stopUserDesktopsInDeploymentMutation = (options?: Partial<Options<StopUserDesktopsInDeploymentData>>): UseMutationOptions<StopUserDesktopsInDeploymentResponse, StopUserDesktopsInDeploymentError, Options<StopUserDesktopsInDeploymentData>> => {
    const mutationOptions: UseMutationOptions<StopUserDesktopsInDeploymentResponse, StopUserDesktopsInDeploymentError, Options<StopUserDesktopsInDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopUserDesktopsInDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllSharedDeploymentsQueryKey = (options?: Options<GetAllSharedDeploymentsData>) => createQueryKey('getAllSharedDeployments', options);

/**
 * Get all shared deployments
 *
 * Returns all the deployments shared to the user in payload.
 */
export const getAllSharedDeploymentsOptions = (options?: Options<GetAllSharedDeploymentsData>) => queryOptions<GetAllSharedDeploymentsResponse, GetAllSharedDeploymentsError, GetAllSharedDeploymentsResponse, ReturnType<typeof getAllSharedDeploymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllSharedDeployments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllSharedDeploymentsQueryKey(options)
});

export const getDeploymentUserDesktopsQueryKey = (options: Options<GetDeploymentUserDesktopsData>) => createQueryKey('getDeploymentUserDesktops', options);

/**
 * Get all desktops in a deployment for a user
 *
 * Returns all desktops in a deployment for a specific user.
 */
export const getDeploymentUserDesktopsOptions = (options: Options<GetDeploymentUserDesktopsData>) => queryOptions<GetDeploymentUserDesktopsResponse, GetDeploymentUserDesktopsError, GetDeploymentUserDesktopsResponse, ReturnType<typeof getDeploymentUserDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentUserDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentUserDesktopsQueryKey(options)
});

export const getDeploymentUserDesktopsDetailQueryKey = (options: Options<GetDeploymentUserDesktopsDetailData>) => createQueryKey('getDeploymentUserDesktopsDetail', options);

/**
 * Get desktop details in a deployment for a user
 *
 * Returns the hardware, access, and configuration details of each desktop in a deployment for a specific user.
 */
export const getDeploymentUserDesktopsDetailOptions = (options: Options<GetDeploymentUserDesktopsDetailData>) => queryOptions<GetDeploymentUserDesktopsDetailResponse, GetDeploymentUserDesktopsDetailError, GetDeploymentUserDesktopsDetailResponse, ReturnType<typeof getDeploymentUserDesktopsDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentUserDesktopsDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentUserDesktopsDetailQueryKey(options)
});

/**
 * Delete a media item
 *
 * Deletes a media item and returns the task ID. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const deleteMediaMutation = (options?: Partial<Options<DeleteMediaData>>): UseMutationOptions<DeleteMediaResponse, DeleteMediaError, Options<DeleteMediaData>> => {
    const mutationOptions: UseMutationOptions<DeleteMediaResponse, DeleteMediaError, Options<DeleteMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMediaQueryKey = (options: Options<GetMediaData>) => createQueryKey('getMedia', options);

/**
 * Get details of a media
 *
 * Returns a media in IsardVDI based on an ID.
 */
export const getMediaOptions = (options: Options<GetMediaData>) => queryOptions<GetMediaResponse, GetMediaError, GetMediaResponse, ReturnType<typeof getMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMediaQueryKey(options)
});

export const getMediaTasksQueryKey = (options: Options<GetMediaTasksData>) => createQueryKey('getMediaTasks', options);

/**
 * Get the tasks a media has had
 *
 * Returns the tasks this media has had, newest first, read from the per-owner task index. Bounded: the index keeps the newest entries per row, and an entry whose job has expired is dropped on read rather than returned. Access is the media ownership dependency this route family already uses.
 */
export const getMediaTasksOptions = (options: Options<GetMediaTasksData>) => queryOptions<GetMediaTasksResponse, GetMediaTasksError, GetMediaTasksResponse, ReturnType<typeof getMediaTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMediaTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMediaTasksQueryKey(options)
});

export const getUserMediaQueryKey = (options?: Options<GetUserMediaData>) => createQueryKey('getUserMedia', options);

/**
 * Get user's media files
 *
 * Returns a list of media files belonging to the calling user. ``@has_token`` — the service filters by ``user_id`` so any logged-in user can call it.
 */
export const getUserMediaOptions = (options?: Options<GetUserMediaData>) => queryOptions<GetUserMediaResponse, GetUserMediaError, GetUserMediaResponse, ReturnType<typeof getUserMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserMediaQueryKey(options)
});

export const getUserSharedMediaQueryKey = (options?: Options<GetUserSharedMediaData>) => createQueryKey('getUserSharedMedia', options);

/**
 * Get shared media for user
 *
 * Returns a list of all media that are shared with them.
 */
export const getUserSharedMediaOptions = (options?: Options<GetUserSharedMediaData>) => queryOptions<GetUserSharedMediaResponse, GetUserSharedMediaError, GetUserSharedMediaResponse, ReturnType<typeof getUserSharedMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserSharedMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserSharedMediaQueryKey(options)
});

export const getUserAllowedMediaQueryKey = (options?: Options<GetUserAllowedMediaData>) => createQueryKey('getUserAllowedMedia', options);

/**
 * Get allowed media for user
 *
 * Returns a list of all media that the user can see, considering its role permissions.
 */
export const getUserAllowedMediaOptions = (options?: Options<GetUserAllowedMediaData>) => queryOptions<GetUserAllowedMediaResponse, GetUserAllowedMediaError, GetUserAllowedMediaResponse, ReturnType<typeof getUserAllowedMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserAllowedMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserAllowedMediaQueryKey(options)
});

export const getMediaDesktopsQueryKey = (options: Options<GetMediaDesktopsData>) => createQueryKey('getMediaDesktops', options);

/**
 * Get desktops using a media item
 *
 * Returns a list of desktops using the given media item.
 */
export const getMediaDesktopsOptions = (options: Options<GetMediaDesktopsData>) => queryOptions<GetMediaDesktopsResponse, GetMediaDesktopsError, GetMediaDesktopsResponse, ReturnType<typeof getMediaDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMediaDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMediaDesktopsQueryKey(options)
});

/**
 * Import user data from a JWT token for migration purposes.
 *
 * Imports user data from a JWT token generated for migration to another IsardVDI user.
 */
export const migrationImportUserMutation = (options?: Partial<Options<MigrationImportUserData>>): UseMutationOptions<MigrationImportUserResponse, MigrationImportUserError, Options<MigrationImportUserData>> => {
    const mutationOptions: UseMutationOptions<MigrationImportUserResponse, MigrationImportUserError, Options<MigrationImportUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await migrationImportUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const migrationListItemsQueryKey = (options?: Options<MigrationListItemsData>) => createQueryKey('migrationListItems', options);

/**
 * List items available for user migration.
 *
 * Lists the items available for migration for the authenticated user.
 */
export const migrationListItemsOptions = (options?: Options<MigrationListItemsData>) => queryOptions<MigrationListItemsResponse2, MigrationListItemsError, MigrationListItemsResponse2, ReturnType<typeof migrationListItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await migrationListItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: migrationListItemsQueryKey(options)
});

/**
 * Migrate user data from one user to another.
 *
 * Migrates user data from the source user to the user calling the endpoint.
 */
export const migrationMigrateUserMutation = (options?: Partial<Options<MigrationMigrateUserData>>): UseMutationOptions<MigrationMigrateUserResponse, MigrationMigrateUserError, Options<MigrationMigrateUserData>> => {
    const mutationOptions: UseMutationOptions<MigrationMigrateUserResponse, MigrationMigrateUserError, Options<MigrationMigrateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await migrationMigrateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStatusBarNotificationsQueryKey = (options?: Options<GetStatusBarNotificationsData>) => createQueryKey('getStatusBarNotifications', options);

/**
 * Get status bar notification
 *
 * Returns the status-bar notification configured for the caller's provider (e.g. a migration banner). ``@has_token``.
 */
export const getStatusBarNotificationsOptions = (options?: Options<GetStatusBarNotificationsData>) => queryOptions<GetStatusBarNotificationsResponse, GetStatusBarNotificationsError, GetStatusBarNotificationsResponse, ReturnType<typeof getStatusBarNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStatusBarNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStatusBarNotificationsQueryKey(options)
});

export const getUserNotificationDisplaysQueryKey = (options: Options<GetUserNotificationDisplaysData>) => createQueryKey('getUserNotificationDisplays', options);

/**
 * Get user notification displays for a trigger
 *
 * Returns the user's notification displays for the specified trigger.
 */
export const getUserNotificationDisplaysOptions = (options: Options<GetUserNotificationDisplaysData>) => queryOptions<GetUserNotificationDisplaysResponse, GetUserNotificationDisplaysError, GetUserNotificationDisplaysResponse, ReturnType<typeof getUserNotificationDisplaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserNotificationDisplays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserNotificationDisplaysQueryKey(options)
});

export const getUserNotificationTriggerDisplayQueryKey = (options: Options<GetUserNotificationTriggerDisplayData>) => createQueryKey('getUserNotificationTriggerDisplay', options);

/**
 * Get user notifications for a trigger and display
 *
 * Returns the user's notifications for the specified trigger and display as a flat, ordered list with the user's language template already resolved. Legacy consumers needing the nested grouping (by order and item_type) should use GET /api/v4/notification/user/{trigger}/{display}.
 */
export const getUserNotificationTriggerDisplayOptions = (options: Options<GetUserNotificationTriggerDisplayData>) => queryOptions<GetUserNotificationTriggerDisplayResponse, GetUserNotificationTriggerDisplayError, GetUserNotificationTriggerDisplayResponse, ReturnType<typeof getUserNotificationTriggerDisplayQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserNotificationTriggerDisplay({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserNotificationTriggerDisplayQueryKey(options)
});

export const getUserNotificationTriggerDisplayNestedQueryKey = (options: Options<GetUserNotificationTriggerDisplayNestedData>) => createQueryKey('getUserNotificationTriggerDisplayNested', options);

/**
 * Get user notifications for a trigger and display (nested)
 *
 * Returns the user's notifications for the specified trigger and display as a nested dict grouped by order and item_type, with each group carrying its template. Matches the legacy apiv3 ``GET /api/v3/notification/user/<trigger>/<display>`` shape so Vue 2 and webapp consumers keep working after the v3 retirement. For new clients, prefer the flat variant at ``/items/notifications/user/{trigger}/{display}``. ``@has_token``.
 *
 * @deprecated
 */
export const getUserNotificationTriggerDisplayNestedOptions = (options: Options<GetUserNotificationTriggerDisplayNestedData>) => queryOptions<GetUserNotificationTriggerDisplayNestedResponse, GetUserNotificationTriggerDisplayNestedError, GetUserNotificationTriggerDisplayNestedResponse, ReturnType<typeof getUserNotificationTriggerDisplayNestedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserNotificationTriggerDisplayNested({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserNotificationTriggerDisplayNestedQueryKey(options)
});

export const checkQuotaNewDesktopQueryKey = (options?: Options<CheckQuotaNewDesktopData>) => createQueryKey('checkQuotaNewDesktop', options);

/**
 * Check desktops quota
 *
 * Checks if creating a new desktop would exceed the user's quota.
 */
export const checkQuotaNewDesktopOptions = (options?: Options<CheckQuotaNewDesktopData>) => queryOptions<CheckQuotaNewDesktopResponse, CheckQuotaNewDesktopError, CheckQuotaNewDesktopResponse, ReturnType<typeof checkQuotaNewDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkQuotaNewDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkQuotaNewDesktopQueryKey(options)
});

export const checkQuotaNewVolatileDesktopQueryKey = (options?: Options<CheckQuotaNewVolatileDesktopData>) => createQueryKey('checkQuotaNewVolatileDesktop', options);

/**
 * Check temporal desktops quota
 *
 * Checks if creating a new temporal desktop would exceed the user's quota.
 */
export const checkQuotaNewVolatileDesktopOptions = (options?: Options<CheckQuotaNewVolatileDesktopData>) => queryOptions<CheckQuotaNewVolatileDesktopResponse, CheckQuotaNewVolatileDesktopError, CheckQuotaNewVolatileDesktopResponse, ReturnType<typeof checkQuotaNewVolatileDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkQuotaNewVolatileDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkQuotaNewVolatileDesktopQueryKey(options)
});

export const getRecycleBinDefaultDeleteConfigQueryKey = (options?: Options<GetRecycleBinDefaultDeleteConfigData>) => createQueryKey('getRecycleBinDefaultDeleteConfig', options);

/**
 * Get recycle bin default delete configuration
 *
 * Returns the default delete configuration for recycle bin items.
 */
export const getRecycleBinDefaultDeleteConfigOptions = (options?: Options<GetRecycleBinDefaultDeleteConfigData>) => queryOptions<GetRecycleBinDefaultDeleteConfigResponse, GetRecycleBinDefaultDeleteConfigError, GetRecycleBinDefaultDeleteConfigResponse, ReturnType<typeof getRecycleBinDefaultDeleteConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinDefaultDeleteConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinDefaultDeleteConfigQueryKey(options)
});

export const getRecycleBinCutoffTimeQueryKey = (options?: Options<GetRecycleBinCutoffTimeData>) => createQueryKey('getRecycleBinCutoffTime', options);

/**
 * Get recycle bin cutoff time
 *
 * Returns the cutoff time for recycle bin items.
 */
export const getRecycleBinCutoffTimeOptions = (options?: Options<GetRecycleBinCutoffTimeData>) => queryOptions<GetRecycleBinCutoffTimeResponse, GetRecycleBinCutoffTimeError, GetRecycleBinCutoffTimeResponse, ReturnType<typeof getRecycleBinCutoffTimeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinCutoffTime({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinCutoffTimeQueryKey(options)
});

export const getRecycleBinCountQueryKey = (options?: Options<GetRecycleBinCountData>) => createQueryKey('getRecycleBinCount', options);

/**
 * Get user recycle bin count
 *
 * Returns the total number of items in the user's recycle bin.
 */
export const getRecycleBinCountOptions = (options?: Options<GetRecycleBinCountData>) => queryOptions<GetRecycleBinCountResponse, GetRecycleBinCountError, GetRecycleBinCountResponse, ReturnType<typeof getRecycleBinCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinCountQueryKey(options)
});

/**
 * Empty recycle bin
 *
 * Empties the entire recycle bin.
 */
export const emptyRecycleBinMutation = (options?: Partial<Options<EmptyRecycleBinData>>): UseMutationOptions<EmptyRecycleBinResponse, EmptyRecycleBinError, Options<EmptyRecycleBinData>> => {
    const mutationOptions: UseMutationOptions<EmptyRecycleBinResponse, EmptyRecycleBinError, Options<EmptyRecycleBinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emptyRecycleBin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecycleBinItemCountUserQueryKey = (options?: Options<GetRecycleBinItemCountUserData>) => createQueryKey('getRecycleBinItemCountUser', options);

/**
 * Get the user recycle bin entries
 *
 * Returns the list of recycle bin entries for a user.
 */
export const getRecycleBinItemCountUserOptions = (options?: Options<GetRecycleBinItemCountUserData>) => queryOptions<GetRecycleBinItemCountUserResponse, GetRecycleBinItemCountUserError, GetRecycleBinItemCountUserResponse, ReturnType<typeof getRecycleBinItemCountUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinItemCountUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinItemCountUserQueryKey(options)
});

/**
 * Delete recycle bin item
 *
 * Deletes a recycle bin item by ID.
 */
export const deleteRecycleBinEntryMutation = (options?: Partial<Options<DeleteRecycleBinEntryData>>): UseMutationOptions<DeleteRecycleBinEntryResponse, DeleteRecycleBinEntryError, Options<DeleteRecycleBinEntryData>> => {
    const mutationOptions: UseMutationOptions<DeleteRecycleBinEntryResponse, DeleteRecycleBinEntryError, Options<DeleteRecycleBinEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteRecycleBinEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecycleBinQueryKey = (options: Options<GetRecycleBinData>) => createQueryKey('getRecycleBin', options);

/**
 * Get recycle bin item details
 *
 * Returns detailed information about a specific recycle bin item.
 */
export const getRecycleBinOptions = (options: Options<GetRecycleBinData>) => queryOptions<GetRecycleBinResponse, GetRecycleBinError, GetRecycleBinResponse, ReturnType<typeof getRecycleBinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinQueryKey(options)
});

/**
 * Restore recycle bin item
 *
 * Restores a recycle bin item by ID.
 */
export const restoreRecycleBinMutation = (options?: Partial<Options<RestoreRecycleBinData>>): UseMutationOptions<RestoreRecycleBinResponse, RestoreRecycleBinError, Options<RestoreRecycleBinData>> => {
    const mutationOptions: UseMutationOptions<RestoreRecycleBinResponse, RestoreRecycleBinError, Options<RestoreRecycleBinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await restoreRecycleBin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk restore recycle bin items
 *
 * Restores multiple recycle bin items. Processing happens in the background.
 */
export const bulkRestoreRecycleBinMutation = (options?: Partial<Options<BulkRestoreRecycleBinData>>): UseMutationOptions<BulkRestoreRecycleBinResponse, BulkRestoreRecycleBinError, Options<BulkRestoreRecycleBinData>> => {
    const mutationOptions: UseMutationOptions<BulkRestoreRecycleBinResponse, BulkRestoreRecycleBinError, Options<BulkRestoreRecycleBinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkRestoreRecycleBin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk delete recycle bin items
 *
 * Permanently deletes multiple recycle bin items. Processing happens in the background.
 */
export const bulkDeleteRecycleBinMutation = (options?: Partial<Options<BulkDeleteRecycleBinData>>): UseMutationOptions<BulkDeleteRecycleBinResponse, BulkDeleteRecycleBinError, Options<BulkDeleteRecycleBinData>> => {
    const mutationOptions: UseMutationOptions<BulkDeleteRecycleBinResponse, BulkDeleteRecycleBinError, Options<BulkDeleteRecycleBinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkDeleteRecycleBin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a storage
 *
 * Deletes a storage item and returns the task ID.
 */
export const deleteStorageMutation = (options?: Partial<Options<DeleteStorageData>>): UseMutationOptions<DeleteStorageResponse, DeleteStorageError, Options<DeleteStorageData>> => {
    const mutationOptions: UseMutationOptions<DeleteStorageResponse, DeleteStorageError, Options<DeleteStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStorageQueryKey = (options: Options<GetStorageData>) => createQueryKey('getStorage', options);

/**
 * Get storage details
 *
 * Returns details of a storage item.
 */
export const getStorageOptions = (options: Options<GetStorageData>) => queryOptions<GetStorageResponse, GetStorageError, GetStorageResponse, ReturnType<typeof getStorageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageQueryKey(options)
});

export const getStorageTasksQueryKey = (options: Options<GetStorageTasksData>) => createQueryKey('getStorageTasks', options);

/**
 * Get the tasks a storage has had
 *
 * Returns the tasks this storage item has had, newest first, read from the per-owner task index. Bounded: the index keeps the newest entries per row, and an entry whose job has expired is dropped on read rather than returned. Same ownership rules as every other per-item storage route.
 */
export const getStorageTasksOptions = (options: Options<GetStorageTasksData>) => queryOptions<GetStorageTasksResponse, GetStorageTasksError, GetStorageTasksResponse, ReturnType<typeof getStorageTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageTasksQueryKey(options)
});

export const getUserReadyStoragesQueryKey = (options?: Options<GetUserReadyStoragesData>) => createQueryKey('getUserReadyStorages', options);

/**
 * Get user's ready disks
 *
 * Returns a list of ready storage items for the authenticated user.
 */
export const getUserReadyStoragesOptions = (options?: Options<GetUserReadyStoragesData>) => queryOptions<GetUserReadyStoragesResponse, GetUserReadyStoragesError, GetUserReadyStoragesResponse, ReturnType<typeof getUserReadyStoragesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserReadyStorages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserReadyStoragesQueryKey(options)
});

/**
 * Abort storage operations
 *
 * Aborts ongoing operations for a storage item.
 */
export const abortStorageOperationsMutation = (options?: Partial<Options<AbortStorageOperationsData>>): UseMutationOptions<AbortStorageOperationsResponse, AbortStorageOperationsError, Options<AbortStorageOperationsData>> => {
    const mutationOptions: UseMutationOptions<AbortStorageOperationsResponse, AbortStorageOperationsError, Options<AbortStorageOperationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await abortStorageOperations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStorageReadyQueryKey = (options?: Options<GetStorageReadyData>) => createQueryKey('getStorageReady', options);

/**
 * Get ready storage items
 *
 * Returns the list of storage items in the ``ready`` state that belong to the calling user. ``@has_token``.
 */
export const getStorageReadyOptions = (options?: Options<GetStorageReadyData>) => queryOptions<GetStorageReadyResponse, GetStorageReadyError, GetStorageReadyResponse, ReturnType<typeof getStorageReadyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageReady({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageReadyQueryKey(options)
});

export const checkStoragePoolCreationAvailabilityQueryKey = (options?: Options<CheckStoragePoolCreationAvailabilityData>) => createQueryKey('checkStoragePoolCreationAvailability', options);

/**
 * Check storage pool creation availability
 *
 * Checks if there's any storage pool category available for creating a new domain
 */
export const checkStoragePoolCreationAvailabilityOptions = (options?: Options<CheckStoragePoolCreationAvailabilityData>) => queryOptions<CheckStoragePoolCreationAvailabilityResponse, CheckStoragePoolCreationAvailabilityError, CheckStoragePoolCreationAvailabilityResponse, ReturnType<typeof checkStoragePoolCreationAvailabilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkStoragePoolCreationAvailability({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkStoragePoolCreationAvailabilityQueryKey(options)
});

export const checkStoragePoolAvailabilityCompatQueryKey = (options?: Options<CheckStoragePoolAvailabilityCompatData>) => createQueryKey('checkStoragePoolAvailabilityCompat', options);

/**
 * Check storage pool availability
 *
 * Check if storage pools are available for the user's category.
 */
export const checkStoragePoolAvailabilityCompatOptions = (options?: Options<CheckStoragePoolAvailabilityCompatData>) => queryOptions<CheckStoragePoolAvailabilityCompatResponse, CheckStoragePoolAvailabilityCompatError, CheckStoragePoolAvailabilityCompatResponse, ReturnType<typeof checkStoragePoolAvailabilityCompatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkStoragePoolAvailabilityCompat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkStoragePoolAvailabilityCompatQueryKey(options)
});

export const getQueuesHealthQueryKey = (options?: Options<GetQueuesHealthData>) => createQueryKey('getQueuesHealth', options);

/**
 * Storage-queue health for the current user
 *
 * A compact, user-safe view of storage-queue health: whether the system is degraded or has a consumer-less (stranded) lane, plus per-tier queued totals. No per-worker or admin detail. Used to drive a user banner.
 */
export const getQueuesHealthOptions = (options?: Options<GetQueuesHealthData>) => queryOptions<GetQueuesHealthResponse, GetQueuesHealthError, GetQueuesHealthResponse, ReturnType<typeof getQueuesHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQueuesHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQueuesHealthQueryKey(options)
});

/**
 * Cancel a task
 *
 * Cancels a task, and with it every job linked to it through dependencies. Only the task owner can cancel it, and only while the chain is still queued (428 otherwise). Best effort: a queued job drops immediately, a running body stops only if it cooperates by watching its cancel signal, and a body that does not watch runs to completion. Re-read the task rather than trust the 204.
 */
export const cancelTaskMutation = (options?: Partial<Options<CancelTaskData>>): UseMutationOptions<CancelTaskResponse, CancelTaskError, Options<CancelTaskData>> => {
    const mutationOptions: UseMutationOptions<CancelTaskResponse, CancelTaskError, Options<CancelTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaskQueryKey = (options: Options<GetTaskData>) => createQueryKey('getTask', options);

/**
 * Get a task
 *
 * Returns a task by its ID. Users can only see their own tasks.
 */
export const getTaskOptions = (options: Options<GetTaskData>) => queryOptions<GetTaskResponse, GetTaskError, GetTaskResponse, ReturnType<typeof getTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaskQueryKey(options)
});

export const getUserTasksQueryKey = (options?: Options<GetUserTasksData>) => createQueryKey('getUserTasks', options);

/**
 * Get user tasks
 *
 * Returns all tasks for the authenticated user.
 */
export const getUserTasksOptions = (options?: Options<GetUserTasksData>) => queryOptions<GetUserTasksResponse, GetUserTasksError, GetUserTasksResponse, ReturnType<typeof getUserTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserTasksQueryKey(options)
});

export const getUserVpnQueryKey = (options?: Options<GetUserVpnData>) => createQueryKey('getUserVpn', options);

/**
 * Get the user vpn
 *
 * Returns the VPN for the user.
 */
export const getUserVpnOptions = (options?: Options<GetUserVpnData>) => queryOptions<unknown, GetUserVpnError, unknown, ReturnType<typeof getUserVpnQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserVpn({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserVpnQueryKey(options)
});

/**
 * Reset the user vpn
 *
 * Resets the VPN keys for the user.
 */
export const userResetVpnMutation = (options?: Partial<Options<UserResetVpnData>>): UseMutationOptions<UserResetVpnResponse, UserResetVpnError, Options<UserResetVpnData>> => {
    const mutationOptions: UseMutationOptions<UserResetVpnResponse, UserResetVpnError, Options<UserResetVpnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userResetVpn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllowedHardwareQueryKey = (options?: Options<GetAllowedHardwareData>) => createQueryKey('getAllowedHardware', options);

/**
 * Get allowed hardware for the user
 *
 * Returns the hardware configurations allowed for the user.
 */
export const getAllowedHardwareOptions = (options?: Options<GetAllowedHardwareData>) => queryOptions<GetAllowedHardwareResponse, GetAllowedHardwareError, GetAllowedHardwareResponse, ReturnType<typeof getAllowedHardwareQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllowedHardware({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllowedHardwareQueryKey(options)
});

export const getAllowedHardwareForDomainQueryKey = (options: Options<GetAllowedHardwareForDomainData>) => createQueryKey('getAllowedHardwareForDomain', options);

/**
 * Get allowed hardware for the user considering a domain
 *
 * Returns the hardware configurations allowed for the user, taking into account the resources already used by the specified domain (so the caller can render an edit dialog with the domain's current resources available again).
 */
export const getAllowedHardwareForDomainOptions = (options: Options<GetAllowedHardwareForDomainData>) => queryOptions<GetAllowedHardwareForDomainResponse, GetAllowedHardwareForDomainError, GetAllowedHardwareForDomainResponse, ReturnType<typeof getAllowedHardwareForDomainQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllowedHardwareForDomain({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllowedHardwareForDomainQueryKey(options)
});

/**
 * Delete current user
 *
 * Deletes the current user (self-deletion).
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserQueryKey = (options?: Options<GetUserData>) => createQueryKey('getUser', options);

/**
 * Get current user information
 *
 * Returns basic information about the current user.
 */
export const getUserOptions = (options?: Options<GetUserData>) => queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserQueryKey(options)
});

export const getUserDetailsQueryKey = (options?: Options<GetUserDetailsData>) => createQueryKey('getUserDetails', options);

/**
 * Get current user details
 *
 * Returns detailed information about the current user.
 */
export const getUserDetailsOptions = (options?: Options<GetUserDetailsData>) => queryOptions<GetUserDetailsResponse, GetUserDetailsError, GetUserDetailsResponse, ReturnType<typeof getUserDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDetailsQueryKey(options)
});

export const getUserQuotasQueryKey = (options?: Options<GetUserQuotasData>) => createQueryKey('getUserQuotas', options);

/**
 * Get user quotas information
 *
 * Returns quotas information for the current user.
 */
export const getUserQuotasOptions = (options?: Options<GetUserQuotasData>) => queryOptions<GetUserQuotasResponse, GetUserQuotasError, GetUserQuotasResponse, ReturnType<typeof getUserQuotasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserQuotas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserQuotasQueryKey(options)
});

export const getUserConfigQueryKey = (options?: Options<GetUserConfigData>) => createQueryKey('getUserConfig', options);

/**
 * Get current user configuration
 *
 * Returns configuration settings for the current user.
 */
export const getUserConfigOptions = (options?: Options<GetUserConfigData>) => queryOptions<GetUserConfigResponse, GetUserConfigError, GetUserConfigResponse, ReturnType<typeof getUserConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserConfigQueryKey(options)
});

/**
 * Set user language
 *
 * Sets the language for the specified user.
 */
export const setUserLanguageMutation = (options?: Partial<Options<SetUserLanguageData>>): UseMutationOptions<SetUserLanguageResponse, SetUserLanguageError, Options<SetUserLanguageData>> => {
    const mutationOptions: UseMutationOptions<SetUserLanguageResponse, SetUserLanguageError, Options<SetUserLanguageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserLanguage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete the user's bastion SSH public key
 *
 * Removes the SSH public key stored on the user's profile, revoking the bastion access it granted. Copies of the key written into a desktop's authorized keys by earlier releases are left untouched and must be removed there.
 */
export const deleteUserBastionSshKeyMutation = (options?: Partial<Options<DeleteUserBastionSshKeyData>>): UseMutationOptions<DeleteUserBastionSshKeyResponse, DeleteUserBastionSshKeyError, Options<DeleteUserBastionSshKeyData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserBastionSshKeyResponse, DeleteUserBastionSshKeyError, Options<DeleteUserBastionSshKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserBastionSshKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserBastionSshKeyQueryKey = (options?: Options<GetUserBastionSshKeyData>) => createQueryKey('getUserBastionSshKey', options);

/**
 * Get the user's bastion SSH public key
 *
 * Returns the single SSH public key stored on the user's profile. The bastion accepts it for any bastion-SSH desktop the user owns, and for the desktops of any deployment they own or co-own.
 */
export const getUserBastionSshKeyOptions = (options?: Options<GetUserBastionSshKeyData>) => queryOptions<GetUserBastionSshKeyResponse, GetUserBastionSshKeyError, GetUserBastionSshKeyResponse, ReturnType<typeof getUserBastionSshKeyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserBastionSshKey({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserBastionSshKeyQueryKey(options)
});

/**
 * Set the user's bastion SSH public key
 *
 * Stores a single SSH public key on the user's profile. Replaces any existing key. The key is validated, and the bastion accepts it from then on for any bastion-SSH desktop the user owns, and for the desktops of any deployment they own or co-own.
 */
export const setUserBastionSshKeyMutation = (options?: Partial<Options<SetUserBastionSshKeyData>>): UseMutationOptions<SetUserBastionSshKeyResponse, SetUserBastionSshKeyError, Options<SetUserBastionSshKeyData>> => {
    const mutationOptions: UseMutationOptions<SetUserBastionSshKeyResponse, SetUserBastionSshKeyError, Options<SetUserBastionSshKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserBastionSshKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set user password
 *
 * Sets the password for the user calling the endpoint.
 */
export const setUserPasswordMutation = (options?: Partial<Options<SetUserPasswordData>>): UseMutationOptions<SetUserPasswordResponse, SetUserPasswordError, Options<SetUserPasswordData>> => {
    const mutationOptions: UseMutationOptions<SetUserPasswordResponse, SetUserPasswordError, Options<SetUserPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserDesktopsLegacyQueryKey = (options?: Options<GetUserDesktopsLegacyData>) => createQueryKey('getUserDesktopsLegacy', options);

/**
 * Get user desktops
 *
 * Returns a list of desktops for the current user.
 */
export const getUserDesktopsLegacyOptions = (options?: Options<GetUserDesktopsLegacyData>) => queryOptions<GetUserDesktopsLegacyResponse, GetUserDesktopsLegacyError, GetUserDesktopsLegacyResponse, ReturnType<typeof getUserDesktopsLegacyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDesktopsLegacy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDesktopsLegacyQueryKey(options)
});

export const getUserDesktopQueryKey = (options: Options<GetUserDesktopData>) => createQueryKey('getUserDesktop', options);

/**
 * Get specific desktop details
 *
 * Returns details of a specific desktop for the current user.
 */
export const getUserDesktopOptions = (options: Options<GetUserDesktopData>) => queryOptions<GetUserDesktopResponse, GetUserDesktopError, GetUserDesktopResponse, ReturnType<typeof getUserDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDesktopQueryKey(options)
});

export const getUserVpnWithOsQueryKey = (options: Options<GetUserVpnWithOsData>) => createQueryKey('getUserVpnWithOs', options);

/**
 * Get VPN config with OS
 *
 * Returns VPN configuration for the user with the specified kind and OS.
 */
export const getUserVpnWithOsOptions = (options: Options<GetUserVpnWithOsData>) => queryOptions<GetUserVpnWithOsResponse, GetUserVpnWithOsError, GetUserVpnWithOsResponse, ReturnType<typeof getUserVpnWithOsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserVpnWithOs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserVpnWithOsQueryKey(options)
});

export const getUserVpnByKindQueryKey = (options: Options<GetUserVpnByKindData>) => createQueryKey('getUserVpnByKind', options);

/**
 * Get VPN config
 *
 * Returns VPN configuration for the user with the specified kind.
 */
export const getUserVpnByKindOptions = (options: Options<GetUserVpnByKindData>) => queryOptions<GetUserVpnByKindResponse, GetUserVpnByKindError, GetUserVpnByKindResponse, ReturnType<typeof getUserVpnByKindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserVpnByKind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserVpnByKindQueryKey(options)
});

export const getWebappDesktopsQueryKey = (options?: Options<GetWebappDesktopsData>) => createQueryKey('getWebappDesktops', options);

/**
 * Get webapp desktops
 *
 * Returns webapp desktops for the current user.
 */
export const getWebappDesktopsOptions = (options?: Options<GetWebappDesktopsData>) => queryOptions<GetWebappDesktopsResponse, GetWebappDesktopsError, GetWebappDesktopsResponse, ReturnType<typeof getWebappDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWebappDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWebappDesktopsQueryKey(options)
});

export const getWebappTemplatesQueryKey = (options?: Options<GetWebappTemplatesData>) => createQueryKey('getWebappTemplates', options);

/**
 * Get webapp templates
 *
 * Returns webapp templates for the current user.
 */
export const getWebappTemplatesOptions = (options?: Options<GetWebappTemplatesData>) => queryOptions<GetWebappTemplatesResponse, GetWebappTemplatesError, GetWebappTemplatesResponse, ReturnType<typeof getWebappTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWebappTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWebappTemplatesQueryKey(options)
});

export const getHardwareKindAllowedQueryKey = (options: Options<GetHardwareKindAllowedData>) => createQueryKey('getHardwareKindAllowed', options);

/**
 * Get allowed hardware by kind
 *
 * Returns the allowed hardware configurations for a specific hardware kind.
 */
export const getHardwareKindAllowedOptions = (options: Options<GetHardwareKindAllowedData>) => queryOptions<GetHardwareKindAllowedResponse, GetHardwareKindAllowedError, GetHardwareKindAllowedResponse, ReturnType<typeof getHardwareKindAllowedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHardwareKindAllowed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHardwareKindAllowedQueryKey(options)
});

export const getUserAppliedQuotaQueryKey = (options?: Options<GetUserAppliedQuotaData>) => createQueryKey('getUserAppliedQuota', options);

/**
 * Get applied quota
 *
 * Returns the applied quota for the current user.
 */
export const getUserAppliedQuotaOptions = (options?: Options<GetUserAppliedQuotaData>) => queryOptions<GetUserAppliedQuotaResponse, GetUserAppliedQuotaError, GetUserAppliedQuotaResponse, ReturnType<typeof getUserAppliedQuotaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserAppliedQuota({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserAppliedQuotaQueryKey(options)
});

export const getBastionAllowedQueryKey = (options?: Options<GetBastionAllowedData>) => createQueryKey('getBastionAllowed', options);

/**
 * Check bastion access
 *
 * Returns whether the current user is allowed to use bastion.
 */
export const getBastionAllowedOptions = (options?: Options<GetBastionAllowedData>) => queryOptions<GetBastionAllowedResponse, GetBastionAllowedError, GetBastionAllowedResponse, ReturnType<typeof getBastionAllowedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBastionAllowed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBastionAllowedQueryKey(options)
});

/**
 * Search table items by term
 *
 * Search for items in a table matching a term. Returns matching rows pluck'd to ``{id, name, ...}`` for typeahead autocompletes (the webapp's select2 ajax adapters at ``static/admin/js/{storage,desktops,authentication,...}.js`` iterate the response with ``$.map``, expecting a list).
 */
export const allowedsTableTermMutation = (options?: Partial<Options<AllowedsTableTermData>>): UseMutationOptions<AllowedsTableTermResponse, AllowedsTableTermError, Options<AllowedsTableTermData>> => {
    const mutationOptions: UseMutationOptions<AllowedsTableTermResponse, AllowedsTableTermError, Options<AllowedsTableTermData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await allowedsTableTerm({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update allowed access for a table item
 *
 * Update the allowed access permissions (roles, categories, groups, users) for an item in the specified table. Handles special bastion table cases.
 */
export const adminAllowedUpdateMutation = (options?: Partial<Options<AdminAllowedUpdateData>>): UseMutationOptions<AdminAllowedUpdateResponse, AdminAllowedUpdateError, Options<AdminAllowedUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminAllowedUpdateResponse, AdminAllowedUpdateError, Options<AdminAllowedUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAllowedUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get allowed access list for a table item
 *
 * Get the allowed access configuration for an item, enriched with names for roles, categories, groups, and users.
 */
export const allowedTableMutation = (options?: Partial<Options<AllowedTableData>>): UseMutationOptions<AllowedTableResponse2, AllowedTableError, Options<AllowedTableData>> => {
    const mutationOptions: UseMutationOptions<AllowedTableResponse2, AllowedTableError, Options<AllowedTableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await allowedTable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserBookingsQueryKey = (options?: Options<GetUserBookingsData>) => createQueryKey('getUserBookings', options);

/**
 * Get user bookings
 *
 * Returns a list of user bookings.
 */
export const getUserBookingsOptions = (options?: Options<GetUserBookingsData>) => queryOptions<GetUserBookingsResponse, GetUserBookingsError, GetUserBookingsResponse, ReturnType<typeof getUserBookingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserBookings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserBookingsQueryKey(options)
});

export const getBookingDesktopQueryKey = (options: Options<GetBookingDesktopData>) => createQueryKey('getBookingDesktop', options);

/**
 * Get desktop's bookings
 *
 * Returns the bookings for a specific desktop.
 */
export const getBookingDesktopOptions = (options: Options<GetBookingDesktopData>) => queryOptions<GetBookingDesktopResponse, GetBookingDesktopError, GetBookingDesktopResponse, ReturnType<typeof getBookingDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingDesktopQueryKey(options)
});

export const getBookingPriorityDesktopQueryKey = (options: Options<GetBookingPriorityDesktopData>) => createQueryKey('getBookingPriorityDesktop', options);

/**
 * Get booking priority for a desktop
 *
 * Returns the calling user's booking priority profile and the desktop name. ``@has_token`` + ``ownsDomainId``.
 */
export const getBookingPriorityDesktopOptions = (options: Options<GetBookingPriorityDesktopData>) => queryOptions<GetBookingPriorityDesktopResponse, GetBookingPriorityDesktopError, GetBookingPriorityDesktopResponse, ReturnType<typeof getBookingPriorityDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingPriorityDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingPriorityDesktopQueryKey(options)
});

export const getBookingPriorityDeploymentQueryKey = (options: Options<GetBookingPriorityDeploymentData>) => createQueryKey('getBookingPriorityDeployment', options);

/**
 * Get booking priority for a deployment
 *
 * Returns the calling user's booking priority profile and the deployment name. ``@has_token`` + ``ownsDeploymentId``.
 */
export const getBookingPriorityDeploymentOptions = (options: Options<GetBookingPriorityDeploymentData>) => queryOptions<GetBookingPriorityDeploymentResponse, GetBookingPriorityDeploymentError, GetBookingPriorityDeploymentResponse, ReturnType<typeof getBookingPriorityDeploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingPriorityDeployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingPriorityDeploymentQueryKey(options)
});

/**
 * Delete booking event
 *
 * Deletes a booking event. ``@has_token`` + ``ownsBookingId``. Refuses to delete an in-progress booking while its desktop/deployment is still running.
 */
export const deleteBookingEventMutation = (options?: Partial<Options<DeleteBookingEventData>>): UseMutationOptions<DeleteBookingEventResponse, DeleteBookingEventError, Options<DeleteBookingEventData>> => {
    const mutationOptions: UseMutationOptions<DeleteBookingEventResponse, DeleteBookingEventError, Options<DeleteBookingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBookingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update booking event
 *
 * Edits an existing booking event's title and time window. ``@has_token`` + ``ownsBookingId``.
 */
export const updateBookingEventMutation = (options?: Partial<Options<UpdateBookingEventData>>): UseMutationOptions<UpdateBookingEventResponse, UpdateBookingEventError, Options<UpdateBookingEventData>> => {
    const mutationOptions: UseMutationOptions<UpdateBookingEventResponse, UpdateBookingEventError, Options<UpdateBookingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBookingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create booking event
 *
 * Creates a new booking event. ``@has_token`` + ``ownsDomainId``/``ownsDeploymentId`` on the booked item.
 */
export const createBookingEventMutation = (options?: Partial<Options<CreateBookingEventData>>): UseMutationOptions<CreateBookingEventResponse, CreateBookingEventError, Options<CreateBookingEventData>> => {
    const mutationOptions: UseMutationOptions<CreateBookingEventResponse, CreateBookingEventError, Options<CreateBookingEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBookingEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMaxBookingDateQueryKey = (options: Options<GetMaxBookingDateData>) => createQueryKey('getMaxBookingDate', options);

/**
 * Get max booking date
 *
 * Returns the maximum booking date for a desktop. ``@has_token`` + ``ownsDomainId``.
 */
export const getMaxBookingDateOptions = (options: Options<GetMaxBookingDateData>) => queryOptions<GetMaxBookingDateResponse, GetMaxBookingDateError, GetMaxBookingDateResponse, ReturnType<typeof getMaxBookingDateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaxBookingDate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaxBookingDateQueryKey(options)
});

export const getItemAvailabilityQueryKey = (options: Options<GetItemAvailabilityData>) => createQueryKey('getItemAvailability', options);

/**
 * Get item availability
 *
 * Returns item availability by crossing info with the resource planner. ``@has_token`` + ``ownsDomainId``/``ownsDeploymentId``.
 */
export const getItemAvailabilityOptions = (options: Options<GetItemAvailabilityData>) => queryOptions<GetItemAvailabilityResponse, GetItemAvailabilityError, GetItemAvailabilityResponse, ReturnType<typeof getItemAvailabilityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getItemAvailability({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemAvailabilityQueryKey(options)
});

export const getBookingReservablesAvailableQueryKey = (options?: Options<GetBookingReservablesAvailableData>) => createQueryKey('getBookingReservablesAvailable', options);

/**
 * Get available reservables
 *
 * Returns available reservables for the current user.
 */
export const getBookingReservablesAvailableOptions = (options?: Options<GetBookingReservablesAvailableData>) => queryOptions<GetBookingReservablesAvailableResponse, GetBookingReservablesAvailableError, GetBookingReservablesAvailableResponse, ReturnType<typeof getBookingReservablesAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingReservablesAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingReservablesAvailableQueryKey(options)
});

export const getReservablesAvailableQueryKey = (options?: Options<GetReservablesAvailableData>) => createQueryKey('getReservablesAvailable', options);

/**
 * Get booking reservables available
 *
 * Returns available reservables for booking.
 */
export const getReservablesAvailableOptions = (options?: Options<GetReservablesAvailableData>) => queryOptions<GetReservablesAvailableResponse, GetReservablesAvailableError, GetReservablesAvailableResponse, ReturnType<typeof getReservablesAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReservablesAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReservablesAvailableQueryKey(options)
});

/**
 * Booking provisioning
 *
 * Determines where a new booking can be placed based on available resources.
 */
export const bookingProvisioningMutation = (options?: Partial<Options<BookingProvisioningData>>): UseMutationOptions<BookingProvisioningResponse, BookingProvisioningError, Options<BookingProvisioningData>> => {
    const mutationOptions: UseMutationOptions<BookingProvisioningResponse, BookingProvisioningError, Options<BookingProvisioningData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bookingProvisioning({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getShareLinkQueryKey = (options: Options<GetShareLinkData>) => createQueryKey('getShareLink', options);

/**
 * Get an url to share a desktop
 *
 * Returns a link to share an IsardVDI desktop based on an ID.
 */
export const getShareLinkOptions = (options: Options<GetShareLinkData>) => queryOptions<GetShareLinkResponse, GetShareLinkError, GetShareLinkResponse, ReturnType<typeof getShareLinkQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getShareLink({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getShareLinkQueryKey(options)
});

/**
 * Generate an link to share a desktop
 *
 * Generates a link to share an IsardVDI desktop based on an ID
 */
export const updateShareLinkMutation = (options?: Partial<Options<UpdateShareLinkData>>): UseMutationOptions<UpdateShareLinkResponse, UpdateShareLinkError, Options<UpdateShareLinkData>> => {
    const mutationOptions: UseMutationOptions<UpdateShareLinkResponse, UpdateShareLinkError, Options<UpdateShareLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create (or reuse) a non-persistent desktop
 *
 * Creates and starts a non-persistent desktop from a template. Where the old frontend is still reachable an existing non-persistent desktop derived from the same template is reused (and started if stopped); only installations exposing the new frontend alone (``FRONTEND_MODE=actual``) may hold several, bounded by the ``volatile`` quota. ``@has_token`` — quota and allowlist checks are enforced server-side.
 */
export const createNonpersistentDesktopMutation = (options?: Partial<Options<CreateNonpersistentDesktopData>>): UseMutationOptions<CreateNonpersistentDesktopResponse, CreateNonpersistentDesktopError, Options<CreateNonpersistentDesktopData>> => {
    const mutationOptions: UseMutationOptions<CreateNonpersistentDesktopResponse, CreateNonpersistentDesktopError, Options<CreateNonpersistentDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createNonpersistentDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a desktop
 *
 * Creates a desktop with the given parameters.
 */
export const createDesktopMutation = (options?: Partial<Options<CreateDesktopData>>): UseMutationOptions<CreateDesktopResponse, CreateDesktopError, Options<CreateDesktopData>> => {
    const mutationOptions: UseMutationOptions<CreateDesktopResponse, CreateDesktopError, Options<CreateDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a desktop
 *
 * Deletes desktop based on the desktop ID
 */
export const deleteDesktopMutation = (options?: Partial<Options<DeleteDesktopData>>): UseMutationOptions<DeleteDesktopResponse, DeleteDesktopError, Options<DeleteDesktopData>> => {
    const mutationOptions: UseMutationOptions<DeleteDesktopResponse, DeleteDesktopError, Options<DeleteDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopQueryKey = (options: Options<GetDesktopData>) => createQueryKey('getDesktop', options);

/**
 * Get details of a desktop
 *
 * Returns a desktop in IsardVDI based on an ID.
 */
export const getDesktopOptions = (options: Options<GetDesktopData>) => queryOptions<GetDesktopResponse, GetDesktopError, GetDesktopResponse, ReturnType<typeof getDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopQueryKey(options)
});

export const getDesktopNetworksQueryKey = (options: Options<GetDesktopNetworksData>) => createQueryKey('getDesktopNetworks', options);

/**
 * Get details of a desktop networks
 *
 * Returns the networks information about a IsardVDI desktops based on an ID.
 */
export const getDesktopNetworksOptions = (options: Options<GetDesktopNetworksData>) => queryOptions<GetDesktopNetworksResponse, GetDesktopNetworksError, GetDesktopNetworksResponse, ReturnType<typeof getDesktopNetworksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopNetworks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopNetworksQueryKey(options)
});

export const getDesktopDetailsQueryKey = (options: Options<GetDesktopDetailsData>) => createQueryKey('getDesktopDetails', options);

/**
 * Get the details of a desktop
 *
 * Gets a desktop details based on the desktop ID
 */
export const getDesktopDetailsOptions = (options: Options<GetDesktopDetailsData>) => queryOptions<GetDesktopDetailsResponse, GetDesktopDetailsError, GetDesktopDetailsResponse, ReturnType<typeof getDesktopDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopDetailsQueryKey(options)
});

export const getDesktopBastionLegacyQueryKey = (options: Options<GetDesktopBastionLegacyData>) => createQueryKey('getDesktopBastionLegacy', options);

/**
 * Get desktop bastion configuration
 *
 * Returns the bastion configuration for a desktop based on the desktop ID
 */
export const getDesktopBastionLegacyOptions = (options: Options<GetDesktopBastionLegacyData>) => queryOptions<GetDesktopBastionLegacyResponse, GetDesktopBastionLegacyError, GetDesktopBastionLegacyResponse, ReturnType<typeof getDesktopBastionLegacyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopBastionLegacy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopBastionLegacyQueryKey(options)
});

/**
 * Update desktop bastion authorized keys
 *
 * Updates the authorized keys for the desktop bastion
 */
export const updateDesktopBastionAuthorizedKeysMutation = (options?: Partial<Options<UpdateDesktopBastionAuthorizedKeysData>>): UseMutationOptions<UpdateDesktopBastionAuthorizedKeysResponse, UpdateDesktopBastionAuthorizedKeysError, Options<UpdateDesktopBastionAuthorizedKeysData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesktopBastionAuthorizedKeysResponse, UpdateDesktopBastionAuthorizedKeysError, Options<UpdateDesktopBastionAuthorizedKeysData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesktopBastionAuthorizedKeys({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Extend desktop timeout
 *
 * Extend the remaining time before automatic desktop shutdown.
 */
export const extendDesktopTimeoutMutation = (options?: Partial<Options<ExtendDesktopTimeoutData>>): UseMutationOptions<ExtendDesktopTimeoutResponse, ExtendDesktopTimeoutError, Options<ExtendDesktopTimeoutData>> => {
    const mutationOptions: UseMutationOptions<ExtendDesktopTimeoutResponse, ExtendDesktopTimeoutError, Options<ExtendDesktopTimeoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extendDesktopTimeout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop a desktop
 *
 * Stops a desktop based on the desktop ID
 */
export const stopDesktopMutation = (options?: Partial<Options<StopDesktopData>>): UseMutationOptions<StopDesktopResponse, StopDesktopError, Options<StopDesktopData>> => {
    const mutationOptions: UseMutationOptions<StopDesktopResponse, StopDesktopError, Options<StopDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop all user desktops
 *
 * Stops all the desktops from the user
 */
export const stopDesktopsMutation = (options?: Partial<Options<StopDesktopsData>>): UseMutationOptions<StopDesktopsResponse, StopDesktopsError, Options<StopDesktopsData>> => {
    const mutationOptions: UseMutationOptions<StopDesktopsResponse, StopDesktopsError, Options<StopDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a desktop
 *
 * Starts a desktop based on the desktop ID
 */
export const startDesktopMutation = (options?: Partial<Options<StartDesktopData>>): UseMutationOptions<StartDesktopResponse, StartDesktopError, Options<StartDesktopData>> => {
    const mutationOptions: UseMutationOptions<StartDesktopResponse, StartDesktopError, Options<StartDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Updates a desktop status
 *
 * Updates the desktop status based on the desktop ID. Mainly used when desktop is Failed
 */
export const updateStatusDesktopMutation = (options?: Partial<Options<UpdateStatusDesktopData>>): UseMutationOptions<UpdateStatusDesktopResponse, UpdateStatusDesktopError, Options<UpdateStatusDesktopData>> => {
    const mutationOptions: UseMutationOptions<UpdateStatusDesktopResponse, UpdateStatusDesktopError, Options<UpdateStatusDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStatusDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry a Failed desktop
 *
 * Transitions a ``Failed`` desktop back to ``StartingPaused`` so the engine can validate it can start on a hypervisor again. Ports v3 ``GET /desktop/updating/{desktop_id}``. Ownership is enforced.
 */
export const retryFailedDesktopMutation = (options?: Partial<Options<RetryFailedDesktopData>>): UseMutationOptions<RetryFailedDesktopResponse, RetryFailedDesktopError, Options<RetryFailedDesktopData>> => {
    const mutationOptions: UseMutationOptions<RetryFailedDesktopResponse, RetryFailedDesktopError, Options<RetryFailedDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryFailedDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force stop a desktop
 *
 * Force stops a desktop based on the desktop ID
 */
export const forceStopDesktopMutation = (options?: Partial<Options<ForceStopDesktopData>>): UseMutationOptions<ForceStopDesktopResponse, ForceStopDesktopError, Options<ForceStopDesktopData>> => {
    const mutationOptions: UseMutationOptions<ForceStopDesktopResponse, ForceStopDesktopError, Options<ForceStopDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forceStopDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopImagesQueryKey = (options?: Options<GetDesktopImagesData>) => createQueryKey('getDesktopImages', options);

/**
 * Get available desktop images
 *
 * Returns available desktop images (stock and user cards)
 */
export const getDesktopImagesOptions = (options?: Options<GetDesktopImagesData>) => queryOptions<GetDesktopImagesResponse, GetDesktopImagesError, GetDesktopImagesResponse, ReturnType<typeof getDesktopImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopImagesQueryKey(options)
});

/**
 * Delete user desktops from a deployment
 *
 * Deletes all desktops belonging to one user inside a deployment
 */
export const deleteUserDeploymentDesktopsMutation = (options?: Partial<Options<DeleteUserDeploymentDesktopsData>>): UseMutationOptions<DeleteUserDeploymentDesktopsResponse, DeleteUserDeploymentDesktopsError, Options<DeleteUserDeploymentDesktopsData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserDeploymentDesktopsResponse, DeleteUserDeploymentDesktopsError, Options<DeleteUserDeploymentDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUserDeploymentDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserDesktopsQueryKey = (options?: Options<GetUserDesktopsData>) => createQueryKey('getUserDesktops', options);

/**
 * Get user desktops
 *
 * Returns a list of all desktops that belong to the user calling the endpoint.
 */
export const getUserDesktopsOptions = (options?: Options<GetUserDesktopsData>) => queryOptions<GetUserDesktopsResponse, GetUserDesktopsError, GetUserDesktopsResponse, ReturnType<typeof getUserDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDesktopsQueryKey(options)
});

export const getUserDesktopsPaginatedQueryKey = (options?: Options<GetUserDesktopsPaginatedData>) => createQueryKey('getUserDesktopsPaginated', options);

/**
 * Get user desktops
 *
 * Returns a list of all desktops that belong to the user calling the endpoint.
 */
export const getUserDesktopsPaginatedOptions = (options?: Options<GetUserDesktopsPaginatedData>) => queryOptions<GetUserDesktopsPaginatedResponse, GetUserDesktopsPaginatedError, GetUserDesktopsPaginatedResponse, ReturnType<typeof getUserDesktopsPaginatedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserDesktopsPaginated({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserDesktopsPaginatedQueryKey(options)
});

export const getDomainsAllowedReservablesQueryKey = (options?: Options<GetDomainsAllowedReservablesData>) => createQueryKey('getDomainsAllowedReservables', options);

/**
 * Get allowed reservables for the calling user
 *
 * Returns the reservable vGPUs visible to the calling user, filtered by category/group/role/user permissions.
 */
export const getDomainsAllowedReservablesOptions = (options?: Options<GetDomainsAllowedReservablesData>) => queryOptions<GetDomainsAllowedReservablesResponse, GetDomainsAllowedReservablesError, GetDomainsAllowedReservablesResponse, ReturnType<typeof getDomainsAllowedReservablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDomainsAllowedReservables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDomainsAllowedReservablesQueryKey(options)
});

/**
 * Create a desktop from media
 *
 * Creates a desktop from media with the given parameters. Available to any logged-in user; quota is enforced server-side.
 */
export const createDesktopFromMediaMutation = (options?: Partial<Options<CreateDesktopFromMediaData>>): UseMutationOptions<CreateDesktopFromMediaResponse, CreateDesktopFromMediaError, Options<CreateDesktopFromMediaData>> => {
    const mutationOptions: UseMutationOptions<CreateDesktopFromMediaResponse, CreateDesktopFromMediaError, Options<CreateDesktopFromMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDesktopFromMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopInfoQueryKey = (options: Options<GetDesktopInfoData>) => createQueryKey('getDesktopInfo', options);

/**
 * Get desktop information
 *
 * Returns detailed information about a specific desktop.
 */
export const getDesktopInfoOptions = (options: Options<GetDesktopInfoData>) => queryOptions<GetDesktopInfoResponse, GetDesktopInfoError, GetDesktopInfoResponse, ReturnType<typeof getDesktopInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopInfoQueryKey(options)
});

/**
 * Edit a desktop
 *
 * Updates a desktop with the given parameters.
 */
export const editDesktopMutation = (options?: Partial<Options<EditDesktopData>>): UseMutationOptions<EditDesktopResponse, EditDesktopError, Options<EditDesktopData>> => {
    const mutationOptions: UseMutationOptions<EditDesktopResponse, EditDesktopError, Options<EditDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDesktopViewerByTypeQueryKey = (options: Options<GetDesktopViewerByTypeData>) => createQueryKey('getDesktopViewerByType', options);

/**
 * Get desktop viewer connection string
 *
 * Returns the connection string for a specific viewer type for the given desktop.
 */
export const getDesktopViewerByTypeOptions = (options: Options<GetDesktopViewerByTypeData>) => queryOptions<GetDesktopViewerByTypeResponse, GetDesktopViewerByTypeError, GetDesktopViewerByTypeResponse, ReturnType<typeof getDesktopViewerByTypeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopViewerByType({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopViewerByTypeQueryKey(options)
});

/**
 * Recreate desktop disk
 *
 * Recreates the desktop disk from its parent template. Will delete the desktop storage and create a new one.
 */
export const recreateDesktopMutation = (options?: Partial<Options<RecreateDesktopData>>): UseMutationOptions<RecreateDesktopResponse, RecreateDesktopError, Options<RecreateDesktopData>> => {
    const mutationOptions: UseMutationOptions<RecreateDesktopResponse, RecreateDesktopError, Options<RecreateDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recreateDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update desktop bastion domain
 *
 * Updates the domain name for the desktop's bastion target.
 */
export const updateDesktopBastionDomainMutation = (options?: Partial<Options<UpdateDesktopBastionDomainData>>): UseMutationOptions<UpdateDesktopBastionDomainResponse, UpdateDesktopBastionDomainError, Options<UpdateDesktopBastionDomainData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesktopBastionDomainResponse, UpdateDesktopBastionDomainError, Options<UpdateDesktopBastionDomainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesktopBastionDomain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update desktop bastion domains (bulk)
 *
 * Replaces the list of individual bastion domains for a desktop. Up to 10 domains are allowed; newly added domains are DNS-verified against the category's CNAME before being saved.
 */
export const updateDesktopBastionDomainsMutation = (options?: Partial<Options<UpdateDesktopBastionDomainsData>>): UseMutationOptions<UpdateDesktopBastionDomainsResponse, UpdateDesktopBastionDomainsError, Options<UpdateDesktopBastionDomainsData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesktopBastionDomainsResponse, UpdateDesktopBastionDomainsError, Options<UpdateDesktopBastionDomainsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesktopBastionDomains({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * DNS-verify a single bastion domain without saving
 *
 * Checks that the DNS CNAME for the given candidate domain resolves to the expected target for this desktop's bastion category.
 */
export const verifyDesktopBastionDomainMutation = (options?: Partial<Options<VerifyDesktopBastionDomainData>>): UseMutationOptions<VerifyDesktopBastionDomainResponse, VerifyDesktopBastionDomainError, Options<VerifyDesktopBastionDomainData>> => {
    const mutationOptions: UseMutationOptions<VerifyDesktopBastionDomainResponse, VerifyDesktopBastionDomainError, Options<VerifyDesktopBastionDomainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyDesktopBastionDomain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTemplateInfoQueryKey = (options: Options<GetTemplateInfoData>) => createQueryKey('getTemplateInfo', options);

/**
 * Get template information
 *
 * Returns detailed information about a specific template.
 */
export const getTemplateInfoOptions = (options: Options<GetTemplateInfoData>) => queryOptions<GetTemplateInfoResponse, GetTemplateInfoError, GetTemplateInfoResponse, ReturnType<typeof getTemplateInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplateInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateInfoQueryKey(options)
});

export const getTemplateDetailsQueryKey = (options: Options<GetTemplateDetailsData>) => createQueryKey('getTemplateDetails', options);

/**
 * Get the details of a template
 *
 * Gets a template details based on the template ID
 */
export const getTemplateDetailsOptions = (options: Options<GetTemplateDetailsData>) => queryOptions<GetTemplateDetailsResponse, GetTemplateDetailsError, GetTemplateDetailsResponse, ReturnType<typeof getTemplateDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplateDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateDetailsQueryKey(options)
});

export const getTemplateNonpersistentDesktopQueryKey = (options: Options<GetTemplateNonpersistentDesktopData>) => createQueryKey('getTemplateNonpersistentDesktop', options);

/**
 * Get the non-persistent desktop this template would reuse
 *
 * Returns the user's non-persistent desktop derived from this template when creating another temporal desktop would reuse it instead of creating a new one, and ``null`` otherwise. Only installations still exposing the old frontend reuse, so this endpoint goes away with it.
 */
export const getTemplateNonpersistentDesktopOptions = (options: Options<GetTemplateNonpersistentDesktopData>) => queryOptions<GetTemplateNonpersistentDesktopResponse, GetTemplateNonpersistentDesktopError, GetTemplateNonpersistentDesktopResponse, ReturnType<typeof getTemplateNonpersistentDesktopQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplateNonpersistentDesktop({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateNonpersistentDesktopQueryKey(options)
});

export const getUserAllowedTemplatesFlatQueryKey = (options: Options<GetUserAllowedTemplatesFlatData>) => createQueryKey('getUserAllowedTemplatesFlat', options);

/**
 * Get flat list of templates the user can use
 *
 * Returns a flat list of enabled templates the caller is allowed to use. ``kind`` is one of ``all`` (owned + shared enabled templates) or ``shared`` (only templates shared with the user, not owned). Used by frontends that need a simple dropdown list without pagination. Replaces v3 ``GET /user/templates/allowed/{kind}`` ``@has_token``.
 */
export const getUserAllowedTemplatesFlatOptions = (options: Options<GetUserAllowedTemplatesFlatData>) => queryOptions<GetUserAllowedTemplatesFlatResponse, GetUserAllowedTemplatesFlatError, GetUserAllowedTemplatesFlatResponse, ReturnType<typeof getUserAllowedTemplatesFlatQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserAllowedTemplatesFlat({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserAllowedTemplatesFlatQueryKey(options)
});

export const getUserSharedTemplatesQueryKey = (options?: Options<GetUserSharedTemplatesData>) => createQueryKey('getUserSharedTemplates', options);

/**
 * Get shared templates for user
 *
 * Returns a list of all templates that are shared with them.
 */
export const getUserSharedTemplatesOptions = (options?: Options<GetUserSharedTemplatesData>) => queryOptions<GetUserSharedTemplatesResponse, GetUserSharedTemplatesError, GetUserSharedTemplatesResponse, ReturnType<typeof getUserSharedTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserSharedTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserSharedTemplatesQueryKey(options)
});

export const getUserAllowedTemplatesQueryKey = (options?: Options<GetUserAllowedTemplatesData>) => createQueryKey('getUserAllowedTemplates', options);

/**
 * Get allowed templates for user
 *
 * Returns a list of all templates that the user can see, considering its role permissions.
 */
export const getUserAllowedTemplatesOptions = (options?: Options<GetUserAllowedTemplatesData>) => queryOptions<GetUserAllowedTemplatesResponse, GetUserAllowedTemplatesError, GetUserAllowedTemplatesResponse, ReturnType<typeof getUserAllowedTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserAllowedTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserAllowedTemplatesQueryKey(options)
});

export const searchUsersInCategoryQueryKey = (options: Options<SearchUsersInCategoryData>) => createQueryKey('searchUsersInCategory', options);

/**
 * Get users in the user category
 *
 * Returns a list of users in a specific category.
 */
export const searchUsersInCategoryOptions = (options: Options<SearchUsersInCategoryData>) => queryOptions<SearchUsersInCategoryResponse, SearchUsersInCategoryError, SearchUsersInCategoryResponse, ReturnType<typeof searchUsersInCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchUsersInCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchUsersInCategoryQueryKey(options)
});

export const getAvailableGroupsForCategoryQueryKey = (options?: Options<GetAvailableGroupsForCategoryData>) => createQueryKey('getAvailableGroupsForCategory', options);

/**
 * Get available groups for a category
 *
 * Returns a list of available groups for a specific category.
 */
export const getAvailableGroupsForCategoryOptions = (options?: Options<GetAvailableGroupsForCategoryData>) => queryOptions<GetAvailableGroupsForCategoryResponse, GetAvailableGroupsForCategoryError, GetAvailableGroupsForCategoryResponse, ReturnType<typeof getAvailableGroupsForCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAvailableGroupsForCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAvailableGroupsForCategoryQueryKey(options)
});

/**
 * Bulk delete deployments
 *
 * Deletes multiple deployments. Optionally permanently.
 */
export const bulkDeleteDeploymentsMutation = (options?: Partial<Options<BulkDeleteDeploymentsData>>): UseMutationOptions<BulkDeleteDeploymentsResponse, BulkDeleteDeploymentsError, Options<BulkDeleteDeploymentsData>> => {
    const mutationOptions: UseMutationOptions<BulkDeleteDeploymentsResponse, BulkDeleteDeploymentsError, Options<BulkDeleteDeploymentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkDeleteDeployments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllDeploymentsQueryKey = (options?: Options<GetAllDeploymentsData>) => createQueryKey('getAllDeployments', options);

/**
 * Get all owned deployments
 *
 * Returns all the deployments that the user in the payload is owner or co-owner.
 */
export const getAllDeploymentsOptions = (options?: Options<GetAllDeploymentsData>) => queryOptions<GetAllDeploymentsResponse, GetAllDeploymentsError, GetAllDeploymentsResponse, ReturnType<typeof getAllDeploymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllDeployments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllDeploymentsQueryKey(options)
});

export const checkDeploymentQuotaGetQueryKey = (options?: Options<CheckDeploymentQuotaGetData>) => createQueryKey('checkDeploymentQuotaGet', options);

/**
 * Check deployment creation quota
 *
 * Checks if the user has enough quota to create a new deployment.
 */
export const checkDeploymentQuotaGetOptions = (options?: Options<CheckDeploymentQuotaGetData>) => queryOptions<CheckDeploymentQuotaGetResponse, CheckDeploymentQuotaGetError, CheckDeploymentQuotaGetResponse, ReturnType<typeof checkDeploymentQuotaGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkDeploymentQuotaGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkDeploymentQuotaGetQueryKey(options)
});

/**
 * Check deployment creation quota with allowed users
 *
 * Checks if the user has enough quota to create a new deployment with the given allowed users.
 */
export const checkDeploymentQuotaPostMutation = (options?: Partial<Options<CheckDeploymentQuotaPostData>>): UseMutationOptions<CheckDeploymentQuotaPostResponse, CheckDeploymentQuotaPostError, Options<CheckDeploymentQuotaPostData>> => {
    const mutationOptions: UseMutationOptions<CheckDeploymentQuotaPostResponse, CheckDeploymentQuotaPostError, Options<CheckDeploymentQuotaPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkDeploymentQuotaPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a deployment
 *
 * Deletes a deployment and all it's desktops permanently.
 */
export const deleteDeploymentMutation = (options?: Partial<Options<DeleteDeploymentData>>): UseMutationOptions<DeleteDeploymentResponse, DeleteDeploymentError, Options<DeleteDeploymentData>> => {
    const mutationOptions: UseMutationOptions<DeleteDeploymentResponse, DeleteDeploymentError, Options<DeleteDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentQueryKey = (options: Options<GetDeploymentData>) => createQueryKey('getDeployment', options);

/**
 * Get details of a deployment
 *
 * Returns a deployment based on an ID.
 */
export const getDeploymentOptions = (options: Options<GetDeploymentData>) => queryOptions<GetDeploymentResponse, GetDeploymentError, GetDeploymentResponse, ReturnType<typeof getDeploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentQueryKey(options)
});

/**
 * Create a new deployment
 *
 * Creates a new deployment with the provided data.
 */
export const createDeploymentMutation = (options?: Partial<Options<CreateDeploymentData>>): UseMutationOptions<CreateDeploymentResponse, CreateDeploymentError, Options<CreateDeploymentData>> => {
    const mutationOptions: UseMutationOptions<CreateDeploymentResponse, CreateDeploymentError, Options<CreateDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop all desktops from a deployment
 *
 * Stop all started desktops from a deployment.
 */
export const stopAllDesktopsInDeploymentMutation = (options?: Partial<Options<StopAllDesktopsInDeploymentData>>): UseMutationOptions<StopAllDesktopsInDeploymentResponse, StopAllDesktopsInDeploymentError, Options<StopAllDesktopsInDeploymentData>> => {
    const mutationOptions: UseMutationOptions<StopAllDesktopsInDeploymentResponse, StopAllDesktopsInDeploymentError, Options<StopAllDesktopsInDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopAllDesktopsInDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Toggle deployment visibility
 *
 * Toggles the visibility of the deployment with the given ID.
 */
export const toggleDeploymentVisibilityMutation = (options?: Partial<Options<ToggleDeploymentVisibilityData>>): UseMutationOptions<ToggleDeploymentVisibilityResponse, ToggleDeploymentVisibilityError, Options<ToggleDeploymentVisibilityData>> => {
    const mutationOptions: UseMutationOptions<ToggleDeploymentVisibilityResponse, ToggleDeploymentVisibilityError, Options<ToggleDeploymentVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleDeploymentVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit an existing deployment. Designed to be used via form
 *
 * Edits an existing deployment with the provided data.
 */
export const editDeploymentMutation = (options?: Partial<Options<EditDeploymentData>>): UseMutationOptions<EditDeploymentResponse, EditDeploymentError, Options<EditDeploymentData>> => {
    const mutationOptions: UseMutationOptions<EditDeploymentResponse, EditDeploymentError, Options<EditDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentCsvQueryKey = (options: Options<GetDeploymentCsvData>) => createQueryKey('getDeploymentCsv', options);

/**
 * Export direct viewer URLs as CSV
 *
 * Generates a CSV file with direct viewer URLs for all desktops in the deployment
 */
export const getDeploymentCsvOptions = (options: Options<GetDeploymentCsvData>) => queryOptions<unknown, GetDeploymentCsvError, unknown, ReturnType<typeof getDeploymentCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentCsvQueryKey(options)
});

export const countRecreateDeploymentDesktopsQueryKey = (options: Options<CountRecreateDeploymentDesktopsData>) => createQueryKey('countRecreateDeploymentDesktops', options);

/**
 * Count the desktops a deployment recreate would create
 *
 * Returns how many desktops a recreate would create, so the confirmation shown to the user matches what will actually be created.
 */
export const countRecreateDeploymentDesktopsOptions = (options: Options<CountRecreateDeploymentDesktopsData>) => queryOptions<CountRecreateDeploymentDesktopsResponse, CountRecreateDeploymentDesktopsError, CountRecreateDeploymentDesktopsResponse, ReturnType<typeof countRecreateDeploymentDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await countRecreateDeploymentDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: countRecreateDeploymentDesktopsQueryKey(options)
});

/**
 * Recreate a deployment
 *
 * Creates the desktops that are missing for the deployment's currently allowed users. Existing desktops are left untouched.
 */
export const recreateDeploymentMutation = (options?: Partial<Options<RecreateDeploymentData>>): UseMutationOptions<RecreateDeploymentResponse, RecreateDeploymentError, Options<RecreateDeploymentData>> => {
    const mutationOptions: UseMutationOptions<RecreateDeploymentResponse, RecreateDeploymentError, Options<RecreateDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recreateDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentBastionQueryKey = (options: Options<GetDeploymentBastionData>) => createQueryKey('getDeploymentBastion', options);

/**
 * Get deployment bastion configuration
 *
 * Returns the deployment-level bastion configuration (ssh/http enable + ports).
 */
export const getDeploymentBastionOptions = (options: Options<GetDeploymentBastionData>) => queryOptions<GetDeploymentBastionResponse, GetDeploymentBastionError, GetDeploymentBastionResponse, ReturnType<typeof getDeploymentBastionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentBastion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentBastionQueryKey(options)
});

/**
 * Set deployment bastion configuration
 *
 * Persists the deployment-level bastion configuration and applies it (ssh/http enable + ports) to every desktop in the deployment. Each user's profile SSH key is added automatically when their desktop starts.
 */
export const setDeploymentBastionMutation = (options?: Partial<Options<SetDeploymentBastionData>>): UseMutationOptions<SetDeploymentBastionResponse, SetDeploymentBastionError, Options<SetDeploymentBastionData>> => {
    const mutationOptions: UseMutationOptions<SetDeploymentBastionResponse, SetDeploymentBastionError, Options<SetDeploymentBastionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDeploymentBastion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentBastionCsvQueryKey = (options: Options<GetDeploymentBastionCsvData>) => createQueryKey('getDeploymentBastionCsv', options);

/**
 * Export deployment bastion data as CSV
 *
 * Generates a CSV with bastion connection info for every desktop in the deployment.
 */
export const getDeploymentBastionCsvOptions = (options: Options<GetDeploymentBastionCsvData>) => queryOptions<unknown, GetDeploymentBastionCsvError, unknown, ReturnType<typeof getDeploymentBastionCsvQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentBastionCsv({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentBastionCsvQueryKey(options)
});

export const getDeploymentDesktopBastionQueryKey = (options: Options<GetDeploymentDesktopBastionData>) => createQueryKey('getDeploymentDesktopBastion', options);

/**
 * Get a deployment desktop's bastion status
 *
 * Read-only bastion status of a single desktop in the deployment, for the deployment owner and co-owners (who are not the desktop's own owner).
 */
export const getDeploymentDesktopBastionOptions = (options: Options<GetDeploymentDesktopBastionData>) => queryOptions<GetDeploymentDesktopBastionResponse, GetDeploymentDesktopBastionError, GetDeploymentDesktopBastionResponse, ReturnType<typeof getDeploymentDesktopBastionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentDesktopBastion({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentDesktopBastionQueryKey(options)
});

export const getDeploymentVideowallQueryKey = (options: Options<GetDeploymentVideowallData>) => createQueryKey('getDeploymentVideowall', options);

/**
 * Get deployment with videowall support
 *
 * Returns a deployment with its desktops for videowall (lab) display.
 */
export const getDeploymentVideowallOptions = (options: Options<GetDeploymentVideowallData>) => queryOptions<GetDeploymentVideowallResponse, GetDeploymentVideowallError, GetDeploymentVideowallResponse, ReturnType<typeof getDeploymentVideowallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentVideowall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentVideowallQueryKey(options)
});

/**
 * Start all desktops in a deployment
 *
 * Start all stopped desktops in a deployment.
 */
export const startAllDesktopsInDeploymentMutation = (options?: Partial<Options<StartAllDesktopsInDeploymentData>>): UseMutationOptions<StartAllDesktopsInDeploymentResponse, StartAllDesktopsInDeploymentError, Options<StartAllDesktopsInDeploymentData>> => {
    const mutationOptions: UseMutationOptions<StartAllDesktopsInDeploymentResponse, StartAllDesktopsInDeploymentError, Options<StartAllDesktopsInDeploymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startAllDesktopsInDeployment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Toggle individual domain visibility
 *
 * Toggles the visibility of a specific domain within a deployment.
 */
export const toggleDomainVisibilityMutation = (options?: Partial<Options<ToggleDomainVisibilityData>>): UseMutationOptions<ToggleDomainVisibilityResponse, ToggleDomainVisibilityError, Options<ToggleDomainVisibilityData>> => {
    const mutationOptions: UseMutationOptions<ToggleDomainVisibilityResponse, ToggleDomainVisibilityError, Options<ToggleDomainVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleDomainVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Toggle deployment domain visibility (by desktop id)
 *
 * Toggles the ``tag_visible`` flag of a deployment desktop, identified by the desktop id alone. ``@is_not_user`` — doesn't require the deployment id in the path. Use the sibling route with the deployment id when the caller has it at hand.
 */
export const toggleDesktopDeploymentVisibilityMutation = (options?: Partial<Options<ToggleDesktopDeploymentVisibilityData>>): UseMutationOptions<ToggleDesktopDeploymentVisibilityResponse, ToggleDesktopDeploymentVisibilityError, Options<ToggleDesktopDeploymentVisibilityData>> => {
    const mutationOptions: UseMutationOptions<ToggleDesktopDeploymentVisibilityResponse, ToggleDesktopDeploymentVisibilityError, Options<ToggleDesktopDeploymentVisibilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleDesktopDeploymentVisibility({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentHardwareQueryKey = (options: Options<GetDeploymentHardwareData>) => createQueryKey('getDeploymentHardware', options);

/**
 * Get deployment hardware details
 *
 * Returns the hardware configuration details of a deployment.
 */
export const getDeploymentHardwareOptions = (options: Options<GetDeploymentHardwareData>) => queryOptions<GetDeploymentHardwareResponse, GetDeploymentHardwareError, GetDeploymentHardwareResponse, ReturnType<typeof getDeploymentHardwareQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentHardware({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentHardwareQueryKey(options)
});

export const getDeploymentInfoQueryKey = (options: Options<GetDeploymentInfoData>) => createQueryKey('getDeploymentInfo', options);

/**
 * Get deployment info with quota limits
 *
 * Returns deployment info with hardware limited by user quota.
 */
export const getDeploymentInfoOptions = (options: Options<GetDeploymentInfoData>) => queryOptions<GetDeploymentInfoResponse, GetDeploymentInfoError, GetDeploymentInfoResponse, ReturnType<typeof getDeploymentInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentInfoQueryKey(options)
});

export const getDeploymentCoOwnersQueryKey = (options: Options<GetDeploymentCoOwnersData>) => createQueryKey('getDeploymentCoOwners', options);

/**
 * Get deployment co-owners
 *
 * Returns the list of co-owners of a deployment.
 */
export const getDeploymentCoOwnersOptions = (options: Options<GetDeploymentCoOwnersData>) => queryOptions<GetDeploymentCoOwnersResponse, GetDeploymentCoOwnersError, GetDeploymentCoOwnersResponse, ReturnType<typeof getDeploymentCoOwnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentCoOwners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentCoOwnersQueryKey(options)
});

/**
 * Update deployment co-owners
 *
 * Updates the list of co-owners of a deployment.
 */
export const updateDeploymentCoOwnersMutation = (options?: Partial<Options<UpdateDeploymentCoOwnersData>>): UseMutationOptions<UpdateDeploymentCoOwnersResponse, UpdateDeploymentCoOwnersError, Options<UpdateDeploymentCoOwnersData>> => {
    const mutationOptions: UseMutationOptions<UpdateDeploymentCoOwnersResponse, UpdateDeploymentCoOwnersError, Options<UpdateDeploymentCoOwnersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDeploymentCoOwners({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentAllowedQueryKey = (options: Options<GetDeploymentAllowedData>) => createQueryKey('getDeploymentAllowed', options);

/**
 * Get allowed users and groups for a deployment
 *
 * Returns the users and groups that currently have access to the specified deployment.
 */
export const getDeploymentAllowedOptions = (options: Options<GetDeploymentAllowedData>) => queryOptions<GetDeploymentAllowedResponse, GetDeploymentAllowedError, GetDeploymentAllowedResponse, ReturnType<typeof getDeploymentAllowedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentAllowed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentAllowedQueryKey(options)
});

/**
 * Edit deployment allowed users
 *
 * Updates the allowed users and groups for a deployment. Removes desktops for users no longer allowed and recreates for new users.
 */
export const editDeploymentUsersMutation = (options?: Partial<Options<EditDeploymentUsersData>>): UseMutationOptions<EditDeploymentUsersResponse, EditDeploymentUsersError, Options<EditDeploymentUsersData>> => {
    const mutationOptions: UseMutationOptions<EditDeploymentUsersResponse, EditDeploymentUsersError, Options<EditDeploymentUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editDeploymentUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeploymentPermissionsQueryKey = (options: Options<GetDeploymentPermissionsData>) => createQueryKey('getDeploymentPermissions', options);

/**
 * Get deployment permissions
 *
 * Returns the permissions list configured for the deployment owner. The shape mirrors the ``user_permissions`` field accepted by ``PUT /item/deployment/{deployment_id}/edit`` so the old-frontend edit form can round-trip the value without reshaping.
 */
export const getDeploymentPermissionsOptions = (options: Options<GetDeploymentPermissionsData>) => queryOptions<GetDeploymentPermissionsResponse, GetDeploymentPermissionsError, GetDeploymentPermissionsResponse, ReturnType<typeof getDeploymentPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeploymentPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeploymentPermissionsQueryKey(options)
});

export const getUsersInGroupQueryKey = (options: Options<GetUsersInGroupData>) => createQueryKey('getUsersInGroup', options);

/**
 * Get users in a group
 *
 * Returns a list of users in a specific group.
 *
 * @deprecated
 */
export const getUsersInGroupOptions = (options: Options<GetUsersInGroupData>) => queryOptions<GetUsersInGroupResponse, GetUsersInGroupError, GetUsersInGroupResponse, ReturnType<typeof getUsersInGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsersInGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsersInGroupQueryKey(options)
});

export const getMediaInstallsQueryKey = (options?: Options<GetMediaInstallsData>) => createQueryKey('getMediaInstalls', options);

/**
 * Get available OS templates for media installs
 *
 * Returns the list of available OS templates (virt_install) that can be used when creating a desktop from media.
 */
export const getMediaInstallsOptions = (options?: Options<GetMediaInstallsData>) => queryOptions<GetMediaInstallsResponse, GetMediaInstallsError, GetMediaInstallsResponse, ReturnType<typeof getMediaInstallsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMediaInstalls({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMediaInstallsQueryKey(options)
});

export const getMediaAllowedTableQueryKey = (options: Options<GetMediaAllowedTableData>) => createQueryKey('getMediaAllowedTable', options);

/**
 * Get allowed users, roles, groups, categories for a media item
 *
 * Returns allowed users, roles, groups, categories for a media item.
 */
export const getMediaAllowedTableOptions = (options: Options<GetMediaAllowedTableData>) => queryOptions<GetMediaAllowedTableResponse, GetMediaAllowedTableError, GetMediaAllowedTableResponse, ReturnType<typeof getMediaAllowedTableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMediaAllowedTable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMediaAllowedTableQueryKey(options)
});

/**
 * Update allowed users, roles, groups, categories for a media item
 *
 * Update the list of groups, users, roles, and categories that have access to the specified media item. Only provided fields will be updated.
 */
export const updateMediaAllowedMutation = (options?: Partial<Options<UpdateMediaAllowedData>>): UseMutationOptions<UpdateMediaAllowedResponse, UpdateMediaAllowedError, Options<UpdateMediaAllowedData>> => {
    const mutationOptions: UseMutationOptions<UpdateMediaAllowedResponse, UpdateMediaAllowedError, Options<UpdateMediaAllowedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMediaAllowed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new media item
 *
 * Creates a new media item. Returns the created media ID on success.
 */
export const createMediaMutation = (options?: Partial<Options<CreateMediaData>>): UseMutationOptions<CreateMediaResponse, CreateMediaError, Options<CreateMediaData>> => {
    const mutationOptions: UseMutationOptions<CreateMediaResponse, CreateMediaError, Options<CreateMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Abort a media download
 *
 * Aborts a media download. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const abortMediaDownloadMutation = (options?: Partial<Options<AbortMediaDownloadData>>): UseMutationOptions<AbortMediaDownloadResponse, AbortMediaDownloadError, Options<AbortMediaDownloadData>> => {
    const mutationOptions: UseMutationOptions<AbortMediaDownloadResponse, AbortMediaDownloadError, Options<AbortMediaDownloadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await abortMediaDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a media download
 *
 * Starts a media download. ``@is_not_user`` — ownership is enforced by ``owns_media_id``.
 */
export const startMediaDownloadMutation = (options?: Partial<Options<StartMediaDownloadData>>): UseMutationOptions<StartMediaDownloadResponse, StartMediaDownloadError, Options<StartMediaDownloadData>> => {
    const mutationOptions: UseMutationOptions<StartMediaDownloadResponse, StartMediaDownloadError, Options<StartMediaDownloadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startMediaDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkQuotaNewMediaQueryKey = (options?: Options<CheckQuotaNewMediaData>) => createQueryKey('checkQuotaNewMedia', options);

/**
 * Check media quota
 *
 * Checks if adding new media would exceed the user's quota. Raises an error if the quota is exceeded.
 */
export const checkQuotaNewMediaOptions = (options?: Options<CheckQuotaNewMediaData>) => queryOptions<CheckQuotaNewMediaResponse, CheckQuotaNewMediaError, CheckQuotaNewMediaResponse, ReturnType<typeof checkQuotaNewMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkQuotaNewMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkQuotaNewMediaQueryKey(options)
});

export const checkQuotaNewTemplateQueryKey = (options?: Options<CheckQuotaNewTemplateData>) => createQueryKey('checkQuotaNewTemplate', options);

/**
 * Check templates quota
 *
 * Checks if creating a new template would exceed the user's quota.
 */
export const checkQuotaNewTemplateOptions = (options?: Options<CheckQuotaNewTemplateData>) => queryOptions<CheckQuotaNewTemplateResponse, CheckQuotaNewTemplateError, CheckQuotaNewTemplateResponse, ReturnType<typeof checkQuotaNewTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkQuotaNewTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkQuotaNewTemplateQueryKey(options)
});

export const checkQuotaNewDeploymentQueryKey = (options?: Options<CheckQuotaNewDeploymentData>) => createQueryKey('checkQuotaNewDeployment', options);

/**
 * Check deployments quota
 *
 * Checks if creating a new deployment would exceed the user's quota.
 */
export const checkQuotaNewDeploymentOptions = (options?: Options<CheckQuotaNewDeploymentData>) => queryOptions<CheckQuotaNewDeploymentResponse, CheckQuotaNewDeploymentError, CheckQuotaNewDeploymentResponse, ReturnType<typeof checkQuotaNewDeploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkQuotaNewDeployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkQuotaNewDeploymentQueryKey(options)
});

/**
 * Increase storage size
 *
 * Schedules a task to increase a storage's virtual size by ``{increment}`` GB. ``@is_not_user``.
 */
export const increaseStorageSizeMutation = (options?: Partial<Options<IncreaseStorageSizeData>>): UseMutationOptions<IncreaseStorageSizeResponse, IncreaseStorageSizeError, Options<IncreaseStorageSizeData>> => {
    const mutationOptions: UseMutationOptions<IncreaseStorageSizeResponse, IncreaseStorageSizeError, Options<IncreaseStorageSizeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await increaseStorageSize({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllUsersQueryKey = (options?: Options<GetAllUsersData>) => createQueryKey('getAllUsers', options);

/**
 * Get all users
 *
 * Returns all the users that the user in the payload can see.
 */
export const getAllUsersOptions = (options?: Options<GetAllUsersData>) => queryOptions<GetAllUsersResponse, GetAllUsersError, GetAllUsersResponse, ReturnType<typeof getAllUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllUsersQueryKey(options)
});

export const getAllGroupsQueryKey = (options?: Options<GetAllGroupsData>) => createQueryKey('getAllGroups', options);

/**
 * Get all groups
 *
 * Returns all the groups that the user in the payload can see.
 */
export const getAllGroupsOptions = (options?: Options<GetAllGroupsData>) => queryOptions<GetAllGroupsResponse, GetAllGroupsError, GetAllGroupsResponse, ReturnType<typeof getAllGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllGroupsQueryKey(options)
});

export const getUserApiKeyQueryKey = (options?: Options<GetUserApiKeyData>) => createQueryKey('getUserApiKey', options);

/**
 * Get user API key
 *
 * Returns the API key for the specified user.
 */
export const getUserApiKeyOptions = (options?: Options<GetUserApiKeyData>) => queryOptions<GetUserApiKeyResponse, GetUserApiKeyError, GetUserApiKeyResponse, ReturnType<typeof getUserApiKeyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserApiKey({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserApiKeyQueryKey(options)
});

/**
 * Expire user API key
 *
 * Deletes the API key for the specified user, making it invalid.
 */
export const expireUserApiKeyMutation = (options?: Partial<Options<ExpireUserApiKeyData>>): UseMutationOptions<ExpireUserApiKeyResponse, ExpireUserApiKeyError, Options<ExpireUserApiKeyData>> => {
    const mutationOptions: UseMutationOptions<ExpireUserApiKeyResponse, ExpireUserApiKeyError, Options<ExpireUserApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await expireUserApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Count users in groups
 *
 * Returns the total number of users in the specified groups.
 */
export const groupsUsersCountMutation = (options?: Partial<Options<GroupsUsersCountData>>): UseMutationOptions<GroupsUsersCountResponse2, GroupsUsersCountError, Options<GroupsUsersCountData>> => {
    const mutationOptions: UseMutationOptions<GroupsUsersCountResponse2, GroupsUsersCountError, Options<GroupsUsersCountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await groupsUsersCount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBookingDeploymentQueryKey = (options: Options<GetBookingDeploymentData>) => createQueryKey('getBookingDeployment', options);

/**
 * Get deployment's bookings
 *
 * Returns the bookings for a specific deployment.
 */
export const getBookingDeploymentOptions = (options: Options<GetBookingDeploymentData>) => queryOptions<GetBookingDeploymentResponse, GetBookingDeploymentError, GetBookingDeploymentResponse, ReturnType<typeof getBookingDeploymentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingDeployment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingDeploymentQueryKey(options)
});

/**
 * Bulk edit multiple desktops
 *
 * Applies a partial desktop update to every desktop in ``ids``. Ports v3 ``PUT /domain/bulk`` — the request body must contain an ``ids`` list alongside the fields to update. Ownership is checked per id.
 */
export const bulkEditDesktopsMutation = (options?: Partial<Options<BulkEditDesktopsData>>): UseMutationOptions<BulkEditDesktopsResponse, BulkEditDesktopsError, Options<BulkEditDesktopsData>> => {
    const mutationOptions: UseMutationOptions<BulkEditDesktopsResponse, BulkEditDesktopsError, Options<BulkEditDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkEditDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create persistent desktops from a template
 *
 * Creates multiple persistent desktops from a template for a set of users/groups/categories/roles. Ports v3 ``POST /persistent_desktop/bulk``. Body requires ``template_id``, ``name``, ``description`` and an ``allowed`` structure describing the target entities.
 */
export const bulkCreatePersistentDesktopsMutation = (options?: Partial<Options<BulkCreatePersistentDesktopsData>>): UseMutationOptions<BulkCreatePersistentDesktopsResponse, BulkCreatePersistentDesktopsError, Options<BulkCreatePersistentDesktopsData>> => {
    const mutationOptions: UseMutationOptions<BulkCreatePersistentDesktopsResponse, BulkCreatePersistentDesktopsError, Options<BulkCreatePersistentDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkCreatePersistentDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserTemplatesQueryKey = (options?: Options<GetUserTemplatesData>) => createQueryKey('getUserTemplates', options);

/**
 * Get user templates
 *
 * Returns a list of all templates that belong to the user calling the endpoint.
 */
export const getUserTemplatesOptions = (options?: Options<GetUserTemplatesData>) => queryOptions<GetUserTemplatesResponse, GetUserTemplatesError, GetUserTemplatesResponse, ReturnType<typeof getUserTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserTemplatesQueryKey(options)
});

export const getUserTemplatesPaginatedQueryKey = (options?: Options<GetUserTemplatesPaginatedData>) => createQueryKey('getUserTemplatesPaginated', options);

/**
 * Get user templates
 *
 * Returns a list of all templates that belong to the user calling the endpoint.
 */
export const getUserTemplatesPaginatedOptions = (options?: Options<GetUserTemplatesPaginatedData>) => queryOptions<GetUserTemplatesPaginatedResponse, GetUserTemplatesPaginatedError, GetUserTemplatesPaginatedResponse, ReturnType<typeof getUserTemplatesPaginatedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserTemplatesPaginated({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserTemplatesPaginatedQueryKey(options)
});

export const getTemplateAllowedQueryKey = (options: Options<GetTemplateAllowedData>) => createQueryKey('getTemplateAllowed', options);

/**
 * Get allowed users, roles, groups, categories for a template
 *
 * Returns the list of groups, users, roles, and categories that currently have access to the specified template.
 */
export const getTemplateAllowedOptions = (options: Options<GetTemplateAllowedData>) => queryOptions<GetTemplateAllowedResponse, GetTemplateAllowedError, GetTemplateAllowedResponse, ReturnType<typeof getTemplateAllowedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplateAllowed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateAllowedQueryKey(options)
});

/**
 * Update allowed entities for a template
 *
 * Update the list of groups, users, roles, and categories that have access to the specified template. Only provided fields will be updated.
 */
export const updateTemplateAllowedMutation = (options?: Partial<Options<UpdateTemplateAllowedData>>): UseMutationOptions<UpdateTemplateAllowedResponse, UpdateTemplateAllowedError, Options<UpdateTemplateAllowedData>> => {
    const mutationOptions: UseMutationOptions<UpdateTemplateAllowedResponse, UpdateTemplateAllowedError, Options<UpdateTemplateAllowedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTemplateAllowed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update template information
 *
 * Update the properties of a specific template.
 */
export const updateTemplateMutation = (options?: Partial<Options<UpdateTemplateData>>): UseMutationOptions<UpdateTemplateResponse, UpdateTemplateError, Options<UpdateTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateTemplateResponse, UpdateTemplateError, Options<UpdateTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable or disable a template
 *
 * Toggles whether a template is enabled (usable for creating desktops). Replaces v3 ``PUT /template/update`` and preserves its side effects: enable runs the template-create quota check, disable cascade-flags non-persistent desktops as ForceDeleting so the engine cleans them up.
 */
export const setTemplateEnabledMutation = (options?: Partial<Options<SetTemplateEnabledData>>): UseMutationOptions<SetTemplateEnabledResponse, SetTemplateEnabledError, Options<SetTemplateEnabledData>> => {
    const mutationOptions: UseMutationOptions<SetTemplateEnabledResponse, SetTemplateEnabledError, Options<SetTemplateEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setTemplateEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTemplateTreeQueryKey = (options: Options<GetTemplateTreeData>) => createQueryKey('getTemplateTree', options);

/**
 * Get template dependency tree
 *
 * Returns a tree structure showing all desktops and templates that depend on the specified template.
 */
export const getTemplateTreeOptions = (options: Options<GetTemplateTreeData>) => queryOptions<GetTemplateTreeResponse, GetTemplateTreeError, GetTemplateTreeResponse, ReturnType<typeof getTemplateTreeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTemplateTree({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTemplateTreeQueryKey(options)
});

/**
 * Create new template
 *
 * Create a new template from a desktop.
 */
export const createTemplateMutation = (options?: Partial<Options<CreateTemplateData>>): UseMutationOptions<CreateTemplateResponse, CreateTemplateError, Options<CreateTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateTemplateResponse, CreateTemplateError, Options<CreateTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Duplicate template
 *
 * Create a new template by duplicating an existing one.
 */
export const duplicateTemplateMutation = (options?: Partial<Options<DuplicateTemplateData>>): UseMutationOptions<DuplicateTemplateResponse, DuplicateTemplateError, Options<DuplicateTemplateData>> => {
    const mutationOptions: UseMutationOptions<DuplicateTemplateResponse, DuplicateTemplateError, Options<DuplicateTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await duplicateTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete template
 *
 * Delete a specific template.
 */
export const deleteTemplateMutation = (options?: Partial<Options<DeleteTemplateData>>): UseMutationOptions<DeleteTemplateResponse, DeleteTemplateError, Options<DeleteTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteTemplateResponse, DeleteTemplateError, Options<DeleteTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Convert template to desktop
 *
 * Convert a specific template into a desktop. Ownership of the template is enforced by ``owns_domain_id`` (which transitively requires ``is_not_user``).
 */
export const convertTemplateToDesktopMutation = (options?: Partial<Options<ConvertTemplateToDesktopData>>): UseMutationOptions<ConvertTemplateToDesktopResponse, ConvertTemplateToDesktopError, Options<ConvertTemplateToDesktopData>> => {
    const mutationOptions: UseMutationOptions<ConvertTemplateToDesktopResponse, ConvertTemplateToDesktopError, Options<ConvertTemplateToDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertTemplateToDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable or disable template
 *
 * Enable or disable a specific template.
 */
export const toggleTemplateEnabledMutation = (options?: Partial<Options<ToggleTemplateEnabledData>>): UseMutationOptions<ToggleTemplateEnabledResponse, ToggleTemplateEnabledError, Options<ToggleTemplateEnabledData>> => {
    const mutationOptions: UseMutationOptions<ToggleTemplateEnabledResponse, ToggleTemplateEnabledError, Options<ToggleTemplateEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleTemplateEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminBastionConfigQueryKey = (options?: Options<GetAdminBastionConfigData>) => createQueryKey('getAdminBastionConfig', options);

/**
 * Get admin bastion configuration
 *
 * Returns the bastion configuration overview including enabled status, domain, SSH port, and domain verification settings.
 */
export const getAdminBastionConfigOptions = (options?: Options<GetAdminBastionConfigData>) => queryOptions<GetAdminBastionConfigResponse, GetAdminBastionConfigError, GetAdminBastionConfigResponse, ReturnType<typeof getAdminBastionConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminBastionConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminBastionConfigQueryKey(options)
});

/**
 * Update bastion configuration
 *
 * Updates the bastion configuration including enabled status, domain, and domain verification settings.
 */
export const updateBastionConfigMutation = (options?: Partial<Options<UpdateBastionConfigData>>): UseMutationOptions<UpdateBastionConfigResponse, UpdateBastionConfigError, Options<UpdateBastionConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateBastionConfigResponse, UpdateBastionConfigError, Options<UpdateBastionConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBastionConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBastionDomainVerificationConfigQueryKey = (options?: Options<GetBastionDomainVerificationConfigData>) => createQueryKey('getBastionDomainVerificationConfig', options);

/**
 * Get bastion domain verification configuration
 *
 * Returns whether domain verification is required for bastion domains.
 *
 * @deprecated
 */
export const getBastionDomainVerificationConfigOptions = (options?: Options<GetBastionDomainVerificationConfigData>) => queryOptions<GetBastionDomainVerificationConfigResponse, GetBastionDomainVerificationConfigError, GetBastionDomainVerificationConfigResponse, ReturnType<typeof getBastionDomainVerificationConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBastionDomainVerificationConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBastionDomainVerificationConfigQueryKey(options)
});

/**
 * Change deployment owner
 *
 * Changes the owner of a deployment to a different user.
 */
export const changeDeploymentOwnerMutation = (options?: Partial<Options<ChangeDeploymentOwnerData>>): UseMutationOptions<ChangeDeploymentOwnerResponse, ChangeDeploymentOwnerError, Options<ChangeDeploymentOwnerData>> => {
    const mutationOptions: UseMutationOptions<ChangeDeploymentOwnerResponse, ChangeDeploymentOwnerError, Options<ChangeDeploymentOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeDeploymentOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetQuotaByKindQueryKey = (options: Options<AdminGetQuotaByKindData>) => createQueryKey('adminGetQuotaByKind', options);

/**
 * Get max quota / limits for a user, category or group
 *
 * Returns the current quota and limits dict for the caller's own ``user``, ``category`` or ``group`` entity. Admin/manager only. Use the ``/admin/quota/{kind}/{item_id}`` variant to target a specific entity by id. ``@is_admin_or_manager``.
 */
export const adminGetQuotaByKindOptions = (options: Options<AdminGetQuotaByKindData>) => queryOptions<AdminGetQuotaByKindResponse, AdminGetQuotaByKindError, AdminGetQuotaByKindResponse, ReturnType<typeof adminGetQuotaByKindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetQuotaByKind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetQuotaByKindQueryKey(options)
});

export const adminGetQuotaByKindItemQueryKey = (options: Options<AdminGetQuotaByKindItemData>) => createQueryKey('adminGetQuotaByKindItem', options);

/**
 * Get max quota / limits for a specific entity
 *
 * Returns the current quota and limits dict for the given entity id. ``kind`` is one of ``user``, ``category`` or ``group``. Admin/manager only. ``@is_admin_or_manager``.
 */
export const adminGetQuotaByKindItemOptions = (options: Options<AdminGetQuotaByKindItemData>) => queryOptions<AdminGetQuotaByKindItemResponse, AdminGetQuotaByKindItemError, AdminGetQuotaByKindItemResponse, ReturnType<typeof adminGetQuotaByKindItemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetQuotaByKindItem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetQuotaByKindItemQueryKey(options)
});

export const getSystemCutoffTimeQueryKey = (options?: Options<GetSystemCutoffTimeData>) => createQueryKey('getSystemCutoffTime', options);

/**
 * Get system recycle bin cutoff time
 *
 * Returns the system-level cutoff time. Managers get their category's cutoff time.
 */
export const getSystemCutoffTimeOptions = (options?: Options<GetSystemCutoffTimeData>) => queryOptions<GetSystemCutoffTimeResponse, GetSystemCutoffTimeError, GetSystemCutoffTimeResponse, ReturnType<typeof getSystemCutoffTimeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSystemCutoffTime({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSystemCutoffTimeQueryKey(options)
});

/**
 * Update system recycle bin cutoff time
 *
 * Updates the system-level cutoff time. Managers update their category's cutoff time.
 */
export const updateSystemCutoffTimeMutation = (options?: Partial<Options<UpdateSystemCutoffTimeData>>): UseMutationOptions<UpdateSystemCutoffTimeResponse, UpdateSystemCutoffTimeError, Options<UpdateSystemCutoffTimeData>> => {
    const mutationOptions: UseMutationOptions<UpdateSystemCutoffTimeResponse, UpdateSystemCutoffTimeError, Options<UpdateSystemCutoffTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSystemCutoffTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRecycleBinStatusQueryKey = (options?: Options<GetRecycleBinStatusData>) => createQueryKey('getRecycleBinStatus', options);

/**
 * Get recycle bin status
 *
 * Returns recycle bin entry counts by status. Managers see only their category.
 */
export const getRecycleBinStatusOptions = (options?: Options<GetRecycleBinStatusData>) => queryOptions<GetRecycleBinStatusResponse, GetRecycleBinStatusError, GetRecycleBinStatusResponse, ReturnType<typeof getRecycleBinStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinStatusQueryKey(options)
});

export const getRecycleBinAdminEntriesQueryKey = (options?: Options<GetRecycleBinAdminEntriesData>) => createQueryKey('getRecycleBinAdminEntries', options);

/**
 * Get recycle bin entries with item counts (admin view)
 *
 * Returns the full list of recycle bin entries with per-item-type counts (desktops, templates, storages, deployments, etc.) for the admin recycle bin table. Managers see only their own category. Optionally filter by a specific entry status.
 */
export const getRecycleBinAdminEntriesOptions = (options?: Options<GetRecycleBinAdminEntriesData>) => queryOptions<GetRecycleBinAdminEntriesResponse, GetRecycleBinAdminEntriesError, GetRecycleBinAdminEntriesResponse, ReturnType<typeof getRecycleBinAdminEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecycleBinAdminEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecycleBinAdminEntriesQueryKey(options)
});

export const getQcow2GeometryQueryKey = (options?: Options<GetQcow2GeometryData>) => createQueryKey('getQcow2Geometry', options);

/**
 * Get the installation qcow2 geometry policy
 *
 * Returns the installation-wide qcow2 geometry policy (cluster_size, extended_l2, lazy_refcounts, preallocation) that apiv4 resolves from its environment and carries in every disk task payload. Read-only. Used by the storage admin CLI, whose container no longer holds the QCOW2_* vars, so its own qcow2 writers (recover --fix, --compress) can write disks coherent with the install policy instead of qemu-img defaults.
 */
export const getQcow2GeometryOptions = (options?: Options<GetQcow2GeometryData>) => queryOptions<GetQcow2GeometryResponse, GetQcow2GeometryError, GetQcow2GeometryResponse, ReturnType<typeof getQcow2GeometryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getQcow2Geometry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getQcow2GeometryQueryKey(options)
});

export const getStorageParentsQueryKey = (options: Options<GetStorageParentsData>) => createQueryKey('getStorageParents', options);

/**
 * Get storage parent chain
 *
 * Returns the parent chain of a storage item.
 */
export const getStorageParentsOptions = (options: Options<GetStorageParentsData>) => queryOptions<GetStorageParentsResponse, GetStorageParentsError, GetStorageParentsResponse, ReturnType<typeof getStorageParentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageParents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageParentsQueryKey(options)
});

export const getStorageTaskQueryKey = (options: Options<GetStorageTaskData>) => createQueryKey('getStorageTask', options);

/**
 * Get storage task
 *
 * Returns the task associated with a storage item.
 */
export const getStorageTaskOptions = (options: Options<GetStorageTaskData>) => queryOptions<GetStorageTaskResponse, GetStorageTaskError, GetStorageTaskResponse, ReturnType<typeof getStorageTaskQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageTask({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageTaskQueryKey(options)
});

export const getStorageHasDerivativesQueryKey = (options: Options<GetStorageHasDerivativesData>) => createQueryKey('getStorageHasDerivatives', options);

/**
 * Check if storage has derivatives
 *
 * Returns how many disks depend on this one as a backing file, counting the whole subtree and not just the direct children.
 */
export const getStorageHasDerivativesOptions = (options: Options<GetStorageHasDerivativesData>) => queryOptions<GetStorageHasDerivativesResponse, GetStorageHasDerivativesError, GetStorageHasDerivativesResponse, ReturnType<typeof getStorageHasDerivativesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageHasDerivatives({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageHasDerivativesQueryKey(options)
});

/**
 * Check storage backing chain
 *
 * Creates a task to check the backing chain of a storage.
 */
export const checkStorageBackingChainMutation = (options?: Partial<Options<CheckStorageBackingChainData>>): UseMutationOptions<CheckStorageBackingChainResponse, CheckStorageBackingChainError, Options<CheckStorageBackingChainData>> => {
    const mutationOptions: UseMutationOptions<CheckStorageBackingChainResponse, CheckStorageBackingChainError, Options<CheckStorageBackingChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkStorageBackingChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Recreate a storage
 *
 * Recreates a storage with the same specifications and parent.
 */
export const recreateStorageMutation = (options?: Partial<Options<RecreateStorageData>>): UseMutationOptions<RecreateStorageResponse, RecreateStorageError, Options<RecreateStorageData>> => {
    const mutationOptions: UseMutationOptions<RecreateStorageResponse, RecreateStorageError, Options<RecreateStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recreateStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop desktops using storage
 *
 * Stops all desktops that are using the specified storage.
 */
export const stopStorageDesktopsMutation = (options?: Partial<Options<StopStorageDesktopsData>>): UseMutationOptions<StopStorageDesktopsResponse, StopStorageDesktopsError, Options<StopStorageDesktopsData>> => {
    const mutationOptions: UseMutationOptions<StopStorageDesktopsResponse, StopStorageDesktopsError, Options<StopStorageDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await stopStorageDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStorageStoragesWithUuidQueryKey = (options: Options<GetStorageStoragesWithUuidData>) => createQueryKey('getStorageStoragesWithUuid', options);

/**
 * Get phantom storages registered against a single storage
 *
 * Returns the ``storages_with_uuid`` field of a single storage. ``@is_admin_or_manager``.
 */
export const getStorageStoragesWithUuidOptions = (options: Options<GetStorageStoragesWithUuidData>) => queryOptions<GetStorageStoragesWithUuidResponse, GetStorageStoragesWithUuidError, GetStorageStoragesWithUuidResponse, ReturnType<typeof getStorageStoragesWithUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageStoragesWithUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageStoragesWithUuidQueryKey(options)
});

export const listAllStoragesWithUuidQueryKey = (options?: Options<ListAllStoragesWithUuidData>) => createQueryKey('listAllStoragesWithUuid', options);

/**
 * List all storages_with_uuid entries
 *
 * Returns the union of every ``storages_with_uuid`` row in the storage table. Manager-role callers are scoped to their own category; admins see everything.
 */
export const listAllStoragesWithUuidOptions = (options?: Options<ListAllStoragesWithUuidData>) => queryOptions<ListAllStoragesWithUuidResponse, ListAllStoragesWithUuidError, ListAllStoragesWithUuidResponse, ReturnType<typeof listAllStoragesWithUuidQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllStoragesWithUuid({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllStoragesWithUuidQueryKey(options)
});

export const listAllStoragesWithUuidStatusQueryKey = (options?: Options<ListAllStoragesWithUuidStatusData>) => createQueryKey('listAllStoragesWithUuidStatus', options);

/**
 * Get per-status counts of storages_with_uuid
 *
 * Returns the per-status counts of phantom ``storages_with_uuid`` rows. Manager-role callers are scoped to their own category.
 */
export const listAllStoragesWithUuidStatusOptions = (options?: Options<ListAllStoragesWithUuidStatusData>) => queryOptions<ListAllStoragesWithUuidStatusResponse, ListAllStoragesWithUuidStatusError, ListAllStoragesWithUuidStatusResponse, ReturnType<typeof listAllStoragesWithUuidStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllStoragesWithUuidStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllStoragesWithUuidStatusQueryKey(options)
});

export const listAllStoragesWithUuidFilteredQueryKey = (options: Options<ListAllStoragesWithUuidFilteredData>) => createQueryKey('listAllStoragesWithUuidFiltered', options);

/**
 * List storages_with_uuid filtered by status
 *
 * Returns the ``storages_with_uuid`` rows matching the given ``status``.
 */
export const listAllStoragesWithUuidFilteredOptions = (options: Options<ListAllStoragesWithUuidFilteredData>) => queryOptions<ListAllStoragesWithUuidFilteredResponse, ListAllStoragesWithUuidFilteredError, ListAllStoragesWithUuidFilteredResponse, ReturnType<typeof listAllStoragesWithUuidFilteredQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllStoragesWithUuidFiltered({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllStoragesWithUuidFilteredQueryKey(options)
});

export const getDefaultStoragePoolQueryKey = (options?: Options<GetDefaultStoragePoolData>) => createQueryKey('getDefaultStoragePool', options);

/**
 * Get default storage pool
 *
 * Returns the default storage pool.
 */
export const getDefaultStoragePoolOptions = (options?: Options<GetDefaultStoragePoolData>) => queryOptions<GetDefaultStoragePoolResponse, GetDefaultStoragePoolError, GetDefaultStoragePoolResponse, ReturnType<typeof getDefaultStoragePoolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDefaultStoragePool({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDefaultStoragePoolQueryKey(options)
});

/**
 * Get storage pool by path
 *
 * Returns the storage pool that matches the given path.
 */
export const getStoragePoolByPathMutation = (options?: Partial<Options<GetStoragePoolByPathData>>): UseMutationOptions<GetStoragePoolByPathResponse, GetStoragePoolByPathError, Options<GetStoragePoolByPathData>> => {
    const mutationOptions: UseMutationOptions<GetStoragePoolByPathResponse, GetStoragePoolByPathError, Options<GetStoragePoolByPathData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getStoragePoolByPath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAdminTasksQueryKey = (options?: Options<GetAdminTasksData>) => createQueryKey('getAdminTasks', options);

/**
 * Get all tasks (admin/manager)
 *
 * Returns admin tasks. Defaults to the most recent ``limit`` tasks; bump to a higher value to paginate through history. Bug 38 hardening — unbounded responses were ~12 MB / 32 s and timed out k6's HTTP client.
 */
export const getAdminTasksOptions = (options?: Options<GetAdminTasksData>) => queryOptions<GetAdminTasksResponse, GetAdminTasksError, GetAdminTasksResponse, ReturnType<typeof getAdminTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminTasksQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getAdminTasksInfiniteQueryKey = (options?: Options<GetAdminTasksData>): QueryKey<Options<GetAdminTasksData>> => createQueryKey('getAdminTasks', options, true);

/**
 * Get all tasks (admin/manager)
 *
 * Returns admin tasks. Defaults to the most recent ``limit`` tasks; bump to a higher value to paginate through history. Bug 38 hardening — unbounded responses were ~12 MB / 32 s and timed out k6's HTTP client.
 */
export const getAdminTasksInfiniteOptions = (options?: Options<GetAdminTasksData>) => infiniteQueryOptions<GetAdminTasksResponse, GetAdminTasksError, InfiniteData<GetAdminTasksResponse>, QueryKey<Options<GetAdminTasksData>>, number | Pick<QueryKey<Options<GetAdminTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetAdminTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getAdminTasks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminTasksInfiniteQueryKey(options)
});

/**
 * Get storage usage analytics
 *
 * Returns storage usage analytics, optionally filtered by categories.
 */
export const analyticsStorageMutation = (options?: Partial<Options<AnalyticsStorageData>>): UseMutationOptions<AnalyticsStorageResponse, AnalyticsStorageError, Options<AnalyticsStorageData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsStorageResponse, AnalyticsStorageError, Options<AnalyticsStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get resource count analytics
 *
 * Returns resource count analytics (desktops, templates, media, etc.), optionally filtered by categories.
 */
export const analyticsResourceCountMutation = (options?: Partial<Options<AnalyticsResourceCountData>>): UseMutationOptions<AnalyticsResourceCountResponse, AnalyticsResourceCountError, Options<AnalyticsResourceCountData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsResourceCountResponse, AnalyticsResourceCountError, Options<AnalyticsResourceCountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsResourceCount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get suggested removals
 *
 * Returns suggested resources for removal based on inactivity.
 */
export const analyticsSuggestedRemovalsMutation = (options?: Partial<Options<AnalyticsSuggestedRemovalsData>>): UseMutationOptions<AnalyticsSuggestedRemovalsResponse, AnalyticsSuggestedRemovalsError, Options<AnalyticsSuggestedRemovalsData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsSuggestedRemovalsResponse, AnalyticsSuggestedRemovalsError, Options<AnalyticsSuggestedRemovalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsSuggestedRemovals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsGraphsConfListQueryKey = (options?: Options<AnalyticsGraphsConfListData>) => createQueryKey('analyticsGraphsConfList', options);

/**
 * Get all analytics graph configurations
 *
 * Returns all analytics graph configurations.
 */
export const analyticsGraphsConfListOptions = (options?: Options<AnalyticsGraphsConfListData>) => queryOptions<AnalyticsGraphsConfListResponse, AnalyticsGraphsConfListError, AnalyticsGraphsConfListResponse, ReturnType<typeof analyticsGraphsConfListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsGraphsConfList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsGraphsConfListQueryKey(options)
});

export const adminAuthenticationProvidersQueryKey = (options?: Options<AdminAuthenticationProvidersData>) => createQueryKey('adminAuthenticationProviders', options);

/**
 * List authentication providers
 *
 * Returns enabled status for all authentication providers.
 */
export const adminAuthenticationProvidersOptions = (options?: Options<AdminAuthenticationProvidersData>) => queryOptions<AdminAuthenticationProvidersResponse, AdminAuthenticationProvidersError, AdminAuthenticationProvidersResponse, ReturnType<typeof adminAuthenticationProvidersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminAuthenticationProviders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminAuthenticationProvidersQueryKey(options)
});

export const getCategoryBrandingQueryKey = (options: Options<GetCategoryBrandingData>) => createQueryKey('getCategoryBranding', options);

/**
 * Get category branding
 *
 * Returns branding configuration (domain + logo) for a category.
 */
export const getCategoryBrandingOptions = (options: Options<GetCategoryBrandingData>) => queryOptions<GetCategoryBrandingResponse, GetCategoryBrandingError, GetCategoryBrandingResponse, ReturnType<typeof getCategoryBrandingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryBranding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryBrandingQueryKey(options)
});

/**
 * Update category branding
 *
 * Updates branding configuration (domain + logo) for a category. Logo data should be a base64 data URL.
 */
export const updateCategoryBrandingMutation = (options?: Partial<Options<UpdateCategoryBrandingData>>): UseMutationOptions<UpdateCategoryBrandingResponse, UpdateCategoryBrandingError, Options<UpdateCategoryBrandingData>> => {
    const mutationOptions: UseMutationOptions<UpdateCategoryBrandingResponse, UpdateCategoryBrandingError, Options<UpdateCategoryBrandingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCategoryBranding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCategoryAuthenticationQueryKey = (options: Options<GetCategoryAuthenticationData>) => createQueryKey('getCategoryAuthentication', options);

/**
 * Get category authentication
 *
 * Returns authentication provider configuration for a category with sensitive fields stripped.
 */
export const getCategoryAuthenticationOptions = (options: Options<GetCategoryAuthenticationData>) => queryOptions<GetCategoryAuthenticationResponse, GetCategoryAuthenticationError, GetCategoryAuthenticationResponse, ReturnType<typeof getCategoryAuthenticationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryAuthentication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryAuthenticationQueryKey(options)
});

/**
 * Update category authentication
 *
 * Updates authentication provider configuration for a category. Sensitive fields (password, client_secret) are preserved if left empty in the payload.
 */
export const updateCategoryAuthenticationMutation = (options?: Partial<Options<UpdateCategoryAuthenticationData>>): UseMutationOptions<UpdateCategoryAuthenticationResponse, UpdateCategoryAuthenticationError, Options<UpdateCategoryAuthenticationData>> => {
    const mutationOptions: UseMutationOptions<UpdateCategoryAuthenticationResponse, UpdateCategoryAuthenticationError, Options<UpdateCategoryAuthenticationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCategoryAuthentication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update category login notification
 *
 * Updates login notification configuration for a specific category.
 */
export const updateCategoryLoginNotificationMutation = (options?: Partial<Options<UpdateCategoryLoginNotificationData>>): UseMutationOptions<UpdateCategoryLoginNotificationResponse, UpdateCategoryLoginNotificationError, Options<UpdateCategoryLoginNotificationData>> => {
    const mutationOptions: UseMutationOptions<UpdateCategoryLoginNotificationResponse, UpdateCategoryLoginNotificationError, Options<UpdateCategoryLoginNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCategoryLoginNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable/disable category login notification
 *
 * Enables or disables a specific login notification type for a category.
 */
export const enableCategoryLoginNotificationMutation = (options?: Partial<Options<EnableCategoryLoginNotificationData>>): UseMutationOptions<EnableCategoryLoginNotificationResponse, EnableCategoryLoginNotificationError, Options<EnableCategoryLoginNotificationData>> => {
    const mutationOptions: UseMutationOptions<EnableCategoryLoginNotificationResponse, EnableCategoryLoginNotificationError, Options<EnableCategoryLoginNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableCategoryLoginNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * List domains
 *
 * List desktops or templates with optional category filter. Managers are scoped to their own category.
 */
export const adminListDomainsMutation = (options?: Partial<Options<AdminListDomainsData2>>): UseMutationOptions<AdminListDomainsResponse, AdminListDomainsError, Options<AdminListDomainsData2>> => {
    const mutationOptions: UseMutationOptions<AdminListDomainsResponse, AdminListDomainsError, Options<AdminListDomainsData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminListDomains({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainDetailsQueryKey = (options: Options<AdminDomainDetailsData>) => createQueryKey('adminDomainDetails', options);

/**
 * Get domain details
 *
 * Returns detailed data for a specific domain.
 */
export const adminDomainDetailsOptions = (options: Options<AdminDomainDetailsData>) => queryOptions<AdminDomainDetailsResponse2, AdminDomainDetailsError, AdminDomainDetailsResponse2, ReturnType<typeof adminDomainDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainDetailsQueryKey(options)
});

export const adminDomainViewerDataQueryKey = (options: Options<AdminDomainViewerDataData>) => createQueryKey('adminDomainViewerData', options);

/**
 * Get domain viewer data
 *
 * Returns viewer connection data for a domain.
 */
export const adminDomainViewerDataOptions = (options: Options<AdminDomainViewerDataData>) => queryOptions<AdminDomainViewerDataResponse2, AdminDomainViewerDataError, AdminDomainViewerDataResponse2, ReturnType<typeof adminDomainViewerDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainViewerData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainViewerDataQueryKey(options)
});

export const adminDomainsStatusQueryKey = (options: Options<AdminDomainsStatusData>) => createQueryKey('adminDomainsStatus', options);

/**
 * Get domains by status
 *
 * Returns domains matching a given status. Supports 'delete_pending' and other status values.
 */
export const adminDomainsStatusOptions = (options: Options<AdminDomainsStatusData>) => queryOptions<AdminDomainsStatusResponse, AdminDomainsStatusError, AdminDomainsStatusResponse, ReturnType<typeof adminDomainsStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainsStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainsStatusQueryKey(options)
});

/**
 * Enqueue find tasks for storages of domains in a given status
 *
 * Scans every ``desktop`` domain with the given status, collects their storage ids and enqueues a ``find`` task for each. ``@is_admin_or_manager`` — managers are scoped to their own category via the ``kind_status_category`` secondary index.
 */
export const adminFindStoragesByDomainStatusMutation = (options?: Partial<Options<AdminFindStoragesByDomainStatusData>>): UseMutationOptions<AdminFindStoragesByDomainStatusResponse, AdminFindStoragesByDomainStatusError, Options<AdminFindStoragesByDomainStatusData>> => {
    const mutationOptions: UseMutationOptions<AdminFindStoragesByDomainStatusResponse, AdminFindStoragesByDomainStatusError, Options<AdminFindStoragesByDomainStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminFindStoragesByDomainStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainStorageQueryKey = (options: Options<AdminDomainStorageData>) => createQueryKey('adminDomainStorage', options);

/**
 * Get domain storage
 *
 * Returns storage information for a domain.
 */
export const adminDomainStorageOptions = (options: Options<AdminDomainStorageData>) => queryOptions<AdminDomainStorageResponse, AdminDomainStorageError, AdminDomainStorageResponse, ReturnType<typeof adminDomainStorageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainStorage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainStorageQueryKey(options)
});

export const adminDesktopsTreeListQueryKey = (options: Options<AdminDesktopsTreeListData>) => createQueryKey('adminDesktopsTreeList', options);

/**
 * Get template tree list
 *
 * Returns the template tree list for a given template.
 */
export const adminDesktopsTreeListOptions = (options: Options<AdminDesktopsTreeListData>) => queryOptions<AdminDesktopsTreeListResponse, AdminDesktopsTreeListError, AdminDesktopsTreeListResponse, ReturnType<typeof adminDesktopsTreeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDesktopsTreeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDesktopsTreeListQueryKey(options)
});

export const adminDomainTemplateTreeQueryKey = (options: Options<AdminDomainTemplateTreeData>) => createQueryKey('adminDomainTemplateTree', options);

/**
 * Get domain template tree
 *
 * Returns the template ancestry tree for a domain.
 */
export const adminDomainTemplateTreeOptions = (options: Options<AdminDomainTemplateTreeData>) => queryOptions<AdminDomainTemplateTreeResponse, AdminDomainTemplateTreeError, AdminDomainTemplateTreeResponse, ReturnType<typeof adminDomainTemplateTreeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainTemplateTree({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainTemplateTreeQueryKey(options)
});

/**
 * Perform multiple domain actions
 *
 * Perform bulk actions (start, stop, delete, etc.) on multiple domains.
 */
export const adminMultipleActionsMutation = (options?: Partial<Options<AdminMultipleActionsData2>>): UseMutationOptions<AdminMultipleActionsResponse, AdminMultipleActionsError, Options<AdminMultipleActionsData2>> => {
    const mutationOptions: UseMutationOptions<AdminMultipleActionsResponse, AdminMultipleActionsError, Options<AdminMultipleActionsData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMultipleActions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a template
 *
 * Deletes a template by ID, moving it to recycle bin.
 */
export const adminTemplateDeleteMutation = (options?: Partial<Options<AdminTemplateDeleteData>>): UseMutationOptions<AdminTemplateDeleteResponse, AdminTemplateDeleteError, Options<AdminTemplateDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminTemplateDeleteResponse, AdminTemplateDeleteError, Options<AdminTemplateDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTemplateDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainsNameSearchQueryKey = (options: Options<AdminDomainsNameSearchData>) => createQueryKey('adminDomainsNameSearch', options);

/**
 * Search domain names
 *
 * Returns up to a few dozen distinct domain names matching the search term, for type-ahead filtering without loading every name.
 */
export const adminDomainsNameSearchOptions = (options: Options<AdminDomainsNameSearchData>) => queryOptions<AdminDomainsNameSearchResponse, AdminDomainsNameSearchError, AdminDomainsNameSearchResponse, ReturnType<typeof adminDomainsNameSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainsNameSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainsNameSearchQueryKey(options)
});

export const adminDomainsFieldQueryKey = (options: Options<AdminDomainsFieldData>) => createQueryKey('adminDomainsField', options);

/**
 * Get domain field values
 *
 * Returns distinct values for a specific field across domains of a given kind.
 */
export const adminDomainsFieldOptions = (options: Options<AdminDomainsFieldData>) => queryOptions<AdminDomainsFieldResponse2, AdminDomainsFieldError, AdminDomainsFieldResponse2, ReturnType<typeof adminDomainsFieldQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainsField({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainsFieldQueryKey(options)
});

export const adminDomainHardwareQueryKey = (options: Options<AdminDomainHardwareData>) => createQueryKey('adminDomainHardware', options);

/**
 * Get domain hardware
 *
 * Returns hardware details for a domain.
 */
export const adminDomainHardwareOptions = (options: Options<AdminDomainHardwareData>) => queryOptions<AdminDomainHardwareResponse2, AdminDomainHardwareError, AdminDomainHardwareResponse2, ReturnType<typeof adminDomainHardwareQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainHardware({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainHardwareQueryKey(options)
});

export const adminDomainSearchInfoQueryKey = (options: Options<AdminDomainSearchInfoData>) => createQueryKey('adminDomainSearchInfo', options);

/**
 * Get domain search info
 *
 * Returns domain info enriched with owner data for search results.
 */
export const adminDomainSearchInfoOptions = (options: Options<AdminDomainSearchInfoData>) => queryOptions<AdminDomainSearchInfoResponse2, AdminDomainSearchInfoError, AdminDomainSearchInfoResponse2, ReturnType<typeof adminDomainSearchInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainSearchInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainSearchInfoQueryKey(options)
});

/**
 * Query desktop logs (raw)
 *
 * Query desktop logs with DataTables-style parameters. Returns raw log data. Managers see their own category only.
 */
export const adminLogsDesktopsRawMutation = (options?: Partial<Options<AdminLogsDesktopsRawData>>): UseMutationOptions<AdminLogsDesktopsRawResponse, AdminLogsDesktopsRawError, Options<AdminLogsDesktopsRawData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsRawResponse, AdminLogsDesktopsRawError, Options<AdminLogsDesktopsRawData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsRaw({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Query desktop logs (grouped)
 *
 * Query desktop logs with DataTables-style parameters. Supports views: 'raw', 'desktop_grouping', 'category_grouping'. Managers see their own category only.
 */
export const adminLogsDesktopsViewMutation = (options?: Partial<Options<AdminLogsDesktopsViewData>>): UseMutationOptions<AdminLogsDesktopsViewResponse, AdminLogsDesktopsViewError, Options<AdminLogsDesktopsViewData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsViewResponse, AdminLogsDesktopsViewError, Options<AdminLogsDesktopsViewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Query user logs (raw)
 *
 * Query user logs with DataTables-style parameters. Returns raw log data. Managers see their own category only.
 */
export const adminLogsUsersRawMutation = (options?: Partial<Options<AdminLogsUsersRawData>>): UseMutationOptions<AdminLogsUsersRawResponse, AdminLogsUsersRawError, Options<AdminLogsUsersRawData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersRawResponse, AdminLogsUsersRawError, Options<AdminLogsUsersRawData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersRaw({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Query user logs (grouped)
 *
 * Query user logs with DataTables-style parameters. Supports views: 'raw', 'user_grouping', 'category_grouping'. Managers see their own category only.
 */
export const adminLogsUsersViewMutation = (options?: Partial<Options<AdminLogsUsersViewData>>): UseMutationOptions<AdminLogsUsersViewResponse, AdminLogsUsersViewError, Options<AdminLogsUsersViewData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersViewResponse, AdminLogsUsersViewError, Options<AdminLogsUsersViewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersView({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminLogsDesktopsListQueryKey = (options?: Options<AdminLogsDesktopsListData>) => createQueryKey('adminLogsDesktopsList', options);

/**
 * List desktop logs (JSON)
 *
 * Simple JSON list of desktop logs with optional filters.
 */
export const adminLogsDesktopsListOptions = (options?: Options<AdminLogsDesktopsListData>) => queryOptions<AdminLogsDesktopsListResponse, AdminLogsDesktopsListError, AdminLogsDesktopsListResponse, ReturnType<typeof adminLogsDesktopsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLogsDesktopsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsDesktopsListQueryKey(options)
});

export const adminLogsDesktopsListInfiniteQueryKey = (options?: Options<AdminLogsDesktopsListData>): QueryKey<Options<AdminLogsDesktopsListData>> => createQueryKey('adminLogsDesktopsList', options, true);

/**
 * List desktop logs (JSON)
 *
 * Simple JSON list of desktop logs with optional filters.
 */
export const adminLogsDesktopsListInfiniteOptions = (options?: Options<AdminLogsDesktopsListData>) => infiniteQueryOptions<AdminLogsDesktopsListResponse, AdminLogsDesktopsListError, InfiniteData<AdminLogsDesktopsListResponse>, QueryKey<Options<AdminLogsDesktopsListData>>, number | Pick<QueryKey<Options<AdminLogsDesktopsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminLogsDesktopsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminLogsDesktopsList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsDesktopsListInfiniteQueryKey(options)
});

export const adminLogsUsersListQueryKey = (options?: Options<AdminLogsUsersListData>) => createQueryKey('adminLogsUsersList', options);

/**
 * List user logs (JSON)
 *
 * Simple JSON list of user logs with optional filters.
 */
export const adminLogsUsersListOptions = (options?: Options<AdminLogsUsersListData>) => queryOptions<AdminLogsUsersListResponse, AdminLogsUsersListError, AdminLogsUsersListResponse, ReturnType<typeof adminLogsUsersListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLogsUsersList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsUsersListQueryKey(options)
});

export const adminLogsUsersListInfiniteQueryKey = (options?: Options<AdminLogsUsersListData>): QueryKey<Options<AdminLogsUsersListData>> => createQueryKey('adminLogsUsersList', options, true);

/**
 * List user logs (JSON)
 *
 * Simple JSON list of user logs with optional filters.
 */
export const adminLogsUsersListInfiniteOptions = (options?: Options<AdminLogsUsersListData>) => infiniteQueryOptions<AdminLogsUsersListResponse, AdminLogsUsersListError, InfiniteData<AdminLogsUsersListResponse>, QueryKey<Options<AdminLogsUsersListData>>, number | Pick<QueryKey<Options<AdminLogsUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminLogsUsersListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminLogsUsersList({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsUsersListInfiniteQueryKey(options)
});

export const adminLoginConfigGetQueryKey = (options?: Options<AdminLoginConfigGetData>) => createQueryKey('adminLoginConfigGet', options);

/**
 * Get global login config (raw)
 *
 * Admin-only raw read of the global login configuration. Returns the unmerged ``Configuration.login`` payload so the admin edit-modal can show the current state. The public ``GET /item/login-config`` returns the same content but goes through the same typed response model.
 */
export const adminLoginConfigGetOptions = (options?: Options<AdminLoginConfigGetData>) => queryOptions<AdminLoginConfigGetResponse, AdminLoginConfigGetError, AdminLoginConfigGetResponse, ReturnType<typeof adminLoginConfigGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLoginConfigGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLoginConfigGetQueryKey(options)
});

export const adminLoginConfigByCategoryQueryKey = (options: Options<AdminLoginConfigByCategoryData>) => createQueryKey('adminLoginConfigByCategory', options);

/**
 * Get per-category login config (raw)
 *
 * Admin-only raw read of a single category's login notification configuration. Unmerged — used by the webapp admin "Edit category login notification" modal. The public ``GET /item/login-config/{category_id}`` returns the merged global + category arrays for the login page.
 */
export const adminLoginConfigByCategoryOptions = (options: Options<AdminLoginConfigByCategoryData>) => queryOptions<AdminLoginConfigByCategoryResponse, AdminLoginConfigByCategoryError, AdminLoginConfigByCategoryResponse, ReturnType<typeof adminLoginConfigByCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLoginConfigByCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLoginConfigByCategoryQueryKey(options)
});

export const adminMediaStatusQueryKey = (options?: Options<AdminMediaStatusData>) => createQueryKey('adminMediaStatus', options);

/**
 * Get media status counts
 *
 * Get counts of media items grouped by status. Managers are scoped to their category.
 */
export const adminMediaStatusOptions = (options?: Options<AdminMediaStatusData>) => queryOptions<AdminMediaStatusResponse, AdminMediaStatusError, AdminMediaStatusResponse, ReturnType<typeof adminMediaStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminMediaStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminMediaStatusQueryKey(options)
});

export const adminMediaListQueryKey = (options?: Options<AdminMediaListData>) => createQueryKey('adminMediaList', options);

/**
 * Get all media
 *
 * Get all media items. Admins see all; managers are scoped to their category.
 */
export const adminMediaListOptions = (options?: Options<AdminMediaListData>) => queryOptions<AdminMediaListResponse, AdminMediaListError, AdminMediaListResponse, ReturnType<typeof adminMediaListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminMediaList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminMediaListQueryKey(options)
});

export const adminMediaByStatusQueryKey = (options: Options<AdminMediaByStatusData>) => createQueryKey('adminMediaByStatus', options);

/**
 * Get media by status
 *
 * Get media items filtered by status. Admins see all; managers are scoped to their category.
 */
export const adminMediaByStatusOptions = (options: Options<AdminMediaByStatusData>) => queryOptions<AdminMediaByStatusResponse, AdminMediaByStatusError, AdminMediaByStatusResponse, ReturnType<typeof adminMediaByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminMediaByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminMediaByStatusQueryKey(options)
});

export const listDesktopAttachedMediaQueryKey = (options: Options<ListDesktopAttachedMediaData>) => createQueryKey('listDesktopAttachedMedia', options);

/**
 * List media attached to a desktop
 *
 * Returns the list of media items (isos + floppies) currently attached to the given desktop's hardware configuration. Used to populate the hotplug modal in the webapp admin. Admin/manager only — matches v3 ``POST /desktops/media_list`` ``@is_admin_or_manager``.
 */
export const listDesktopAttachedMediaOptions = (options: Options<ListDesktopAttachedMediaData>) => queryOptions<ListDesktopAttachedMediaResponse, ListDesktopAttachedMediaError, ListDesktopAttachedMediaResponse, ReturnType<typeof listDesktopAttachedMediaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDesktopAttachedMedia({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDesktopAttachedMediaQueryKey(options)
});

/**
 * Change media owner
 *
 * Reassigns a media item to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsMediaId(media_id)`` are enforced by the service.
 */
export const changeMediaOwnerMutation = (options?: Partial<Options<ChangeMediaOwnerData>>): UseMutationOptions<ChangeMediaOwnerResponse, ChangeMediaOwnerError, Options<ChangeMediaOwnerData>> => {
    const mutationOptions: UseMutationOptions<ChangeMediaOwnerResponse, ChangeMediaOwnerError, Options<ChangeMediaOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeMediaOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check media file existence on disk
 *
 * Schedules a background task that verifies the media file on disk. If the media is not currently downloaded its status is forced to ``deleted``. Otherwise an RQ ``check_media_existence`` task is enqueued against the storage pool that owns the file. Admin/manager only — matches v3 ``PUT /media/check/{id}`` ``@is_admin_or_manager``.
 */
export const checkMediaMutation = (options?: Partial<Options<CheckMediaData>>): UseMutationOptions<CheckMediaResponse, CheckMediaError, Options<CheckMediaData>> => {
    const mutationOptions: UseMutationOptions<CheckMediaResponse, CheckMediaError, Options<CheckMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageStatusQueryKey = (options?: Options<AdminStorageStatusData>) => createQueryKey('adminStorageStatus', options);

/**
 * Get storage status counts
 *
 * Get counts of storages grouped by status. Managers are scoped to their category.
 */
export const adminStorageStatusOptions = (options?: Options<AdminStorageStatusData>) => queryOptions<AdminStorageStatusResponse, AdminStorageStatusError, AdminStorageStatusResponse, ReturnType<typeof adminStorageStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageStatusQueryKey(options)
});

export const adminStorageListQueryKey = (options?: Options<AdminStorageListData>) => createQueryKey('adminStorageList', options);

/**
 * Get all storages
 *
 * Get all storage items. Admins see all; managers are scoped to their category.
 */
export const adminStorageListOptions = (options?: Options<AdminStorageListData>) => queryOptions<AdminStorageListResponse, AdminStorageListError, AdminStorageListResponse, ReturnType<typeof adminStorageListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageListQueryKey(options)
});

/**
 * Get all storages with category filter
 *
 * Get all storage items with optional category filter. Admins can filter by categories; managers are scoped to their category.
 */
export const adminStorageListFilteredMutation = (options?: Partial<Options<AdminStorageListFilteredData>>): UseMutationOptions<AdminStorageListFilteredResponse, AdminStorageListFilteredError, Options<AdminStorageListFilteredData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageListFilteredResponse, AdminStorageListFilteredError, Options<AdminStorageListFilteredData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageListFiltered({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageByStatusQueryKey = (options: Options<AdminStorageByStatusData>) => createQueryKey('adminStorageByStatus', options);

/**
 * Get storages by status
 *
 * Get storage items filtered by status. Admins see all; managers are scoped to their category.
 */
export const adminStorageByStatusOptions = (options: Options<AdminStorageByStatusData>) => queryOptions<AdminStorageByStatusResponse, AdminStorageByStatusError, AdminStorageByStatusResponse, ReturnType<typeof adminStorageByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageByStatusQueryKey(options)
});

/**
 * Get storages by status with category filter
 *
 * Get storage items filtered by status with optional category filter.
 */
export const adminStorageByStatusFilteredMutation = (options?: Partial<Options<AdminStorageByStatusFilteredData>>): UseMutationOptions<AdminStorageByStatusFilteredResponse, AdminStorageByStatusFilteredError, Options<AdminStorageByStatusFilteredData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageByStatusFilteredResponse, AdminStorageByStatusFilteredError, Options<AdminStorageByStatusFilteredData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageByStatusFiltered({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageDomainsQueryKey = (options: Options<AdminStorageDomainsData>) => createQueryKey('adminStorageDomains', options);

/**
 * Get domains attached to a storage
 *
 * Get the list of domains that use a specific storage.
 */
export const adminStorageDomainsOptions = (options: Options<AdminStorageDomainsData>) => queryOptions<AdminStorageDomainsResponse, AdminStorageDomainsError, AdminStorageDomainsResponse, ReturnType<typeof adminStorageDomainsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageDomains({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageDomainsQueryKey(options)
});

export const adminMediaDomainsQueryKey = (options: Options<AdminMediaDomainsData>) => createQueryKey('adminMediaDomains', options);

/**
 * Get domains using a media item
 *
 * Get the list of domains that use a specific media item.
 */
export const adminMediaDomainsOptions = (options: Options<AdminMediaDomainsData>) => queryOptions<AdminMediaDomainsResponse, AdminMediaDomainsError, AdminMediaDomainsResponse, ReturnType<typeof adminMediaDomainsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminMediaDomains({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminMediaDomainsQueryKey(options)
});

/**
 * Delete a storage
 *
 * Delete a storage via the canonical task chain — same chain the user-facing ``DELETE /item/storage/{id}`` invokes. Rejects with 428 if the storage still has child storages.
 */
export const adminStorageDeleteMutation = (options?: Partial<Options<AdminStorageDeleteData>>): UseMutationOptions<AdminStorageDeleteResponse, AdminStorageDeleteError, Options<AdminStorageDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageDeleteResponse, AdminStorageDeleteError, Options<AdminStorageDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageInfoQueryKey = (options: Options<AdminStorageInfoData>) => createQueryKey('adminStorageInfo', options);

/**
 * Get storage information
 *
 * Get detailed information about a specific storage.
 */
export const adminStorageInfoOptions = (options: Options<AdminStorageInfoData>) => queryOptions<AdminStorageInfoResponse, AdminStorageInfoError, AdminStorageInfoResponse, ReturnType<typeof adminStorageInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageInfoQueryKey(options)
});

export const adminStorageSearchInfoQueryKey = (options: Options<AdminStorageSearchInfoData>) => createQueryKey('adminStorageSearchInfo', options);

/**
 * Get storage search information with owner data
 *
 * Get storage information including owner details.
 */
export const adminStorageSearchInfoOptions = (options: Options<AdminStorageSearchInfoData>) => queryOptions<AdminStorageSearchInfoResponse, AdminStorageSearchInfoError, AdminStorageSearchInfoResponse, ReturnType<typeof adminStorageSearchInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageSearchInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageSearchInfoQueryKey(options)
});

export const adminTableGetQueryKey = (options: Options<AdminTableGetData>) => createQueryKey('adminTableGet', options);

/**
 * Get items from a table
 *
 * Get a single item by ID or list all items from a table. Admins see all items; managers are scoped to their category.
 */
export const adminTableGetOptions = (options: Options<AdminTableGetData>) => queryOptions<AdminTableGetResponse, AdminTableGetError, AdminTableGetResponse, ReturnType<typeof adminTableGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminTableGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminTableGetQueryKey(options)
});

/**
 * List table items with filters
 *
 * List items from a table with optional filters, pluck, order, and index. Admins see all items; managers are scoped to their category.
 */
export const adminTableListMutation = (options?: Partial<Options<AdminTableListData>>): UseMutationOptions<AdminTableListResponse, AdminTableListError, Options<AdminTableListData>> => {
    const mutationOptions: UseMutationOptions<AdminTableListResponse, AdminTableListError, Options<AdminTableListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTableList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get usage consumption between dates
 *
 * Returns usage consumption data between the specified dates with optional filtering.
 */
export const adminUsageConsumptionMutation = (options?: Partial<Options<AdminUsageConsumptionData>>): UseMutationOptions<AdminUsageConsumptionResponse, AdminUsageConsumptionError, Options<AdminUsageConsumptionData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageConsumptionResponse, AdminUsageConsumptionError, Options<AdminUsageConsumptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageConsumption({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get start/end consumption
 *
 * Returns consumption data at start and end dates for comparison.
 */
export const adminUsageStartEndMutation = (options?: Partial<Options<AdminUsageStartEndData>>): UseMutationOptions<AdminUsageStartEndResponse, AdminUsageStartEndError, Options<AdminUsageStartEndData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageStartEndResponse, AdminUsageStartEndError, Options<AdminUsageStartEndData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageStartEnd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageConsumersQueryKey = (options: Options<AdminUsageConsumersData>) => createQueryKey('adminUsageConsumers', options);

/**
 * Get usage consumers for item type
 *
 * Returns distinct consumer types for the given item type.
 */
export const adminUsageConsumersOptions = (options: Options<AdminUsageConsumersData>) => queryOptions<AdminUsageConsumersResponse, AdminUsageConsumersError, AdminUsageConsumersResponse, ReturnType<typeof adminUsageConsumersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageConsumers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageConsumersQueryKey(options)
});

export const adminUsageDistinctItemsQueryKey = (options: Options<AdminUsageDistinctItemsData>) => createQueryKey('adminUsageDistinctItems', options);

/**
 * Get distinct usage items
 *
 * Returns distinct items for a consumer type within a date range.
 */
export const adminUsageDistinctItemsOptions = (options: Options<AdminUsageDistinctItemsData>) => queryOptions<AdminUsageDistinctItemsResponse, AdminUsageDistinctItemsError, AdminUsageDistinctItemsResponse, ReturnType<typeof adminUsageDistinctItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageDistinctItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageDistinctItemsQueryKey(options)
});

export const adminUsageDistinctItemsInfiniteQueryKey = (options: Options<AdminUsageDistinctItemsData>): QueryKey<Options<AdminUsageDistinctItemsData>> => createQueryKey('adminUsageDistinctItems', options, true);

/**
 * Get distinct usage items
 *
 * Returns distinct items for a consumer type within a date range.
 */
export const adminUsageDistinctItemsInfiniteOptions = (options: Options<AdminUsageDistinctItemsData>) => infiniteQueryOptions<AdminUsageDistinctItemsResponse, AdminUsageDistinctItemsError, InfiniteData<AdminUsageDistinctItemsResponse>, QueryKey<Options<AdminUsageDistinctItemsData>>, string | Pick<QueryKey<Options<AdminUsageDistinctItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminUsageDistinctItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            path: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminUsageDistinctItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageDistinctItemsInfiniteQueryKey(options)
});

/**
 * Get usage parameters by IDs
 *
 * Returns usage parameters filtered by a list of IDs.
 */
export const adminUsageListParametersMutation = (options?: Partial<Options<AdminUsageListParametersData>>): UseMutationOptions<AdminUsageListParametersResponse, AdminUsageListParametersError, Options<AdminUsageListParametersData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageListParametersResponse, AdminUsageListParametersError, Options<AdminUsageListParametersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageListParameters({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageGroupingsDropdownQueryKey = (options?: Options<AdminUsageGroupingsDropdownData>) => createQueryKey('adminUsageGroupingsDropdown', options);

/**
 * Get usage groupings dropdown
 *
 * Returns usage groupings structured for dropdown menus. Shape: ``{system: {desktop:[...], media:[...], storage:[...], user:[...]}, custom: {...}}``.
 */
export const adminUsageGroupingsDropdownOptions = (options?: Options<AdminUsageGroupingsDropdownData>) => queryOptions<AdminUsageGroupingsDropdownResponse, AdminUsageGroupingsDropdownError, AdminUsageGroupingsDropdownResponse, ReturnType<typeof adminUsageGroupingsDropdownQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageGroupingsDropdown({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageGroupingsDropdownQueryKey(options)
});

export const adminUsageGroupingGetQueryKey = (options: Options<AdminUsageGroupingGetData>) => createQueryKey('adminUsageGroupingGet', options);

/**
 * Get usage grouping by ID
 *
 * Returns a specific usage grouping.
 */
export const adminUsageGroupingGetOptions = (options: Options<AdminUsageGroupingGetData>) => queryOptions<AdminUsageGroupingGetResponse, AdminUsageGroupingGetError, AdminUsageGroupingGetResponse, ReturnType<typeof adminUsageGroupingGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageGroupingGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageGroupingGetQueryKey(options)
});

export const adminUsageCreditsQueryKey = (options: Options<AdminUsageCreditsData>) => createQueryKey('adminUsageCredits', options);

/**
 * Get usage credits for item
 *
 * Returns usage credits for a specific item, type, grouping, and date range.
 */
export const adminUsageCreditsOptions = (options: Options<AdminUsageCreditsData>) => queryOptions<AdminUsageCreditsResponse, AdminUsageCreditsError, AdminUsageCreditsResponse, ReturnType<typeof adminUsageCreditsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageCreditsQueryKey(options)
});

export const adminUsageResetDatesAllQueryKey = (options?: Options<AdminUsageResetDatesAllData>) => createQueryKey('adminUsageResetDatesAll', options);

/**
 * Get all reset dates
 *
 * Returns all usage reset dates.
 */
export const adminUsageResetDatesAllOptions = (options?: Options<AdminUsageResetDatesAllData>) => queryOptions<AdminUsageResetDatesAllResponse, AdminUsageResetDatesAllError, AdminUsageResetDatesAllResponse, ReturnType<typeof adminUsageResetDatesAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageResetDatesAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageResetDatesAllQueryKey(options)
});

export const adminUsageResetDatesRangeQueryKey = (options: Options<AdminUsageResetDatesRangeData>) => createQueryKey('adminUsageResetDatesRange', options);

/**
 * Get reset dates in range
 *
 * Returns usage reset dates within the specified date range.
 */
export const adminUsageResetDatesRangeOptions = (options: Options<AdminUsageResetDatesRangeData>) => queryOptions<AdminUsageResetDatesRangeResponse, AdminUsageResetDatesRangeError, AdminUsageResetDatesRangeResponse, ReturnType<typeof adminUsageResetDatesRangeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageResetDatesRange({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageResetDatesRangeQueryKey(options)
});

export const adminGetJwtQueryKey = (options: Options<AdminGetJwtData>) => createQueryKey('adminGetJwt', options);

/**
 * Get impersonation JWT for user
 *
 * Generates a JWT token to impersonate the specified user. Requires ownership check.
 */
export const adminGetJwtOptions = (options: Options<AdminGetJwtData>) => queryOptions<AdminGetJwtResponse, AdminGetJwtError, AdminGetJwtResponse, ReturnType<typeof adminGetJwtQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetJwt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetJwtQueryKey(options)
});

export const adminUserExistsQueryKey = (options: Options<AdminUserExistsData>) => createQueryKey('adminUserExists', options);

/**
 * Check if user exists
 *
 * Returns whether a user with the given ID exists.
 */
export const adminUserExistsOptions = (options: Options<AdminUserExistsData>) => queryOptions<AdminUserExistsResponse, AdminUserExistsError, AdminUserExistsResponse, ReturnType<typeof adminUserExistsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUserExists({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUserExistsQueryKey(options)
});

export const adminGetUserQueryKey = (options: Options<AdminGetUserData>) => createQueryKey('adminGetUser', options);

/**
 * Get user full data
 *
 * Returns full data for a user.
 */
export const adminGetUserOptions = (options: Options<AdminGetUserData>) => queryOptions<AdminGetUserResponse, AdminGetUserError, AdminGetUserResponse, ReturnType<typeof adminGetUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserQueryKey(options)
});

/**
 * Update user
 *
 * Updates a single user.
 */
export const adminUpdateUserMutation = (options?: Partial<Options<AdminUpdateUserData>>): UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetUserRawQueryKey = (options: Options<AdminGetUserRawData>) => createQueryKey('adminGetUserRaw', options);

/**
 * Get user raw data
 *
 * Returns raw user data from database.
 */
export const adminGetUserRawOptions = (options: Options<AdminGetUserRawData>) => queryOptions<AdminGetUserRawResponse, AdminGetUserRawError, AdminGetUserRawResponse, ReturnType<typeof adminGetUserRawQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserRaw({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserRawQueryKey(options)
});

/**
 * Delete users
 *
 * Deletes one or more users.
 */
export const adminDeleteUsersMutation = (options?: Partial<Options<AdminDeleteUsersData>>): UseMutationOptions<AdminDeleteUsersResponse, AdminDeleteUsersError, Options<AdminDeleteUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteUsersResponse, AdminDeleteUsersError, Options<AdminDeleteUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListUsersQueryKey = (options?: Options<AdminListUsersData>) => createQueryKey('adminListUsers', options);

/**
 * List users
 *
 * Returns list of users. Admins see all, managers see their category.
 */
export const adminListUsersOptions = (options?: Options<AdminListUsersData>) => queryOptions<AdminListUsersResponse, AdminListUsersError, AdminListUsersResponse, ReturnType<typeof adminListUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersQueryKey(options)
});

export const adminListUsersNavQueryKey = (options: Options<AdminListUsersNavData>) => createQueryKey('adminListUsersNav', options);

/**
 * List users by navigation context
 *
 * Returns list of users for management or quotas_limits navigation.
 */
export const adminListUsersNavOptions = (options: Options<AdminListUsersNavData>) => queryOptions<AdminListUsersNavResponse, AdminListUsersNavError, AdminListUsersNavResponse, ReturnType<typeof adminListUsersNavQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListUsersNav({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersNavQueryKey(options)
});

/**
 * Create user
 *
 * Creates a new user.
 */
export const adminCreateUserMutation = (options?: Partial<Options<AdminCreateUserData>>): UseMutationOptions<AdminCreateUserResponse, AdminCreateUserError, Options<AdminCreateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateUserResponse, AdminCreateUserError, Options<AdminCreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk update users
 *
 * Updates multiple users at once.
 */
export const adminUpdateUsersBulkMutation = (options?: Partial<Options<AdminUpdateUsersBulkData>>): UseMutationOptions<AdminUpdateUsersBulkResponse, AdminUpdateUsersBulkError, Options<AdminUpdateUsersBulkData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateUsersBulkResponse, AdminUpdateUsersBulkError, Options<AdminUpdateUsersBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateUsersBulk({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force logout user
 *
 * Revokes all sessions for a user.
 */
export const adminUserLogoutMutation = (options?: Partial<Options<AdminUserLogoutData>>): UseMutationOptions<AdminUserLogoutResponse, AdminUserLogoutError, Options<AdminUserLogoutData>> => {
    const mutationOptions: UseMutationOptions<AdminUserLogoutResponse, AdminUserLogoutError, Options<AdminUserLogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserLogout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Search users
 *
 * Search users by name term.
 */
export const adminSearchUsersMutation = (options?: Partial<Options<AdminSearchUsersData>>): UseMutationOptions<AdminSearchUsersResponse, AdminSearchUsersError, Options<AdminSearchUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminSearchUsersResponse, AdminSearchUsersError, Options<AdminSearchUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSearchUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate CSV for user creation
 *
 * Validates a list of users from CSV data.
 */
export const adminValidateCsvUsersMutation = (options?: Partial<Options<AdminValidateCsvUsersData>>): UseMutationOptions<AdminValidateCsvUsersResponse, AdminValidateCsvUsersError, Options<AdminValidateCsvUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminValidateCsvUsersResponse, AdminValidateCsvUsersError, Options<AdminValidateCsvUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminValidateCsvUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate CSV for user editing
 *
 * Validates a list of users from CSV for editing.
 */
export const adminValidateCsvUsersEditMutation = (options?: Partial<Options<AdminValidateCsvUsersEditData>>): UseMutationOptions<AdminValidateCsvUsersEditResponse, AdminValidateCsvUsersEditError, Options<AdminValidateCsvUsersEditData>> => {
    const mutationOptions: UseMutationOptions<AdminValidateCsvUsersEditResponse, AdminValidateCsvUsersEditError, Options<AdminValidateCsvUsersEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminValidateCsvUsersEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Import users from CSV
 *
 * Creates users from validated CSV data.
 */
export const adminImportCsvUsersMutation = (options?: Partial<Options<AdminImportCsvUsersData>>): UseMutationOptions<AdminImportCsvUsersResponse, AdminImportCsvUsersError, Options<AdminImportCsvUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminImportCsvUsersResponse, AdminImportCsvUsersError, Options<AdminImportCsvUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminImportCsvUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit users from CSV
 *
 * Updates users from validated CSV data.
 */
export const adminEditCsvUsersMutation = (options?: Partial<Options<AdminEditCsvUsersData>>): UseMutationOptions<AdminEditCsvUsersResponse, AdminEditCsvUsersError, Options<AdminEditCsvUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminEditCsvUsersResponse, AdminEditCsvUsersError, Options<AdminEditCsvUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEditCsvUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk create users
 *
 * Creates multiple users in bulk.
 */
export const adminBulkCreateUsersMutation = (options?: Partial<Options<AdminBulkCreateUsersData>>): UseMutationOptions<AdminBulkCreateUsersResponse, AdminBulkCreateUsersError, Options<AdminBulkCreateUsersData>> => {
    const mutationOptions: UseMutationOptions<AdminBulkCreateUsersResponse, AdminBulkCreateUsersError, Options<AdminBulkCreateUsersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminBulkCreateUsers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add secondary groups
 *
 * Adds secondary groups to specified users.
 */
export const adminSecondaryGroupsAddMutation = (options?: Partial<Options<AdminSecondaryGroupsAddData>>): UseMutationOptions<AdminSecondaryGroupsAddResponse, AdminSecondaryGroupsAddError, Options<AdminSecondaryGroupsAddData>> => {
    const mutationOptions: UseMutationOptions<AdminSecondaryGroupsAddResponse, AdminSecondaryGroupsAddError, Options<AdminSecondaryGroupsAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSecondaryGroupsAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Overwrite secondary groups
 *
 * Overwrites secondary groups for specified users.
 */
export const adminSecondaryGroupsOverwriteMutation = (options?: Partial<Options<AdminSecondaryGroupsOverwriteData>>): UseMutationOptions<AdminSecondaryGroupsOverwriteResponse, AdminSecondaryGroupsOverwriteError, Options<AdminSecondaryGroupsOverwriteData>> => {
    const mutationOptions: UseMutationOptions<AdminSecondaryGroupsOverwriteResponse, AdminSecondaryGroupsOverwriteError, Options<AdminSecondaryGroupsOverwriteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSecondaryGroupsOverwrite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove secondary groups
 *
 * Removes secondary groups from specified users.
 */
export const adminSecondaryGroupsDeleteMutation = (options?: Partial<Options<AdminSecondaryGroupsDeleteData>>): UseMutationOptions<AdminSecondaryGroupsDeleteResponse, AdminSecondaryGroupsDeleteError, Options<AdminSecondaryGroupsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminSecondaryGroupsDeleteResponse, AdminSecondaryGroupsDeleteError, Options<AdminSecondaryGroupsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSecondaryGroupsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetPasswordPolicyQueryKey = (options: Options<AdminGetPasswordPolicyData>) => createQueryKey('adminGetPasswordPolicy', options);

/**
 * Get user password policy
 *
 * Returns the password policy for a user.
 */
export const adminGetPasswordPolicyOptions = (options: Options<AdminGetPasswordPolicyData>) => queryOptions<AdminGetPasswordPolicyResponse, AdminGetPasswordPolicyError, AdminGetPasswordPolicyResponse, ReturnType<typeof adminGetPasswordPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetPasswordPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetPasswordPolicyQueryKey(options)
});

/**
 * Reset user VPN
 *
 * Resets VPN credentials for a user.
 */
export const adminResetVpnMutation = (options?: Partial<Options<AdminResetVpnData>>): UseMutationOptions<AdminResetVpnResponse, AdminResetVpnError, Options<AdminResetVpnData>> => {
    const mutationOptions: UseMutationOptions<AdminResetVpnResponse, AdminResetVpnError, Options<AdminResetVpnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminResetVpn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListGroupsQueryKey = (options?: Options<AdminListGroupsData>) => createQueryKey('adminListGroups', options);

/**
 * List groups
 *
 * Returns all groups. Managers see only their category groups.
 */
export const adminListGroupsOptions = (options?: Options<AdminListGroupsData>) => queryOptions<AdminListGroupsResponse, AdminListGroupsError, AdminListGroupsResponse, ReturnType<typeof adminListGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListGroupsQueryKey(options)
});

export const adminListGroupsNavQueryKey = (options: Options<AdminListGroupsNavData>) => createQueryKey('adminListGroupsNav', options);

/**
 * List groups by navigation context
 *
 * Returns groups for management or quotas_limits navigation.
 */
export const adminListGroupsNavOptions = (options: Options<AdminListGroupsNavData>) => queryOptions<AdminListGroupsNavResponse, AdminListGroupsNavError, AdminListGroupsNavResponse, ReturnType<typeof adminListGroupsNavQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListGroupsNav({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListGroupsNavQueryKey(options)
});

/**
 * Delete group
 *
 * Deletes a group.
 */
export const adminDeleteGroupMutation = (options?: Partial<Options<AdminDeleteGroupData>>): UseMutationOptions<AdminDeleteGroupResponse, AdminDeleteGroupError, Options<AdminDeleteGroupData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteGroupResponse, AdminDeleteGroupError, Options<AdminDeleteGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetGroupQueryKey = (options: Options<AdminGetGroupData>) => createQueryKey('adminGetGroup', options);

/**
 * Get group
 *
 * Returns full data for a group.
 */
export const adminGetGroupOptions = (options: Options<AdminGetGroupData>) => queryOptions<AdminGetGroupResponse, AdminGetGroupError, AdminGetGroupResponse, ReturnType<typeof adminGetGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetGroupQueryKey(options)
});

/**
 * Update group
 *
 * Updates a group.
 */
export const adminUpdateGroupMutation = (options?: Partial<Options<AdminUpdateGroupData>>): UseMutationOptions<AdminUpdateGroupResponse, AdminUpdateGroupError, Options<AdminUpdateGroupData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateGroupResponse, AdminUpdateGroupError, Options<AdminUpdateGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create group
 *
 * Creates a new group.
 */
export const adminCreateGroupMutation = (options?: Partial<Options<AdminCreateGroupData>>): UseMutationOptions<AdminCreateGroupResponse, AdminCreateGroupError, Options<AdminCreateGroupData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateGroupResponse, AdminCreateGroupError, Options<AdminCreateGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetGroupUsersQueryKey = (options: Options<AdminGetGroupUsersData>) => createQueryKey('adminGetGroupUsers', options);

/**
 * Get users in group
 *
 * Returns all users in a specific group.
 */
export const adminGetGroupUsersOptions = (options: Options<AdminGetGroupUsersData>) => queryOptions<AdminGetGroupUsersResponse, AdminGetGroupUsersError, AdminGetGroupUsersResponse, ReturnType<typeof adminGetGroupUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetGroupUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetGroupUsersQueryKey(options)
});

/**
 * Update group enrollment
 *
 * Updates enrollment settings for a group.
 */
export const adminGroupEnrollmentMutation = (options?: Partial<Options<AdminGroupEnrollmentData2>>): UseMutationOptions<AdminGroupEnrollmentResponse2, AdminGroupEnrollmentError, Options<AdminGroupEnrollmentData2>> => {
    const mutationOptions: UseMutationOptions<AdminGroupEnrollmentResponse2, AdminGroupEnrollmentError, Options<AdminGroupEnrollmentData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminGroupEnrollment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListCategoriesNavQueryKey = (options: Options<AdminListCategoriesNavData>) => createQueryKey('adminListCategoriesNav', options);

/**
 * List categories by navigation context
 *
 * Returns categories for management or quotas_limits navigation.
 */
export const adminListCategoriesNavOptions = (options: Options<AdminListCategoriesNavData>) => queryOptions<AdminListCategoriesNavResponse, AdminListCategoriesNavError, AdminListCategoriesNavResponse, ReturnType<typeof adminListCategoriesNavQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListCategoriesNav({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListCategoriesNavQueryKey(options)
});

export const adminGetCategoryUsersQueryKey = (options: Options<AdminGetCategoryUsersData>) => createQueryKey('adminGetCategoryUsers', options);

/**
 * Get users in category
 *
 * Returns all users in a specific category.
 */
export const adminGetCategoryUsersOptions = (options: Options<AdminGetCategoryUsersData>) => queryOptions<AdminGetCategoryUsersResponse, AdminGetCategoryUsersError, AdminGetCategoryUsersResponse, ReturnType<typeof adminGetCategoryUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetCategoryUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetCategoryUsersQueryKey(options)
});

export const adminGetCategoryByNameQueryKey = (options: Options<AdminGetCategoryByNameData>) => createQueryKey('adminGetCategoryByName', options);

/**
 * Get category by name
 *
 * Returns a category ID by its name.
 */
export const adminGetCategoryByNameOptions = (options: Options<AdminGetCategoryByNameData>) => queryOptions<AdminGetCategoryByNameResponse, AdminGetCategoryByNameError, AdminGetCategoryByNameResponse, ReturnType<typeof adminGetCategoryByNameQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetCategoryByName({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetCategoryByNameQueryKey(options)
});

export const adminGetGroupByNameCategoryQueryKey = (options: Options<AdminGetGroupByNameCategoryData>) => createQueryKey('adminGetGroupByNameCategory', options);

/**
 * Get group by category and name
 *
 * Returns a group ID by category name and group name.
 */
export const adminGetGroupByNameCategoryOptions = (options: Options<AdminGetGroupByNameCategoryData>) => queryOptions<AdminGetGroupByNameCategoryResponse, AdminGetGroupByNameCategoryError, AdminGetGroupByNameCategoryResponse, ReturnType<typeof adminGetGroupByNameCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetGroupByNameCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetGroupByNameCategoryQueryKey(options)
});

/**
 * Update group quota
 *
 * Updates quota for a group.
 */
export const adminUpdateGroupQuotaMutation = (options?: Partial<Options<AdminUpdateGroupQuotaData>>): UseMutationOptions<AdminUpdateGroupQuotaResponse, AdminUpdateGroupQuotaError, Options<AdminUpdateGroupQuotaData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateGroupQuotaResponse, AdminUpdateGroupQuotaError, Options<AdminUpdateGroupQuotaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateGroupQuota({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update group limits
 *
 * Updates limits for a group.
 */
export const adminUpdateGroupLimitsMutation = (options?: Partial<Options<AdminUpdateGroupLimitsData>>): UseMutationOptions<AdminUpdateGroupLimitsResponse, AdminUpdateGroupLimitsError, Options<AdminUpdateGroupLimitsData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateGroupLimitsResponse, AdminUpdateGroupLimitsError, Options<AdminUpdateGroupLimitsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateGroupLimits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check user deletion dependencies
 *
 * Checks dependencies before deleting users.
 */
export const adminUserDeleteCheckMutation = (options?: Partial<Options<AdminUserDeleteCheckData>>): UseMutationOptions<AdminUserDeleteCheckResponse, AdminUserDeleteCheckError, Options<AdminUserDeleteCheckData>> => {
    const mutationOptions: UseMutationOptions<AdminUserDeleteCheckResponse, AdminUserDeleteCheckError, Options<AdminUserDeleteCheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserDeleteCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check group deletion dependencies
 *
 * Checks dependencies before deleting groups.
 */
export const adminGroupDeleteCheckMutation = (options?: Partial<Options<AdminGroupDeleteCheckData>>): UseMutationOptions<AdminGroupDeleteCheckResponse, AdminGroupDeleteCheckError, Options<AdminGroupDeleteCheckData>> => {
    const mutationOptions: UseMutationOptions<AdminGroupDeleteCheckResponse, AdminGroupDeleteCheckError, Options<AdminGroupDeleteCheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminGroupDeleteCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check category deletion dependencies
 *
 * Checks dependencies before deleting categories.
 */
export const adminCategoryDeleteCheckMutation = (options?: Partial<Options<AdminCategoryDeleteCheckData>>): UseMutationOptions<AdminCategoryDeleteCheckResponse, AdminCategoryDeleteCheckError, Options<AdminCategoryDeleteCheckData>> => {
    const mutationOptions: UseMutationOptions<AdminCategoryDeleteCheckResponse, AdminCategoryDeleteCheckError, Options<AdminCategoryDeleteCheckData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCategoryDeleteCheck({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check group/category association
 *
 * Validates a group/category association.
 */
export const adminCheckGroupCategoryMutation = (options?: Partial<Options<AdminCheckGroupCategoryData2>>): UseMutationOptions<AdminCheckGroupCategoryResponse, AdminCheckGroupCategoryError, Options<AdminCheckGroupCategoryData2>> => {
    const mutationOptions: UseMutationOptions<AdminCheckGroupCategoryResponse, AdminCheckGroupCategoryError, Options<AdminCheckGroupCategoryData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCheckGroupCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetTemplatesQueryKey = (options?: Options<AdminGetTemplatesData>) => createQueryKey('adminGetTemplates', options);

/**
 * Get admin templates
 *
 * Returns templates allowed for the admin/manager.
 */
export const adminGetTemplatesOptions = (options?: Options<AdminGetTemplatesData>) => queryOptions<AdminGetTemplatesResponse, AdminGetTemplatesError, AdminGetTemplatesResponse, ReturnType<typeof adminGetTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetTemplatesQueryKey(options)
});

export const adminGetUserTemplatesQueryKey = (options: Options<AdminGetUserTemplatesData>) => createQueryKey('adminGetUserTemplates', options);

/**
 * Get user templates
 *
 * Returns templates allowed for a specific user.
 */
export const adminGetUserTemplatesOptions = (options: Options<AdminGetUserTemplatesData>) => queryOptions<AdminGetUserTemplatesResponse, AdminGetUserTemplatesError, AdminGetUserTemplatesResponse, ReturnType<typeof adminGetUserTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserTemplatesQueryKey(options)
});

export const adminGetUserDesktopsQueryKey = (options: Options<AdminGetUserDesktopsData>) => createQueryKey('adminGetUserDesktops', options);

/**
 * Get user desktops
 *
 * Returns desktops for a specific user.
 */
export const adminGetUserDesktopsOptions = (options: Options<AdminGetUserDesktopsData>) => queryOptions<AdminGetUserDesktopsResponse, AdminGetUserDesktopsError, AdminGetUserDesktopsResponse, ReturnType<typeof adminGetUserDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserDesktopsQueryKey(options)
});

export const adminGetRolesQueryKey = (options?: Options<AdminGetRolesData>) => createQueryKey('adminGetRoles', options);

/**
 * List available roles
 *
 * Returns roles available to the current user.
 */
export const adminGetRolesOptions = (options?: Options<AdminGetRolesData>) => queryOptions<AdminGetRolesResponse, AdminGetRolesError, AdminGetRolesResponse, ReturnType<typeof adminGetRolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetRoles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetRolesQueryKey(options)
});

export const adminGetUserVpnWithOsQueryKey = (options: Options<AdminGetUserVpnWithOsData>) => createQueryKey('adminGetUserVpnWithOs', options);

/**
 * Get user VPN config with OS
 *
 * Returns VPN configuration for a user with kind and OS.
 */
export const adminGetUserVpnWithOsOptions = (options: Options<AdminGetUserVpnWithOsData>) => queryOptions<AdminGetUserVpnWithOsResponse, AdminGetUserVpnWithOsError, AdminGetUserVpnWithOsResponse, ReturnType<typeof adminGetUserVpnWithOsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserVpnWithOs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserVpnWithOsQueryKey(options)
});

export const adminGetUserVpnQueryKey = (options: Options<AdminGetUserVpnData>) => createQueryKey('adminGetUserVpn', options);

/**
 * Get user VPN config
 *
 * Returns VPN configuration for a user.
 */
export const adminGetUserVpnOptions = (options: Options<AdminGetUserVpnData>) => queryOptions<AdminGetUserVpnResponse, AdminGetUserVpnError, AdminGetUserVpnResponse, ReturnType<typeof adminGetUserVpnQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserVpn({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserVpnQueryKey(options)
});

export const adminGetUserSchemaQueryKey = (options?: Options<AdminGetUserSchemaData>) => createQueryKey('adminGetUserSchema', options);

/**
 * Get user schema
 *
 * Returns roles, categories, and groups for admin forms.
 */
export const adminGetUserSchemaOptions = (options?: Options<AdminGetUserSchemaData>) => queryOptions<AdminGetUserSchemaResponse, AdminGetUserSchemaError, AdminGetUserSchemaResponse, ReturnType<typeof adminGetUserSchemaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserSchema({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserSchemaQueryKey(options)
});

export const adminGetQuotasQueryKey = (options?: Options<AdminGetQuotasData>) => createQueryKey('adminGetQuotas', options);

/**
 * Get admin quotas
 *
 * Returns quotas for the admin view.
 */
export const adminGetQuotasOptions = (options?: Options<AdminGetQuotasData>) => queryOptions<AdminGetQuotasResponse, AdminGetQuotasError, AdminGetQuotasResponse, ReturnType<typeof adminGetQuotasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetQuotas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetQuotasQueryKey(options)
});

export const adminGetUserAppliedQuotaQueryKey = (options: Options<AdminGetUserAppliedQuotaData>) => createQueryKey('adminGetUserAppliedQuota', options);

/**
 * Get user applied quota
 *
 * Returns the applied quota for a specific user.
 */
export const adminGetUserAppliedQuotaOptions = (options: Options<AdminGetUserAppliedQuotaData>) => queryOptions<AdminGetUserAppliedQuotaResponse, AdminGetUserAppliedQuotaError, AdminGetUserAppliedQuotaResponse, ReturnType<typeof adminGetUserAppliedQuotaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserAppliedQuota({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserAppliedQuotaQueryKey(options)
});

/**
 * Migrate user
 *
 * Migrates a user's resources to another user.
 */
export const adminMigrateUserMutation = (options?: Partial<Options<AdminMigrateUserData>>): UseMutationOptions<AdminMigrateUserResponse, AdminMigrateUserError, Options<AdminMigrateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminMigrateUserResponse, AdminMigrateUserError, Options<AdminMigrateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMigrateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCheckMigrationQueryKey = (options: Options<AdminCheckMigrationData>) => createQueryKey('adminCheckMigration', options);

/**
 * Check user migration
 *
 * Checks if migration between two users is valid.
 */
export const adminCheckMigrationOptions = (options: Options<AdminCheckMigrationData>) => queryOptions<AdminCheckMigrationResponse, AdminCheckMigrationError, AdminCheckMigrationResponse, ReturnType<typeof adminCheckMigrationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckMigration({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckMigrationQueryKey(options)
});

/**
 * Migrate user desktops
 *
 * Migrates desktops from one user to another.
 */
export const adminMigrateUserDesktopsMutation = (options?: Partial<Options<AdminMigrateUserDesktopsData>>): UseMutationOptions<AdminMigrateUserDesktopsResponse, AdminMigrateUserDesktopsError, Options<AdminMigrateUserDesktopsData>> => {
    const mutationOptions: UseMutationOptions<AdminMigrateUserDesktopsResponse, AdminMigrateUserDesktopsError, Options<AdminMigrateUserDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMigrateUserDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Migrate user templates
 *
 * Migrates templates from one user to another.
 */
export const adminMigrateUserTemplatesMutation = (options?: Partial<Options<AdminMigrateUserTemplatesData>>): UseMutationOptions<AdminMigrateUserTemplatesResponse, AdminMigrateUserTemplatesError, Options<AdminMigrateUserTemplatesData>> => {
    const mutationOptions: UseMutationOptions<AdminMigrateUserTemplatesResponse, AdminMigrateUserTemplatesError, Options<AdminMigrateUserTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMigrateUserTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Migrate user media
 *
 * Migrates media from one user to another.
 */
export const adminMigrateUserMediaMutation = (options?: Partial<Options<AdminMigrateUserMediaData>>): UseMutationOptions<AdminMigrateUserMediaResponse, AdminMigrateUserMediaError, Options<AdminMigrateUserMediaData>> => {
    const mutationOptions: UseMutationOptions<AdminMigrateUserMediaResponse, AdminMigrateUserMediaError, Options<AdminMigrateUserMediaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMigrateUserMedia({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Migrate user deployments
 *
 * Migrates deployments from one user to another.
 */
export const adminMigrateUserDeploymentsMutation = (options?: Partial<Options<AdminMigrateUserDeploymentsData>>): UseMutationOptions<AdminMigrateUserDeploymentsResponse, AdminMigrateUserDeploymentsError, Options<AdminMigrateUserDeploymentsData>> => {
    const mutationOptions: UseMutationOptions<AdminMigrateUserDeploymentsResponse, AdminMigrateUserDeploymentsError, Options<AdminMigrateUserDeploymentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminMigrateUserDeployments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check migrated users
 *
 * Checks if any users in the list are migrated.
 */
export const adminCheckMigratedMutation = (options?: Partial<Options<AdminCheckMigratedData2>>): UseMutationOptions<AdminCheckMigratedResponse2, AdminCheckMigratedError, Options<AdminCheckMigratedData2>> => {
    const mutationOptions: UseMutationOptions<AdminCheckMigratedResponse2, AdminCheckMigratedError, Options<AdminCheckMigratedData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCheckMigrated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetBastionDomainQueryKey = (options: Options<AdminGetBastionDomainData>) => createQueryKey('adminGetBastionDomain', options);

/**
 * Get category bastion domain
 *
 * Returns the bastion domain for a category.
 */
export const adminGetBastionDomainOptions = (options: Options<AdminGetBastionDomainData>) => queryOptions<AdminGetBastionDomainResponse, AdminGetBastionDomainError, AdminGetBastionDomainResponse, ReturnType<typeof adminGetBastionDomainQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetBastionDomain({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetBastionDomainQueryKey(options)
});

/**
 * Update category bastion domain
 *
 * Updates the bastion domain for a category.
 */
export const adminUpdateBastionDomainMutation = (options?: Partial<Options<AdminUpdateBastionDomainData>>): UseMutationOptions<AdminUpdateBastionDomainResponse, AdminUpdateBastionDomainError, Options<AdminUpdateBastionDomainData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateBastionDomainResponse, AdminUpdateBastionDomainError, Options<AdminUpdateBastionDomainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateBastionDomain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getItemPlanningsQueryKey = (options: Options<GetItemPlanningsData>) => createQueryKey('getItemPlannings', options);

/**
 * Get plannings for a specific reservable item
 *
 * Returns all plannings for a specific reservable item, optionally filtered by date range.
 * If no date range is provided, returns ongoing plannings.
 */
export const getItemPlanningsOptions = (options: Options<GetItemPlanningsData>) => queryOptions<GetItemPlanningsResponse, GetItemPlanningsError, GetItemPlanningsResponse, ReturnType<typeof getItemPlanningsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getItemPlannings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemPlanningsQueryKey(options)
});

export const getItemPlanningsInfiniteQueryKey = (options: Options<GetItemPlanningsData>): QueryKey<Options<GetItemPlanningsData>> => createQueryKey('getItemPlannings', options, true);

/**
 * Get plannings for a specific reservable item
 *
 * Returns all plannings for a specific reservable item, optionally filtered by date range.
 * If no date range is provided, returns ongoing plannings.
 */
export const getItemPlanningsInfiniteOptions = (options: Options<GetItemPlanningsData>) => infiniteQueryOptions<GetItemPlanningsResponse, GetItemPlanningsError, InfiniteData<GetItemPlanningsResponse>, QueryKey<Options<GetItemPlanningsData>>, string | null | Pick<QueryKey<Options<GetItemPlanningsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetItemPlanningsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getItemPlannings({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemPlanningsInfiniteQueryKey(options)
});

/**
 * Delete a specific planning
 *
 * Deletes a specific planning by its ID.
 */
export const deletePlanningMutation = (options?: Partial<Options<DeletePlanningData>>): UseMutationOptions<DeletePlanningResponse, DeletePlanningError, Options<DeletePlanningData>> => {
    const mutationOptions: UseMutationOptions<DeletePlanningResponse, DeletePlanningError, Options<DeletePlanningData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePlanning({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new planning
 *
 * Creates a new planning for a reservable resource.
 */
export const createPlanningMutation = (options?: Partial<Options<CreatePlanningData>>): UseMutationOptions<CreatePlanningResponse, CreatePlanningError, Options<CreatePlanningData>> => {
    const mutationOptions: UseMutationOptions<CreatePlanningResponse, CreatePlanningError, Options<CreatePlanningData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlanning({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReservablesQueryKey = (options?: Options<GetReservablesData>) => createQueryKey('getReservables', options);

/**
 * Get list of reservable types
 *
 * Returns a list of all available reservable types (e.g., gpus, usbs).
 */
export const getReservablesOptions = (options?: Options<GetReservablesData>) => queryOptions<GetReservablesResponse, GetReservablesError, GetReservablesResponse, ReturnType<typeof getReservablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReservables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReservablesQueryKey(options)
});

export const getReservableItemsQueryKey = (options: Options<GetReservableItemsData>) => createQueryKey('getReservableItems', options);

/**
 * Get items of a specific reservable type
 *
 * Returns all items for a specific reservable type (e.g., all GPUs).
 */
export const getReservableItemsOptions = (options: Options<GetReservableItemsData>) => queryOptions<GetReservableItemsResponse, GetReservableItemsError, GetReservableItemsResponse, ReturnType<typeof getReservableItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReservableItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReservableItemsQueryKey(options)
});

export const listEnabledSubitemsQueryKey = (options: Options<ListEnabledSubitemsData>) => createQueryKey('listEnabledSubitems', options);

/**
 * List enabled subitems
 *
 * Returns the list of enabled subitems for a specific reservable item.
 */
export const listEnabledSubitemsOptions = (options: Options<ListEnabledSubitemsData>) => queryOptions<ListEnabledSubitemsResponse, ListEnabledSubitemsError, ListEnabledSubitemsResponse, ReturnType<typeof listEnabledSubitemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEnabledSubitems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEnabledSubitemsQueryKey(options)
});

export const listAllPlansQueryKey = (options?: Options<ListAllPlansData>) => createQueryKey('listAllPlans', options);

/**
 * List all plans
 *
 * Returns all resource planner plans.
 */
export const listAllPlansOptions = (options?: Options<ListAllPlansData>) => queryOptions<ListAllPlansResponse, ListAllPlansError, ListAllPlansResponse, ReturnType<typeof listAllPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllPlansQueryKey(options)
});

export const getItemPlansQueryKey = (options: Options<GetItemPlansData>) => createQueryKey('getItemPlans', options);

/**
 * Get plans for item
 *
 * Returns plans for a specific item that overlap with ``[start, end]``. If both are omitted, defaults to plans active right now (v3 parity).
 */
export const getItemPlansOptions = (options: Options<GetItemPlansData>) => queryOptions<GetItemPlansResponse, GetItemPlansError, GetItemPlansResponse, ReturnType<typeof getItemPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getItemPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemPlansQueryKey(options)
});

export const getItemPlansInfiniteQueryKey = (options: Options<GetItemPlansData>): QueryKey<Options<GetItemPlansData>> => createQueryKey('getItemPlans', options, true);

/**
 * Get plans for item
 *
 * Returns plans for a specific item that overlap with ``[start, end]``. If both are omitted, defaults to plans active right now (v3 parity).
 */
export const getItemPlansInfiniteOptions = (options: Options<GetItemPlansData>) => infiniteQueryOptions<GetItemPlansResponse, GetItemPlansError, InfiniteData<GetItemPlansResponse>, QueryKey<Options<GetItemPlansData>>, string | null | Pick<QueryKey<Options<GetItemPlansData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetItemPlansData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                start: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getItemPlans({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getItemPlansInfiniteQueryKey(options)
});

/**
 * Create plan
 *
 * Creates a new resource planner plan.
 */
export const createPlanMutation = (options?: Partial<Options<CreatePlanData>>): UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> => {
    const mutationOptions: UseMutationOptions<CreatePlanResponse, CreatePlanError, Options<CreatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete plan
 *
 * Deletes a resource planner plan and its associated bookings.
 */
export const deletePlanMutation = (options?: Partial<Options<DeletePlanData>>): UseMutationOptions<DeletePlanResponse, DeletePlanError, Options<DeletePlanData>> => {
    const mutationOptions: UseMutationOptions<DeletePlanResponse, DeletePlanError, Options<DeletePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update plan
 *
 * Updates a resource planner plan's start and end dates.
 */
export const updatePlanMutation = (options?: Partial<Options<UpdatePlanData>>): UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> => {
    const mutationOptions: UseMutationOptions<UpdatePlanResponse, UpdatePlanError, Options<UpdatePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change desktop owner
 *
 * Reassigns a persistent desktop to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsDomainId(desktop_id)`` are enforced by the service.
 */
export const changeDesktopOwnerMutation = (options?: Partial<Options<ChangeDesktopOwnerData>>): UseMutationOptions<ChangeDesktopOwnerResponse, ChangeDesktopOwnerError, Options<ChangeDesktopOwnerData>> => {
    const mutationOptions: UseMutationOptions<ChangeDesktopOwnerResponse, ChangeDesktopOwnerError, Options<ChangeDesktopOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeDesktopOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change template owner
 *
 * Reassigns a template to a different user. ``@is_admin_or_manager``. Both ``ownsUserId(user_id)`` and ``ownsDomainId(template_id)`` are enforced by the service.
 */
export const changeTemplateOwnerMutation = (options?: Partial<Options<ChangeTemplateOwnerData>>): UseMutationOptions<ChangeTemplateOwnerResponse, ChangeTemplateOwnerError, Options<ChangeTemplateOwnerData>> => {
    const mutationOptions: UseMutationOptions<ChangeTemplateOwnerResponse, ChangeTemplateOwnerError, Options<ChangeTemplateOwnerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changeTemplateOwner({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove disallowed bastion targets
 *
 * Removes bastion targets that are no longer allowed based on current permissions.
 */
export const removeDisallowedBastionTargetsMutation = (options?: Partial<Options<RemoveDisallowedBastionTargetsData>>): UseMutationOptions<RemoveDisallowedBastionTargetsResponse, RemoveDisallowedBastionTargetsError, Options<RemoveDisallowedBastionTargetsData>> => {
    const mutationOptions: UseMutationOptions<RemoveDisallowedBastionTargetsResponse, RemoveDisallowedBastionTargetsError, Options<RemoveDisallowedBastionTargetsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeDisallowedBastionTargets({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a default card
 *
 * Generates a default card image for a domain. Admin only.
 *
 * @deprecated
 */
export const generateDefaultCardMutation = (options?: Partial<Options<GenerateDefaultCardData>>): UseMutationOptions<GenerateDefaultCardResponse, GenerateDefaultCardError, Options<GenerateDefaultCardData>> => {
    const mutationOptions: UseMutationOptions<GenerateDefaultCardResponse, GenerateDefaultCardError, Options<GenerateDefaultCardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generateDefaultCard({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMaintenanceTextQueryKey = (options?: Options<GetMaintenanceTextData>) => createQueryKey('getMaintenanceText', options);

/**
 * Get maintenance text
 *
 * Returns the current maintenance text.
 */
export const getMaintenanceTextOptions = (options?: Options<GetMaintenanceTextData>) => queryOptions<GetMaintenanceTextResponse, GetMaintenanceTextError, GetMaintenanceTextResponse, ReturnType<typeof getMaintenanceTextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaintenanceText({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenanceTextQueryKey(options)
});

/**
 * Update maintenance text
 *
 * Updates the maintenance text displayed to users.
 */
export const updateMaintenanceTextMutation = (options?: Partial<Options<UpdateMaintenanceTextData>>): UseMutationOptions<UpdateMaintenanceTextResponse, UpdateMaintenanceTextError, Options<UpdateMaintenanceTextData>> => {
    const mutationOptions: UseMutationOptions<UpdateMaintenanceTextResponse, UpdateMaintenanceTextError, Options<UpdateMaintenanceTextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMaintenanceText({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCategoryMaintenanceQueryKey = (options: Options<GetCategoryMaintenanceData>) => createQueryKey('getCategoryMaintenance', options);

/**
 * Get category maintenance status
 *
 * Returns the maintenance status for a specific category. Admin only.
 */
export const getCategoryMaintenanceOptions = (options: Options<GetCategoryMaintenanceData>) => queryOptions<GetCategoryMaintenanceResponse, GetCategoryMaintenanceError, GetCategoryMaintenanceResponse, ReturnType<typeof getCategoryMaintenanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCategoryMaintenance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCategoryMaintenanceQueryKey(options)
});

export const getMaintenanceQueryKey = (options?: Options<GetMaintenanceData>) => createQueryKey('getMaintenance', options);

/**
 * Get maintenance
 *
 * Returns the current maintenance status of the API considering the user role and category.
 */
export const getMaintenanceOptions = (options?: Options<GetMaintenanceData>) => queryOptions<GetMaintenanceResponse, GetMaintenanceError, GetMaintenanceResponse, ReturnType<typeof getMaintenanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaintenance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenanceQueryKey(options)
});

/**
 * Update maintenance status
 *
 * Updates the maintenance status of the API.
 */
export const updateMaintenanceMutation = (options?: Partial<Options<UpdateMaintenanceData>>): UseMutationOptions<UpdateMaintenanceResponse, UpdateMaintenanceError, Options<UpdateMaintenanceData>> => {
    const mutationOptions: UseMutationOptions<UpdateMaintenanceResponse, UpdateMaintenanceError, Options<UpdateMaintenanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMaintenance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMigrationConfigQueryKey = (options?: Options<GetMigrationConfigData>) => createQueryKey('getMigrationConfig', options);

/**
 * Get user migration configuration
 *
 * Returns the user migration configuration settings.
 */
export const getMigrationConfigOptions = (options?: Options<GetMigrationConfigData>) => queryOptions<GetMigrationConfigResponse, GetMigrationConfigError, GetMigrationConfigResponse, ReturnType<typeof getMigrationConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMigrationConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMigrationConfigQueryKey(options)
});

/**
 * Update user migration configuration
 *
 * Updates the user migration configuration settings.
 */
export const updateMigrationConfigMutation = (options?: Partial<Options<UpdateMigrationConfigData>>): UseMutationOptions<UpdateMigrationConfigResponse, UpdateMigrationConfigError, Options<UpdateMigrationConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateMigrationConfigResponse, UpdateMigrationConfigError, Options<UpdateMigrationConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMigrationConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllMigrationsQueryKey = (options?: Options<GetAllMigrationsData>) => createQueryKey('getAllMigrations', options);

/**
 * List all user migrations
 *
 * Returns the list of all user migration records.
 */
export const getAllMigrationsOptions = (options?: Options<GetAllMigrationsData>) => queryOptions<GetAllMigrationsResponse, GetAllMigrationsError, GetAllMigrationsResponse, ReturnType<typeof getAllMigrationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllMigrations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllMigrationsQueryKey(options)
});

/**
 * Revoke a user migration
 *
 * Changes the status of a user migration to revoked.
 */
export const revokeMigrationMutation = (options?: Partial<Options<RevokeMigrationData>>): UseMutationOptions<RevokeMigrationResponse, RevokeMigrationError, Options<RevokeMigrationData>> => {
    const mutationOptions: UseMutationOptions<RevokeMigrationResponse, RevokeMigrationError, Options<RevokeMigrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeMigration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a user migration
 *
 * Permanently deletes a user migration record.
 */
export const deleteMigrationMutation = (options?: Partial<Options<DeleteMigrationData>>): UseMutationOptions<DeleteMigrationResponse, DeleteMigrationError, Options<DeleteMigrationData>> => {
    const mutationOptions: UseMutationOptions<DeleteMigrationResponse, DeleteMigrationError, Options<DeleteMigrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMigration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete entries past cutoff time
 *
 * Permanently deletes all recycle bin entries that have surpassed the cutoff time.
 */
export const deleteCutoffTimeSurpassedMutation = (options?: Partial<Options<DeleteCutoffTimeSurpassedData>>): UseMutationOptions<DeleteCutoffTimeSurpassedResponse, DeleteCutoffTimeSurpassedError, Options<DeleteCutoffTimeSurpassedData>> => {
    const mutationOptions: UseMutationOptions<DeleteCutoffTimeSurpassedResponse, DeleteCutoffTimeSurpassedError, Options<DeleteCutoffTimeSurpassedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCutoffTimeSurpassed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStuckRecycleBinEntriesQueryKey = (options?: Options<ListStuckRecycleBinEntriesData>) => createQueryKey('listStuckRecycleBinEntries', options);

/**
 * List entries stuck mid-delete
 *
 * Lists recycle bin entries stranded in 'deleting' or 'queued' (e.g. orphaned by an isard-api restart while the delete queue was draining). Read-only; optional 'older_than_minutes' filters out entries that may still be actively draining.
 */
export const listStuckRecycleBinEntriesOptions = (options?: Options<ListStuckRecycleBinEntriesData>) => queryOptions<ListStuckRecycleBinEntriesResponse, ListStuckRecycleBinEntriesError, ListStuckRecycleBinEntriesResponse, ReturnType<typeof listStuckRecycleBinEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStuckRecycleBinEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStuckRecycleBinEntriesQueryKey(options)
});

/**
 * Recover entries stuck mid-delete
 *
 * Re-enqueues recycle bin entries stranded in 'deleting' or 'queued' so the bulk-delete worker retries them. Manual admin recovery for entries orphaned by an isard-api restart (the startup reconcile only recovers 'queued'). Idempotent for disks already deleted.
 */
export const recoverStuckRecycleBinEntriesMutation = (options?: Partial<Options<RecoverStuckRecycleBinEntriesData>>): UseMutationOptions<RecoverStuckRecycleBinEntriesResponse, RecoverStuckRecycleBinEntriesError, Options<RecoverStuckRecycleBinEntriesData>> => {
    const mutationOptions: UseMutationOptions<RecoverStuckRecycleBinEntriesResponse, RecoverStuckRecycleBinEntriesError, Options<RecoverStuckRecycleBinEntriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recoverStuckRecycleBinEntries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set old entries max time
 *
 * Sets the maximum time (in hours) before old entries are processed.
 */
export const setOldEntriesMaxTimeMutation = (options?: Partial<Options<SetOldEntriesMaxTimeData>>): UseMutationOptions<SetOldEntriesMaxTimeResponse, SetOldEntriesMaxTimeError, Options<SetOldEntriesMaxTimeData>> => {
    const mutationOptions: UseMutationOptions<SetOldEntriesMaxTimeResponse, SetOldEntriesMaxTimeError, Options<SetOldEntriesMaxTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOldEntriesMaxTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set old entries action
 *
 * Sets the action to perform on old entries (delete or none).
 */
export const setOldEntriesActionMutation = (options?: Partial<Options<SetOldEntriesActionData>>): UseMutationOptions<SetOldEntriesActionResponse, SetOldEntriesActionError, Options<SetOldEntriesActionData>> => {
    const mutationOptions: UseMutationOptions<SetOldEntriesActionResponse, SetOldEntriesActionError, Options<SetOldEntriesActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setOldEntriesAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOldEntriesConfigQueryKey = (options?: Options<GetOldEntriesConfigData>) => createQueryKey('getOldEntriesConfig', options);

/**
 * Get old entries configuration
 *
 * Returns the configuration for old recycle bin entries.
 */
export const getOldEntriesConfigOptions = (options?: Options<GetOldEntriesConfigData>) => queryOptions<GetOldEntriesConfigResponse, GetOldEntriesConfigError, GetOldEntriesConfigResponse, ReturnType<typeof getOldEntriesConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOldEntriesConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOldEntriesConfigQueryKey(options)
});

/**
 * Delete old entries
 *
 * Permanently deletes recycle bin entries older than the configured max time.
 */
export const deleteOldEntriesMutation = (options?: Partial<Options<DeleteOldEntriesData>>): UseMutationOptions<DeleteOldEntriesResponse, DeleteOldEntriesError, Options<DeleteOldEntriesData>> => {
    const mutationOptions: UseMutationOptions<DeleteOldEntriesResponse, DeleteOldEntriesError, Options<DeleteOldEntriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOldEntries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set default delete behavior
 *
 * Sets whether items are sent to recycle bin or deleted permanently by default.
 */
export const setDefaultDeleteMutation = (options?: Partial<Options<SetDefaultDeleteData>>): UseMutationOptions<SetDefaultDeleteResponse, SetDefaultDeleteError, Options<SetDefaultDeleteData>> => {
    const mutationOptions: UseMutationOptions<SetDefaultDeleteResponse, SetDefaultDeleteError, Options<SetDefaultDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDefaultDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDeleteActionQueryKey = (options?: Options<GetDeleteActionData>) => createQueryKey('getDeleteAction', options);

/**
 * Get delete action
 *
 * Returns the configured delete action (move or delete).
 */
export const getDeleteActionOptions = (options?: Options<GetDeleteActionData>) => queryOptions<GetDeleteActionResponse, GetDeleteActionError, GetDeleteActionResponse, ReturnType<typeof getDeleteActionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDeleteAction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDeleteActionQueryKey(options)
});

/**
 * Set delete action
 *
 * Sets the delete action (move to recycle bin or delete permanently).
 */
export const setDeleteActionMutation = (options?: Partial<Options<SetDeleteActionData>>): UseMutationOptions<SetDeleteActionResponse, SetDeleteActionError, Options<SetDeleteActionData>> => {
    const mutationOptions: UseMutationOptions<SetDeleteActionResponse, SetDeleteActionError, Options<SetDeleteActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setDeleteAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllUnusedItemTimeoutRulesQueryKey = (options?: Options<GetAllUnusedItemTimeoutRulesData>) => createQueryKey('getAllUnusedItemTimeoutRules', options);

/**
 * Get all unused item timeout rules
 *
 * Returns all configured unused item timeout rules.
 */
export const getAllUnusedItemTimeoutRulesOptions = (options?: Options<GetAllUnusedItemTimeoutRulesData>) => queryOptions<GetAllUnusedItemTimeoutRulesResponse, GetAllUnusedItemTimeoutRulesError, GetAllUnusedItemTimeoutRulesResponse, ReturnType<typeof getAllUnusedItemTimeoutRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllUnusedItemTimeoutRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllUnusedItemTimeoutRulesQueryKey(options)
});

/**
 * Create unused item timeout rule
 *
 * Creates a new unused item timeout rule.
 */
export const createUnusedItemTimeoutRuleMutation = (options?: Partial<Options<CreateUnusedItemTimeoutRuleData>>): UseMutationOptions<CreateUnusedItemTimeoutRuleResponse, CreateUnusedItemTimeoutRuleError, Options<CreateUnusedItemTimeoutRuleData>> => {
    const mutationOptions: UseMutationOptions<CreateUnusedItemTimeoutRuleResponse, CreateUnusedItemTimeoutRuleError, Options<CreateUnusedItemTimeoutRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUnusedItemTimeoutRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete unused item timeout rule
 *
 * Deletes an unused item timeout rule.
 */
export const deleteUnusedItemTimeoutRuleMutation = (options?: Partial<Options<DeleteUnusedItemTimeoutRuleData>>): UseMutationOptions<DeleteUnusedItemTimeoutRuleResponse, DeleteUnusedItemTimeoutRuleError, Options<DeleteUnusedItemTimeoutRuleData>> => {
    const mutationOptions: UseMutationOptions<DeleteUnusedItemTimeoutRuleResponse, DeleteUnusedItemTimeoutRuleError, Options<DeleteUnusedItemTimeoutRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUnusedItemTimeoutRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnusedItemTimeoutRuleQueryKey = (options: Options<GetUnusedItemTimeoutRuleData>) => createQueryKey('getUnusedItemTimeoutRule', options);

/**
 * Get unused item timeout rule
 *
 * Returns a specific unused item timeout rule.
 */
export const getUnusedItemTimeoutRuleOptions = (options: Options<GetUnusedItemTimeoutRuleData>) => queryOptions<GetUnusedItemTimeoutRuleResponse, GetUnusedItemTimeoutRuleError, GetUnusedItemTimeoutRuleResponse, ReturnType<typeof getUnusedItemTimeoutRuleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUnusedItemTimeoutRule({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUnusedItemTimeoutRuleQueryKey(options)
});

/**
 * Update unused item timeout rule
 *
 * Updates an existing unused item timeout rule.
 */
export const updateUnusedItemTimeoutRuleMutation = (options?: Partial<Options<UpdateUnusedItemTimeoutRuleData>>): UseMutationOptions<UpdateUnusedItemTimeoutRuleResponse, UpdateUnusedItemTimeoutRuleError, Options<UpdateUnusedItemTimeoutRuleData>> => {
    const mutationOptions: UseMutationOptions<UpdateUnusedItemTimeoutRuleResponse, UpdateUnusedItemTimeoutRuleError, Options<UpdateUnusedItemTimeoutRuleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUnusedItemTimeoutRule({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send unused items to recycle bin
 *
 * Finds unused desktops and sends them to the recycle bin. Called by the scheduler for automatic cleanup.
 *
 * @deprecated
 */
export const recycleBinAddUnusedItemsMutation = (options?: Partial<Options<RecycleBinAddUnusedItemsData>>): UseMutationOptions<RecycleBinAddUnusedItemsResponse, RecycleBinAddUnusedItemsError, Options<RecycleBinAddUnusedItemsData>> => {
    const mutationOptions: UseMutationOptions<RecycleBinAddUnusedItemsResponse, RecycleBinAddUnusedItemsError, Options<RecycleBinAddUnusedItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recycleBinAddUnusedItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set storage to maintenance status
 *
 * Sets a storage item to maintenance status.
 */
export const setStorageMaintenanceMutation = (options?: Partial<Options<SetStorageMaintenanceData>>): UseMutationOptions<SetStorageMaintenanceResponse, SetStorageMaintenanceError, Options<SetStorageMaintenanceData>> => {
    const mutationOptions: UseMutationOptions<SetStorageMaintenanceResponse, SetStorageMaintenanceError, Options<SetStorageMaintenanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setStorageMaintenance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set storage to ready status
 *
 * Sets a storage item to ready status.
 */
export const setStorageReadyMutation = (options?: Partial<Options<SetStorageReadyData>>): UseMutationOptions<SetStorageReadyResponse, SetStorageReadyError, Options<SetStorageReadyData>> => {
    const mutationOptions: UseMutationOptions<SetStorageReadyResponse, SetStorageReadyError, Options<SetStorageReadyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setStorageReady({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch check backing chain
 *
 * Check backing chain for a batch of storages by their IDs.
 */
export const batchCheckBackingChainMutation = (options?: Partial<Options<BatchCheckBackingChainData>>): UseMutationOptions<BatchCheckBackingChainResponse, BatchCheckBackingChainError, Options<BatchCheckBackingChainData>> => {
    const mutationOptions: UseMutationOptions<BatchCheckBackingChainResponse, BatchCheckBackingChainError, Options<BatchCheckBackingChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchCheckBackingChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch check backing chain by status
 *
 * Check backing chain for all storages with the given status.
 */
export const batchCheckBackingChainByStatusMutation = (options?: Partial<Options<BatchCheckBackingChainByStatusData>>): UseMutationOptions<BatchCheckBackingChainByStatusResponse, BatchCheckBackingChainByStatusError, Options<BatchCheckBackingChainByStatusData>> => {
    const mutationOptions: UseMutationOptions<BatchCheckBackingChainByStatusResponse, BatchCheckBackingChainByStatusError, Options<BatchCheckBackingChainByStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchCheckBackingChainByStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a new storage
 *
 * Creates a new storage with the given specifications.
 */
export const createStorageMutation = (options?: Partial<Options<CreateStorageData>>): UseMutationOptions<CreateStorageResponse, CreateStorageError, Options<CreateStorageData>> => {
    const mutationOptions: UseMutationOptions<CreateStorageResponse, CreateStorageError, Options<CreateStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStorageStatusesQueryKey = (options: Options<GetStorageStatusesData>) => createQueryKey('getStorageStatuses', options);

/**
 * Get storage and domain statuses
 *
 * Returns the status of a storage and its associated domains.
 */
export const getStorageStatusesOptions = (options: Options<GetStorageStatusesData>) => queryOptions<GetStorageStatusesResponse, GetStorageStatusesError, GetStorageStatusesResponse, ReturnType<typeof getStorageStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStorageStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStorageStatusesQueryKey(options)
});

/**
 * Sparsify a storage
 *
 * Creates a task to sparsify a storage qcow2 image.
 */
export const sparsifyStorageMutation = (options?: Partial<Options<SparsifyStorageData>>): UseMutationOptions<SparsifyStorageResponse, SparsifyStorageError, Options<SparsifyStorageData>> => {
    const mutationOptions: UseMutationOptions<SparsifyStorageResponse, SparsifyStorageError, Options<SparsifyStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sparsifyStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch sparsify storages
 *
 * Sparsify multiple storages by their IDs.
 */
export const batchSparsifyStoragesMutation = (options?: Partial<Options<BatchSparsifyStoragesData>>): UseMutationOptions<BatchSparsifyStoragesResponse, BatchSparsifyStoragesError, Options<BatchSparsifyStoragesData>> => {
    const mutationOptions: UseMutationOptions<BatchSparsifyStoragesResponse, BatchSparsifyStoragesError, Options<BatchSparsifyStoragesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchSparsifyStorages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch sparsify storages by status
 *
 * Sparsify all storages with the given status.
 */
export const batchSparsifyStoragesByStatusMutation = (options?: Partial<Options<BatchSparsifyStoragesByStatusData>>): UseMutationOptions<BatchSparsifyStoragesByStatusResponse, BatchSparsifyStoragesByStatusError, Options<BatchSparsifyStoragesByStatusData>> => {
    const mutationOptions: UseMutationOptions<BatchSparsifyStoragesByStatusResponse, BatchSparsifyStoragesByStatusError, Options<BatchSparsifyStoragesByStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchSparsifyStoragesByStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect storage from backing chain
 *
 * Creates a task to disconnect a storage from its backing chain.
 */
export const disconnectStorageMutation = (options?: Partial<Options<DisconnectStorageData>>): UseMutationOptions<DisconnectStorageResponse, DisconnectStorageError, Options<DisconnectStorageData>> => {
    const mutationOptions: UseMutationOptions<DisconnectStorageResponse, DisconnectStorageError, Options<DisconnectStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disconnectStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Convert a storage
 *
 * Creates a task to convert a storage to a new format.
 */
export const convertStorageMutation = (options?: Partial<Options<ConvertStorageData>>): UseMutationOptions<ConvertStorageResponse, ConvertStorageError, Options<ConvertStorageData>> => {
    const mutationOptions: UseMutationOptions<ConvertStorageResponse, ConvertStorageError, Options<ConvertStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await convertStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply Windows registry patch
 *
 * Applies a registry patch to a storage qcow2 image.
 */
export const virtWinRegStorageMutation = (options?: Partial<Options<VirtWinRegStorageData>>): UseMutationOptions<VirtWinRegStorageResponse, VirtWinRegStorageError, Options<VirtWinRegStorageData>> => {
    const mutationOptions: UseMutationOptions<VirtWinRegStorageResponse, VirtWinRegStorageError, Options<VirtWinRegStorageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await virtWinRegStorage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move storage by path
 *
 * Creates a task to move a storage to a new path.
 */
export const moveStorageByPathMutation = (options?: Partial<Options<MoveStorageByPathData>>): UseMutationOptions<MoveStorageByPathResponse, MoveStorageByPathError, Options<MoveStorageByPathData>> => {
    const mutationOptions: UseMutationOptions<MoveStorageByPathResponse, MoveStorageByPathError, Options<MoveStorageByPathData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveStorageByPath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rsync storage to path
 *
 * Creates a task to rsync a storage to a destination path.
 */
export const rsyncStorageToPathMutation = (options?: Partial<Options<RsyncStorageToPathData>>): UseMutationOptions<RsyncStorageToPathResponse, RsyncStorageToPathError, Options<RsyncStorageToPathData>> => {
    const mutationOptions: UseMutationOptions<RsyncStorageToPathResponse, RsyncStorageToPathError, Options<RsyncStorageToPathData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rsyncStorageToPath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rsync storage to storage pool
 *
 * Creates a task to rsync a storage to a storage pool.
 */
export const rsyncStorageToStoragePoolMutation = (options?: Partial<Options<RsyncStorageToStoragePoolData>>): UseMutationOptions<RsyncStorageToStoragePoolResponse, RsyncStorageToStoragePoolError, Options<RsyncStorageToStoragePoolData>> => {
    const mutationOptions: UseMutationOptions<RsyncStorageToStoragePoolResponse, RsyncStorageToStoragePoolError, Options<RsyncStorageToStoragePoolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rsyncStorageToStoragePool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete storage path
 *
 * Deletes the path for a storage item.
 */
export const deleteStoragePathMutation = (options?: Partial<Options<DeleteStoragePathData>>): UseMutationOptions<DeleteStoragePathResponse, DeleteStoragePathError, Options<DeleteStoragePathData>> => {
    const mutationOptions: UseMutationOptions<DeleteStoragePathResponse, DeleteStoragePathError, Options<DeleteStoragePathData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteStoragePath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set storage path
 *
 * Sets the path for a storage item.
 */
export const setStoragePathMutation = (options?: Partial<Options<SetStoragePathData>>): UseMutationOptions<SetStoragePathResponse, SetStoragePathError, Options<SetStoragePathData>> => {
    const mutationOptions: UseMutationOptions<SetStoragePathResponse, SetStoragePathError, Options<SetStoragePathData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setStoragePath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const findStorageQueryKey = (options: Options<FindStorageData>) => createQueryKey('findStorage', options);

/**
 * Find a storage on disk
 *
 * Schedules a ``find`` task to locate a storage item on disk and returns the task ID.
 */
export const findStorageOptions = (options: Options<FindStorageData>) => queryOptions<FindStorageResponse, FindStorageError, FindStorageResponse, ReturnType<typeof findStorageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findStorage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findStorageQueryKey(options)
});

/**
 * Batch find storages
 *
 * Finds multiple storages on disk by their IDs.
 */
export const batchFindStoragesMutation = (options?: Partial<Options<BatchFindStoragesData>>): UseMutationOptions<BatchFindStoragesResponse, BatchFindStoragesError, Options<BatchFindStoragesData>> => {
    const mutationOptions: UseMutationOptions<BatchFindStoragesResponse, BatchFindStoragesError, Options<BatchFindStoragesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchFindStorages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch find storages by status
 *
 * Finds all storages on disk with the given status.
 */
export const batchFindStoragesByStatusMutation = (options?: Partial<Options<BatchFindStoragesByStatusData>>): UseMutationOptions<BatchFindStoragesByStatusResponse, BatchFindStoragesByStatusError, Options<BatchFindStoragesByStatusData>> => {
    const mutationOptions: UseMutationOptions<BatchFindStoragesByStatusResponse, BatchFindStoragesByStatusError, Options<BatchFindStoragesByStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await batchFindStoragesByStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create storage pool
 *
 * Creates a new storage pool. May return non-blocking warnings (e.g. no storage/hypervisor node serves the new pool yet).
 */
export const createStoragePoolMutation = (options?: Partial<Options<CreateStoragePoolData>>): UseMutationOptions<CreateStoragePoolResponse, CreateStoragePoolError, Options<CreateStoragePoolData>> => {
    const mutationOptions: UseMutationOptions<CreateStoragePoolResponse, CreateStoragePoolError, Options<CreateStoragePoolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createStoragePool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listStoragePoolsQueryKey = (options?: Options<ListStoragePoolsData>) => createQueryKey('listStoragePools', options);

/**
 * List all storage pools
 *
 * Returns all storage pools with enriched data.
 */
export const listStoragePoolsOptions = (options?: Options<ListStoragePoolsData>) => queryOptions<ListStoragePoolsResponse, ListStoragePoolsError, ListStoragePoolsResponse, ReturnType<typeof listStoragePoolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listStoragePools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listStoragePoolsQueryKey(options)
});

/**
 * Delete storage pool
 *
 * Deletes a storage pool by ID.
 */
export const deleteStoragePoolMutation = (options?: Partial<Options<DeleteStoragePoolData>>): UseMutationOptions<DeleteStoragePoolResponse, DeleteStoragePoolError, Options<DeleteStoragePoolData>> => {
    const mutationOptions: UseMutationOptions<DeleteStoragePoolResponse, DeleteStoragePoolError, Options<DeleteStoragePoolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteStoragePool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStoragePoolQueryKey = (options: Options<GetStoragePoolData>) => createQueryKey('getStoragePool', options);

/**
 * Get storage pool
 *
 * Returns a specific storage pool by ID.
 */
export const getStoragePoolOptions = (options: Options<GetStoragePoolData>) => queryOptions<GetStoragePoolResponse, GetStoragePoolError, GetStoragePoolResponse, ReturnType<typeof getStoragePoolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStoragePool({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStoragePoolQueryKey(options)
});

/**
 * Update storage pool
 *
 * Updates an existing storage pool. On disable, returns a warning listing pending work (residing disks + queued tasks) that keeps draining.
 */
export const updateStoragePoolMutation = (options?: Partial<Options<UpdateStoragePoolData>>): UseMutationOptions<UpdateStoragePoolResponse, UpdateStoragePoolError, Options<UpdateStoragePoolData>> => {
    const mutationOptions: UseMutationOptions<UpdateStoragePoolResponse, UpdateStoragePoolError, Options<UpdateStoragePoolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateStoragePool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getStoragePoolPendingQueryKey = (options: Options<GetStoragePoolPendingData>) => createQueryKey('getStoragePoolPending', options);

/**
 * Storage pool drain-status
 *
 * Whether a pool is quiescent: enabled flag, categories, residing disks, queued lane jobs, consumer coverage, and a 'drained' flag (true when it can be deleted). Use after disabling a pool to watch it drain.
 */
export const getStoragePoolPendingOptions = (options: Options<GetStoragePoolPendingData>) => queryOptions<GetStoragePoolPendingResponse, GetStoragePoolPendingError, GetStoragePoolPendingResponse, ReturnType<typeof getStoragePoolPendingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getStoragePoolPending({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getStoragePoolPendingQueryKey(options)
});

/**
 * Check category availability
 *
 * Checks if the given categories are available for assignment to a storage pool.
 */
export const checkCategoryStoragePoolAvailabilityMutation = (options?: Partial<Options<CheckCategoryStoragePoolAvailabilityData>>): UseMutationOptions<CheckCategoryStoragePoolAvailabilityResponse, CheckCategoryStoragePoolAvailabilityError, Options<CheckCategoryStoragePoolAvailabilityData>> => {
    const mutationOptions: UseMutationOptions<CheckCategoryStoragePoolAvailabilityResponse, CheckCategoryStoragePoolAvailabilityError, Options<CheckCategoryStoragePoolAvailabilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkCategoryStoragePoolAvailability({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin cancel a task
 *
 * Admin-cancels a task and its whole dependency chain, with no ownership or status gate — clears a wedged / deferred / running-if-cooperative task. Best effort: a queued job drops immediately, a running body stops only if it cooperates by watching the ``task:cancel:<id>`` signal, and a body that does not watch runs to completion. Re-read the task rather than trust the 204. 404 if the task is gone.
 */
export const adminCancelTaskMutation = (options?: Partial<Options<AdminCancelTaskData>>): UseMutationOptions<AdminCancelTaskResponse, AdminCancelTaskError, Options<AdminCancelTaskData>> => {
    const mutationOptions: UseMutationOptions<AdminCancelTaskResponse, AdminCancelTaskError, Options<AdminCancelTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCancelTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry a failed task
 *
 * Re-enqueues a failed task on the lane it came from. Admin only. Refused with 428 when the addressed job is not itself the one that failed, when it is a chain finalize step no worker fleet serves, or when a direct dependent was cancelled and rq would therefore never re-run it; 429 when the lane has no live consumer.
 */
export const retryTaskMutation = (options?: Partial<Options<RetryTaskData>>): UseMutationOptions<RetryTaskResponse, RetryTaskError, Options<RetryTaskData>> => {
    const mutationOptions: UseMutationOptions<RetryTaskResponse, RetryTaskError, Options<RetryTaskData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryTask({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry all failed storage tasks
 *
 * Retries all failed storage tasks. Returns how many were retried, skipped as not retryable, and errored. Admin only.
 */
export const retryAllFailedTasksMutation = (options?: Partial<Options<RetryAllFailedTasksData>>): UseMutationOptions<RetryAllFailedTasksResponse, RetryAllFailedTasksError, Options<RetryAllFailedTasksData>> => {
    const mutationOptions: UseMutationOptions<RetryAllFailedTasksResponse, RetryAllFailedTasksError, Options<RetryAllFailedTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryAllFailedTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect a VPN client
 *
 * Disconnects a specific VPN client.
 */
export const vpnConnectionDisconnectMutation = (options?: Partial<Options<VpnConnectionDisconnectData>>): UseMutationOptions<VpnConnectionDisconnectResponse, VpnConnectionDisconnectError, Options<VpnConnectionDisconnectData>> => {
    const mutationOptions: UseMutationOptions<VpnConnectionDisconnectResponse, VpnConnectionDisconnectError, Options<VpnConnectionDisconnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vpnConnectionDisconnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Register VPN client connection
 *
 * Registers a new VPN client connection (connected).
 */
export const vpnConnectionConnectMutation = (options?: Partial<Options<VpnConnectionConnectData>>): UseMutationOptions<VpnConnectionConnectResponse, VpnConnectionConnectError, Options<VpnConnectionConnectData>> => {
    const mutationOptions: UseMutationOptions<VpnConnectionConnectResponse, VpnConnectionConnectError, Options<VpnConnectionConnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vpnConnectionConnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update VPN client connection (roamed)
 *
 * Updates a VPN client connection after roaming.
 */
export const vpnConnectionRoamMutation = (options?: Partial<Options<VpnConnectionRoamData>>): UseMutationOptions<VpnConnectionRoamResponse, VpnConnectionRoamError, Options<VpnConnectionRoamData>> => {
    const mutationOptions: UseMutationOptions<VpnConnectionRoamResponse, VpnConnectionRoamError, Options<VpnConnectionRoamData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vpnConnectionRoam({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset all VPN connections for a kind
 *
 * Resets all VPN connections for the specified kind (all/users/hypers).
 */
export const vpnConnectionResetMutation = (options?: Partial<Options<VpnConnectionResetData>>): UseMutationOptions<VpnConnectionResetResponse, VpnConnectionResetError, Options<VpnConnectionResetData>> => {
    const mutationOptions: UseMutationOptions<VpnConnectionResetResponse, VpnConnectionResetError, Options<VpnConnectionResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vpnConnectionReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disconnect multiple VPN connections
 *
 * Disconnects multiple VPN connections from a list.
 */
export const vpnConnectionsDisconnectMutation = (options?: Partial<Options<VpnConnectionsDisconnectData>>): UseMutationOptions<VpnConnectionsDisconnectResponse, VpnConnectionsDisconnectError, Options<VpnConnectionsDisconnectData>> => {
    const mutationOptions: UseMutationOptions<VpnConnectionsDisconnectResponse, VpnConnectionsDisconnectError, Options<VpnConnectionsDisconnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vpnConnectionsDisconnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete analytics graph configuration
 *
 * Deletes an analytics graph configuration by ID.
 */
export const analyticsGraphConfDeleteMutation = (options?: Partial<Options<AnalyticsGraphConfDeleteData>>): UseMutationOptions<AnalyticsGraphConfDeleteResponse, AnalyticsGraphConfDeleteError, Options<AnalyticsGraphConfDeleteData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsGraphConfDeleteResponse, AnalyticsGraphConfDeleteError, Options<AnalyticsGraphConfDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsGraphConfDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const analyticsGraphConfGetQueryKey = (options: Options<AnalyticsGraphConfGetData>) => createQueryKey('analyticsGraphConfGet', options);

/**
 * Get analytics graph configuration
 *
 * Returns a specific analytics graph configuration by ID.
 */
export const analyticsGraphConfGetOptions = (options: Options<AnalyticsGraphConfGetData>) => queryOptions<AnalyticsGraphConfGetResponse, AnalyticsGraphConfGetError, AnalyticsGraphConfGetResponse, ReturnType<typeof analyticsGraphConfGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await analyticsGraphConfGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: analyticsGraphConfGetQueryKey(options)
});

/**
 * Update analytics graph configuration
 *
 * Updates an existing analytics graph configuration.
 */
export const analyticsGraphConfUpdateMutation = (options?: Partial<Options<AnalyticsGraphConfUpdateData>>): UseMutationOptions<AnalyticsGraphConfUpdateResponse, AnalyticsGraphConfUpdateError, Options<AnalyticsGraphConfUpdateData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsGraphConfUpdateResponse, AnalyticsGraphConfUpdateError, Options<AnalyticsGraphConfUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsGraphConfUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create analytics graph configuration
 *
 * Creates a new analytics graph configuration.
 */
export const analyticsGraphConfAddMutation = (options?: Partial<Options<AnalyticsGraphConfAddData>>): UseMutationOptions<AnalyticsGraphConfAddResponse, AnalyticsGraphConfAddError, Options<AnalyticsGraphConfAddData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsGraphConfAddResponse, AnalyticsGraphConfAddError, Options<AnalyticsGraphConfAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsGraphConfAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get least used desktops
 *
 * Returns desktops that have been least used within the specified period.
 */
export const analyticsDesktopsLessUsedMutation = (options?: Partial<Options<AnalyticsDesktopsLessUsedData>>): UseMutationOptions<AnalyticsDesktopsLessUsedResponse, AnalyticsDesktopsLessUsedError, Options<AnalyticsDesktopsLessUsedData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsDesktopsLessUsedResponse, AnalyticsDesktopsLessUsedError, Options<AnalyticsDesktopsLessUsedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsDesktopsLessUsed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get recently used desktops
 *
 * Returns desktops that have been recently used within the specified period.
 */
export const analyticsDesktopsRecentlyUsedMutation = (options?: Partial<Options<AnalyticsDesktopsRecentlyUsedData>>): UseMutationOptions<AnalyticsDesktopsRecentlyUsedResponse, AnalyticsDesktopsRecentlyUsedError, Options<AnalyticsDesktopsRecentlyUsedData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsDesktopsRecentlyUsedResponse, AnalyticsDesktopsRecentlyUsedError, Options<AnalyticsDesktopsRecentlyUsedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsDesktopsRecentlyUsed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get most used desktops
 *
 * Returns desktops that have been most frequently started within the specified period.
 */
export const analyticsDesktopsMostUsedMutation = (options?: Partial<Options<AnalyticsDesktopsMostUsedData>>): UseMutationOptions<AnalyticsDesktopsMostUsedResponse, AnalyticsDesktopsMostUsedError, Options<AnalyticsDesktopsMostUsedData>> => {
    const mutationOptions: UseMutationOptions<AnalyticsDesktopsMostUsedResponse, AnalyticsDesktopsMostUsedError, Options<AnalyticsDesktopsMostUsedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyticsDesktopsMostUsed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get echart daily-items data
 *
 * Returns ``{x, series}`` bucketed by ``(year, month, day)`` of ``table[date_field]``. Distinct from the other echart views which return ``list[{value, name}]``.
 */
export const adminEchartDailyItemsMutation = (options?: Partial<Options<AdminEchartDailyItemsData>>): UseMutationOptions<AdminEchartDailyItemsResponse, AdminEchartDailyItemsError, Options<AdminEchartDailyItemsData>> => {
    const mutationOptions: UseMutationOptions<AdminEchartDailyItemsResponse, AdminEchartDailyItemsError, Options<AdminEchartDailyItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEchartDailyItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get echart data
 *
 * Returns chart data for the specified view type. For ``daily_items`` see ``/admin/item/echart/daily_items``.
 */
export const adminEchartMutation = (options?: Partial<Options<AdminEchartData>>): UseMutationOptions<AdminEchartResponse, AdminEchartError, Options<AdminEchartData>> => {
    const mutationOptions: UseMutationOptions<AdminEchartResponse, AdminEchartError, Options<AdminEchartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEchart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create authentication policy
 *
 * Creates a new authentication policy.
 */
export const adminAuthenticationPolicyAddMutation = (options?: Partial<Options<AdminAuthenticationPolicyAddData>>): UseMutationOptions<AdminAuthenticationPolicyAddResponse, AdminAuthenticationPolicyAddError, Options<AdminAuthenticationPolicyAddData>> => {
    const mutationOptions: UseMutationOptions<AdminAuthenticationPolicyAddResponse, AdminAuthenticationPolicyAddError, Options<AdminAuthenticationPolicyAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAuthenticationPolicyAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminAuthenticationPoliciesQueryKey = (options?: Options<AdminAuthenticationPoliciesData>) => createQueryKey('adminAuthenticationPolicies', options);

/**
 * List authentication policies
 *
 * Returns all authentication policies.
 */
export const adminAuthenticationPoliciesOptions = (options?: Options<AdminAuthenticationPoliciesData>) => queryOptions<AdminAuthenticationPoliciesResponse, AdminAuthenticationPoliciesError, AdminAuthenticationPoliciesResponse, ReturnType<typeof adminAuthenticationPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminAuthenticationPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminAuthenticationPoliciesQueryKey(options)
});

/**
 * Delete authentication policy
 *
 * Deletes an authentication policy by its ID.
 */
export const adminAuthenticationPolicyDeleteMutation = (options?: Partial<Options<AdminAuthenticationPolicyDeleteData>>): UseMutationOptions<AdminAuthenticationPolicyDeleteResponse, AdminAuthenticationPolicyDeleteError, Options<AdminAuthenticationPolicyDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminAuthenticationPolicyDeleteResponse, AdminAuthenticationPolicyDeleteError, Options<AdminAuthenticationPolicyDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAuthenticationPolicyDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminAuthenticationPolicyQueryKey = (options: Options<AdminAuthenticationPolicyData>) => createQueryKey('adminAuthenticationPolicy', options);

/**
 * Get authentication policy
 *
 * Returns an authentication policy by its ID.
 */
export const adminAuthenticationPolicyOptions = (options: Options<AdminAuthenticationPolicyData>) => queryOptions<AdminAuthenticationPolicyResponse, AdminAuthenticationPolicyError, AdminAuthenticationPolicyResponse, ReturnType<typeof adminAuthenticationPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminAuthenticationPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminAuthenticationPolicyQueryKey(options)
});

/**
 * Update authentication policy
 *
 * Updates an authentication policy by its ID.
 */
export const adminAuthenticationPolicyEditMutation = (options?: Partial<Options<AdminAuthenticationPolicyEditData>>): UseMutationOptions<AdminAuthenticationPolicyEditResponse, AdminAuthenticationPolicyEditError, Options<AdminAuthenticationPolicyEditData>> => {
    const mutationOptions: UseMutationOptions<AdminAuthenticationPolicyEditResponse, AdminAuthenticationPolicyEditError, Options<AdminAuthenticationPolicyEditData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAuthenticationPolicyEdit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force email validation at login
 *
 * Forces email validation at login for users matching the policy.
 */
export const adminForceEmailMutation = (options?: Partial<Options<AdminForceEmailData>>): UseMutationOptions<AdminForceEmailResponse, AdminForceEmailError, Options<AdminForceEmailData>> => {
    const mutationOptions: UseMutationOptions<AdminForceEmailResponse, AdminForceEmailError, Options<AdminForceEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminForceEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force disclaimer acknowledgement at login
 *
 * Forces disclaimer acknowledgement at login for users matching the policy.
 */
export const adminForceDisclaimerMutation = (options?: Partial<Options<AdminForceDisclaimerData>>): UseMutationOptions<AdminForceDisclaimerResponse, AdminForceDisclaimerError, Options<AdminForceDisclaimerData>> => {
    const mutationOptions: UseMutationOptions<AdminForceDisclaimerResponse, AdminForceDisclaimerError, Options<AdminForceDisclaimerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminForceDisclaimer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Force password update at login
 *
 * Forces password update at login for users matching the policy.
 */
export const adminForcePasswordMutation = (options?: Partial<Options<AdminForcePasswordData>>): UseMutationOptions<AdminForcePasswordResponse, AdminForcePasswordError, Options<AdminForcePasswordData>> => {
    const mutationOptions: UseMutationOptions<AdminForcePasswordResponse, AdminForcePasswordError, Options<AdminForcePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminForcePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProviderConfigRouteQueryKey = (options: Options<GetProviderConfigRouteData>) => createQueryKey('getProviderConfigRoute', options);

/**
 * Get provider configuration
 *
 * Returns the configuration for a specific authentication provider.
 */
export const getProviderConfigRouteOptions = (options: Options<GetProviderConfigRouteData>) => queryOptions<GetProviderConfigRouteResponse, GetProviderConfigRouteError, GetProviderConfigRouteResponse, ReturnType<typeof getProviderConfigRouteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProviderConfigRoute({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProviderConfigRouteQueryKey(options)
});

/**
 * Update provider configuration
 *
 * Updates the configuration for a specific authentication provider.
 */
export const editProviderConfigRouteMutation = (options?: Partial<Options<EditProviderConfigRouteData>>): UseMutationOptions<EditProviderConfigRouteResponse, EditProviderConfigRouteError, Options<EditProviderConfigRouteData>> => {
    const mutationOptions: UseMutationOptions<EditProviderConfigRouteResponse, EditProviderConfigRouteError, Options<EditProviderConfigRouteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editProviderConfigRoute({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetMigrationExceptionsQueryKey = (options?: Options<AdminGetMigrationExceptionsData>) => createQueryKey('adminGetMigrationExceptions', options);

/**
 * List migration exceptions
 *
 * Returns all migration exceptions.
 */
export const adminGetMigrationExceptionsOptions = (options?: Options<AdminGetMigrationExceptionsData>) => queryOptions<AdminGetMigrationExceptionsResponse, AdminGetMigrationExceptionsError, AdminGetMigrationExceptionsResponse, ReturnType<typeof adminGetMigrationExceptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetMigrationExceptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetMigrationExceptionsQueryKey(options)
});

/**
 * Add migration exception
 *
 * Adds a migration exception for specific items.
 */
export const adminAddMigrationExceptionMutation = (options?: Partial<Options<AdminAddMigrationExceptionData>>): UseMutationOptions<AdminAddMigrationExceptionResponse, AdminAddMigrationExceptionError, Options<AdminAddMigrationExceptionData>> => {
    const mutationOptions: UseMutationOptions<AdminAddMigrationExceptionResponse, AdminAddMigrationExceptionError, Options<AdminAddMigrationExceptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAddMigrationException({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete migration exception
 *
 * Deletes a migration exception by its ID.
 */
export const adminDeleteMigrationExceptionMutation = (options?: Partial<Options<AdminDeleteMigrationExceptionData>>): UseMutationOptions<AdminDeleteMigrationExceptionResponse, AdminDeleteMigrationExceptionError, Options<AdminDeleteMigrationExceptionData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteMigrationExceptionResponse, AdminDeleteMigrationExceptionError, Options<AdminDeleteMigrationExceptionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteMigrationException({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminBackupsListQueryKey = (options?: Options<AdminBackupsListData>) => createQueryKey('adminBackupsList', options);

/**
 * List backups
 *
 * Get a list of backups. Optionally get a specific backup by ID via query parameter, or limit the result via the limit query parameter.
 */
export const adminBackupsListOptions = (options?: Options<AdminBackupsListData>) => queryOptions<AdminBackupsListResponse, AdminBackupsListError, AdminBackupsListResponse, ReturnType<typeof adminBackupsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminBackupsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminBackupsListQueryKey(options)
});

export const adminBackupIntegrityGetQueryKey = (options?: Options<AdminBackupIntegrityGetData>) => createQueryKey('adminBackupIntegrityGet', options);

/**
 * Get weekly borg integrity check toggle
 *
 * Return the saved weekly-borg-integrity toggle. Off by default; backupninja containers poll this live before each saturday run.
 */
export const adminBackupIntegrityGetOptions = (options?: Options<AdminBackupIntegrityGetData>) => queryOptions<AdminBackupIntegrityGetResponse, AdminBackupIntegrityGetError, AdminBackupIntegrityGetResponse, ReturnType<typeof adminBackupIntegrityGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminBackupIntegrityGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminBackupIntegrityGetQueryKey(options)
});

/**
 * Enable or disable weekly borg integrity check
 *
 * Persist the weekly-borg-integrity toggle. Takes effect on the next scheduled run; no container restart required.
 */
export const adminBackupIntegritySetMutation = (options?: Partial<Options<AdminBackupIntegritySetData>>): UseMutationOptions<AdminBackupIntegritySetResponse, AdminBackupIntegritySetError, Options<AdminBackupIntegritySetData>> => {
    const mutationOptions: UseMutationOptions<AdminBackupIntegritySetResponse, AdminBackupIntegritySetError, Options<AdminBackupIntegritySetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminBackupIntegritySet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminBackupConfigQueryKey = (options?: Options<AdminBackupConfigData>) => createQueryKey('adminBackupConfig', options);

/**
 * Get backup configuration
 *
 * Get backup configuration from environment variables.
 */
export const adminBackupConfigOptions = (options?: Options<AdminBackupConfigData>) => queryOptions<AdminBackupConfigResponse, AdminBackupConfigError, AdminBackupConfigResponse, ReturnType<typeof adminBackupConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminBackupConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminBackupConfigQueryKey(options)
});

export const adminBackupGetQueryKey = (options: Options<AdminBackupGetData>) => createQueryKey('adminBackupGet', options);

/**
 * Get a specific backup
 *
 * Get a specific backup by its ID.
 */
export const adminBackupGetOptions = (options: Options<AdminBackupGetData>) => queryOptions<AdminBackupGetResponse, AdminBackupGetError, AdminBackupGetResponse, ReturnType<typeof adminBackupGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminBackupGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminBackupGetQueryKey(options)
});

/**
 * Submit backup report
 *
 * Ingestion endpoint for backupninja. Rejects non-service callers so regular admin users cannot forge or pollute backup history.
 */
export const adminBackupReportMutation = (options?: Partial<Options<AdminBackupReportData>>): UseMutationOptions<AdminBackupReportResponse, AdminBackupReportError, Options<AdminBackupReportData>> => {
    const mutationOptions: UseMutationOptions<AdminBackupReportResponse, AdminBackupReportError, Options<AdminBackupReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminBackupReport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainXmlGetQueryKey = (options: Options<AdminDomainXmlGetData>) => createQueryKey('adminDomainXmlGet', options);

/**
 * Get domain XML
 *
 * Returns the XML configuration for a domain.
 */
export const adminDomainXmlGetOptions = (options: Options<AdminDomainXmlGetData>) => queryOptions<AdminDomainXmlGetResponse, AdminDomainXmlGetError, AdminDomainXmlGetResponse, ReturnType<typeof adminDomainXmlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainXmlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainXmlGetQueryKey(options)
});

/**
 * Update domain XML
 *
 * Updates the XML configuration for a domain and returns the updated XML.
 */
export const adminDomainXmlUpdateMutation = (options?: Partial<Options<AdminDomainXmlUpdateData>>): UseMutationOptions<AdminDomainXmlUpdateResponse, AdminDomainXmlUpdateError, Options<AdminDomainXmlUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminDomainXmlUpdateResponse, AdminDomainXmlUpdateError, Options<AdminDomainXmlUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDomainXmlUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainLiveXmlQueryKey = (options: Options<AdminDomainLiveXmlData>) => createQueryKey('adminDomainLiveXml', options);

/**
 * Get a started desktop's live libvirt XML
 *
 * Live libvirt XML (incl. secrets) of a started desktop, from engine RAM. Proxies to the engine's internal API; the XML is never stored in the DB. 409 when the desktop is not running; 404 when the live XML was not captured (restart the desktop to capture).
 */
export const adminDomainLiveXmlOptions = (options: Options<AdminDomainLiveXmlData>) => queryOptions<AdminDomainLiveXmlResponse2, AdminDomainLiveXmlError, AdminDomainLiveXmlResponse2, ReturnType<typeof adminDomainLiveXmlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainLiveXml({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainLiveXmlQueryKey(options)
});

/**
 * Change desktop status in bulk
 *
 * Changes the status of all desktops matching the current status to the target status.
 */
export const adminDesktopsStatusMutation = (options?: Partial<Options<AdminDesktopsStatusData>>): UseMutationOptions<AdminDesktopsStatusResponse, AdminDesktopsStatusError, Options<AdminDesktopsStatusData>> => {
    const mutationOptions: UseMutationOptions<AdminDesktopsStatusResponse, AdminDesktopsStatusError, Options<AdminDesktopsStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDesktopsStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change desktop status by category
 *
 * Changes the status of desktops in a specific category matching the current status to the target status.
 */
export const adminDesktopsStatusCategoryMutation = (options?: Partial<Options<AdminDesktopsStatusCategoryData>>): UseMutationOptions<AdminDesktopsStatusCategoryResponse, AdminDesktopsStatusCategoryError, Options<AdminDesktopsStatusCategoryData>> => {
    const mutationOptions: UseMutationOptions<AdminDesktopsStatusCategoryResponse, AdminDesktopsStatusCategoryError, Options<AdminDesktopsStatusCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDesktopsStatusCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update domain storage path
 *
 * Updates the storage path of a domain, replacing all occurrences of the old path with the new path.
 */
export const adminDomainStoragePathMutation = (options?: Partial<Options<AdminDomainStoragePathData2>>): UseMutationOptions<AdminDomainStoragePathResponse2, AdminDomainStoragePathError, Options<AdminDomainStoragePathData2>> => {
    const mutationOptions: UseMutationOptions<AdminDomainStoragePathResponse2, AdminDomainStoragePathError, Options<AdminDomainStoragePathData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDomainStoragePath({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminLogsDesktopsConfigQueryKey = (options?: Options<AdminLogsDesktopsConfigData>) => createQueryKey('adminLogsDesktopsConfig', options);

/**
 * Get desktop logs old entries config
 *
 * Returns the configuration for desktop logs old entries management.
 */
export const adminLogsDesktopsConfigOptions = (options?: Options<AdminLogsDesktopsConfigData>) => queryOptions<AdminLogsDesktopsConfigResponse, AdminLogsDesktopsConfigError, AdminLogsDesktopsConfigResponse, ReturnType<typeof adminLogsDesktopsConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLogsDesktopsConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsDesktopsConfigQueryKey(options)
});

/**
 * Set desktop logs max time
 *
 * Sets the maximum time (in hours) for desktop logs old entries. Minimum value is 24 hours.
 */
export const adminLogsDesktopsMaxTimeMutation = (options?: Partial<Options<AdminLogsDesktopsMaxTimeData>>): UseMutationOptions<AdminLogsDesktopsMaxTimeResponse, AdminLogsDesktopsMaxTimeError, Options<AdminLogsDesktopsMaxTimeData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsMaxTimeResponse, AdminLogsDesktopsMaxTimeError, Options<AdminLogsDesktopsMaxTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsMaxTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set desktop logs old entries action
 *
 * Sets the action for desktop logs old entries. Valid values: "delete", "none".
 */
export const adminLogsDesktopsActionMutation = (options?: Partial<Options<AdminLogsDesktopsActionData>>): UseMutationOptions<AdminLogsDesktopsActionResponse, AdminLogsDesktopsActionError, Options<AdminLogsDesktopsActionData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsActionResponse, AdminLogsDesktopsActionError, Options<AdminLogsDesktopsActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete old desktop logs
 *
 * Deletes desktop logs older than the configured max time. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsDesktopsDeleteMutation = (options?: Partial<Options<AdminLogsDesktopsDeleteData>>): UseMutationOptions<AdminLogsDesktopsDeleteResponse, AdminLogsDesktopsDeleteError, Options<AdminLogsDesktopsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsDeleteResponse, AdminLogsDesktopsDeleteError, Options<AdminLogsDesktopsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all desktop logs
 *
 * Deletes all desktop logs regardless of age. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsDesktopsDeleteAllMutation = (options?: Partial<Options<AdminLogsDesktopsDeleteAllData>>): UseMutationOptions<AdminLogsDesktopsDeleteAllResponse, AdminLogsDesktopsDeleteAllError, Options<AdminLogsDesktopsDeleteAllData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsDesktopsDeleteAllResponse, AdminLogsDesktopsDeleteAllError, Options<AdminLogsDesktopsDeleteAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsDesktopsDeleteAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminLogsUsersConfigQueryKey = (options?: Options<AdminLogsUsersConfigData>) => createQueryKey('adminLogsUsersConfig', options);

/**
 * Get user logs old entries config
 *
 * Returns the configuration for user logs old entries management.
 */
export const adminLogsUsersConfigOptions = (options?: Options<AdminLogsUsersConfigData>) => queryOptions<AdminLogsUsersConfigResponse, AdminLogsUsersConfigError, AdminLogsUsersConfigResponse, ReturnType<typeof adminLogsUsersConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminLogsUsersConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminLogsUsersConfigQueryKey(options)
});

/**
 * Set user logs max time
 *
 * Sets the maximum time (in hours) for user logs old entries. Minimum value is 24 hours.
 */
export const adminLogsUsersMaxTimeMutation = (options?: Partial<Options<AdminLogsUsersMaxTimeData>>): UseMutationOptions<AdminLogsUsersMaxTimeResponse, AdminLogsUsersMaxTimeError, Options<AdminLogsUsersMaxTimeData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersMaxTimeResponse, AdminLogsUsersMaxTimeError, Options<AdminLogsUsersMaxTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersMaxTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set user logs old entries action
 *
 * Sets the action for user logs old entries. Valid values: "delete", "none".
 */
export const adminLogsUsersActionMutation = (options?: Partial<Options<AdminLogsUsersActionData>>): UseMutationOptions<AdminLogsUsersActionResponse, AdminLogsUsersActionError, Options<AdminLogsUsersActionData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersActionResponse, AdminLogsUsersActionError, Options<AdminLogsUsersActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete old user logs
 *
 * Deletes user logs older than the configured max time. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsUsersDeleteMutation = (options?: Partial<Options<AdminLogsUsersDeleteData>>): UseMutationOptions<AdminLogsUsersDeleteResponse, AdminLogsUsersDeleteError, Options<AdminLogsUsersDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersDeleteResponse, AdminLogsUsersDeleteError, Options<AdminLogsUsersDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all user logs
 *
 * Deletes all user logs regardless of age. Runs asynchronously and returns the count of logs to delete.
 */
export const adminLogsUsersDeleteAllMutation = (options?: Partial<Options<AdminLogsUsersDeleteAllData>>): UseMutationOptions<AdminLogsUsersDeleteAllResponse, AdminLogsUsersDeleteAllError, Options<AdminLogsUsersDeleteAllData>> => {
    const mutationOptions: UseMutationOptions<AdminLogsUsersDeleteAllResponse, AdminLogsUsersDeleteAllError, Options<AdminLogsUsersDeleteAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLogsUsersDeleteAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainXmlCapabilitiesQueryKey = (options?: Options<AdminDomainXmlCapabilitiesData>) => createQueryKey('adminDomainXmlCapabilities', options);

/**
 * Get XML capabilities
 *
 * Returns libvirt domain XML capabilities and section definitions.
 */
export const adminDomainXmlCapabilitiesOptions = (options?: Options<AdminDomainXmlCapabilitiesData>) => queryOptions<AdminDomainXmlCapabilitiesResponse2, AdminDomainXmlCapabilitiesError, AdminDomainXmlCapabilitiesResponse2, ReturnType<typeof adminDomainXmlCapabilitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainXmlCapabilities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainXmlCapabilitiesQueryKey(options)
});

/**
 * Parse raw XML into sections
 *
 * Split raw XML into editable sections without a saved domain.
 */
export const adminDomainXmlSectionsParseMutation = (options?: Partial<Options<AdminDomainXmlSectionsParseData>>): UseMutationOptions<AdminDomainXmlSectionsParseResponse2, AdminDomainXmlSectionsParseError, Options<AdminDomainXmlSectionsParseData>> => {
    const mutationOptions: UseMutationOptions<AdminDomainXmlSectionsParseResponse2, AdminDomainXmlSectionsParseError, Options<AdminDomainXmlSectionsParseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDomainXmlSectionsParse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDomainXmlSectionsGetQueryKey = (options: Options<AdminDomainXmlSectionsGetData>) => createQueryKey('adminDomainXmlSectionsGet', options);

/**
 * Get domain XML sections
 *
 * Split a domain's XML into editable sections.
 */
export const adminDomainXmlSectionsGetOptions = (options: Options<AdminDomainXmlSectionsGetData>) => queryOptions<AdminDomainXmlSectionsGetResponse2, AdminDomainXmlSectionsGetError, AdminDomainXmlSectionsGetResponse2, ReturnType<typeof adminDomainXmlSectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainXmlSectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainXmlSectionsGetQueryKey(options)
});

/**
 * Save domain XML sections
 *
 * Merge edited XML sections back into the domain's full XML.
 */
export const adminDomainXmlSectionsSaveMutation = (options?: Partial<Options<AdminDomainXmlSectionsSaveData2>>): UseMutationOptions<AdminDomainXmlSectionsSaveResponse2, AdminDomainXmlSectionsSaveError, Options<AdminDomainXmlSectionsSaveData2>> => {
    const mutationOptions: UseMutationOptions<AdminDomainXmlSectionsSaveResponse2, AdminDomainXmlSectionsSaveError, Options<AdminDomainXmlSectionsSaveData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDomainXmlSectionsSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Save domain XML sections as a new virt_install template
 *
 * Merges the edited XML sections into the domain's full XML, generalises disk paths / UUIDs / runtime attributes, derives ``www``/``icon``/``vers`` metadata from the libosinfo tag, and inserts a new ``virt_install`` row with a slug-of-name id.
 */
export const adminDomainXmlSectionsSaveAsVirtInstallMutation = (options?: Partial<Options<AdminDomainXmlSectionsSaveAsVirtInstallData>>): UseMutationOptions<AdminDomainXmlSectionsSaveAsVirtInstallResponse, AdminDomainXmlSectionsSaveAsVirtInstallError, Options<AdminDomainXmlSectionsSaveAsVirtInstallData>> => {
    const mutationOptions: UseMutationOptions<AdminDomainXmlSectionsSaveAsVirtInstallResponse, AdminDomainXmlSectionsSaveAsVirtInstallError, Options<AdminDomainXmlSectionsSaveAsVirtInstallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDomainXmlSectionsSaveAsVirtInstall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminVirtInstallXmlSectionsGetQueryKey = (options: Options<AdminVirtInstallXmlSectionsGetData>) => createQueryKey('adminVirtInstallXmlSectionsGet', options);

/**
 * Get virt_install XML sections
 *
 * Split a ``virt_install`` template's XML into editable sections for the admin XML sections editor.
 */
export const adminVirtInstallXmlSectionsGetOptions = (options: Options<AdminVirtInstallXmlSectionsGetData>) => queryOptions<AdminVirtInstallXmlSectionsGetResponse, AdminVirtInstallXmlSectionsGetError, AdminVirtInstallXmlSectionsGetResponse, ReturnType<typeof adminVirtInstallXmlSectionsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminVirtInstallXmlSectionsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminVirtInstallXmlSectionsGetQueryKey(options)
});

/**
 * Save virt_install XML sections
 *
 * Merge edited sections back into a ``virt_install`` template's full XML.
 */
export const adminVirtInstallXmlSectionsSaveMutation = (options?: Partial<Options<AdminVirtInstallXmlSectionsSaveData>>): UseMutationOptions<AdminVirtInstallXmlSectionsSaveResponse2, AdminVirtInstallXmlSectionsSaveError, Options<AdminVirtInstallXmlSectionsSaveData>> => {
    const mutationOptions: UseMutationOptions<AdminVirtInstallXmlSectionsSaveResponse2, AdminVirtInstallXmlSectionsSaveError, Options<AdminVirtInstallXmlSectionsSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminVirtInstallXmlSectionsSave({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminDownloadsQueryKey = (options?: Options<AdminDownloadsData>) => createQueryKey('adminDownloads', options);

/**
 * Get downloads overview
 *
 * Get an overview of available downloads. Requires registration.
 */
export const adminDownloadsOptions = (options?: Options<AdminDownloadsData>) => queryOptions<AdminDownloadsResponse, AdminDownloadsError, AdminDownloadsResponse, ReturnType<typeof adminDownloadsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDownloads({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDownloadsQueryKey(options)
});

export const adminDownloadsKindQueryKey = (options: Options<AdminDownloadsKindData>) => createQueryKey('adminDownloadsKind', options);

/**
 * Get downloads by kind
 *
 * Get available downloads for a specific kind (domains, media, virt_install, videos, viewers).
 */
export const adminDownloadsKindOptions = (options: Options<AdminDownloadsKindData>) => queryOptions<AdminDownloadsKindResponse, AdminDownloadsKindError, AdminDownloadsKindResponse, ReturnType<typeof adminDownloadsKindQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDownloadsKind({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDownloadsKindQueryKey(options)
});

/**
 * Register with updates server
 *
 * Register this IsardVDI instance with the updates server.
 */
export const adminDownloadsRegisterMutation = (options?: Partial<Options<AdminDownloadsRegisterData>>): UseMutationOptions<AdminDownloadsRegisterResponse, AdminDownloadsRegisterError, Options<AdminDownloadsRegisterData>> => {
    const mutationOptions: UseMutationOptions<AdminDownloadsRegisterResponse, AdminDownloadsRegisterError, Options<AdminDownloadsRegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDownloadsRegister({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Execute download action for all items
 *
 * Execute a download action (download, abort, delete) for all new items of a kind.
 */
export const adminDownloadsActionMutation = (options?: Partial<Options<AdminDownloadsActionData>>): UseMutationOptions<AdminDownloadsActionResponse, AdminDownloadsActionError, Options<AdminDownloadsActionData>> => {
    const mutationOptions: UseMutationOptions<AdminDownloadsActionResponse, AdminDownloadsActionError, Options<AdminDownloadsActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDownloadsAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Execute download action for a specific item
 *
 * Execute a download action (download, abort, delete) for a specific item.
 */
export const adminDownloadsActionIdMutation = (options?: Partial<Options<AdminDownloadsActionIdData>>): UseMutationOptions<AdminDownloadsActionIdResponse, AdminDownloadsActionIdError, Options<AdminDownloadsActionIdData>> => {
    const mutationOptions: UseMutationOptions<AdminDownloadsActionIdResponse, AdminDownloadsActionIdError, Options<AdminDownloadsActionIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDownloadsActionId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminHypervisorsListQueryKey = (options?: Options<AdminHypervisorsListData>) => createQueryKey('adminHypervisorsList', options);

/**
 * List all hypervisors
 *
 * List all hypervisors, optionally filtered by status.
 */
export const adminHypervisorsListOptions = (options?: Options<AdminHypervisorsListData>) => queryOptions<AdminHypervisorsListResponse, AdminHypervisorsListError, AdminHypervisorsListResponse, ReturnType<typeof adminHypervisorsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorsListQueryKey(options)
});

export const adminHypervisorsListByStatusQueryKey = (options: Options<AdminHypervisorsListByStatusData>) => createQueryKey('adminHypervisorsListByStatus', options);

/**
 * List hypervisors by status
 *
 * List hypervisors filtered by status (Online, Offline, Error).
 */
export const adminHypervisorsListByStatusOptions = (options: Options<AdminHypervisorsListByStatusData>) => queryOptions<AdminHypervisorsListByStatusResponse, AdminHypervisorsListByStatusError, AdminHypervisorsListByStatusResponse, ReturnType<typeof adminHypervisorsListByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorsListByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorsListByStatusQueryKey(options)
});

export const adminHypervisorStatusQueryKey = (options: Options<AdminHypervisorStatusData>) => createQueryKey('adminHypervisorStatus', options);

/**
 * Get hypervisor status
 *
 * Get the status and only_forced flag for a hypervisor.
 */
export const adminHypervisorStatusOptions = (options: Options<AdminHypervisorStatusData>) => queryOptions<AdminHypervisorStatusResponse2, AdminHypervisorStatusError, AdminHypervisorStatusResponse2, ReturnType<typeof adminHypervisorStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorStatusQueryKey(options)
});

/**
 * Create or register a hypervisor
 *
 * Register a new hypervisor or update an existing one. Performs SSH key scanning and certificate exchange.
 */
export const adminHypervisorCreateMutation = (options?: Partial<Options<AdminHypervisorCreateData2>>): UseMutationOptions<AdminHypervisorCreateResponse2, AdminHypervisorCreateError, Options<AdminHypervisorCreateData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorCreateResponse2, AdminHypervisorCreateError, Options<AdminHypervisorCreateData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a hypervisor
 *
 * Remove a hypervisor. Stops its domains and waits for engine removal.
 */
export const adminHypervisorDeleteMutation = (options?: Partial<Options<AdminHypervisorDeleteData>>): UseMutationOptions<AdminHypervisorDeleteResponse, AdminHypervisorDeleteError, Options<AdminHypervisorDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorDeleteResponse, AdminHypervisorDeleteError, Options<AdminHypervisorDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable or disable a hypervisor
 *
 * Enable or disable an existing hypervisor.
 */
export const adminHypervisorEnableMutation = (options?: Partial<Options<AdminHypervisorEnableData2>>): UseMutationOptions<AdminHypervisorEnableResponse2, AdminHypervisorEnableError, Options<AdminHypervisorEnableData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorEnableResponse2, AdminHypervisorEnableError, Options<AdminHypervisorEnableData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorEnable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop all domains on a hypervisor
 *
 * Force stop all running domains on the specified hypervisor.
 */
export const adminHypervisorStopDomainsMutation = (options?: Partial<Options<AdminHypervisorStopDomainsData>>): UseMutationOptions<AdminHypervisorStopDomainsResponse, AdminHypervisorStopDomainsError, Options<AdminHypervisorStopDomainsData>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorStopDomainsResponse, AdminHypervisorStopDomainsError, Options<AdminHypervisorStopDomainsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorStopDomains({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminHypervisorVpnQueryKey = (options: Options<AdminHypervisorVpnData>) => createQueryKey('adminHypervisorVpn', options);

/**
 * Get hypervisor VPN config
 *
 * Get the VPN configuration for a hypervisor.
 */
export const adminHypervisorVpnOptions = (options: Options<AdminHypervisorVpnData>) => queryOptions<AdminHypervisorVpnResponse2, AdminHypervisorVpnError, AdminHypervisorVpnResponse2, ReturnType<typeof adminHypervisorVpnQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorVpn({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorVpnQueryKey(options)
});

/**
 * Update wireguard guest address
 *
 * Update the wireguard guest IP address for a domain identified by MAC.
 */
export const adminHypervisorWgAddrMutation = (options?: Partial<Options<AdminHypervisorWgAddrData2>>): UseMutationOptions<AdminHypervisorWgAddrResponse2, AdminHypervisorWgAddrError, Options<AdminHypervisorWgAddrData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorWgAddrResponse2, AdminHypervisorWgAddrError, Options<AdminHypervisorWgAddrData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorWgAddr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report media found on hypervisor
 *
 * Register media files discovered on a hypervisor.
 */
export const adminHypervisorMediaFoundMutation = (options?: Partial<Options<AdminHypervisorMediaFoundData2>>): UseMutationOptions<AdminHypervisorMediaFoundResponse, AdminHypervisorMediaFoundError, Options<AdminHypervisorMediaFoundData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorMediaFoundResponse, AdminHypervisorMediaFoundError, Options<AdminHypervisorMediaFoundData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorMediaFound({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Report disks found on hypervisor
 *
 * Register disk files discovered on a hypervisor.
 */
export const adminHypervisorDisksFoundMutation = (options?: Partial<Options<AdminHypervisorDisksFoundData2>>): UseMutationOptions<AdminHypervisorDisksFoundResponse, AdminHypervisorDisksFoundError, Options<AdminHypervisorDisksFoundData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorDisksFoundResponse, AdminHypervisorDisksFoundError, Options<AdminHypervisorDisksFoundData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorDisksFound({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete media by paths
 *
 * Delete media entries matching the specified paths.
 */
export const adminHypervisorMediaDeleteMutation = (options?: Partial<Options<AdminHypervisorMediaDeleteData2>>): UseMutationOptions<AdminHypervisorMediaDeleteResponse, AdminHypervisorMediaDeleteError, Options<AdminHypervisorMediaDeleteData2>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorMediaDeleteResponse, AdminHypervisorMediaDeleteError, Options<AdminHypervisorMediaDeleteData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorMediaDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminOrchestratorHypervisorsListQueryKey = (options?: Options<AdminOrchestratorHypervisorsListData>) => createQueryKey('adminOrchestratorHypervisorsList', options);

/**
 * List orchestrator hypervisors
 *
 * List all hypervisors with orchestrator-specific fields.
 */
export const adminOrchestratorHypervisorsListOptions = (options?: Options<AdminOrchestratorHypervisorsListData>) => queryOptions<AdminOrchestratorHypervisorsListResponse, AdminOrchestratorHypervisorsListError, AdminOrchestratorHypervisorsListResponse, ReturnType<typeof adminOrchestratorHypervisorsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminOrchestratorHypervisorsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminOrchestratorHypervisorsListQueryKey(options)
});

export const adminOrchestratorHypervisorGetQueryKey = (options: Options<AdminOrchestratorHypervisorGetData>) => createQueryKey('adminOrchestratorHypervisorGet', options);

/**
 * Get orchestrator hypervisor details
 *
 * Get orchestrator-specific details for a single hypervisor.
 */
export const adminOrchestratorHypervisorGetOptions = (options: Options<AdminOrchestratorHypervisorGetData>) => queryOptions<AdminOrchestratorHypervisorGetResponse, AdminOrchestratorHypervisorGetError, AdminOrchestratorHypervisorGetResponse, ReturnType<typeof adminOrchestratorHypervisorGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminOrchestratorHypervisorGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminOrchestratorHypervisorGetQueryKey(options)
});

/**
 * List orchestrator-managed hypervisors
 *
 * List only hypervisors that are marked as orchestrator-managed.
 */
export const adminOrchestratorManagedListMutation = (options?: Partial<Options<AdminOrchestratorManagedListData>>): UseMutationOptions<AdminOrchestratorManagedListResponse, AdminOrchestratorManagedListError, Options<AdminOrchestratorManagedListData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorManagedListResponse, AdminOrchestratorManagedListError, Options<AdminOrchestratorManagedListData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorManagedList({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset hypervisor dead row timeout
 *
 * Reset (remove) the dead row timeout for an orchestrator-managed hypervisor.
 */
export const adminOrchestratorDeadRowResetMutation = (options?: Partial<Options<AdminOrchestratorDeadRowResetData>>): UseMutationOptions<AdminOrchestratorDeadRowResetResponse, AdminOrchestratorDeadRowResetError, Options<AdminOrchestratorDeadRowResetData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorDeadRowResetResponse, AdminOrchestratorDeadRowResetError, Options<AdminOrchestratorDeadRowResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorDeadRowReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set hypervisor dead row timeout
 *
 * Set the dead row timeout for an orchestrator-managed hypervisor.
 */
export const adminOrchestratorDeadRowSetMutation = (options?: Partial<Options<AdminOrchestratorDeadRowSetData>>): UseMutationOptions<AdminOrchestratorDeadRowSetResponse, AdminOrchestratorDeadRowSetError, Options<AdminOrchestratorDeadRowSetData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorDeadRowSetResponse, AdminOrchestratorDeadRowSetError, Options<AdminOrchestratorDeadRowSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorDeadRowSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set hypervisor only_forced flag
 *
 * Set or clear the only_forced flag for a hypervisor.
 */
export const adminOrchestratorOnlyForcedSetMutation = (options?: Partial<Options<AdminOrchestratorOnlyForcedSetData>>): UseMutationOptions<AdminOrchestratorOnlyForcedSetResponse, AdminOrchestratorOnlyForcedSetError, Options<AdminOrchestratorOnlyForcedSetData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorOnlyForcedSetResponse, AdminOrchestratorOnlyForcedSetError, Options<AdminOrchestratorOnlyForcedSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorOnlyForcedSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stop hypervisor desktops (orchestrator)
 *
 * Stop all started desktops on an orchestrator-managed hypervisor.
 */
export const adminOrchestratorStopDesktopsMutation = (options?: Partial<Options<AdminOrchestratorStopDesktopsData>>): UseMutationOptions<AdminOrchestratorStopDesktopsResponse, AdminOrchestratorStopDesktopsError, Options<AdminOrchestratorStopDesktopsData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorStopDesktopsResponse, AdminOrchestratorStopDesktopsError, Options<AdminOrchestratorStopDesktopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorStopDesktops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unmark hypervisor from orchestrator management
 *
 * Remove orchestrator management flag from a hypervisor.
 */
export const adminOrchestratorManageUnsetMutation = (options?: Partial<Options<AdminOrchestratorManageUnsetData>>): UseMutationOptions<AdminOrchestratorManageUnsetResponse, AdminOrchestratorManageUnsetError, Options<AdminOrchestratorManageUnsetData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorManageUnsetResponse, AdminOrchestratorManageUnsetError, Options<AdminOrchestratorManageUnsetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorManageUnset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark hypervisor for orchestrator management
 *
 * Mark a hypervisor as managed by the orchestrator.
 */
export const adminOrchestratorManageSetMutation = (options?: Partial<Options<AdminOrchestratorManageSetData>>): UseMutationOptions<AdminOrchestratorManageSetResponse, AdminOrchestratorManageSetError, Options<AdminOrchestratorManageSetData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorManageSetResponse, AdminOrchestratorManageSetError, Options<AdminOrchestratorManageSetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorManageSet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminHypervisorVirtPoolsGetQueryKey = (options: Options<AdminHypervisorVirtPoolsGetData>) => createQueryKey('adminHypervisorVirtPoolsGet', options);

/**
 * Get hypervisor virt pools
 *
 * Get the virt pool assignments for a hypervisor.
 */
export const adminHypervisorVirtPoolsGetOptions = (options: Options<AdminHypervisorVirtPoolsGetData>) => queryOptions<AdminHypervisorVirtPoolsGetResponse, AdminHypervisorVirtPoolsGetError, AdminHypervisorVirtPoolsGetResponse, ReturnType<typeof adminHypervisorVirtPoolsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorVirtPoolsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorVirtPoolsGetQueryKey(options)
});

/**
 * Update hypervisor virt pool assignment
 *
 * Enable or disable a virt pool for a hypervisor.
 */
export const adminHypervisorVirtPoolsUpdateMutation = (options?: Partial<Options<AdminHypervisorVirtPoolsUpdateData>>): UseMutationOptions<AdminHypervisorVirtPoolsUpdateResponse, AdminHypervisorVirtPoolsUpdateError, Options<AdminHypervisorVirtPoolsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorVirtPoolsUpdateResponse, AdminHypervisorVirtPoolsUpdateError, Options<AdminHypervisorVirtPoolsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorVirtPoolsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminHypervisorMountpointsQueryKey = (options: Options<AdminHypervisorMountpointsData>) => createQueryKey('adminHypervisorMountpoints', options);

/**
 * Get hypervisor mountpoints
 *
 * Get the filesystem mountpoints reported by a hypervisor.
 */
export const adminHypervisorMountpointsOptions = (options: Options<AdminHypervisorMountpointsData>) => queryOptions<AdminHypervisorMountpointsResponse, AdminHypervisorMountpointsError, AdminHypervisorMountpointsResponse, ReturnType<typeof adminHypervisorMountpointsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorMountpoints({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorMountpointsQueryKey(options)
});

export const adminHypervisorStartedDomainsQueryKey = (options: Options<AdminHypervisorStartedDomainsData>) => createQueryKey('adminHypervisorStartedDomains', options);

/**
 * Get started domains on a hypervisor
 *
 * Get all currently started desktop domains on a hypervisor.
 */
export const adminHypervisorStartedDomainsOptions = (options: Options<AdminHypervisorStartedDomainsData>) => queryOptions<AdminHypervisorStartedDomainsResponse, AdminHypervisorStartedDomainsError, AdminHypervisorStartedDomainsResponse, ReturnType<typeof adminHypervisorStartedDomainsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminHypervisorStartedDomains({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminHypervisorStartedDomainsQueryKey(options)
});

/**
 * Register VLANs from hypervisor
 *
 * Creates network interface entries for discovered VLANs.
 */
export const adminRegisterVlansMutation = (options?: Partial<Options<AdminRegisterVlansData>>): UseMutationOptions<AdminRegisterVlansResponse, AdminRegisterVlansError, Options<AdminRegisterVlansData>> => {
    const mutationOptions: UseMutationOptions<AdminRegisterVlansResponse, AdminRegisterVlansError, Options<AdminRegisterVlansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminRegisterVlans({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update hypervisor boot progress
 *
 * Updates the boot progress data for a hypervisor.
 */
export const adminHypervisorBootProgressMutation = (options?: Partial<Options<AdminHypervisorBootProgressData>>): UseMutationOptions<AdminHypervisorBootProgressResponse, AdminHypervisorBootProgressError, Options<AdminHypervisorBootProgressData>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorBootProgressResponse, AdminHypervisorBootProgressError, Options<AdminHypervisorBootProgressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorBootProgress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Ingest a hypervisor's applied GPU profile report
 *
 * A gpu-apply-capable hypervisor reports back, after registration, the per-card profile it actually applied locally (+ the created mdev pool). Persisted into vgpus so the DB reflects reality and the engine reconcile confirms instead of re-applying. Hypervisor-facing: the hypervisor service JWT (kid isardvdi-hypervisors) maps to the admin role.
 */
export const adminHypervisorGpuAppliedMutation = (options?: Partial<Options<AdminHypervisorGpuAppliedData>>): UseMutationOptions<AdminHypervisorGpuAppliedResponse, AdminHypervisorGpuAppliedError, Options<AdminHypervisorGpuAppliedData>> => {
    const mutationOptions: UseMutationOptions<AdminHypervisorGpuAppliedResponse, AdminHypervisorGpuAppliedError, Options<AdminHypervisorGpuAppliedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminHypervisorGpuApplied({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview the impact of forcing a GPU profile
 *
 * Admin-only read-only pre-flight for the force-profile dialog: which running desktops would be stopped and which reservables would be removed (no other card provides them) if this card is forced to target_profile.
 */
export const adminGpuForceProfilePreviewMutation = (options?: Partial<Options<AdminGpuForceProfilePreviewData>>): UseMutationOptions<AdminGpuForceProfilePreviewResponse2, AdminGpuForceProfilePreviewError, Options<AdminGpuForceProfilePreviewData>> => {
    const mutationOptions: UseMutationOptions<AdminGpuForceProfilePreviewResponse2, AdminGpuForceProfilePreviewError, Options<AdminGpuForceProfilePreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminGpuForceProfilePreview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update login notification
 *
 * Updates the login notification configuration for cover and form.
 */
export const adminLoginNotificationUpdateMutation = (options?: Partial<Options<AdminLoginNotificationUpdateData>>): UseMutationOptions<AdminLoginNotificationUpdateResponse, AdminLoginNotificationUpdateError, Options<AdminLoginNotificationUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminLoginNotificationUpdateResponse, AdminLoginNotificationUpdateError, Options<AdminLoginNotificationUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLoginNotificationUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable/disable cover login notification
 *
 * Enables or disables the login notification for the cover.
 */
export const adminLoginNotificationCoverEnableMutation = (options?: Partial<Options<AdminLoginNotificationCoverEnableData>>): UseMutationOptions<AdminLoginNotificationCoverEnableResponse, AdminLoginNotificationCoverEnableError, Options<AdminLoginNotificationCoverEnableData>> => {
    const mutationOptions: UseMutationOptions<AdminLoginNotificationCoverEnableResponse, AdminLoginNotificationCoverEnableError, Options<AdminLoginNotificationCoverEnableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLoginNotificationCoverEnable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable/disable form login notification
 *
 * Enables or disables the login notification for the form.
 */
export const adminLoginNotificationFormEnableMutation = (options?: Partial<Options<AdminLoginNotificationFormEnableData>>): UseMutationOptions<AdminLoginNotificationFormEnableResponse, AdminLoginNotificationFormEnableError, Options<AdminLoginNotificationFormEnableData>> => {
    const mutationOptions: UseMutationOptions<AdminLoginNotificationFormEnableResponse, AdminLoginNotificationFormEnableError, Options<AdminLoginNotificationFormEnableData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminLoginNotificationFormEnable({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create notification template
 *
 * Creates a new notification template.
 */
export const adminCreateNotificationTemplateMutation = (options?: Partial<Options<AdminCreateNotificationTemplateData>>): UseMutationOptions<AdminCreateNotificationTemplateResponse, AdminCreateNotificationTemplateError, Options<AdminCreateNotificationTemplateData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateNotificationTemplateResponse, AdminCreateNotificationTemplateError, Options<AdminCreateNotificationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateNotificationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListNotificationTemplatesQueryKey = (options?: Options<AdminListNotificationTemplatesData>) => createQueryKey('adminListNotificationTemplates', options);

/**
 * List all notification templates
 *
 * Returns all notification templates.
 */
export const adminListNotificationTemplatesOptions = (options?: Options<AdminListNotificationTemplatesData>) => queryOptions<AdminListNotificationTemplatesResponse, AdminListNotificationTemplatesError, AdminListNotificationTemplatesResponse, ReturnType<typeof adminListNotificationTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListNotificationTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListNotificationTemplatesQueryKey(options)
});

export const adminListCustomNotificationTemplatesQueryKey = (options?: Options<AdminListCustomNotificationTemplatesData>) => createQueryKey('adminListCustomNotificationTemplates', options);

/**
 * List custom notification templates
 *
 * Returns custom (non-system) notification templates.
 */
export const adminListCustomNotificationTemplatesOptions = (options?: Options<AdminListCustomNotificationTemplatesData>) => queryOptions<AdminListCustomNotificationTemplatesResponse, AdminListCustomNotificationTemplatesError, AdminListCustomNotificationTemplatesResponse, ReturnType<typeof adminListCustomNotificationTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListCustomNotificationTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListCustomNotificationTemplatesQueryKey(options)
});

export const adminListSystemNotificationTemplatesQueryKey = (options?: Options<AdminListSystemNotificationTemplatesData>) => createQueryKey('adminListSystemNotificationTemplates', options);

/**
 * List system notification templates
 *
 * Returns system notification templates.
 */
export const adminListSystemNotificationTemplatesOptions = (options?: Options<AdminListSystemNotificationTemplatesData>) => queryOptions<AdminListSystemNotificationTemplatesResponse, AdminListSystemNotificationTemplatesError, AdminListSystemNotificationTemplatesResponse, ReturnType<typeof adminListSystemNotificationTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListSystemNotificationTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListSystemNotificationTemplatesQueryKey(options)
});

/**
 * Delete notification template
 *
 * Deletes a notification template by its ID.
 */
export const adminDeleteNotificationTemplateMutation = (options?: Partial<Options<AdminDeleteNotificationTemplateData>>): UseMutationOptions<AdminDeleteNotificationTemplateResponse, AdminDeleteNotificationTemplateError, Options<AdminDeleteNotificationTemplateData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteNotificationTemplateResponse, AdminDeleteNotificationTemplateError, Options<AdminDeleteNotificationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteNotificationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetNotificationTemplateQueryKey = (options: Options<AdminGetNotificationTemplateData>) => createQueryKey('adminGetNotificationTemplate', options);

/**
 * Get notification template
 *
 * Returns a notification template by its ID.
 */
export const adminGetNotificationTemplateOptions = (options: Options<AdminGetNotificationTemplateData>) => queryOptions<AdminGetNotificationTemplateResponse, AdminGetNotificationTemplateError, AdminGetNotificationTemplateResponse, ReturnType<typeof adminGetNotificationTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetNotificationTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetNotificationTemplateQueryKey(options)
});

/**
 * Update notification template
 *
 * Updates a notification template by its ID.
 */
export const adminUpdateNotificationTemplateMutation = (options?: Partial<Options<AdminUpdateNotificationTemplateData>>): UseMutationOptions<AdminUpdateNotificationTemplateResponse, AdminUpdateNotificationTemplateError, Options<AdminUpdateNotificationTemplateData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateNotificationTemplateResponse, AdminUpdateNotificationTemplateError, Options<AdminUpdateNotificationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateNotificationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview template rendering
 *
 * Renders a notification event template with the provided data.
 */
export const adminPreviewNotificationTemplateMutation = (options?: Partial<Options<AdminPreviewNotificationTemplateData>>): UseMutationOptions<AdminPreviewNotificationTemplateResponse, AdminPreviewNotificationTemplateError, Options<AdminPreviewNotificationTemplateData>> => {
    const mutationOptions: UseMutationOptions<AdminPreviewNotificationTemplateResponse, AdminPreviewNotificationTemplateError, Options<AdminPreviewNotificationTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminPreviewNotificationTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListNotificationsQueryKey = (options?: Options<AdminListNotificationsData>) => createQueryKey('adminListNotifications', options);

/**
 * List all notifications
 *
 * Returns all notifications.
 */
export const adminListNotificationsOptions = (options?: Options<AdminListNotificationsData>) => queryOptions<AdminListNotificationsResponse, AdminListNotificationsError, AdminListNotificationsResponse, ReturnType<typeof adminListNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListNotificationsQueryKey(options)
});

/**
 * Create notification
 *
 * Creates a new notification.
 */
export const adminCreateNotificationMutation = (options?: Partial<Options<AdminCreateNotificationData>>): UseMutationOptions<AdminCreateNotificationResponse, AdminCreateNotificationError, Options<AdminCreateNotificationData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateNotificationResponse, AdminCreateNotificationError, Options<AdminCreateNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListNotificationActionsQueryKey = (options?: Options<AdminListNotificationActionsData>) => createQueryKey('adminListNotificationActions', options);

/**
 * List notification actions
 *
 * Returns all notification actions.
 */
export const adminListNotificationActionsOptions = (options?: Options<AdminListNotificationActionsData>) => queryOptions<AdminListNotificationActionsResponse, AdminListNotificationActionsError, AdminListNotificationActionsResponse, ReturnType<typeof adminListNotificationActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListNotificationActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListNotificationActionsQueryKey(options)
});

/**
 * Delete notification
 *
 * Deletes a notification by its ID.
 */
export const adminDeleteNotificationMutation = (options?: Partial<Options<AdminDeleteNotificationData>>): UseMutationOptions<AdminDeleteNotificationResponse, AdminDeleteNotificationError, Options<AdminDeleteNotificationData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteNotificationResponse, AdminDeleteNotificationError, Options<AdminDeleteNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetNotificationQueryKey = (options: Options<AdminGetNotificationData>) => createQueryKey('adminGetNotification', options);

/**
 * Get notification
 *
 * Returns a notification by its ID.
 */
export const adminGetNotificationOptions = (options: Options<AdminGetNotificationData>) => queryOptions<AdminGetNotificationResponse, AdminGetNotificationError, AdminGetNotificationResponse, ReturnType<typeof adminGetNotificationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetNotification({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetNotificationQueryKey(options)
});

/**
 * Update notification
 *
 * Updates a notification by its ID.
 */
export const adminUpdateNotificationMutation = (options?: Partial<Options<AdminUpdateNotificationData>>): UseMutationOptions<AdminUpdateNotificationResponse, AdminUpdateNotificationError, Options<AdminUpdateNotificationData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateNotificationResponse, AdminUpdateNotificationError, Options<AdminUpdateNotificationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateNotification({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetNotificationsDataByStatusQueryKey = (options: Options<AdminGetNotificationsDataByStatusData>) => createQueryKey('adminGetNotificationsDataByStatus', options);

/**
 * Get user notification data by status
 *
 * Returns notification data for a user filtered by status.
 */
export const adminGetNotificationsDataByStatusOptions = (options: Options<AdminGetNotificationsDataByStatusData>) => queryOptions<AdminGetNotificationsDataByStatusResponse, AdminGetNotificationsDataByStatusError, AdminGetNotificationsDataByStatusResponse, ReturnType<typeof adminGetNotificationsDataByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetNotificationsDataByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetNotificationsDataByStatusQueryKey(options)
});

export const adminGetNotificationStatusesQueryKey = (options?: Options<AdminGetNotificationStatusesData>) => createQueryKey('adminGetNotificationStatuses', options);

/**
 * Get available notification statuses
 *
 * Returns all distinct notification statuses.
 */
export const adminGetNotificationStatusesOptions = (options?: Options<AdminGetNotificationStatusesData>) => queryOptions<AdminGetNotificationStatusesResponse, AdminGetNotificationStatusesError, AdminGetNotificationStatusesResponse, ReturnType<typeof adminGetNotificationStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetNotificationStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetNotificationStatusesQueryKey(options)
});

export const adminGetNotificationsGroupedByStatusQueryKey = (options: Options<AdminGetNotificationsGroupedByStatusData>) => createQueryKey('adminGetNotificationsGroupedByStatus', options);

/**
 * Get notifications grouped by status
 *
 * Returns notification data grouped by user for a given status.
 */
export const adminGetNotificationsGroupedByStatusOptions = (options: Options<AdminGetNotificationsGroupedByStatusData>) => queryOptions<AdminGetNotificationsGroupedByStatusResponse, AdminGetNotificationsGroupedByStatusError, AdminGetNotificationsGroupedByStatusResponse, ReturnType<typeof adminGetNotificationsGroupedByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetNotificationsGroupedByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetNotificationsGroupedByStatusQueryKey(options)
});

/**
 * Delete user notification data
 *
 * Deletes all notification data for a specific user.
 */
export const adminDeleteUserNotificationDataMutation = (options?: Partial<Options<AdminDeleteUserNotificationDataData>>): UseMutationOptions<AdminDeleteUserNotificationDataResponse, AdminDeleteUserNotificationDataError, Options<AdminDeleteUserNotificationDataData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteUserNotificationDataResponse, AdminDeleteUserNotificationDataError, Options<AdminDeleteUserNotificationDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteUserNotificationData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete specific notification data
 *
 * Deletes a specific notification data entry by its ID.
 */
export const adminDeleteNotificationDataMutation = (options?: Partial<Options<AdminDeleteNotificationDataData>>): UseMutationOptions<AdminDeleteNotificationDataResponse, AdminDeleteNotificationDataError, Options<AdminDeleteNotificationDataData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteNotificationDataResponse, AdminDeleteNotificationDataError, Options<AdminDeleteNotificationDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteNotificationData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all notification data
 *
 * Deletes all notification data entries.
 */
export const adminDeleteAllNotificationDataMutation = (options?: Partial<Options<AdminDeleteAllNotificationDataData>>): UseMutationOptions<AdminDeleteAllNotificationDataResponse, AdminDeleteAllNotificationDataError, Options<AdminDeleteAllNotificationDataData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteAllNotificationDataResponse, AdminDeleteAllNotificationDataError, Options<AdminDeleteAllNotificationDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteAllNotificationData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetUserNotificationDisplaysQueryKey = (options: Options<AdminGetUserNotificationDisplaysData>) => createQueryKey('adminGetUserNotificationDisplays', options);

/**
 * Get user notification displays
 *
 * Returns the notification displays for a specific user and trigger.
 */
export const adminGetUserNotificationDisplaysOptions = (options: Options<AdminGetUserNotificationDisplaysData>) => queryOptions<AdminGetUserNotificationDisplaysResponse, AdminGetUserNotificationDisplaysError, AdminGetUserNotificationDisplaysResponse, ReturnType<typeof adminGetUserNotificationDisplaysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserNotificationDisplays({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserNotificationDisplaysQueryKey(options)
});

/**
 * Delete expired user notifications data
 *
 * Deletes expired user notifications data.
 */
export const deleteExpiredUserNotificationsDataMutation = (options?: Partial<Options<DeleteExpiredUserNotificationsDataData>>): UseMutationOptions<DeleteExpiredUserNotificationsDataResponse, DeleteExpiredUserNotificationsDataError, Options<DeleteExpiredUserNotificationsDataData>> => {
    const mutationOptions: UseMutationOptions<DeleteExpiredUserNotificationsDataResponse, DeleteExpiredUserNotificationsDataError, Options<DeleteExpiredUserNotificationsDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteExpiredUserNotificationsData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify user about desktop
 *
 * Sends a notification to a user about a desktop event.
 */
export const adminNotifyUserDesktopMutation = (options?: Partial<Options<AdminNotifyUserDesktopData>>): UseMutationOptions<AdminNotifyUserDesktopResponse, AdminNotifyUserDesktopError, Options<AdminNotifyUserDesktopData>> => {
    const mutationOptions: UseMutationOptions<AdminNotifyUserDesktopResponse, AdminNotifyUserDesktopError, Options<AdminNotifyUserDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminNotifyUserDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify a desktop
 *
 * Sends a notification to a desktop.
 */
export const adminNotifyDesktopMutation = (options?: Partial<Options<AdminNotifyDesktopData>>): UseMutationOptions<AdminNotifyDesktopResponse, AdminNotifyDesktopError, Options<AdminNotifyDesktopData>> => {
    const mutationOptions: UseMutationOptions<AdminNotifyDesktopResponse, AdminNotifyDesktopError, Options<AdminNotifyDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminNotifyDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify desktop queue
 *
 * Parses desktop queues for a hypervisor and notifies affected users.
 */
export const adminNotifyDesktopQueueMutation = (options?: Partial<Options<AdminNotifyDesktopQueueData>>): UseMutationOptions<AdminNotifyDesktopQueueResponse, AdminNotifyDesktopQueueError, Options<AdminNotifyDesktopQueueData>> => {
    const mutationOptions: UseMutationOptions<AdminNotifyDesktopQueueResponse, AdminNotifyDesktopQueueError, Options<AdminNotifyDesktopQueueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminNotifyDesktopQueue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminOperationsHypervisorsQueryKey = (options?: Options<AdminOperationsHypervisorsData>) => createQueryKey('adminOperationsHypervisors', options);

/**
 * List operations hypervisors
 *
 * Lists all hypervisors managed by the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisorsOptions = (options?: Options<AdminOperationsHypervisorsData>) => queryOptions<AdminOperationsHypervisorsResponse, AdminOperationsHypervisorsError, AdminOperationsHypervisorsResponse, ReturnType<typeof adminOperationsHypervisorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminOperationsHypervisors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminOperationsHypervisorsQueryKey(options)
});

/**
 * Stop a hypervisor
 *
 * Stops a hypervisor via the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisorStopMutation = (options?: Partial<Options<AdminOperationsHypervisorStopData>>): UseMutationOptions<AdminOperationsHypervisorStopResponse, AdminOperationsHypervisorStopError, Options<AdminOperationsHypervisorStopData>> => {
    const mutationOptions: UseMutationOptions<AdminOperationsHypervisorStopResponse, AdminOperationsHypervisorStopError, Options<AdminOperationsHypervisorStopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOperationsHypervisorStop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start a hypervisor
 *
 * Starts a hypervisor via the operations service. Requires operations API to be enabled.
 */
export const adminOperationsHypervisorStartMutation = (options?: Partial<Options<AdminOperationsHypervisorStartData>>): UseMutationOptions<AdminOperationsHypervisorStartResponse, AdminOperationsHypervisorStartError, Options<AdminOperationsHypervisorStartData>> => {
    const mutationOptions: UseMutationOptions<AdminOperationsHypervisorStartResponse, AdminOperationsHypervisorStartError, Options<AdminOperationsHypervisorStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOperationsHypervisorStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminOrchestratorConfigQueryKey = (options?: Options<AdminOrchestratorConfigData>) => createQueryKey('adminOrchestratorConfig', options);

/**
 * Get orchestrator configuration
 *
 * Returns whether the orchestrator is enabled.
 */
export const adminOrchestratorConfigOptions = (options?: Options<AdminOrchestratorConfigData>) => queryOptions<AdminOrchestratorConfigResponse, AdminOrchestratorConfigError, AdminOrchestratorConfigResponse, ReturnType<typeof adminOrchestratorConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminOrchestratorConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminOrchestratorConfigQueryKey(options)
});

/**
 * Update orchestrator configuration
 *
 * Enables or disables the orchestrator.
 */
export const adminOrchestratorConfigUpdateMutation = (options?: Partial<Options<AdminOrchestratorConfigUpdateData>>): UseMutationOptions<AdminOrchestratorConfigUpdateResponse, AdminOrchestratorConfigUpdateError, Options<AdminOrchestratorConfigUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminOrchestratorConfigUpdateResponse, AdminOrchestratorConfigUpdateError, Options<AdminOrchestratorConfigUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminOrchestratorConfigUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminQueuesJobsQueryKey = (options?: Options<AdminQueuesJobsData>) => createQueryKey('adminQueuesJobs', options);

/**
 * List all queues with job counts
 *
 * Returns all queues with their job counts by status.
 */
export const adminQueuesJobsOptions = (options?: Options<AdminQueuesJobsData>) => queryOptions<AdminQueuesJobsResponse, AdminQueuesJobsError, AdminQueuesJobsResponse, ReturnType<typeof adminQueuesJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesJobsQueryKey(options)
});

export const adminQueuesConsumersQueryKey = (options?: Options<AdminQueuesConsumersData>) => createQueryKey('adminQueuesConsumers', options);

/**
 * List queue consumers/workers
 *
 * Returns all queue workers with their subscriber information.
 */
export const adminQueuesConsumersOptions = (options?: Options<AdminQueuesConsumersData>) => queryOptions<AdminQueuesConsumersResponse, AdminQueuesConsumersError, AdminQueuesConsumersResponse, ReturnType<typeof adminQueuesConsumersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesConsumers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesConsumersQueryKey(options)
});

export const adminQueuesLaneHealthQueryKey = (options?: Options<AdminQueuesLaneHealthData>) => createQueryKey('adminQueuesLaneHealth', options);

/**
 * Storage lane health (orphan-lane detector)
 *
 * Detects ORPHAN storage lanes: queues holding jobs with no worker consuming them (their tasks stall forever). Lane-centric, so it sees what the worker-centric consumers view cannot.
 */
export const adminQueuesLaneHealthOptions = (options?: Options<AdminQueuesLaneHealthData>) => queryOptions<AdminQueuesLaneHealthResponse, AdminQueuesLaneHealthError, AdminQueuesLaneHealthResponse, ReturnType<typeof adminQueuesLaneHealthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesLaneHealth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesLaneHealthQueryKey(options)
});

export const adminQueuesGovernorQueryKey = (options?: Options<AdminQueuesGovernorData>) => createQueryKey('adminQueuesGovernor', options);

/**
 * Storage-governor gauge document
 *
 * Composite storage-governor observability gauges: heavy at-cap + leak, per-pool/per-category inflight-vs-cap, worker heartbeat health, Redis health, mode, warnings, effective config, generated_at and truncation honesty fields. Degrades to a 200 body with honesty fields (redis.up false, multitenancy_active 'unknown', empty pools/workers) on transient Redis/rdb failure rather than 5xx — a polled 500 would eject the operator mid-incident. Also the stats-go scrape source.
 */
export const adminQueuesGovernorOptions = (options?: Options<AdminQueuesGovernorData>) => queryOptions<AdminQueuesGovernorResponse, AdminQueuesGovernorError, AdminQueuesGovernorResponse, ReturnType<typeof adminQueuesGovernorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesGovernor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesGovernorQueryKey(options)
});

export const adminQueuesBacklogQueryKey = (options?: Options<AdminQueuesBacklogData>) => createQueryKey('adminQueuesBacklog', options);

/**
 * Per-(pool, category, tier) backlog rollup
 *
 * Per-lane backlog rollup: queued / started / started-over-timeout / failed / deferred counts, head-only oldest-queued-age, and has_consumer / coverage_known / stranded coverage flags. Degrades to an empty list on transient Redis failure rather than 5xx.
 */
export const adminQueuesBacklogOptions = (options?: Options<AdminQueuesBacklogData>) => queryOptions<AdminQueuesBacklogResponse, AdminQueuesBacklogError, AdminQueuesBacklogResponse, ReturnType<typeof adminQueuesBacklogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesBacklog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesBacklogQueryKey(options)
});

export const adminQueuesProblemTasksQueryKey = (options?: Options<AdminQueuesProblemTasksData>) => createQueryKey('adminQueuesProblemTasks', options);

/**
 * Bounded, filterable problem-task listing
 *
 * Lists problem tasks — ``failed`` (with traceback + retries_left), ``stuck_running`` (started jobs past their timeout), ``deferred_orphan`` (finalize-crashed deferred jobs whose chain has settled), or ``all`` — filterable by pool / category_id / tier and paginated. Every enumeration is bounded (one rq:queues snapshot, per-lane registry slice with cleanup=False, overall scan cap) and dangling-safe. Degrades to a 200 body with count 0 / empty tasks on transient Redis failure rather than 5xx.
 */
export const adminQueuesProblemTasksOptions = (options?: Options<AdminQueuesProblemTasksData>) => queryOptions<AdminQueuesProblemTasksResponse, AdminQueuesProblemTasksError, AdminQueuesProblemTasksResponse, ReturnType<typeof adminQueuesProblemTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminQueuesProblemTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesProblemTasksQueryKey(options)
});

export const adminQueuesProblemTasksInfiniteQueryKey = (options?: Options<AdminQueuesProblemTasksData>): QueryKey<Options<AdminQueuesProblemTasksData>> => createQueryKey('adminQueuesProblemTasks', options, true);

/**
 * Bounded, filterable problem-task listing
 *
 * Lists problem tasks — ``failed`` (with traceback + retries_left), ``stuck_running`` (started jobs past their timeout), ``deferred_orphan`` (finalize-crashed deferred jobs whose chain has settled), or ``all`` — filterable by pool / category_id / tier and paginated. Every enumeration is bounded (one rq:queues snapshot, per-lane registry slice with cleanup=False, overall scan cap) and dangling-safe. Degrades to a 200 body with count 0 / empty tasks on transient Redis failure rather than 5xx.
 */
export const adminQueuesProblemTasksInfiniteOptions = (options?: Options<AdminQueuesProblemTasksData>) => infiniteQueryOptions<AdminQueuesProblemTasksResponse, AdminQueuesProblemTasksError, InfiniteData<AdminQueuesProblemTasksResponse>, QueryKey<Options<AdminQueuesProblemTasksData>>, number | Pick<QueryKey<Options<AdminQueuesProblemTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<AdminQueuesProblemTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await adminQueuesProblemTasks({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminQueuesProblemTasksInfiniteQueryKey(options)
});

export const adminGetOldTasksConfigQueryKey = (options?: Options<AdminGetOldTasksConfigData>) => createQueryKey('adminGetOldTasksConfig', options);

/**
 * Get auto delete config
 *
 * Returns the auto-delete configuration for old tasks.
 */
export const adminGetOldTasksConfigOptions = (options?: Options<AdminGetOldTasksConfigData>) => queryOptions<AdminGetOldTasksConfigResponse, AdminGetOldTasksConfigError, AdminGetOldTasksConfigResponse, ReturnType<typeof adminGetOldTasksConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetOldTasksConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetOldTasksConfigQueryKey(options)
});

export const adminGetOldTasksQueryKey = (options: Options<AdminGetOldTasksData>) => createQueryKey('adminGetOldTasks', options);

/**
 * Get old tasks
 *
 * Returns old tasks that are older than the specified seconds.
 */
export const adminGetOldTasksOptions = (options: Options<AdminGetOldTasksData>) => queryOptions<AdminGetOldTasksResponse, AdminGetOldTasksError, AdminGetOldTasksResponse, ReturnType<typeof adminGetOldTasksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetOldTasks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetOldTasksQueryKey(options)
});

/**
 * Delete old tasks
 *
 * Deletes old tasks older than the specified seconds.
 */
export const adminDeleteOldTasksMutation = (options?: Partial<Options<AdminDeleteOldTasksData>>): UseMutationOptions<AdminDeleteOldTasksResponse, AdminDeleteOldTasksError, Options<AdminDeleteOldTasksData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteOldTasksResponse, AdminDeleteOldTasksError, Options<AdminDeleteOldTasksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteOldTasks({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set auto delete max time
 *
 * Sets the maximum time (in seconds, min 86400) for auto-deleting old tasks.
 */
export const adminSetOldTasksMaxTimeMutation = (options?: Partial<Options<AdminSetOldTasksMaxTimeData>>): UseMutationOptions<AdminSetOldTasksMaxTimeResponse, AdminSetOldTasksMaxTimeError, Options<AdminSetOldTasksMaxTimeData>> => {
    const mutationOptions: UseMutationOptions<AdminSetOldTasksMaxTimeResponse, AdminSetOldTasksMaxTimeError, Options<AdminSetOldTasksMaxTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetOldTasksMaxTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetStorageSchedulerConfigQueryKey = (options?: Options<AdminGetStorageSchedulerConfigData>) => createQueryKey('adminGetStorageSchedulerConfig', options);

/**
 * Get storage governor config
 *
 * Returns the live storage-governor knobs (enabled kill-switch, PSI limit, heavy cap, poll backoff) and the per-category fairness knobs (weights, per-category and default in-flight caps) the elastic storage workers apply.
 */
export const adminGetStorageSchedulerConfigOptions = (options?: Options<AdminGetStorageSchedulerConfigData>) => queryOptions<AdminGetStorageSchedulerConfigResponse, AdminGetStorageSchedulerConfigError, AdminGetStorageSchedulerConfigResponse, ReturnType<typeof adminGetStorageSchedulerConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetStorageSchedulerConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetStorageSchedulerConfigQueryKey(options)
});

/**
 * Set storage governor config
 *
 * Live-updates the storage-governor knobs including the per-category fairness weights/caps (partial; only provided keys are written, a supplied category map replaces the stored one). Elastic workers pick up the change within one poll, no restart.
 */
export const adminSetStorageSchedulerConfigMutation = (options?: Partial<Options<AdminSetStorageSchedulerConfigData>>): UseMutationOptions<AdminSetStorageSchedulerConfigResponse, AdminSetStorageSchedulerConfigError, Options<AdminSetStorageSchedulerConfigData>> => {
    const mutationOptions: UseMutationOptions<AdminSetStorageSchedulerConfigResponse, AdminSetStorageSchedulerConfigError, Options<AdminSetStorageSchedulerConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetStorageSchedulerConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set auto delete queue registries
 *
 * Sets which queue registries are included in auto-delete.
 */
export const adminSetOldTasksQueueRegistriesMutation = (options?: Partial<Options<AdminSetOldTasksQueueRegistriesData>>): UseMutationOptions<AdminSetOldTasksQueueRegistriesResponse, AdminSetOldTasksQueueRegistriesError, Options<AdminSetOldTasksQueueRegistriesData>> => {
    const mutationOptions: UseMutationOptions<AdminSetOldTasksQueueRegistriesResponse, AdminSetOldTasksQueueRegistriesError, Options<AdminSetOldTasksQueueRegistriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetOldTasksQueueRegistries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable or disable auto delete
 *
 * Enables or disables the auto-delete of old tasks.
 */
export const adminSetOldTasksEnabledMutation = (options?: Partial<Options<AdminSetOldTasksEnabledData>>): UseMutationOptions<AdminSetOldTasksEnabledResponse, AdminSetOldTasksEnabledError, Options<AdminSetOldTasksEnabledData>> => {
    const mutationOptions: UseMutationOptions<AdminSetOldTasksEnabledResponse, AdminSetOldTasksEnabledError, Options<AdminSetOldTasksEnabledData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSetOldTasksEnabled({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Auto delete old tasks
 *
 * Deletes old tasks based on the auto-delete configuration.
 */
export const adminDeleteOldTasksAutoMutation = (options?: Partial<Options<AdminDeleteOldTasksAutoData>>): UseMutationOptions<AdminDeleteOldTasksAutoResponse, AdminDeleteOldTasksAutoError, Options<AdminDeleteOldTasksAutoData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteOldTasksAutoResponse, AdminDeleteOldTasksAutoError, Options<AdminDeleteOldTasksAutoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteOldTasksAuto({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminRemoteVpnWithOsQueryKey = (options: Options<AdminRemoteVpnWithOsData>) => createQueryKey('adminRemoteVpnWithOs', options);

/**
 * Get remote VPN data with OS
 *
 * Get remote VPN configuration or installation data for a specific OS.
 */
export const adminRemoteVpnWithOsOptions = (options: Options<AdminRemoteVpnWithOsData>) => queryOptions<AdminRemoteVpnWithOsResponse, AdminRemoteVpnWithOsError, AdminRemoteVpnWithOsResponse, ReturnType<typeof adminRemoteVpnWithOsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminRemoteVpnWithOs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminRemoteVpnWithOsQueryKey(options)
});

export const adminRemoteVpnQueryKey = (options: Options<AdminRemoteVpnData>) => createQueryKey('adminRemoteVpn', options);

/**
 * Get remote VPN data
 *
 * Get remote VPN configuration data.
 */
export const adminRemoteVpnOptions = (options: Options<AdminRemoteVpnData>) => queryOptions<AdminRemoteVpnResponse, AdminRemoteVpnError, AdminRemoteVpnResponse, ReturnType<typeof adminRemoteVpnQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminRemoteVpn({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminRemoteVpnQueryKey(options)
});

/**
 * Add QoS disk profile
 *
 * Add a new QoS disk profile with IO tune parameters.
 */
export const adminQosDiskAddMutation = (options?: Partial<Options<AdminQosDiskAddData>>): UseMutationOptions<AdminQosDiskAddResponse, AdminQosDiskAddError, Options<AdminQosDiskAddData>> => {
    const mutationOptions: UseMutationOptions<AdminQosDiskAddResponse, AdminQosDiskAddError, Options<AdminQosDiskAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminQosDiskAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update QoS disk profile
 *
 * Update an existing QoS disk profile.
 */
export const adminQosDiskUpdateMutation = (options?: Partial<Options<AdminQosDiskUpdateData>>): UseMutationOptions<AdminQosDiskUpdateResponse, AdminQosDiskUpdateError, Options<AdminQosDiskUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminQosDiskUpdateResponse, AdminQosDiskUpdateError, Options<AdminQosDiskUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminQosDiskUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetRoleQueryKey = (options: Options<AdminGetRoleData>) => createQueryKey('adminGetRole', options);

/**
 * Get a role
 *
 * Returns a role by its ID.
 */
export const adminGetRoleOptions = (options: Options<AdminGetRoleData>) => queryOptions<AdminGetRoleResponse, AdminGetRoleError, AdminGetRoleResponse, ReturnType<typeof adminGetRoleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetRole({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetRoleQueryKey(options)
});

/**
 * Update role
 *
 * Updates a role.
 */
export const adminUpdateRoleMutation = (options?: Partial<Options<AdminUpdateRoleData>>): UseMutationOptions<AdminUpdateRoleResponse, AdminUpdateRoleError, Options<AdminUpdateRoleData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateRoleResponse, AdminUpdateRoleError, Options<AdminUpdateRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminSchedulerJobsSystemQueryKey = (options?: Options<AdminSchedulerJobsSystemData>) => createQueryKey('adminSchedulerJobsSystem', options);

/**
 * Get system scheduler jobs
 *
 * Get the list of system scheduler jobs ordered by next run time.
 */
export const adminSchedulerJobsSystemOptions = (options?: Options<AdminSchedulerJobsSystemData>) => queryOptions<AdminSchedulerJobsSystemResponse, AdminSchedulerJobsSystemError, AdminSchedulerJobsSystemResponse, ReturnType<typeof adminSchedulerJobsSystemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminSchedulerJobsSystem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminSchedulerJobsSystemQueryKey(options)
});

export const adminSchedulerJobsBookingsQueryKey = (options?: Options<AdminSchedulerJobsBookingsData>) => createQueryKey('adminSchedulerJobsBookings', options);

/**
 * Get bookings scheduler jobs
 *
 * Get the list of bookings scheduler jobs ordered by next run time.
 */
export const adminSchedulerJobsBookingsOptions = (options?: Options<AdminSchedulerJobsBookingsData>) => queryOptions<AdminSchedulerJobsBookingsResponse, AdminSchedulerJobsBookingsError, AdminSchedulerJobsBookingsResponse, ReturnType<typeof adminSchedulerJobsBookingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminSchedulerJobsBookings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminSchedulerJobsBookingsQueryKey(options)
});

export const adminSmtpGetQueryKey = (options?: Options<AdminSmtpGetData>) => createQueryKey('adminSmtpGet', options);

/**
 * Get SMTP configuration
 *
 * Returns the current SMTP configuration.
 */
export const adminSmtpGetOptions = (options?: Options<AdminSmtpGetData>) => queryOptions<AdminSmtpGetResponse, AdminSmtpGetError, AdminSmtpGetResponse, ReturnType<typeof adminSmtpGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminSmtpGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminSmtpGetQueryKey(options)
});

/**
 * Update SMTP configuration
 *
 * Updates and saves the SMTP configuration.
 */
export const adminSmtpPutMutation = (options?: Partial<Options<AdminSmtpPutData>>): UseMutationOptions<AdminSmtpPutResponse, AdminSmtpPutError, Options<AdminSmtpPutData>> => {
    const mutationOptions: UseMutationOptions<AdminSmtpPutResponse, AdminSmtpPutError, Options<AdminSmtpPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSmtpPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminSmtpEnabledGetQueryKey = (options?: Options<AdminSmtpEnabledGetData>) => createQueryKey('adminSmtpEnabledGet', options);

/**
 * Get SMTP enabled status
 *
 * Returns whether SMTP is enabled.
 */
export const adminSmtpEnabledGetOptions = (options?: Options<AdminSmtpEnabledGetData>) => queryOptions<AdminSmtpEnabledGetResponse, AdminSmtpEnabledGetError, AdminSmtpEnabledGetResponse, ReturnType<typeof adminSmtpEnabledGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminSmtpEnabledGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminSmtpEnabledGetQueryKey(options)
});

/**
 * Test SMTP configuration
 *
 * Tests an SMTP configuration by connecting and authenticating.
 */
export const adminSmtpTestPostMutation = (options?: Partial<Options<AdminSmtpTestPostData>>): UseMutationOptions<AdminSmtpTestPostResponse, AdminSmtpTestPostError, Options<AdminSmtpTestPostData>> => {
    const mutationOptions: UseMutationOptions<AdminSmtpTestPostResponse, AdminSmtpTestPostError, Options<AdminSmtpTestPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSmtpTestPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Emit socketio events
 *
 * Sends one or more socketio events. Expects a JSON array of event objects.
 */
export const adminEmitSocketioMutation = (options?: Partial<Options<AdminEmitSocketioData>>): UseMutationOptions<AdminEmitSocketioResponse, AdminEmitSocketioError, Options<AdminEmitSocketioData>> => {
    const mutationOptions: UseMutationOptions<AdminEmitSocketioResponse, AdminEmitSocketioError, Options<AdminEmitSocketioData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEmitSocketio({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const statsDesktopsStatusQueryKey = (options?: Options<StatsDesktopsStatusData>) => createQueryKey('statsDesktopsStatus', options);

/**
 * Get desktop status statistics
 *
 * Returns desktop statistics grouped by status.
 */
export const statsDesktopsStatusOptions = (options?: Options<StatsDesktopsStatusData>) => queryOptions<StatsDesktopsStatusResponse, StatsDesktopsStatusError, StatsDesktopsStatusResponse, ReturnType<typeof statsDesktopsStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsDesktopsStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsDesktopsStatusQueryKey(options)
});

export const statsDomainsStatusQueryKey = (options?: Options<StatsDomainsStatusData>) => createQueryKey('statsDomainsStatus', options);

/**
 * Get domains status statistics
 *
 * Returns domain statistics grouped by kind and status.
 */
export const statsDomainsStatusOptions = (options?: Options<StatsDomainsStatusData>) => queryOptions<StatsDomainsStatusResponse2, StatsDomainsStatusError, StatsDomainsStatusResponse2, ReturnType<typeof statsDomainsStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsDomainsStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsDomainsStatusQueryKey(options)
});

export const statsCategoriesQueryKey = (options?: Options<StatsCategoriesData>) => createQueryKey('statsCategories', options);

/**
 * Get grouped category statistics
 *
 * Returns comprehensive statistics grouped by categories.
 */
export const statsCategoriesOptions = (options?: Options<StatsCategoriesData>) => queryOptions<StatsCategoriesResponse2, StatsCategoriesError, StatsCategoriesResponse2, ReturnType<typeof statsCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsCategoriesQueryKey(options)
});

export const statsCategoriesDeploymentsQueryKey = (options?: Options<StatsCategoriesDeploymentsData>) => createQueryKey('statsCategoriesDeployments', options);

/**
 * Get category deployments statistics
 *
 * Returns deployment counts grouped by category.
 */
export const statsCategoriesDeploymentsOptions = (options?: Options<StatsCategoriesDeploymentsData>) => queryOptions<StatsCategoriesDeploymentsResponse2, StatsCategoriesDeploymentsError, StatsCategoriesDeploymentsResponse2, ReturnType<typeof statsCategoriesDeploymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsCategoriesDeployments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsCategoriesDeploymentsQueryKey(options)
});

export const statsUsersQueryKey = (options?: Options<StatsUsersData>) => createQueryKey('statsUsers', options);

/**
 * Get user statistics
 *
 * Returns a list of all users with their role, category and group.
 */
export const statsUsersOptions = (options?: Options<StatsUsersData>) => queryOptions<StatsUsersResponse, StatsUsersError, StatsUsersResponse, ReturnType<typeof statsUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsUsersQueryKey(options)
});

export const statsDesktopsQueryKey = (options?: Options<StatsDesktopsData>) => createQueryKey('statsDesktops', options);

/**
 * Get desktop statistics
 *
 * Returns a list of all desktops with their owning user.
 */
export const statsDesktopsOptions = (options?: Options<StatsDesktopsData>) => queryOptions<StatsDesktopsResponse, StatsDesktopsError, StatsDesktopsResponse, ReturnType<typeof statsDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsDesktopsQueryKey(options)
});

export const statsTemplatesQueryKey = (options?: Options<StatsTemplatesData>) => createQueryKey('statsTemplates', options);

/**
 * Get template statistics
 *
 * Returns a list of all template IDs.
 */
export const statsTemplatesOptions = (options?: Options<StatsTemplatesData>) => queryOptions<StatsTemplatesResponse, StatsTemplatesError, StatsTemplatesResponse, ReturnType<typeof statsTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsTemplatesQueryKey(options)
});

export const statsHypervisorsQueryKey = (options?: Options<StatsHypervisorsData>) => createQueryKey('statsHypervisors', options);

/**
 * Get hypervisor statistics
 *
 * Returns a list of all hypervisors with their status and only_forced flag.
 */
export const statsHypervisorsOptions = (options?: Options<StatsHypervisorsData>) => queryOptions<StatsHypervisorsResponse, StatsHypervisorsError, StatsHypervisorsResponse, ReturnType<typeof statsHypervisorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await statsHypervisors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: statsHypervisorsQueryKey(options)
});

export const adminDomainsStartedCountQueryKey = (options?: Options<AdminDomainsStartedCountData>) => createQueryKey('adminDomainsStartedCount', options);

/**
 * Get started domains count by category
 *
 * Returns the count of started desktop domains grouped by category.
 */
export const adminDomainsStartedCountOptions = (options?: Options<AdminDomainsStartedCountData>) => queryOptions<AdminDomainsStartedCountResponse, AdminDomainsStartedCountError, AdminDomainsStartedCountResponse, ReturnType<typeof adminDomainsStartedCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminDomainsStartedCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminDomainsStartedCountQueryKey(options)
});

export const adminStorageByRoleQueryKey = (options: Options<AdminStorageByRoleData>) => createQueryKey('adminStorageByRole', options);

/**
 * Get storages by user role
 *
 * Get all storages filtered by the owning user's role. Admin only.
 */
export const adminStorageByRoleOptions = (options: Options<AdminStorageByRoleData>) => queryOptions<AdminStorageByRoleResponse, AdminStorageByRoleError, AdminStorageByRoleResponse, ReturnType<typeof adminStorageByRoleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageByRole({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageByRoleQueryKey(options)
});

/**
 * Refresh qemu-img-info size of running desktops' disks
 *
 * Enqueue a low-priority qemu-img-info refresh for every ready, non-readonly disk attached to a currently-running desktop, so a long-running desktop's stored actual-size does not stay frozen at its last stop. Intended to be driven by the scheduler (cron/interval). Admin only.
 */
export const adminStorageRefreshRunningSizesMutation = (options?: Partial<Options<AdminStorageRefreshRunningSizesData>>): UseMutationOptions<AdminStorageRefreshRunningSizesResponse, AdminStorageRefreshRunningSizesError, Options<AdminStorageRefreshRunningSizesData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageRefreshRunningSizesResponse, AdminStorageRefreshRunningSizesError, Options<AdminStorageRefreshRunningSizesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageRefreshRunningSizes({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview a storage-disk migration plan (dry run)
 *
 * Resolve the selection and return what would move, grouped by root tree. Nothing is persisted.
 */
export const adminStorageMigrationPlanMutation = (options?: Partial<Options<AdminStorageMigrationPlanData>>): UseMutationOptions<AdminStorageMigrationPlanResponse, AdminStorageMigrationPlanError, Options<AdminStorageMigrationPlanData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageMigrationPlanResponse, AdminStorageMigrationPlanError, Options<AdminStorageMigrationPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageMigrationPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageMigrationListQueryKey = (options?: Options<AdminStorageMigrationListData>) => createQueryKey('adminStorageMigrationList', options);

/**
 * List storage-disk migration jobs
 */
export const adminStorageMigrationListOptions = (options?: Options<AdminStorageMigrationListData>) => queryOptions<AdminStorageMigrationListResponse, AdminStorageMigrationListError, AdminStorageMigrationListResponse, ReturnType<typeof adminStorageMigrationListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageMigrationList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageMigrationListQueryKey(options)
});

/**
 * Create a storage-disk migration job
 *
 * Resolve + persist a migration (status planned) and its per-disk ledger rows.
 */
export const adminStorageMigrationCreateMutation = (options?: Partial<Options<AdminStorageMigrationCreateData>>): UseMutationOptions<AdminStorageMigrationCreateResponse, AdminStorageMigrationCreateError, Options<AdminStorageMigrationCreateData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageMigrationCreateResponse, AdminStorageMigrationCreateError, Options<AdminStorageMigrationCreateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageMigrationCreate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStorageMigrationPathPrefixesQueryKey = (options?: Options<AdminStorageMigrationPathPrefixesData>) => createQueryKey('adminStorageMigrationPathPrefixes', options);

/**
 * List real source path-prefixes for the path selection kind
 *
 * Distinct storage.directory_path values (optionally scoped to a source pool) that populate the path-migration dropdown. Read-only.
 */
export const adminStorageMigrationPathPrefixesOptions = (options?: Options<AdminStorageMigrationPathPrefixesData>) => queryOptions<AdminStorageMigrationPathPrefixesResponse, AdminStorageMigrationPathPrefixesError, AdminStorageMigrationPathPrefixesResponse, ReturnType<typeof adminStorageMigrationPathPrefixesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageMigrationPathPrefixes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageMigrationPathPrefixesQueryKey(options)
});

export const adminStorageMigrationLogQueryKey = (options: Options<AdminStorageMigrationLogData>) => createQueryKey('adminStorageMigrationLog', options);

/**
 * Download a storage-disk migration report (CSV or JSON)
 *
 * A downloadable per-disk audit of what was moved / failed / skipped / quarantined / in-place, annotated by occurrence for recurring jobs, with a summary header. format=csv (default) | json.
 */
export const adminStorageMigrationLogOptions = (options: Options<AdminStorageMigrationLogData>) => queryOptions<unknown, AdminStorageMigrationLogError, unknown, ReturnType<typeof adminStorageMigrationLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageMigrationLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageMigrationLogQueryKey(options)
});

export const adminStorageMigrationStatusQueryKey = (options: Options<AdminStorageMigrationStatusData>) => createQueryKey('adminStorageMigrationStatus', options);

/**
 * Storage-disk migration status (live ledger aggregate)
 */
export const adminStorageMigrationStatusOptions = (options: Options<AdminStorageMigrationStatusData>) => queryOptions<AdminStorageMigrationStatusResponse, AdminStorageMigrationStatusError, AdminStorageMigrationStatusResponse, ReturnType<typeof adminStorageMigrationStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStorageMigrationStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStorageMigrationStatusQueryKey(options)
});

/**
 * Control a storage-disk migration (start, pause, cancel)
 */
export const adminStorageMigrationActionMutation = (options?: Partial<Options<AdminStorageMigrationActionData>>): UseMutationOptions<AdminStorageMigrationActionResponse, AdminStorageMigrationActionError, Options<AdminStorageMigrationActionData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageMigrationActionResponse, AdminStorageMigrationActionError, Options<AdminStorageMigrationActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageMigrationAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a storage-disk migration's config
 */
export const adminStorageMigrationConfigMutation = (options?: Partial<Options<AdminStorageMigrationConfigData>>): UseMutationOptions<AdminStorageMigrationConfigResponse, AdminStorageMigrationConfigError, Options<AdminStorageMigrationConfigData>> => {
    const mutationOptions: UseMutationOptions<AdminStorageMigrationConfigResponse, AdminStorageMigrationConfigError, Options<AdminStorageMigrationConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminStorageMigrationConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminStoragePoolMigrationPlanQueryKey = (options: Options<AdminStoragePoolMigrationPlanData>) => createQueryKey('adminStoragePoolMigrationPlan', options);

/**
 * Pool-scoped migration aggregation (root-tree overview)
 *
 * Enumerate the pool's root trees with per-tree derivative / desktop / byte counts for the admin overview.
 */
export const adminStoragePoolMigrationPlanOptions = (options: Options<AdminStoragePoolMigrationPlanData>) => queryOptions<AdminStoragePoolMigrationPlanResponse, AdminStoragePoolMigrationPlanError, AdminStoragePoolMigrationPlanResponse, ReturnType<typeof adminStoragePoolMigrationPlanQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminStoragePoolMigrationPlan({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminStoragePoolMigrationPlanQueryKey(options)
});

export const adminSystemLogoGetQueryKey = (options?: Options<AdminSystemLogoGetData>) => createQueryKey('adminSystemLogoGet', options);

/**
 * Get system logo status
 *
 * Returns whether a custom system-wide logo and/or collapsed logo are currently configured.
 */
export const adminSystemLogoGetOptions = (options?: Options<AdminSystemLogoGetData>) => queryOptions<AdminSystemLogoGetResponse, AdminSystemLogoGetError, AdminSystemLogoGetResponse, ReturnType<typeof adminSystemLogoGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminSystemLogoGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminSystemLogoGetQueryKey(options)
});

/**
 * Update system logo
 *
 * Uploads, replaces or removes the system-wide default logo and/or collapsed logo. Logo data should be a base64 data URL.
 */
export const adminSystemLogoPutMutation = (options?: Partial<Options<AdminSystemLogoPutData>>): UseMutationOptions<AdminSystemLogoPutResponse, AdminSystemLogoPutError, Options<AdminSystemLogoPutData>> => {
    const mutationOptions: UseMutationOptions<AdminSystemLogoPutResponse, AdminSystemLogoPutError, Options<AdminSystemLogoPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSystemLogoPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Insert a new item into a table
 *
 * Insert a new item into the specified table. Checks for duplicate names in tables that require it.
 */
export const adminTableInsertMutation = (options?: Partial<Options<AdminTableInsertData>>): UseMutationOptions<AdminTableInsertResponse, AdminTableInsertError, Options<AdminTableInsertData>> => {
    const mutationOptions: UseMutationOptions<AdminTableInsertResponse, AdminTableInsertError, Options<AdminTableInsertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTableInsert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an item in a table
 *
 * Update an existing item in the specified table. Checks for duplicate names in tables that require it.
 */
export const adminTableUpdateMutation = (options?: Partial<Options<AdminTableUpdateData>>): UseMutationOptions<AdminTableUpdateResponse, AdminTableUpdateError, Options<AdminTableUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminTableUpdateResponse, AdminTableUpdateError, Options<AdminTableUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTableUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an item from a table
 *
 * Delete an item from the specified table by ID. Unassigns resources from desktops and deployments for relevant tables.
 */
export const adminTableDeleteMutation = (options?: Partial<Options<AdminTableDeleteData>>): UseMutationOptions<AdminTableDeleteResponse, AdminTableDeleteError, Options<AdminTableDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminTableDeleteResponse, AdminTableDeleteError, Options<AdminTableDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminTableDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageConsumersCountQueryKey = (options?: Options<AdminUsageConsumersCountData>) => createQueryKey('adminUsageConsumersCount', options);

/**
 * Count usage consumers
 *
 * Returns the total count of usage consumption records.
 */
export const adminUsageConsumersCountOptions = (options?: Options<AdminUsageConsumersCountData>) => queryOptions<AdminUsageConsumersCountResponse, AdminUsageConsumersCountError, AdminUsageConsumersCountResponse, ReturnType<typeof adminUsageConsumersCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageConsumersCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageConsumersCountQueryKey(options)
});

/**
 * Consolidate all consumption data
 *
 * Triggers consolidation of all usage consumption data.
 */
export const adminUsageConsolidateMutation = (options?: Partial<Options<AdminUsageConsolidateData>>): UseMutationOptions<AdminUsageConsolidateResponse, AdminUsageConsolidateError, Options<AdminUsageConsolidateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageConsolidateResponse, AdminUsageConsolidateError, Options<AdminUsageConsolidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageConsolidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Consolidate consumption for item type with days
 *
 * Triggers consolidation of usage consumption data for a specific item type and number of days.
 */
export const adminUsageConsolidateItemDaysMutation = (options?: Partial<Options<AdminUsageConsolidateItemDaysData>>): UseMutationOptions<AdminUsageConsolidateItemDaysResponse, AdminUsageConsolidateItemDaysError, Options<AdminUsageConsolidateItemDaysData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageConsolidateItemDaysResponse, AdminUsageConsolidateItemDaysError, Options<AdminUsageConsolidateItemDaysData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageConsolidateItemDays({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Consolidate consumption for item type
 *
 * Triggers consolidation of usage consumption data for a specific item type.
 */
export const adminUsageConsolidateItemMutation = (options?: Partial<Options<AdminUsageConsolidateItemData>>): UseMutationOptions<AdminUsageConsolidateItemResponse, AdminUsageConsolidateItemError, Options<AdminUsageConsolidateItemData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageConsolidateItemResponse, AdminUsageConsolidateItemError, Options<AdminUsageConsolidateItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageConsolidateItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageRetentionGetQueryKey = (options?: Options<AdminUsageRetentionGetData>) => createQueryKey('adminUsageRetentionGet', options);

/**
 * Get usage retention policy
 *
 * Returns the tiered rollup policy applied to ``usage_consumption``: how many months of recent daily granularity to keep, when rows collapse to weekly buckets, and the optional hard delete cap.
 */
export const adminUsageRetentionGetOptions = (options?: Options<AdminUsageRetentionGetData>) => queryOptions<AdminUsageRetentionGetResponse, AdminUsageRetentionGetError, AdminUsageRetentionGetResponse, ReturnType<typeof adminUsageRetentionGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageRetentionGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageRetentionGetQueryKey(options)
});

/**
 * Update usage retention policy
 *
 * Persists the tiered rollup policy. The next incremental rollup (chained after the daily consolidator) will honour the new thresholds; running ``rollup_usage_consumption.py --mode=backfill`` applies them to the historical tail.
 */
export const adminUsageRetentionUpdateMutation = (options?: Partial<Options<AdminUsageRetentionUpdateData>>): UseMutationOptions<AdminUsageRetentionUpdateResponse, AdminUsageRetentionUpdateError, Options<AdminUsageRetentionUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageRetentionUpdateResponse, AdminUsageRetentionUpdateError, Options<AdminUsageRetentionUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageRetentionUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageParametersListQueryKey = (options?: Options<AdminUsageParametersListData>) => createQueryKey('adminUsageParametersList', options);

/**
 * Get all usage parameters
 *
 * Returns all usage parameters.
 */
export const adminUsageParametersListOptions = (options?: Options<AdminUsageParametersListData>) => queryOptions<AdminUsageParametersListResponse, AdminUsageParametersListError, AdminUsageParametersListResponse, ReturnType<typeof adminUsageParametersListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageParametersList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageParametersListQueryKey(options)
});

/**
 * Create usage parameter
 *
 * Creates a new usage parameter.
 */
export const adminUsageParametersAddMutation = (options?: Partial<Options<AdminUsageParametersAddData>>): UseMutationOptions<AdminUsageParametersAddResponse, AdminUsageParametersAddError, Options<AdminUsageParametersAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageParametersAddResponse, AdminUsageParametersAddError, Options<AdminUsageParametersAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageParametersAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete usage parameter
 *
 * Deletes a usage parameter by ID.
 */
export const adminUsageParametersDeleteMutation = (options?: Partial<Options<AdminUsageParametersDeleteData>>): UseMutationOptions<AdminUsageParametersDeleteResponse, AdminUsageParametersDeleteError, Options<AdminUsageParametersDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageParametersDeleteResponse, AdminUsageParametersDeleteError, Options<AdminUsageParametersDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageParametersDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update usage parameter
 *
 * Updates an existing usage parameter.
 */
export const adminUsageParametersUpdateMutation = (options?: Partial<Options<AdminUsageParametersUpdateData>>): UseMutationOptions<AdminUsageParametersUpdateResponse, AdminUsageParametersUpdateError, Options<AdminUsageParametersUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageParametersUpdateResponse, AdminUsageParametersUpdateError, Options<AdminUsageParametersUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageParametersUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageLimitsListQueryKey = (options?: Options<AdminUsageLimitsListData>) => createQueryKey('adminUsageLimitsList', options);

/**
 * Get all usage limits
 *
 * Returns all usage limits.
 */
export const adminUsageLimitsListOptions = (options?: Options<AdminUsageLimitsListData>) => queryOptions<AdminUsageLimitsListResponse, AdminUsageLimitsListError, AdminUsageLimitsListResponse, ReturnType<typeof adminUsageLimitsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageLimitsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageLimitsListQueryKey(options)
});

/**
 * Create usage limit
 *
 * Creates a new usage limit.
 */
export const adminUsageLimitsAddMutation = (options?: Partial<Options<AdminUsageLimitsAddData>>): UseMutationOptions<AdminUsageLimitsAddResponse, AdminUsageLimitsAddError, Options<AdminUsageLimitsAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageLimitsAddResponse, AdminUsageLimitsAddError, Options<AdminUsageLimitsAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageLimitsAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete usage limit
 *
 * Deletes a usage limit by ID.
 */
export const adminUsageLimitsDeleteMutation = (options?: Partial<Options<AdminUsageLimitsDeleteData>>): UseMutationOptions<AdminUsageLimitsDeleteResponse, AdminUsageLimitsDeleteError, Options<AdminUsageLimitsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageLimitsDeleteResponse, AdminUsageLimitsDeleteError, Options<AdminUsageLimitsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageLimitsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update usage limit
 *
 * Updates an existing usage limit.
 */
export const adminUsageLimitsUpdateMutation = (options?: Partial<Options<AdminUsageLimitsUpdateData>>): UseMutationOptions<AdminUsageLimitsUpdateResponse, AdminUsageLimitsUpdateError, Options<AdminUsageLimitsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageLimitsUpdateResponse, AdminUsageLimitsUpdateError, Options<AdminUsageLimitsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageLimitsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageGroupingsListQueryKey = (options?: Options<AdminUsageGroupingsListData>) => createQueryKey('adminUsageGroupingsList', options);

/**
 * Get all usage groupings
 *
 * Returns all usage groupings (system + custom).
 */
export const adminUsageGroupingsListOptions = (options?: Options<AdminUsageGroupingsListData>) => queryOptions<AdminUsageGroupingsListResponse, AdminUsageGroupingsListError, AdminUsageGroupingsListResponse, ReturnType<typeof adminUsageGroupingsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageGroupingsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageGroupingsListQueryKey(options)
});

/**
 * Create usage grouping
 *
 * Creates a new usage grouping.
 */
export const adminUsageGroupingsAddMutation = (options?: Partial<Options<AdminUsageGroupingsAddData>>): UseMutationOptions<AdminUsageGroupingsAddResponse, AdminUsageGroupingsAddError, Options<AdminUsageGroupingsAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageGroupingsAddResponse, AdminUsageGroupingsAddError, Options<AdminUsageGroupingsAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageGroupingsAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete usage grouping
 *
 * Deletes a usage grouping by ID.
 */
export const adminUsageGroupingsDeleteMutation = (options?: Partial<Options<AdminUsageGroupingsDeleteData>>): UseMutationOptions<AdminUsageGroupingsDeleteResponse, AdminUsageGroupingsDeleteError, Options<AdminUsageGroupingsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageGroupingsDeleteResponse, AdminUsageGroupingsDeleteError, Options<AdminUsageGroupingsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageGroupingsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update usage grouping
 *
 * Updates an existing usage grouping.
 */
export const adminUsageGroupingsUpdateMutation = (options?: Partial<Options<AdminUsageGroupingsUpdateData>>): UseMutationOptions<AdminUsageGroupingsUpdateResponse, AdminUsageGroupingsUpdateError, Options<AdminUsageGroupingsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageGroupingsUpdateResponse, AdminUsageGroupingsUpdateError, Options<AdminUsageGroupingsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageGroupingsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageAllCreditsQueryKey = (options?: Options<AdminUsageAllCreditsData>) => createQueryKey('adminUsageAllCredits', options);

/**
 * Get all usage credits
 *
 * Returns all usage credits with category names and grouping names.
 */
export const adminUsageAllCreditsOptions = (options?: Options<AdminUsageAllCreditsData>) => queryOptions<AdminUsageAllCreditsResponse, AdminUsageAllCreditsError, AdminUsageAllCreditsResponse, ReturnType<typeof adminUsageAllCreditsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageAllCredits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageAllCreditsQueryKey(options)
});

export const adminUsageCreditsByIdQueryKey = (options: Options<AdminUsageCreditsByIdData>) => createQueryKey('adminUsageCreditsById', options);

/**
 * Get usage credit by ID
 *
 * Returns a specific usage credit.
 */
export const adminUsageCreditsByIdOptions = (options: Options<AdminUsageCreditsByIdData>) => queryOptions<AdminUsageCreditsByIdResponse, AdminUsageCreditsByIdError, AdminUsageCreditsByIdResponse, ReturnType<typeof adminUsageCreditsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageCreditsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageCreditsByIdQueryKey(options)
});

/**
 * Create usage credit
 *
 * Creates usage credits for one or more items.
 */
export const adminUsageCreditsAddMutation = (options?: Partial<Options<AdminUsageCreditsAddData>>): UseMutationOptions<AdminUsageCreditsAddResponse, AdminUsageCreditsAddError, Options<AdminUsageCreditsAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageCreditsAddResponse, AdminUsageCreditsAddError, Options<AdminUsageCreditsAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageCreditsAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete usage credit
 *
 * Deletes a usage credit by ID.
 */
export const adminUsageCreditsDeleteMutation = (options?: Partial<Options<AdminUsageCreditsDeleteData>>): UseMutationOptions<AdminUsageCreditsDeleteResponse, AdminUsageCreditsDeleteError, Options<AdminUsageCreditsDeleteData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageCreditsDeleteResponse, AdminUsageCreditsDeleteError, Options<AdminUsageCreditsDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageCreditsDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update usage credit
 *
 * Updates an existing usage credit.
 */
export const adminUsageCreditsUpdateMutation = (options?: Partial<Options<AdminUsageCreditsUpdateData>>): UseMutationOptions<AdminUsageCreditsUpdateResponse, AdminUsageCreditsUpdateError, Options<AdminUsageCreditsUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageCreditsUpdateResponse, AdminUsageCreditsUpdateError, Options<AdminUsageCreditsUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageCreditsUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unify item name in consumption records
 *
 * Unifies the item name across all consumption records for the given item.
 */
export const adminUsageUnifyItemNameMutation = (options?: Partial<Options<AdminUsageUnifyItemNameData>>): UseMutationOptions<AdminUsageUnifyItemNameResponse, AdminUsageUnifyItemNameError, Options<AdminUsageUnifyItemNameData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageUnifyItemNameResponse, AdminUsageUnifyItemNameError, Options<AdminUsageUnifyItemNameData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageUnifyItemName({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set usage reset dates
 *
 * Replaces all usage reset dates with the provided list.
 */
export const adminUsageResetDatesAddMutation = (options?: Partial<Options<AdminUsageResetDatesAddData>>): UseMutationOptions<AdminUsageResetDatesAddResponse, AdminUsageResetDatesAddError, Options<AdminUsageResetDatesAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageResetDatesAddResponse, AdminUsageResetDatesAddError, Options<AdminUsageResetDatesAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageResetDatesAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all consumption data
 *
 * Deletes all usage consumption data. This operation runs in the background.
 */
export const adminUsageDeleteConsumptionDataMutation = (options?: Partial<Options<AdminUsageDeleteConsumptionDataData>>): UseMutationOptions<AdminUsageDeleteConsumptionDataResponse, AdminUsageDeleteConsumptionDataError, Options<AdminUsageDeleteConsumptionDataData>> => {
    const mutationOptions: UseMutationOptions<AdminUsageDeleteConsumptionDataResponse, AdminUsageDeleteConsumptionDataError, Options<AdminUsageDeleteConsumptionDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUsageDeleteConsumptionData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUsageCheckOverlappingQueryKey = (options: Options<AdminUsageCheckOverlappingData>) => createQueryKey('adminUsageCheckOverlapping', options);

/**
 * Check overlapping credits
 *
 * Checks if there are overlapping credit intervals for the given credit and date range.
 */
export const adminUsageCheckOverlappingOptions = (options: Options<AdminUsageCheckOverlappingData>) => queryOptions<AdminUsageCheckOverlappingResponse, AdminUsageCheckOverlappingError, AdminUsageCheckOverlappingResponse, ReturnType<typeof adminUsageCheckOverlappingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUsageCheckOverlapping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUsageCheckOverlappingQueryKey(options)
});

/**
 * Auto-register user storage provider
 *
 * Auto-registers a user storage provider with the given credentials.
 */
export const adminUserStorageAutoRegisterMutation = (options?: Partial<Options<AdminUserStorageAutoRegisterData>>): UseMutationOptions<AdminUserStorageAutoRegisterResponse, AdminUserStorageAutoRegisterError, Options<AdminUserStorageAutoRegisterData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageAutoRegisterResponse, AdminUserStorageAutoRegisterError, Options<AdminUserStorageAutoRegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageAutoRegister({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test user storage connection
 *
 * Tests the connection to a user storage provider.
 */
export const adminUserStorageTestMutation = (options?: Partial<Options<AdminUserStorageTestData>>): UseMutationOptions<AdminUserStorageTestResponse, AdminUserStorageTestError, Options<AdminUserStorageTestData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageTestResponse, AdminUserStorageTestError, Options<AdminUserStorageTestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageTest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUserStorageLoginAuthQueryKey = (options: Options<AdminUserStorageLoginAuthData>) => createQueryKey('adminUserStorageLoginAuth', options);

/**
 * Get user storage login auth URL
 *
 * Returns the login authentication URL for a user storage provider.
 */
export const adminUserStorageLoginAuthOptions = (options: Options<AdminUserStorageLoginAuthData>) => queryOptions<AdminUserStorageLoginAuthResponse, AdminUserStorageLoginAuthError, AdminUserStorageLoginAuthResponse, ReturnType<typeof adminUserStorageLoginAuthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUserStorageLoginAuth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUserStorageLoginAuthQueryKey(options)
});

export const adminUserStorageListQueryKey = (options?: Options<AdminUserStorageListData>) => createQueryKey('adminUserStorageList', options);

/**
 * List user storage providers
 *
 * Returns all user storage providers.
 */
export const adminUserStorageListOptions = (options?: Options<AdminUserStorageListData>) => queryOptions<AdminUserStorageListResponse, AdminUserStorageListError, AdminUserStorageListResponse, ReturnType<typeof adminUserStorageListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUserStorageList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUserStorageListQueryKey(options)
});

export const adminUserStorageUsersQueryKey = (options?: Options<AdminUserStorageUsersData>) => createQueryKey('adminUserStorageUsers', options);

/**
 * List user storage users
 *
 * Returns all users with user storage configured.
 */
export const adminUserStorageUsersOptions = (options?: Options<AdminUserStorageUsersData>) => queryOptions<AdminUserStorageUsersResponse, AdminUserStorageUsersError, AdminUserStorageUsersResponse, ReturnType<typeof adminUserStorageUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUserStorageUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUserStorageUsersQueryKey(options)
});

/**
 * Delete user storage provider
 *
 * Deletes a user storage provider by ID.
 */
export const adminUserStorageRemoveMutation = (options?: Partial<Options<AdminUserStorageRemoveData>>): UseMutationOptions<AdminUserStorageRemoveResponse, AdminUserStorageRemoveError, Options<AdminUserStorageRemoveData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageRemoveResponse, AdminUserStorageRemoveError, Options<AdminUserStorageRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminUserStorageGetQueryKey = (options: Options<AdminUserStorageGetData>) => createQueryKey('adminUserStorageGet', options);

/**
 * Get user storage provider
 *
 * Returns a specific user storage provider by ID.
 */
export const adminUserStorageGetOptions = (options: Options<AdminUserStorageGetData>) => queryOptions<AdminUserStorageGetResponse, AdminUserStorageGetError, AdminUserStorageGetResponse, ReturnType<typeof adminUserStorageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminUserStorageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminUserStorageGetQueryKey(options)
});

/**
 * Reset user storage provider
 *
 * Resets a user storage provider by ID.
 */
export const adminUserStorageResetMutation = (options?: Partial<Options<AdminUserStorageResetData>>): UseMutationOptions<AdminUserStorageResetResponse, AdminUserStorageResetError, Options<AdminUserStorageResetData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageResetResponse, AdminUserStorageResetError, Options<AdminUserStorageResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset all user storage providers
 *
 * Resets all user storage providers.
 */
export const adminUserStorageResetAllMutation = (options?: Partial<Options<AdminUserStorageResetAllData>>): UseMutationOptions<AdminUserStorageResetAllResponse, AdminUserStorageResetAllError, Options<AdminUserStorageResetAllData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageResetAllResponse, AdminUserStorageResetAllError, Options<AdminUserStorageResetAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageResetAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add user storage provider
 *
 * Adds a user storage provider using the specified auth protocol (auth_basic or auth_oauth2).
 */
export const adminUserStorageAddMutation = (options?: Partial<Options<AdminUserStorageAddData>>): UseMutationOptions<AdminUserStorageAddResponse, AdminUserStorageAddError, Options<AdminUserStorageAddData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageAddResponse, AdminUserStorageAddError, Options<AdminUserStorageAddData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageAdd({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync user storage provider
 *
 * Syncs groups, users, or all for a user storage provider.
 */
export const adminUserStorageSyncMutation = (options?: Partial<Options<AdminUserStorageSyncData>>): UseMutationOptions<AdminUserStorageSyncResponse, AdminUserStorageSyncError, Options<AdminUserStorageSyncData>> => {
    const mutationOptions: UseMutationOptions<AdminUserStorageSyncResponse, AdminUserStorageSyncError, Options<AdminUserStorageSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUserStorageSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset user password
 *
 * Admin resets a user's password.
 */
export const adminResetPasswordMutation = (options?: Partial<Options<AdminResetPasswordData>>): UseMutationOptions<AdminResetPasswordResponse, AdminResetPasswordError, Options<AdminResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<AdminResetPasswordResponse, AdminResetPasswordError, Options<AdminResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminResetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminCheckPasswordResetRequiredQueryKey = (options: Options<AdminCheckPasswordResetRequiredData>) => createQueryKey('adminCheckPasswordResetRequired', options);

/**
 * Check password reset required
 *
 * Check if a user needs to reset their password.
 */
export const adminCheckPasswordResetRequiredOptions = (options: Options<AdminCheckPasswordResetRequiredData>) => queryOptions<AdminCheckPasswordResetRequiredResponse, AdminCheckPasswordResetRequiredError, AdminCheckPasswordResetRequiredResponse, ReturnType<typeof adminCheckPasswordResetRequiredQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckPasswordResetRequired({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckPasswordResetRequiredQueryKey(options)
});

export const adminCheckEmailVerificationQueryKey = (options: Options<AdminCheckEmailVerificationData>) => createQueryKey('adminCheckEmailVerification', options);

/**
 * Check email verification required
 *
 * Check if a user needs to verify their email.
 */
export const adminCheckEmailVerificationOptions = (options: Options<AdminCheckEmailVerificationData>) => queryOptions<AdminCheckEmailVerificationResponse, AdminCheckEmailVerificationError, AdminCheckEmailVerificationResponse, ReturnType<typeof adminCheckEmailVerificationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckEmailVerification({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckEmailVerificationQueryKey(options)
});

export const adminCheckDisclaimerQueryKey = (options: Options<AdminCheckDisclaimerData>) => createQueryKey('adminCheckDisclaimer', options);

/**
 * Check disclaimer acknowledgement
 *
 * Check if a user has acknowledged the disclaimer.
 */
export const adminCheckDisclaimerOptions = (options: Options<AdminCheckDisclaimerData>) => queryOptions<AdminCheckDisclaimerResponse, AdminCheckDisclaimerError, AdminCheckDisclaimerResponse, ReturnType<typeof adminCheckDisclaimerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckDisclaimer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckDisclaimerQueryKey(options)
});

export const adminCheckMigrationRequiredQueryKey = (options: Options<AdminCheckMigrationRequiredData>) => createQueryKey('adminCheckMigrationRequired', options);

/**
 * Check migration required
 *
 * Check if a user needs to migrate their account.
 */
export const adminCheckMigrationRequiredOptions = (options: Options<AdminCheckMigrationRequiredData>) => queryOptions<AdminCheckMigrationRequiredResponse, AdminCheckMigrationRequiredError, AdminCheckMigrationRequiredResponse, ReturnType<typeof adminCheckMigrationRequiredQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminCheckMigrationRequired({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminCheckMigrationRequiredQueryKey(options)
});

export const adminListCategoriesQueryKey = (options?: Options<AdminListCategoriesData>) => createQueryKey('adminListCategories', options);

/**
 * List categories
 *
 * Returns all categories.
 */
export const adminListCategoriesOptions = (options?: Options<AdminListCategoriesData>) => queryOptions<AdminListCategoriesResponse, AdminListCategoriesError, AdminListCategoriesResponse, ReturnType<typeof adminListCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListCategoriesQueryKey(options)
});

export const adminListCategoriesFrontendQueryKey = (options: Options<AdminListCategoriesFrontendData>) => createQueryKey('adminListCategoriesFrontend', options);

/**
 * List frontend categories
 *
 * Returns categories for frontend display.
 */
export const adminListCategoriesFrontendOptions = (options: Options<AdminListCategoriesFrontendData>) => queryOptions<AdminListCategoriesFrontendResponse, AdminListCategoriesFrontendError, AdminListCategoriesFrontendResponse, ReturnType<typeof adminListCategoriesFrontendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListCategoriesFrontend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListCategoriesFrontendQueryKey(options)
});

/**
 * Delete category
 *
 * Deletes a category.
 */
export const adminDeleteCategoryMutation = (options?: Partial<Options<AdminDeleteCategoryData>>): UseMutationOptions<AdminDeleteCategoryResponse, AdminDeleteCategoryError, Options<AdminDeleteCategoryData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteCategoryResponse, AdminDeleteCategoryError, Options<AdminDeleteCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetCategoryQueryKey = (options: Options<AdminGetCategoryData>) => createQueryKey('adminGetCategory', options);

/**
 * Get category
 *
 * Returns data for a specific category.
 */
export const adminGetCategoryOptions = (options: Options<AdminGetCategoryData>) => queryOptions<AdminGetCategoryResponse, AdminGetCategoryError, AdminGetCategoryResponse, ReturnType<typeof adminGetCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetCategoryQueryKey(options)
});

/**
 * Update category
 *
 * Updates a category.
 */
export const adminUpdateCategoryMutation = (options?: Partial<Options<AdminUpdateCategoryData>>): UseMutationOptions<AdminUpdateCategoryResponse, AdminUpdateCategoryError, Options<AdminUpdateCategoryData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateCategoryResponse, AdminUpdateCategoryError, Options<AdminUpdateCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create category
 *
 * Creates a new category with an associated Main group.
 */
export const adminCreateCategoryMutation = (options?: Partial<Options<AdminCreateCategoryData>>): UseMutationOptions<AdminCreateCategoryResponse, AdminCreateCategoryError, Options<AdminCreateCategoryData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateCategoryResponse, AdminCreateCategoryError, Options<AdminCreateCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update category quota
 *
 * Updates quota for a category.
 */
export const adminUpdateCategoryQuotaMutation = (options?: Partial<Options<AdminUpdateCategoryQuotaData>>): UseMutationOptions<AdminUpdateCategoryQuotaResponse, AdminUpdateCategoryQuotaError, Options<AdminUpdateCategoryQuotaData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateCategoryQuotaResponse, AdminUpdateCategoryQuotaError, Options<AdminUpdateCategoryQuotaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateCategoryQuota({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update category limits
 *
 * Updates limits for a category.
 */
export const adminUpdateCategoryLimitsMutation = (options?: Partial<Options<AdminUpdateCategoryLimitsData>>): UseMutationOptions<AdminUpdateCategoryLimitsResponse, AdminUpdateCategoryLimitsError, Options<AdminUpdateCategoryLimitsData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateCategoryLimitsResponse, AdminUpdateCategoryLimitsError, Options<AdminUpdateCategoryLimitsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateCategoryLimits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetSecretsQueryKey = (options?: Options<AdminGetSecretsData>) => createQueryKey('adminGetSecrets', options);

/**
 * Get admin secrets
 *
 * Returns admin secrets/keys.
 */
export const adminGetSecretsOptions = (options?: Options<AdminGetSecretsData>) => queryOptions<AdminGetSecretsResponse, AdminGetSecretsError, AdminGetSecretsResponse, ReturnType<typeof adminGetSecretsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetSecrets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetSecretsQueryKey(options)
});

/**
 * Create admin secret
 *
 * Creates a new admin secret.
 */
export const adminCreateSecretMutation = (options?: Partial<Options<AdminCreateSecretData>>): UseMutationOptions<AdminCreateSecretResponse, AdminCreateSecretError, Options<AdminCreateSecretData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateSecretResponse, AdminCreateSecretError, Options<AdminCreateSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete admin secret
 *
 * Deletes an admin secret.
 */
export const adminDeleteSecretMutation = (options?: Partial<Options<AdminDeleteSecretData>>): UseMutationOptions<AdminDeleteSecretResponse, AdminDeleteSecretError, Options<AdminDeleteSecretData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteSecretResponse, AdminDeleteSecretError, Options<AdminDeleteSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetUserByEmailCategoryQueryKey = (options: Options<AdminGetUserByEmailCategoryData>) => createQueryKey('adminGetUserByEmailCategory', options);

/**
 * Get user by email and category
 *
 * Returns user ID by email and category.
 */
export const adminGetUserByEmailCategoryOptions = (options: Options<AdminGetUserByEmailCategoryData>) => queryOptions<AdminGetUserByEmailCategoryResponse, AdminGetUserByEmailCategoryError, AdminGetUserByEmailCategoryResponse, ReturnType<typeof adminGetUserByEmailCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUserByEmailCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUserByEmailCategoryQueryKey(options)
});

/**
 * Auto register user
 *
 * Auto-registers a user from the Register-Claims token.
 */
export const adminAutoRegisterMutation = (options?: Partial<Options<AdminAutoRegisterData>>): UseMutationOptions<AdminAutoRegisterResponse, AdminAutoRegisterError, Options<AdminAutoRegisterData>> => {
    const mutationOptions: UseMutationOptions<AdminAutoRegisterResponse, AdminAutoRegisterError, Options<AdminAutoRegisterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminAutoRegister({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Broadcast admin message
 *
 * Broadcasts a message to all connected users via SocketIO.
 */
export const adminBroadcastMutation = (options?: Partial<Options<AdminBroadcastData2>>): UseMutationOptions<AdminBroadcastResponse, AdminBroadcastError, Options<AdminBroadcastData2>> => {
    const mutationOptions: UseMutationOptions<AdminBroadcastResponse, AdminBroadcastError, Options<AdminBroadcastData2>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminBroadcast({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminViewersConfigQueryKey = (options?: Options<AdminViewersConfigData>) => createQueryKey('adminViewersConfig', options);

/**
 * Get viewers configuration
 *
 * Returns all viewers configurations as a list — one entry per viewer (``file_rdpgw``, ``file_rdpvpn``, ``file_spice``) with ``key``, ``viewer``, ``custom``, ``default``, ``fixed`` fields. Webapp DataTables consumes the response root as the row array.
 */
export const adminViewersConfigOptions = (options?: Options<AdminViewersConfigData>) => queryOptions<AdminViewersConfigResponse, AdminViewersConfigError, AdminViewersConfigResponse, ReturnType<typeof adminViewersConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminViewersConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminViewersConfigQueryKey(options)
});

/**
 * Update viewer configuration
 *
 * Updates the custom configuration for a specific viewer.
 */
export const adminViewersConfigUpdateMutation = (options?: Partial<Options<AdminViewersConfigUpdateData>>): UseMutationOptions<AdminViewersConfigUpdateResponse, AdminViewersConfigUpdateError, Options<AdminViewersConfigUpdateData>> => {
    const mutationOptions: UseMutationOptions<AdminViewersConfigUpdateResponse, AdminViewersConfigUpdateError, Options<AdminViewersConfigUpdateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminViewersConfigUpdate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset viewer configuration
 *
 * Resets a viewer custom configuration to its default. Valid viewers: file_rdpgw, file_rdpvpn, file_spice.
 */
export const adminViewersConfigResetMutation = (options?: Partial<Options<AdminViewersConfigResetData>>): UseMutationOptions<AdminViewersConfigResetResponse, AdminViewersConfigResetError, Options<AdminViewersConfigResetData>> => {
    const mutationOptions: UseMutationOptions<AdminViewersConfigResetResponse, AdminViewersConfigResetError, Options<AdminViewersConfigResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminViewersConfigReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllBookingsQueryKey = (options?: Options<GetAllBookingsData>) => createQueryKey('getAllBookings', options);

/**
 * Get all bookings
 *
 * Returns a list of all bookings (admin only).
 */
export const getAllBookingsOptions = (options?: Options<GetAllBookingsData>) => queryOptions<GetAllBookingsResponse, GetAllBookingsError, GetAllBookingsResponse, ReturnType<typeof getAllBookingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllBookings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllBookingsQueryKey(options)
});

/**
 * Get users by priority rule
 *
 * Returns users matching a priority rule.
 */
export const getUsersPrioritiesMutation = (options?: Partial<Options<GetUsersPrioritiesData>>): UseMutationOptions<GetUsersPrioritiesResponse, GetUsersPrioritiesError, Options<GetUsersPrioritiesData>> => {
    const mutationOptions: UseMutationOptions<GetUsersPrioritiesResponse, GetUsersPrioritiesError, Options<GetUsersPrioritiesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getUsersPriorities({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete priority
 *
 * Deletes a booking priority by ID.
 */
export const deletePriorityMutation = (options?: Partial<Options<DeletePriorityData>>): UseMutationOptions<DeletePriorityResponse, DeletePriorityError, Options<DeletePriorityData>> => {
    const mutationOptions: UseMutationOptions<DeletePriorityResponse, DeletePriorityError, Options<DeletePriorityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePriority({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPriorityRulesQueryKey = (options?: Options<ListPriorityRulesData>) => createQueryKey('listPriorityRules', options);

/**
 * List priority rules
 *
 * Returns a list of all priority rules.
 */
export const listPriorityRulesOptions = (options?: Options<ListPriorityRulesData>) => queryOptions<ListPriorityRulesResponse, ListPriorityRulesError, ListPriorityRulesResponse, ReturnType<typeof listPriorityRulesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPriorityRules({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPriorityRulesQueryKey(options)
});

export const getGpuBookingsForecastQueryKey = (options?: Options<GetGpuBookingsForecastData>) => createQueryKey('getGpuBookingsForecast', options);

/**
 * Get GPU bookings forecast
 *
 * Returns GPU bookings forecast with current, 30min and 60min projections.
 */
export const getGpuBookingsForecastOptions = (options?: Options<GetGpuBookingsForecastData>) => queryOptions<GetGpuBookingsForecastResponse, GetGpuBookingsForecastError, GetGpuBookingsForecastResponse, ReturnType<typeof getGpuBookingsForecastQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGpuBookingsForecast({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGpuBookingsForecastQueryKey(options)
});

/**
 * Empty all bookings in plan
 *
 * Deletes all bookings associated with a plan.
 */
export const emptyBookingPlanMutation = (options?: Partial<Options<EmptyBookingPlanData>>): UseMutationOptions<EmptyBookingPlanResponse, EmptyBookingPlanError, Options<EmptyBookingPlanData>> => {
    const mutationOptions: UseMutationOptions<EmptyBookingPlanResponse, EmptyBookingPlanError, Options<EmptyBookingPlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emptyBookingPlan({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBookingPlansQueryKey = (options: Options<GetBookingPlansData>) => createQueryKey('getBookingPlans', options);

/**
 * Get booking's plans
 *
 * Returns the plans associated with a booking.
 */
export const getBookingPlansOptions = (options: Options<GetBookingPlansData>) => queryOptions<GetBookingPlansResponse, GetBookingPlansError, GetBookingPlansResponse, ReturnType<typeof getBookingPlansQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBookingPlans({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBookingPlansQueryKey(options)
});

export const listProfilesQueryKey = (options: Options<ListProfilesData>) => createQueryKey('listProfiles', options);

/**
 * List profiles for a reservable type
 *
 * Returns all profiles for a specific reservable type.
 */
export const listProfilesOptions = (options: Options<ListProfilesData>) => queryOptions<ListProfilesResponse, ListProfilesError, ListProfilesResponse, ReturnType<typeof listProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProfilesQueryKey(options)
});

export const listBookablesQueryKey = (options: Options<ListBookablesData>) => createQueryKey('listBookables', options);

/**
 * List bookable reservables with their backing categories
 *
 * Returns the bookable reservables of a type, each enriched with the distinct categories of the delegated GPU cards that back it. Replaces the generic admin table feed for the Bookables admin view.
 */
export const listBookablesOptions = (options: Options<ListBookablesData>) => queryOptions<ListBookablesResponse, ListBookablesError, ListBookablesResponse, ReturnType<typeof listBookablesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBookables({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBookablesQueryKey(options)
});

export const listReservableSubitemsQueryKey = (options: Options<ListReservableSubitemsData>) => createQueryKey('listReservableSubitems', options);

/**
 * List subitems of a reservable item
 *
 * Returns the catalog of subitems (e.g., vGPU profiles) for a specific reservable item. v3 parity for the admin Hypervisors
 */
export const listReservableSubitemsOptions = (options: Options<ListReservableSubitemsData>) => queryOptions<ListReservableSubitemsResponse, ListReservableSubitemsError, ListReservableSubitemsResponse, ReturnType<typeof listReservableSubitemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReservableSubitems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReservableSubitemsQueryKey(options)
});

/**
 * Add new reservable item
 *
 * Creates a new reservable item of the specified type.
 */
export const addReservableItemMutation = (options?: Partial<Options<AddReservableItemData>>): UseMutationOptions<AddReservableItemResponse, AddReservableItemError, Options<AddReservableItemData>> => {
    const mutationOptions: UseMutationOptions<AddReservableItemResponse, AddReservableItemError, Options<AddReservableItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addReservableItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable or disable a reservable subitem
 *
 * Enables or disables a specific reservable subitem (e.g., GPU profile). Pass ``?notify_user=true`` to fan out a ``deleted-gpu`` email to every user whose desktops/deployments/bookings reference the reservable (v3 parity).
 */
export const enableReservableSubitemMutation = (options?: Partial<Options<EnableReservableSubitemData>>): UseMutationOptions<EnableReservableSubitemResponse, EnableReservableSubitemError, Options<EnableReservableSubitemData>> => {
    const mutationOptions: UseMutationOptions<EnableReservableSubitemResponse, EnableReservableSubitemError, Options<EnableReservableSubitemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enableReservableSubitem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkLastSubitemQueryKey = (options: Options<CheckLastSubitemData>) => createQueryKey('checkLastSubitem', options);

/**
 * Check last subitem
 *
 * Checks if a GPU profile was the last enabled and returns affected desktops and plans.
 */
export const checkLastSubitemOptions = (options: Options<CheckLastSubitemData>) => queryOptions<CheckLastSubitemResponse, CheckLastSubitemError, CheckLastSubitemResponse, ReturnType<typeof checkLastSubitemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkLastSubitem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkLastSubitemQueryKey(options)
});

export const checkLastItemQueryKey = (options: Options<CheckLastItemData>) => createQueryKey('checkLastItem', options);

/**
 * Check last item
 *
 * Checks if a GPU item was the last enabled and returns affected desktops and plans.
 */
export const checkLastItemOptions = (options: Options<CheckLastItemData>) => queryOptions<CheckLastItemResponse, CheckLastItemError, CheckLastItemResponse, ReturnType<typeof checkLastItemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkLastItem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkLastItemQueryKey(options)
});

/**
 * Delete reservable item
 *
 * Deletes a reservable item and all its associated plans and bookings. Pass ``?notify_user=true`` to fan out a ``deleted-gpu`` email to affected users first (v3 parity).
 */
export const deleteReservableItemMutation = (options?: Partial<Options<DeleteReservableItemData>>): UseMutationOptions<DeleteReservableItemResponse, DeleteReservableItemError, Options<DeleteReservableItemData>> => {
    const mutationOptions: UseMutationOptions<DeleteReservableItemResponse, DeleteReservableItemError, Options<DeleteReservableItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteReservableItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update reservable item
 *
 * Update name and description of a reservable item (e.g., GPU).
 */
export const updateReservableItemMutation = (options?: Partial<Options<UpdateReservableItemData>>): UseMutationOptions<UpdateReservableItemResponse, UpdateReservableItemError, Options<UpdateReservableItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateReservableItemResponse, UpdateReservableItemError, Options<UpdateReservableItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateReservableItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkIntegrityQueryKey = (options?: Options<CheckIntegrityData>) => createQueryKey('checkIntegrity', options);

/**
 * Check planning integrity
 *
 * Checks if any plan item IDs are overlapped.
 */
export const checkIntegrityOptions = (options?: Options<CheckIntegrityData>) => queryOptions<CheckIntegrityResponse, CheckIntegrityError, CheckIntegrityResponse, ReturnType<typeof checkIntegrityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkIntegrity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkIntegrityQueryKey(options)
});

export const getActualPlanQueryKey = (options: Options<GetActualPlanData>) => createQueryKey('getActualPlan', options);

/**
 * Get actual plan for item
 *
 * Returns the current active plan for a specific item.
 */
export const getActualPlanOptions = (options: Options<GetActualPlanData>) => queryOptions<GetActualPlanResponse, GetActualPlanError, GetActualPlanResponse, ReturnType<typeof getActualPlanQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActualPlan({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActualPlanQueryKey(options)
});

export const getPlanBookingsQueryKey = (options: Options<GetPlanBookingsData>) => createQueryKey('getPlanBookings', options);

/**
 * Get plan bookings
 *
 * Returns all bookings associated with a specific plan.
 */
export const getPlanBookingsOptions = (options: Options<GetPlanBookingsData>) => queryOptions<GetPlanBookingsResponse, GetPlanBookingsError, GetPlanBookingsResponse, ReturnType<typeof getPlanBookingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlanBookings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlanBookingsQueryKey(options)
});

export const getAllDesktopsQueryKey = (options?: Options<GetAllDesktopsData>) => createQueryKey('getAllDesktops', options);

/**
 * Get all desktops
 *
 * Returns a list of all desktops in the system.
 */
export const getAllDesktopsOptions = (options?: Options<GetAllDesktopsData>) => queryOptions<GetAllDesktopsResponse, GetAllDesktopsError, GetAllDesktopsResponse, ReturnType<typeof getAllDesktopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAllDesktops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAllDesktopsQueryKey(options)
});

/**
 * Register a new user
 *
 * Registers a new user in the system.
 */
export const registerUserMutation = (options?: Partial<Options<RegisterUserData>>): UseMutationOptions<RegisterUserResponse, RegisterUserError, Options<RegisterUserData>> => {
    const mutationOptions: UseMutationOptions<RegisterUserResponse, RegisterUserError, Options<RegisterUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Apply a registration code to an existing user
 *
 * Updates an existing user's role and group from a registration code.
 */
export const reRegisterUserMutation = (options?: Partial<Options<ReRegisterUserData>>): UseMutationOptions<ReRegisterUserResponse, ReRegisterUserError, Options<ReRegisterUserData>> => {
    const mutationOptions: UseMutationOptions<ReRegisterUserResponse, ReRegisterUserError, Options<ReRegisterUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reRegisterUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserPasswordPolicyQueryKey = (options?: Options<GetUserPasswordPolicyData>) => createQueryKey('getUserPasswordPolicy', options);

/**
 * Get user password policy
 *
 * Returns the password policy for the user.
 */
export const getUserPasswordPolicyOptions = (options?: Options<GetUserPasswordPolicyData>) => queryOptions<GetUserPasswordPolicyResponse, GetUserPasswordPolicyError, GetUserPasswordPolicyResponse, ReturnType<typeof getUserPasswordPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserPasswordPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserPasswordPolicyQueryKey(options)
});

export const apiV4DisclaimerQueryKey = (options?: Options<ApiV4DisclaimerData>) => createQueryKey('apiV4Disclaimer', options);

/**
 * Get disclaimer content
 *
 * Returns disclaimer content for the login page.
 */
export const apiV4DisclaimerOptions = (options?: Options<ApiV4DisclaimerData>) => queryOptions<ApiV4DisclaimerResponse, ApiV4DisclaimerError, ApiV4DisclaimerResponse, ReturnType<typeof apiV4DisclaimerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await apiV4Disclaimer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: apiV4DisclaimerQueryKey(options)
});

export const getDisclaimerQueryKey = (options?: Options<GetDisclaimerData>) => createQueryKey('getDisclaimer', options);

/**
 * Get disclaimer template
 *
 * Returns the disclaimer template for the current user.
 */
export const getDisclaimerOptions = (options?: Options<GetDisclaimerData>) => queryOptions<GetDisclaimerResponse, GetDisclaimerError, GetDisclaimerResponse, ReturnType<typeof getDisclaimerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDisclaimer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDisclaimerQueryKey(options)
});

/**
 * Check desktop viewer ownership
 *
 * Verify that the caller is authorised to reach a running desktop's viewer. Used by rdpgw, websockify and guac as a service-side preflight before proxying a connection.
 *
 * Dispatches on three mutually-exclusive variants:
 * - If the JWT payload carries a ``desktop_id`` (direct-viewer token), the body may contain an ``ip`` which must match the desktop's viewer ``guest_ip``.
 * - Else if the body contains ``ip``, look up the running desktop by ``guest_ip`` index.
 * - Else the body must contain ``proxy_video``, ``proxy_hyper_host`` and ``port``, and the desktop is found via the ``proxies`` index.
 *
 * This endpoint replaces v3's ``GET /user/owns_desktop`` which used a GET-with-body pattern that could not be represented in OpenAPI.
 */
export const userOwnsDesktopMutation = (options?: Partial<Options<UserOwnsDesktopData>>): UseMutationOptions<UserOwnsDesktopResponse, UserOwnsDesktopError, Options<UserOwnsDesktopData>> => {
    const mutationOptions: UseMutationOptions<UserOwnsDesktopResponse, UserOwnsDesktopError, Options<UserOwnsDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await userOwnsDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getNetworksFromTokenQueryKey = (options: Options<GetNetworksFromTokenData>) => createQueryKey('getNetworksFromToken', options);

/**
 * Get networks of a desktop from a direct viewer token
 *
 * Returns the networks information about an IsardVDI desktop identified by a direct viewer share token. Requires a direct viewer JWT as Authorization bearer.
 */
export const getNetworksFromTokenOptions = (options: Options<GetNetworksFromTokenData>) => queryOptions<GetNetworksFromTokenResponse, GetNetworksFromTokenError, GetNetworksFromTokenResponse, ReturnType<typeof getNetworksFromTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNetworksFromToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNetworksFromTokenQueryKey(options)
});

export const getDesktopDetailsFromTokenQueryKey = (options: Options<GetDesktopDetailsFromTokenData>) => createQueryKey('getDesktopDetailsFromToken', options);

/**
 * Get the details of a desktop from a direct viewer token
 *
 * Returns the details of an IsardVDI desktop identified by a direct viewer share token, including its read-only bastion access info if enabled. Requires a direct viewer JWT as Authorization bearer.
 */
export const getDesktopDetailsFromTokenOptions = (options: Options<GetDesktopDetailsFromTokenData>) => queryOptions<GetDesktopDetailsFromTokenResponse, GetDesktopDetailsFromTokenError, GetDesktopDetailsFromTokenResponse, ReturnType<typeof getDesktopDetailsFromTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesktopDetailsFromToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesktopDetailsFromTokenQueryKey(options)
});

/**
 * Start a desktop from a direct viewer token
 *
 * Starts an IsardVDI desktop identified by a direct viewer share token. Requires a direct viewer JWT as Authorization bearer. No-op if the desktop is not in a stopped/failed state.
 */
export const startDesktopFromTokenMutation = (options?: Partial<Options<StartDesktopFromTokenData>>): UseMutationOptions<StartDesktopFromTokenResponse, StartDesktopFromTokenError, Options<StartDesktopFromTokenData>> => {
    const mutationOptions: UseMutationOptions<StartDesktopFromTokenResponse, StartDesktopFromTokenError, Options<StartDesktopFromTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startDesktopFromToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset Desktop
 */
export const resetDesktopMutation = (options?: Partial<Options<ResetDesktopData>>): UseMutationOptions<ResetDesktopResponse, ResetDesktopError, Options<ResetDesktopData>> => {
    const mutationOptions: UseMutationOptions<ResetDesktopResponse, ResetDesktopError, Options<ResetDesktopData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetDesktop({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a JWT token to export user data for migration purposes.
 *
 * Generates a JWT token that contains the user's data for migration to another IsardVDI user.
 */
export const migrationExportUserMutation = (options?: Partial<Options<MigrationExportUserData>>): UseMutationOptions<MigrationExportUserResponse, MigrationExportUserError, Options<MigrationExportUserData>> => {
    const mutationOptions: UseMutationOptions<MigrationExportUserResponse, MigrationExportUserError, Options<MigrationExportUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await migrationExportUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProviderExportEnabledQueryKey = (options: Options<GetProviderExportEnabledData>) => createQueryKey('getProviderExportEnabled', options);

/**
 * Check if provider allows exporting user migrations.
 *
 * Returns whether the authentication provider allows users to export their data for migration.
 */
export const getProviderExportEnabledOptions = (options: Options<GetProviderExportEnabledData>) => queryOptions<GetProviderExportEnabledResponse, GetProviderExportEnabledError, GetProviderExportEnabledResponse, ReturnType<typeof getProviderExportEnabledQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProviderExportEnabled({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProviderExportEnabledQueryKey(options)
});

export const getProviderImportEnabledQueryKey = (options: Options<GetProviderImportEnabledData>) => createQueryKey('getProviderImportEnabled', options);

/**
 * Check if provider allows importing user migrations.
 *
 * Returns whether the authentication provider allows users to import data from another user.
 */
export const getProviderImportEnabledOptions = (options: Options<GetProviderImportEnabledData>) => queryOptions<GetProviderImportEnabledResponse, GetProviderImportEnabledError, GetProviderImportEnabledResponse, ReturnType<typeof getProviderImportEnabledQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProviderImportEnabled({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProviderImportEnabledQueryKey(options)
});

/**
 * Set user email
 *
 * Sets the email address for the specified user.
 */
export const setUserEmailMutation = (options?: Partial<Options<SetUserEmailData>>): UseMutationOptions<SetUserEmailResponse, SetUserEmailError, Options<SetUserEmailData>> => {
    const mutationOptions: UseMutationOptions<SetUserEmailResponse, SetUserEmailError, Options<SetUserEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setUserEmail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
